// English translations keyed by the original interface text.
const messages: Record<string, string> = {
  "Modo escuro": "Dark mode",
  "Modo claro": "Light mode",
  "Escuro": "Dark",
  "Claro": "Light",
  " — {value0}": " — {value0}",
  " · assistido em média ": " · average watched ",
  " · o player mostra \"Conteúdo indisponível\" enquanto pausado": " · the player displays \"Content unavailable\" while paused",
  " · Página": " · Page",
  " · v{value0}": " · v{value0}",
  " · vencedora": " · winner",
  " \"5 Dicas Secretas\" vs \"Dicas Secretas\"": " \"5 Secret Tips\" vs \"Secret Tips\"",
  " ({value0})": " ({value0})",
  " (as de maior volume)": " (highest volume)",
  " (inativa)": " (inactive)",
  " (seleção manual)": " (manual selection)",
  " {value0}": " {value0}",
  " / {value0}": " / {value0}",
  " • {value0} de conteúdo": " • {value0} of content",
  " | Conta: ****": " | Account: ****",
  " Alterar número ": " Change number ",
  " ao seu vídeo. O espectador poderá ativar ou desativar a legenda pelo botão ": " to your video. Viewers can enable or disable captions using the ",
  " Após identificar um vencedor, crie um novo teste usando aquele como controle vs novas variações.": " After identifying a winner, create a new test using it as the control against new variations.",
  " As cores indicam horários com": " Colors indicate times with",
  " As cores mais intensas indicam horários com maior": " More intense colors indicate times with higher",
  " As cores mais intensas indicam horários com maior volume de": " More intense colors indicate times with a higher volume of",
  " Bloquear número ": " Block number ",
  " Cole o código abaixo na tag": " Paste the code below into the tag",
  " Com 100 indicações no plano Premium, você ganha ": " With 100 referrals on the Premium plan, you earn ",
  " Compare resultados baseados na origem do tráfego (Facebook vs Instagram vs Email).": " Compare results by traffic source (Facebook vs Instagram vs Email).",
  " Components": " Components",
  " Contraste insuficiente (": " Insufficient contrast (",
  " convertido": " converted",
  " de ": " from ",
  " De até 20% do valor do plano de assinatura do indicado.": " Up to 20% of the referred customer's subscription plan price.",
  " do vídeo.": " of the video.",
  " domínio": " domain",
  " dos seus usuários usam ": " of your users use ",
  " em {value0}": " in {value0}",
  " em todas as variações, evitando diferenças no tamanho do player.": " across all variations, avoiding differences in player size.",
  " encontrado": " found",
  " episódios • ": " episodes • ",
  " espectadores · ": " viewers · ",
  " Esta ação não afeta o vídeo já enviado.": " This action does not affect the video already uploaded.",
  " evento(s) nas últimas 24h (": " event(s) in the last 24h (",
  " evento(s), mas nenhum nas últimas 24h (último: ": " event(s), but none in the last 24h (last: ",
  " Evite sobrepor partes importantes": " Avoid covering important areas",
  " leads": " leads",
  " leads (": " leads (",
  " min": " min",
  " modo compacto": " compact mode",
  " nas variações já criadas.": " in the variations already created.",
  " O endereço salvo continua o anterior.": " The previously saved address remains unchanged.",
  " Observe se a diferença se mantém constante ao longo de diversos dias.": " Check whether the difference remains consistent over several days.",
  " outras regras...": " other rules...",
  " Para resultados confiáveis, espere pelo menos 100-200 visualizações por variação.": " For reliable results, wait for at least 100–200 views per variation.",
  " plays": " plays",
  " Plays": " Plays",
  " problema": " problem",
  " registro": " record",
  " registro(s)": " record(s)",
  " registros": " records",
  " regra": " rule",
  " Revise seus últimos 5-10 testes para identificar padrões comuns nos vencedores.": " Review your last 5–10 tests to identify common patterns among winners.",
  " rotas • ": " routes • ",
  " segundo": " second",
  " stores • ": " stores • ",
  " terminando em ": " ending in ",
  " total": " total",
  " Último: {value0}.": " Last: {value0}.",
  " Uma variação vencedora normalmente supera as outras em pelo menos 10-15% em métricas-chave.": " A winning variation usually outperforms the others by at least 10–15% on key metrics.",
  " usados": " used",
  " UTM criada": " UTM created",
  " vídeo": " video",
  " vídeos": " videos",
  " vídeos em teste": " videos being tested",
  " views": " views",
  "— Escolha um vídeo —": "— Choose a video —",
  "— Sem destino —": "— No destination —",
  ", todas ligadas": ", all on",
  ": a pré-visualização pode ter etapas sem vídeo ou opções sem destino.": ": the preview may include steps without videos or options without a destination.",
  ":1). Recomendado: mínimo 4.5:1 para acessibilidade (WCAG AA).": ":1). Recommended: minimum 4.5:1 for accessibility (WCAG AA).",
  "? Esta ação não pode ser desfeita.": "? This action cannot be undone.",
  ". Ao confirmar, você reconhece que recebeu acesso autorizado para usar este vídeo na sua conta HostVSL e concorda em não redistribuir este conteúdo para outras pessoas fora do fluxo oficial de compartilhamento.": ". By confirming, you acknowledge that you have received authorized access to use this video in your HostVSL account and agree not to redistribute this content to others outside the official sharing process.",
  ". Cancele quando quiser.": ". Cancel anytime.",
  ". Clique em uma célula para ver detalhes e abrir no Tracking.": ". Click a cell to view details and open it in Tracking.",
  ". Cole apenas o valor, sem escrever nada antes dele.": ". Paste only the value, without adding any text before it.",
  ". Deseja continuar?": ". Do you want to continue?",
  ". Ele será usado para todas as intros do teste.": ". It will be used for every intro in the test.",
  ". Use esses dados para planejar estratégias de tráfego.": ". Use this data to plan traffic strategies.",
  ".SRT": ".SRT",
  ".VTT": ".VTT",
  "· assistido em média": "· average watched",
  "· Página": "· Page",
  "' da lista?": "' from the list?",
  "\" aparece.": "\" appears.",
  "\" será removida deste teste.": "\" will be removed from this test.",
  "\" será removido da fila de upload.": "\" will be removed from the upload queue.",
  "\" será removido da lista.": "\" will be removed from the list.",
  "\" será removido permanentemente.": "\" will be permanently removed.",
  "\"? Ela deixará de funcionar imediatamente.": "\"? It will stop working immediately.",
  "\"? Esta ação não pode ser desfeita.": "\"? This action cannot be undone.",
  "\"{value0}\"": "\"{value0}\"",
  "\"{value0}\" enviado. O processamento começou.": "\"{value0}\" uploaded. Processing has started.",
  "\"{value0}\" está completamente pronto e disponível para visualização!": "\"{value0}\" is fully ready and available to watch!",
  "\"{value0}\" está pronto para personalização": "\"{value0}\" is ready to customize",
  "\"{value0}\" está pronto para personalização (configurações padrão)": "\"{value0}\" is ready to customize (default settings)",
  "\"{value0}\" já pode ser personalizado! O MP4 ainda está sendo gerado.": "\"{value0}\" can now be customized! The MP4 is still being generated.",
  "\"5 Dicas Secretas\" vs \"Dicas Secretas\"": "\"5 Secret Tips\" vs \"Secret Tips\"",
  "\"Assista esse vídeo\"": "\"Watch this video\"",
  "\"Ganhe R$ 1.000/mês\" vs \"Ganhe dinheiro\"": "\"Earn $1,000/month\" vs \"Make money\"",
  "\"Últimas 24h\", \"Vagas Limitadas\"": "\"Last 24h\", \"Limited Spots\"",
  "(cópia)": "(copy)",
  "(deve ser 100%)": "(must be 100%)",
  "(fim)": "(end)",
  "(Mais alta)": "(Highest)",
  "(Mais baixa)": "(Lowest)",
  "(mínimo 4.5:1)": "(minimum 4.5:1)",
  "(não usado neste template)": "(not used in this template)",
  "(opcional)": "(optional)",
  "(Produto)": "(Product)",
  "(Recomendado:": "(Recommended:",
  "(recomendado)": "(recommended)",
  "(Visível só para você)": "(Visible only to you)",
  "(XX) XXXXX-XXXX": "(XX) XXXXX-XXXX",
  "). Ou o VSL não foi aberto nas últimas 24h, ou o envio server-side falhou (credencial/endpoint) — ou a URL vinculada não é a página do vídeo.": "). Either the VSL has not been opened in the last 24h, server-side sending failed (credentials/endpoint), or the linked URL is not the video page.",
  "[AO VIVO] Crie seu webinário do zero em 60 minutos": "[LIVE] Create your webinar from scratch in 60 minutes",
  "{nome} de {cidade} acabou de comprar {produto}": "{nome} from {cidade} just bought {produto}",
  "{value0} (clique duas vezes para renomear)": "{value0} (double-click to rename)",
  "{value0} (seletor)": "{value0} (selector)",
  "{value0} (valor)": "{value0} (value)",
  "{value0} • Atualizado: {value1}": "{value0} • Updated: {value1}",
  "{value0} arquivo(s) acima do limite de 2GB. Baixe pro PC primeiro.": "{value0} file(s) over the 2GB limit. Download to your PC first.",
  "{value0} de {value1} integrações criadas. Você pode configurar as demais em Rastreamento.": "{value0} of {value1} integrations created. Configure the rest in Tracking.",
  "{value0} ficou no topo": "{value0} came out on top",
  "{value0} indisponível neste ambiente. Tente novamente mais tarde.": "{value0} unavailable in this environment. Try again later.",
  "{value0} logo": "{value0} logo",
  "{value0} notificações não lidas": "{value0} unread notifications",
  "{value0} plays adicionados com sucesso!": "{value0} plays added successfully!",
  "{value0} registro(s) exportado(s).": "{value0} record(s) exported.",
  "{value0} removido da seleção": "{value0} removed from selection",
  "{value0} thumbnail": "{value0} thumbnail",
  "{value0} tracking(s) excluído(s) com sucesso!": "{value0} tracking entry/entries deleted successfully!",
  "{value0} únicos": "{value0} unique",
  "{value0} vídeo(s) adicionado(s) à fila": "{value0} video(s) added to queue",
  "{value0} vídeo(s) adicionado(s) à pasta": "{value0} video(s) added to folder",
  "{value0} vídeo(s) adicionado(s) à playlist.": "{value0} video(s) added to playlist.",
  "{value0} vídeo(s) em processamento": "{value0} video(s) processing",
  "{value0} vídeo(s) excluído(s) com sucesso": "{value0} video(s) deleted successfully",
  "{value0} vídeo{value1} importado{value2}": "{value0} video{value1} imported{value2}",
  "{value0} vídeo{value1} importado{value2} com sucesso": "{value0} video{value1} imported{value2} successfully",
  "{value0} vídeo{value1} na fila de envio.": "{value0} video{value1} in the upload queue.",
  "{value0} vídeos": "{value0} videos",
  "{value0} vídeos enviando": "{value0} videos uploading",
  "{value0}, {value1}, {value2} {value3} ({value4}% do pico)": "{value0}, {value1}, {value2} {value3} ({value4}% of peak)",
  "{value0}% (individual)": "{value0}% (individual)",
  "{value0}% taxa de clique": "{value0}% click rate",
  "{value0}º pitch": "Pitch {value0}",
  "@empresa.com, @outra.com": "@company.com, @other.com",
  "/ mês": "/ month",
  "/mês": "/month",
  "&gt;": "&gt;",
  "#meuElemento ou .minha-classe": "#myElement or .my-class",
  "% (ajuste para 100%)": "% (adjust to 100%)",
  "% abaixo do desktop. Otimize sua experiência mobile.": "% below desktop. Optimize your mobile experience.",
  "% ainda assistindo": "% still watching",
  "% concluído": "% completed",
  "% convertem": "% convert",
  "% da audiência ainda está assistindo.": "% of the audience is still watching.",
  "% das views": "% of views",
  "% das visualizações": "% of views",
  "% de engajamento neste ponto": "% engagement at this point",
  "% de participação": "% share",
  "% de retenção": "% retention",
  "% de visitantes que deram play no vídeo. Avalia título + thumbnail.": "% of visitors who played the video. Evaluates title + thumbnail.",
  "% do horário de pico": "% of peak time",
  "% do limite": "% of limit",
  "% do pico": "% of peak",
  "% do pico do período": "% of the period's peak",
  "% do total": "% of total",
  "% do tráfego": "% of traffic",
  "% do vídeo": "% of video",
  "% dos espectadores saem aqui": "% of viewers leave here",
  "% dos espectadores saíram aqui": "% of viewers left here",
  "% dos plays do período.": "% of plays in the period.",
  "% engajamento": "% engagement",
  "% Engajamento": "% Engagement",
  "% médio de tempo assistido. Indica profundidade da retenção.": "% average watch time. Indicates retention depth.",
  "% OFF ativo": "% OFF active",
  "% PlayRate": "% PlayRate",
  "% retenção": "% retention",
  "% variação": "% change",
  "% vs 4 sem": "% vs 4 weeks",
  "% vs período anterior": "% vs previous period",
  "% vs. período anterior": "% vs. previous period",
  "• 3 fontes profissionais": "• 3 professional fonts",
  "• Analytics avançados": "• Advanced analytics",
  "• Animações CSS": "• CSS animations",
  "• As notificações funcionam mesmo com o navegador fechado (em segundo plano)": "• Notifications work even with the browser closed (in the background)",
  "• As preferências são salvas automaticamente ao alterar qualquer configuração": "• Preferences save automatically when you change any setting",
  "• Até 3 variações simultâneas": "• Up to 3 simultaneous variations",
  "• Código de embed": "• Embed code",
  "• Compressão automática": "• Auto compression",
  "• Configurações de qualidade": "• Quality settings",
  "• Controle total com código": "• Full control with code",
  "• Cores personalizáveis": "• Customizable colors",
  "• Cores que não contrastam:": "• Colors that don't contrast:",
  "• Crie urgência:": "• Create urgency:",
  "• CTR (Click-through Rate)": "• CTR (Click-through Rate)",
  "• Dispositivo principal: Mobile (65% das capturas)": "• Primary device: Mobile (65% of captures)",
  "• Divisão automática de tráfego": "• Automatic traffic split",
  "• Editor visual intuitivo": "• Intuitive visual editor",
  "• Engajamento": "• Engagement",
  "• Escalar campanhas entre 22h-24h": "• Scale campaigns between 22:00–24:00",
  "• Formatos PNG, JPEG, GIF": "• PNG, JPEG, GIF formats",
  "• Headlines genéricas:": "• Generic headlines:",
  "• Horário campeão: 22h-24h com 238 conversões": "• Winning time: 22:00–24:00 with 238 conversions",
  "• IMPORTANTE: Após a confirmação, os fundos podem levar até 3 dias úteis para constar em sua conta bancária.": "• IMPORTANT: After confirmation, funds may take up to 3 business days to appear in your bank account.",
  "• Integração com CDN": "• CDN integration",
  "• Integração com JS": "• JS integration",
  "• Investir mais em tráfego móvel (maior conversão)": "• Invest more in mobile traffic (higher conversion)",
  "• Layouts complexos": "• Complex layouts",
  "• Mantenha legível:": "• Keep it readable:",
  "• Métricas em tempo real": "• Real-time metrics",
  "• Múltiplos focos:": "• Multiple focuses:",
  "• O repasse será depositado na conta bancária padrão vinculada ao seu cadastro.": "• Payouts will be deposited into the default bank account linked to your registration.",
  "• O valor mínimo regulamentado para saques manuais é de": "• The regulated minimum amount for manual withdrawals is",
  "• Otimização de performance": "• Performance optimization",
  "• Para desenvolvedores": "• For developers",
  "• Posição que cobre conteúdo:": "• Position that covers content:",
  "• Preview em tempo real": "• Real-time preview",
  "• Seja específico:": "• Be specific:",
  "• Tamanho máximo: 2MB": "• Max size: 2MB",
  "• Tamanhos responsivos": "• Responsive sizes",
  "• Taxa de completude de dados: 92% (excelente)": "• Data completeness rate: 92% (excellent)",
  "• Taxa de conversão": "• Conversion rate",
  "• Taxas operacionais de saque serão debitadas de acordo com as regras internas do split.": "• Operational withdrawal fees will be deducted according to internal split rules.",
  "• Tempo médio de exibição": "• Avg. display time",
  "• Testar captura com senha neste horário": "• Test password capture at this time",
  "• Teste posições:": "• Test positions:",
  "• Texto muito longo:": "• Text too long:",
  "• Timing inadequado:": "• Poor timing:",
  "• Upload de imagens/GIFs": "• Upload images/GIFs",
  "• Use números:": "• Use numbers:",
  "• Use o botão \"Enviar Notificação Teste\" para verificar se está tudo funcionando": "• Use \"Send Test Notification\" to check that everything works",
  "• Use power words:": "• Use power words:",
  "• Versões desktop/mobile": "• Desktop/mobile versions",
  "• Você pode desativar notificações específicas sem perder as outras": "• You can disable specific notifications without losing the others",
  "© 2025 Host VSL": "© 2025 Host VSL",
  "© HostVSL. 2025. Todos os direitos reservados.": "© HostVSL. 2025. All rights reserved.",
  "← Voltar para Métricas": "← Back to Metrics",
  "→ Será salvo como:": "→ Will be saved as:",
  "→ Será salvo como: https://": "→ Will be saved as: https://",
  "+ Adicionar": "+ Add",
  "+ Adicionar ao Plano": "+ Add to Plan",
  "+ Adicionar mais": "+ Add more",
  "+ Adicionar parâmetro": "+ Add parameter",
  "+ Adicionar Plays Extras": "+ Add Extra Plays",
  "+ Adicionar vídeos": "+ Add videos",
  "+ Conectar Novo Pixel": "+ Connect New Pixel",
  "+ Conectar Plataforma": "+ Connect Platform",
  "+ Etapa": "+ Step",
  "+ Novo Vídeo": "+ New Video",
  "± 8% variação": "± 8% variation",
  "<div>Seu HTML aqui</div>": "<div>Your HTML here</div>",
  "<h1>Meu título personalizado</h1>&#10;Cole seu código HTML aqui...": "<h1>My custom title</h1>&#10;Paste your HTML code here...",
  "| Conta: ****": "| Account: ****",
  "⏰ Horário de pico": "⏰ Peak time",
  "⚛️ Componentes React": "⚛️ React Components",
  "⚠️ Alguns navegadores podem restringir o áudio automático mesmo após interação do visitante.": "⚠️ Some browsers may restrict automatic audio even after visitor interaction.",
  "⚠️ Aviso: Dados grandes": "⚠️ Warning: Large data",
  "⚠️ Este domínio já está cadastrado": "⚠️ This domain is already registered",
  "⚠️ O usuário ainda não configurou uma conta padrão!": "⚠️ The user has not configured a default account yet!",
  "⚠️ ÚLTIMA CHANCE!": "⚠️ LAST CHANCE!",
  "⚠️ Velocidades muito altas (acima de 1.5x) podem prejudicar a compreensão e confiança no conteúdo.": "⚠️ Very high speeds (above 1.5x) can hurt content comprehension and trust.",
  "⚡ Requisito: Autoplay Ativo": "⚡ Requirement: Autoplay enabled",
  "✅ \"{value0}\" foi movido com sucesso!": "✅ \"{value0}\" was moved successfully!",
  "✅ Faça": "✅ Do",
  "✅ Status: OK": "✅ Status: OK",
  "✅ Thumbnail adicionada com sucesso": "✅ Thumbnail added successfully",
  "✖ O domínio inserido não é válido": "✖ The domain entered is invalid",
  "✨ 15 dias grátis": "✨ 15 days free",
  "✨ Proteção geográfica configurada com sucesso!": "✨ Geographic protection configured successfully!",
  "✨ Proteção por região configurada com sucesso!": "✨ Regional protection configured successfully!",
  "❌ Erro ao importar": "❌ Error importing",
  "❌ Evite": "❌ Avoid",
  "❓ Como funciona": "❓ How it works",
  "⭐ Diferenciais Premium": "⭐ Premium Advantages",
  "🌍 Proteção por Localização": "🌍 Location Protection",
  "🌐 Environment:": "🌐 Environment:",
  "🎁 Bônus": "🎁 Bonus",
  "🎉 Notificações ativadas!": "🎉 Notifications enabled!",
  "🎉 Nova conversão!": "🎉 New conversion!",
  "🎥 Taxa de Reprodução": "🎥 Play Rate",
  "🎥 Vídeo:": "🎥 Video:",
  "🎨 Cores do Tema": "🎨 Theme Colors",
  "🎨 Modos de Criação": "🎨 Creation modes",
  "🎬 Vamos começar sua transformação em vídeo?": "🎬 Ready to start your video transformation?",
  "🎯 Configurações Netflix": "🎯 Netflix Settings",
  "🎯 Melhores Práticas": "🎯 Best practices",
  "🎯 O ideal": "🎯 Ideal",
  "🎯 O ideal: curva estável com retenção >50% até metade da VSL.": "🎯 Ideal: a stable curve with >50% retention until halfway through the VSL.",
  "🏆 Estratégias Avançadas": "🏆 Advanced Strategies",
  "🏆 Horário Campeão": "🏆 Winning Time",
  "🏆 Velocidade Campeã": "🏆 Champion Speed",
  "👑 Principal": "👑 Primary",
  "👤 Ações do Usuário": "👤 User Actions",
  "👤 Criador": "👤 Creator",
  "💡 Barra verde indica o \"Dia Campeão\"": "💡 Green bar indicates the \"Winning Day\"",
  "💡 Clique no vídeo para reproduzir/pausar e testar o formulário": "💡 Click the video to play/pause and test the form",
  "💡 Dica": "💡 Tip",
  "💡 Dica de Ouro": "💡 Pro Tip",
  "💡 Dica Inteligente": "💡 Smart Tip",
  "💡 Dica: Configure um teste na aba 'Teste A/B' para visualizar métricas comparativas por variação.": "💡 Tip: Configure a test in the 'A/B Test' tab to view comparative metrics by variation.",
  "💡 Dica: Configure um teste na aba \"Teste A/B\" para visualizar métricas comparativas por variação.": "💡 Tip: Configure a test in the \"A/B Test\" tab to view comparative metrics by variation.",
  "💡 Dicas de Templates": "💡 Template tips",
  "💡 Insight Automático": "💡 Automatic Insight",
  "💡 Insight do Dia": "💡 Daily Insight",
  "💡 Os vídeos são opcionais e serão aplicados conforme a ação escolhida.": "💡 Videos are optional and apply according to the selected action.",
  "💡 Pronto? Suba seu vídeo agora e surpreenda seus espectadores.": "💡 Ready? Upload your video now and surprise your viewers.",
  "💡 Recomendações": "💡 Recommendations",
  "💡 Sobre as notificações": "💡 About notifications",
  "💾 localStorage (persist)": "💾 localStorage (persist)",
  "📈 Engajamento": "📈 Engagement",
  "📊 Análise de Introduções": "📊 Intro Analysis",
  "📊 Análise de Retenção – VSLs Testadas": "📊 Retention Analysis – Tested VSLs",
  "📊 Interpretação das Métricas": "📊 Understanding Metrics",
  "📊 Interpretando os Resultados": "📊 Interpreting Results",
  "📊 Meta alcançada!": "📊 Goal achieved!",
  "📊 Métricas —": "📊 Metrics —",
  "📊 Métricas do Vídeo": "📊 Video Metrics",
  "📊 O teste está ativo, mas ainda não há métricas disponíveis. As métricas aparecerão assim que houver visualizações.": "📊 The test is active, but no metrics are available yet. Metrics will appear as soon as there are views.",
  "📊 Principais Insights": "📊 Key Insights",
  "📋 Como melhorar?": "📋 How to improve?",
  "📋 O que são Headlines/Subheadlines?": "📋 What are Headlines/Subheadlines?",
  "📋 Sugestões Avançadas": "📋 Advanced Suggestions",
  "📋 Ver Análise Educacional": "📋 View Educational Analysis",
  "📌 Sugestões": "📌 Suggestions",
  "📘 Como interpretar os dados do Teste A/B?": "📘 How to interpret A/B Test data?",
  "📘 Como interpretar?": "📘 How to interpret?",
  "📝 Rodapé": "📝 Footer",
  "📤 Upload iniciado": "📤 Upload started",
  "📦 Código de Incorporação": "📦 Embed Code",
  "📱 Mobile": "📱 Mobile",
  "📷 Personalização do Header": "📷 Header Customization",
  "🔁 Visualizações x Plays": "🔁 Views vs Plays",
  "🔒 Conexão segura • Dados criptografados • Suporte 24/7": "🔒 Secure connection • Encrypted data • 24/7 support",
  "🔒 Site seguro": "🔒 Secure site",
  "🔗 Botão Externo": "🔗 External Button",
  "🔥 Alto engajamento!": "🔥 High engagement!",
  "🔥 Engajamento": "🔥 Engagement",
  "🔥 Excelente desempenho! Alta taxa de play e engajamento sustentado. \n        💡 Sugestão: aumente gradualmente o tráfego para esta variação.": "🔥 Excellent performance! High play rate and sustained engagement. \n        💡 Suggestion: gradually increase traffic to this variation.",
  "🔧 Otimizações Comuns": "🔧 Common Optimizations",
  "🔴 Perda rápida nos primeiros segundos": "🔴 Rapid drop-off in the first few seconds",
  "🕐 Timestamp:": "🕐 Timestamp:",
  "🖥️ Desktop": "🖥️ Desktop",
  "🖼️ Favicon e Título": "🖼️ Favicon and Title",
  "🖼️ Logo da Playlist": "🖼️ Playlist Logo",
  "🗄️ Supabase (API)": "🗄️ Supabase (API)",
  "🧪 Notificação de teste": "🧪 Test notification",
  "🚀 Para continuar assistindo, preencha seus dados rápidos abaixo!": "🚀 To keep watching, quickly fill in your details below!",
  "🛡️ Código de Incorporação com Proteção": "🛡️ Protected Embed Code",
  "🛡️ Proteção por Domínio": "🛡️ Domain Protection",
  "🟡 Retenção cai significativamente aos 15-20s → promessa confusa?": "🟡 Retention drops significantly at 15–20s → unclear promise?",
  "🟢 Boa estabilidade de retenção ao longo do vídeo": "🟢 Good retention stability throughout the video",
  "$ {value0}": "$ {value0}",
  "0 = exibir até o final do vídeo": "0 = display until the video ends",
  "0 4px 16px rgba(0,0,0,0.08)": "0 4px 16px rgba(0,0,0,0.08)",
  "0 participantes": "0 participants",
  "001 - Banco do Brasil S.A.": "001 - Banco do Brasil S.A.",
  "004 - Banco do Nordeste do Brasil S.A.": "004 - Banco do Nordeste do Brasil S.A.",
  "02 JAN 2026": "02 JAN 2026",
  "021 - BANESTES S.A. Banco do Estado do Espírito Santo": "021 - BANESTES S.A. Banco do Estado do Espírito Santo",
  "033 - Banco Santander (Brasil) S.A.": "033 - Banco Santander (Brasil) S.A.",
  "041 - Banco do Estado do Rio Grande do Sul S.A. (Banrisul)": "041 - Banco do Estado do Rio Grande do Sul S.A. (Banrisul)",
  "070 - Banco de Brasília S.A. (BRB)": "070 - Banco de Brasília S.A. (BRB)",
  "077 - Banco Inter S.A.": "077 - Banco Inter S.A.",
  "085 - Cooperativa Central de Crédito Ailos": "085 - Cooperativa Central de Crédito Ailos",
  "09 JAN 2026": "09 JAN 2026",
  "1 = maior prioridade. Regras com maior prioridade são avaliadas primeiro.": "1 = highest priority. Higher-priority rules are evaluated first.",
  "1 linha": "1 line",
  "1 Play = R$": "1 Play = R$",
  "1 Play = R$ 0,02": "1 Play = R$ 0,02",
  "1 USD = BRL": "1 USD = BRL",
  "1. Crie o fluxo": "1. Create the flow",
  "1. Crie um teste": "1. Create a test",
  "1. Para PlayRate Baixo (abaixo de 45%):": "1. For Low PlayRate (below 45%):",
  "1. Pegue o seu link": "1. Get your link",
  "1. Selecione duas VSLs": "1. Select two VSLs",
  "1.0x (Normal)": "1.0x (Normal)",
  "1.8 GB": "1.8 GB",
  "10 minutos": "10 minutes",
  "10 p/ pág": "10 per page",
  "10 segundos": "10 seconds",
  "10% das comissões deles": "10% of their commissions",
  "100 p/ pág": "100 per page",
  "104 - Caixa Econômica Federal": "104 - Caixa Econômica Federal",
  "12% menos": "12% less",
  "136 - Confederação Nacional das Cooperativas Unicred": "136 - Confederação Nacional das Cooperativas Unicred",
  "15 dias grátis": "15 days free",
  "15 dias grátis — você só paga após o período de teste": "15 days free — you only pay after the trial period",
  "15 minutos": "15 minutes",
  "15 segundos": "15 seconds",
  "16 JAN 2026": "16 JAN 2026",
  "197 - Stone Co. (Stone Pagamentos)": "197 - Stone Co. (Stone Pagamentos)",
  "2 dias atrás": "2 days ago",
  "2 linhas": "2 lines",
  "2 segundos": "2 seconds",
  "2. Acompanhe os cliques": "2. Track clicks",
  "2. Analise os dados reais": "2. Analyze real data",
  "2. Distribução automática": "2. Automatic distribution",
  "2. Distribuição automática": "2. Automatic distribution",
  "2. Envie os vídeos": "2. Upload the videos",
  "2. Para Engajamento Baixo (abaixo de 50%):": "2. For Low Engagement (below 50%):",
  "20 p/ pág": "20 per page",
  "20% de comissão recorrente": "20% recurring commission",
  "208 - Banco BTG Pactual S.A.": "208 - Banco BTG Pactual S.A.",
  "20px": "20px",
  "212 - Banco Original S.A.": "212 - Banco Original S.A.",
  "23 JAN 2026": "23 JAN 2026",
  "237 - Banco Bradesco S.A.": "237 - Banco Bradesco S.A.",
  "25 p/ pág": "25 per page",
  "25% recorrente": "25% recurring",
  "26 DEZ 2025": "26 DEC 2025",
  "260 - Nu Pagamentos S.A. (Nubank)": "260 - Nu Pagamentos S.A. (Nubank)",
  "290 - Pagseguro Internet S.A. (PagBank)": "290 - Pagseguro Internet S.A. (PagBank)",
  "3 dias úteis": "3 business days",
  "3 linhas": "3 lines",
  "3 segundos": "3 seconds",
  "3. Análise de métricas": "3. Metrics analysis",
  "3. Identifique a vencedora": "3. Identify the winner",
  "3. Monte as etapas": "3. Build the steps",
  "3. Para Cliques Baixos no CTA:": "3. For Low CTA Clicks:",
  "3. Receba os pagamentos": "3. Receive payments",
  "30 dias": "30 days",
  "30 minutos": "30 minutes",
  "30.000 plays por mês": "30,000 plays per month",
  "30px": "30px",
  "323 - Mercado Pago Caixa Eletrônica do MP Ltda.": "323 - Mercado Pago Caixa Eletrônica do MP Ltda.",
  "336 - Banco C6 S.A. (C6 Bank)": "336 - Banco C6 S.A. (C6 Bank)",
  "341 - Itaú Unibanco S.A.": "341 - Itaú Unibanco S.A.",
  "389 - Banco Mercantil do Brasil S.A.": "389 - Banco Mercantil do Brasil S.A.",
  "390 × 844 · iPhone": "390 × 844 · iPhone",
  "399 - Kirton Bank S.A. (Banco Múltiplo)": "399 - Kirton Bank S.A. (Banco Múltiplo)",
  "4. Identifique o vencedor": "4. Identify the winner",
  "4. Otimize suas decisões": "4. Optimize your decisions",
  "4. Personalize o player": "4. Customize the player",
  "403 - Cora Sociedade de Crédito Direto S.A.": "403 - Cora Sociedade de Crédito Direto S.A.",
  "422 - Banco Safra S.A.": "422 - Banco Safra S.A.",
  "5 minutos": "5 minutes",
  "5 segundos": "5 seconds",
  "5. Publique e cole o código": "5. Publish and paste the code",
  "50 p/ pág": "50 per page",
  "50% OFF": "50% OFF",
  "536 - Neon Pagamentos S.A. (Banco Neon)": "536 - Neon Pagamentos S.A. (Banco Neon)",
  "5px": "5px",
  "6 cards premium com métricas essenciais": "6 premium cards with essential metrics",
  "6. Acompanhe as métricas": "6. Track metrics",
  "6.000 plays por mês": "6,000 plays per month",
  "60.000 plays por mês": "60,000 plays per month",
  "623 - Banco Pan S.A.": "623 - Banco Pan S.A.",
  "637 - Banco Sofisa S.A.": "637 - Banco Sofisa S.A.",
  "65% = VSL magnética.": "65% = a magnetic VSL.",
  "655 - Banco Votorantim S.A. (Banco BV)": "655 - Banco Votorantim S.A. (Banco BV)",
  "67% dos visitantes entram neste ponto": "67% of visitors enter at this point",
  "7 dias": "7 days",
  "745 - Banco Citibank S.A.": "745 - Banco Citibank S.A.",
  "748 - Banco Cooperativo Sicredi S.A.": "748 - Banco Cooperativo Sicredi S.A.",
  "756 - Banco Cooperativo do Brasil S.A. (Sicoob)": "756 - Banco Cooperativo do Brasil S.A. (Sicoob)",
  "756 - Banco Ourinvest S.A. (Nomad)": "756 - Banco Ourinvest S.A. (Nomad)",
  "80% das vagas preenchidas": "80% of spots filled",
  "820 × 1180 · iPad": "820 × 1180 · iPad",
  "90 dias": "90 days",
  "A = Ativo": "A = Active",
  "A Academy chegou para acelerar seu domínio da plataforma. Trilha organizada por módulos, com aulas curtas e objetivas sobre cada recurso, do básico ao avançado, com progresso salvo automaticamente.": "Academy is here to help you master the platform faster. A learning path organized into modules, with short, focused lessons on each feature, from beginner to advanced, and automatically saved progress.",
  "A agência deve conter exatamente 4 dígitos.": "The branch number must contain exactly 4 digits.",
  "A aplicação utiliza uma arquitetura de componentes modular, com componentes reutilizáveis organizados por domínio.": "The application uses a modular component architecture, with reusable components organized by domain.",
  "A borda será aplicada ao redor do player conforme largura e cor escolhidas.": "The border will be applied around the player using the selected width and color.",
  "A Builderall oferece a plataforma mais completa de marketing e automação para você expandir seus negócios.": "Builderall offers a comprehensive marketing and automation platform to grow your business.",
  "A cada visitante, uma nova intro é exibida aleatoriamente para coleta de dados.": "Each visitor is shown a randomly selected intro to collect data.",
  "A captura foi desativada com sucesso.": "Capture was successfully disabled.",
  "A captura por senha foi configurada com sucesso.": "Password capture was successfully configured.",
  "A captura por senha foi desativada com sucesso.": "Password capture was successfully disabled.",
  "A configuração de Teste A/B foi movida para a aba \"Teste A/B\" no menu de configurações do Autoplay.": "A/B Test settings have moved to the \"A/B Test\" tab in the Autoplay settings menu.",
  "A conta informada deve pertencer ao mesmo titular do CPF cadastrado.": "The account must belong to the same holder as the registered CPF.",
  "A conta precisa de atenção ou envio de novos documentos.": "The account needs attention or additional documents.",
  "A contagem será exibida automaticamente com base no tempo definido.": "The countdown will be displayed automatically based on the time set.",
  "A curva mostra o play rate de cada hora": "The curve shows the play rate for each hour",
  "A data de término foi atingida e o teste foi encerrado.": "The end date was reached and the test has ended.",
  "A data não pode ser no passado.": "The date cannot be in the past.",
  "A distribuição de tráfego foi atualizada com sucesso": "Traffic distribution updated successfully",
  "A distribuição de tráfego foi atualizada com sucesso.": "Traffic distribution was successfully updated.",
  "A distribuição precisa somar 100%": "Distribution must total 100%",
  "A distribuição precisa totalizar 100%": "Distribution must total 100%",
  "A estratégia foi {value0}.": "The strategy was {value0}.",
  "A estratégia foi atualizada com sucesso.": "Strategy updated successfully.",
  "A etapa {value0} não é alcançada a partir do início.": "Step {value0} cannot be reached from the start.",
  "A etapa {value0} não tem vídeo.": "Step {value0} has no video.",
  "A exclusão de registros estará disponível em breve.": "Deleting records will be available soon.",
  "A Ferramenta Mais Fácil Para Criar Chatbots Sem Código Do Brasil. Agora você pode automatizar seu marketing, geração de lead, atendimento e muito mais com um robô.": "Brazil's Easiest Tool for Creating No-Code Chatbots. Now you can automate marketing, lead generation, customer service, and more with a bot.",
  "A FunnelX é a nossa ferramenta para criar quizzes interativos de alta performance. Engaje sua audiência, qualifique leads e direcione cada pessoa para a oferta certa, com lógica condicional e visual premium.": "FunnelX is our tool for creating high-performing interactive quizzes. Engage your audience, qualify leads, and guide each person to the right offer with conditional logic and premium visuals.",
  "A Host VSL entrou em uma nova fase. O Front 2.0 foi criado para quem quer operar com mais clareza, mais velocidade e mais controle.": "Host VSL has entered a new phase. Front 2.0 was created for those who want greater clarity, speed, and control.",
  "A Host VSL entrou em uma nova fase. O Front 2.0 foi criado para quem quer operar com mais clareza, mais velocidade e mais controle. Tudo ficou mais consistente, mais fluido e pronto para acompanhar o crescimento de quem escala vendas todos os dias.": "Host VSL has entered a new phase. Front 2.0 was created for those who want greater clarity, speed, and control. Everything is more consistent, smoother, and ready to grow with those who scale sales every day.",
  "A Host VSL Transforma Recursos em Resultados": "Host VSL Turns Features into Results",
  "A HostVSL funciona em sistema pré-pago. Você paga antecipadamente pelo seu plano e pelos plays inclusos. Se precisar de mais plays, pode comprá-los avulsos ou configurar a recarga automática.": "HostVSL operates on a prepaid basis. You pay in advance for your plan and included plays. If you need more plays, you can buy them separately or set up automatic top-ups.",
  "A HostVSL segue um design system premium inspirado na Apple, com foco em minimalismo, elegância e consistência visual.": "HostVSL follows a premium design system inspired by Apple, focused on minimalism, elegance, and visual consistency.",
  "A HostVSL utiliza Zustand para gerenciamento de estado global. Cada store é responsável por um domínio específico da aplicação, com persistência automática via localStorage quando necessário.": "HostVSL uses Zustand for global state management. Each store handles a specific application domain, with automatic localStorage persistence when needed.",
  "A imagem deve ter no máximo 2MB": "The image must be no larger than 2MB",
  "A imagem foi enviada e salva com sucesso": "The image was successfully uploaded and saved",
  "A integração com {value0} foi configurada.": "The {value0} integration has been configured.",
  "A legenda ficará desativada para o espectador.": "Subtitles will be disabled for the viewer.",
  "A legenda já começa ativa quando o vídeo carregar": "Subtitles start active when the video loads",
  "A linha vertical amarela indica o ponto do pitch de vendas": "The yellow vertical line indicates the sales pitch point",
  "A logo foi enviada e salva com sucesso": "The logo was successfully uploaded and saved",
  "A logo foi removida com sucesso": "The logo was successfully removed",
  "A maioria dos espectadores inicia o vídeo do começo. Otimize seus primeiros 10 segundos para maximizar a retenção.": "Most viewers start watching from the beginning. Optimize your first 10 seconds to maximize retention.",
  "A melhorar": "Needs improvement",
  "A notificação pode virar um link clicável que abre a sua oferta em uma nova aba": "The notification can become a clickable link that opens your offer in a new tab",
  "A nova thumbnail foi aplicada à sua playlist.": "The new thumbnail has been applied to your playlist.",
  "A pasta \"{value0}\" foi criada com sucesso.": "Folder \"{value0}\" was successfully created.",
  "A pausa precisa vir depois de as opções aparecerem.": "The pause must come after the options appear.",
  "A pausa também foi removida: ela depende de quando as opções aparecem.": "The pause was also removed: it depends on when the options appear.",
  "A plataforma integra com Supabase para backend (autenticação, banco de dados, storage) e utiliza React Query para cache e sincronização de dados.": "The platform integrates with Supabase for its backend (authentication, database, storage) and uses React Query for data caching and synchronization.",
  "A playlist foi removida com sucesso.": "The playlist was successfully removed.",
  "A playlist precisa ter pelo menos 1 vídeo para gerar a thumbnail.": "The playlist needs at least 1 video to generate a thumbnail.",
  "A playlist precisa ter pelo menos 1 vídeo.": "The playlist needs at least 1 video.",
  "A playlist que você está procurando não existe ou foi removida.": "The playlist you are looking for does not exist or has been removed.",
  "A prévia para marcar os tempos aparece assim que o vídeo começar a ficar pronto. Enquanto isso, você pode digitar os tempos.": "The preview for marking timestamps appears as soon as the video starts becoming ready. In the meantime, you can enter timestamps manually.",
  "A prioridade dos testes foi alterada": "Test priority has changed",
  "A processar...": "Processing...",
  "a qualquer momento.": "at any time.",
  "A queda acentuada no início sugere que seu gancho não está forte o suficiente. Teste um problema mais urgente ou curiosidade mais intensa.": "The sharp drop at the start suggests your hook is not strong enough. Test a more urgent problem or a stronger curiosity hook.",
  "A regra do cloaker foi atualizada.": "The cloaker rule has been updated.",
  "A regra foi excluída com sucesso": "Rule deleted successfully",
  "A reprodução automática cria a sensação de início imediato, aumentando o engajamento dos usuários. O vídeo começa sem som para cumprir as políticas dos navegadores, e o overlay incentiva a ativação do áudio.": "Autoplay creates a sense of immediate start, boosting user engagement. The video begins muted to comply with browser policies, and the overlay encourages audio activation.",
  "A senha deve ter pelo menos 6 caracteres": "The password must be at least 6 characters long",
  "A senha deve ter pelo menos 6 caracteres.": "The password must be at least 6 characters long.",
  "A solução perfeita para aumentar suas vendas! Com SMS Funnel você divulga seu produto ou serviço em tempo real para todo Brasil e todas as operadoras.": "The perfect solution to increase your sales! With SMS Funnel, you can promote your product or service in real time across Brazil and all mobile carriers.",
  "A soma da distribuição de tráfego deve ser 100%": "Traffic distribution must sum to 100%",
  "A thumbnail de final foi configurada": "The end thumbnail has been set",
  "A thumbnail de início foi configurada": "The start thumbnail has been set",
  "A thumbnail foi removida": "The thumbnail has been removed",
  "A thumbnail foi removida com sucesso": "The thumbnail was successfully removed",
  "A thumbnail inicial só funciona se os Controles de Vídeo estiverem ativados. Ative os Controles nas configurações.": "The initial thumbnail only works when Video Controls are enabled. Enable Controls in settings.",
  "A URL deve começar com http:// ou https://": "The URL must start with http:// or https://",
  "A URL não pode estar vazia": "The URL cannot be empty",
  "A venda será contabilizada para o afiliado detentor do último link acessado pelo cliente antes do registo.": "The sale will be credited to the affiliate whose link the customer last visited before registering.",
  "A verificar conta...": "Verifying account...",
  "A versão no ar já é igual ao rascunho.": "The live version already matches the draft.",
  "A versão publicada continua no ar como está.": "The published version remains live as it is.",
  "A VSL protegida não foi encontrada.": "The protected VSL was not found.",
  "Abaixo": "Below",
  "Abaixo de 45%:": "Below 45%:",
  "Abaixo de 50%:": "Below 50%:",
  "Abaixo do vídeo": "Below the video",
  "Abaixo do Vídeo": "Below the Video",
  "Abertura do link": "Link opening",
  "Abra a pré-visualização e percorra os caminhos como um visitante. Também dá para começar por uma etapa específica. A prévia não contabiliza plays e mostra o endereço das saídas sem abrir a página. Confira a aba Problemas e resolva as pendências antes de publicar.": "Open the preview and follow paths as a visitor. You can also start from a specific step. The preview does not count plays and shows exit addresses without opening the page. Check the Issues tab and resolve outstanding items before publishing.",
  "Abra as métricas do fluxo para entender quantas pessoas começaram a assistir, por quais etapas passaram e quais opções escolheram. Na aba Vídeos, selecione um vídeo para analisar sua curva de retenção, a duração, a retenção média e a quantidade de plays usada na análise.": "Open flow metrics to understand how many people started watching, which steps they visited, and which options they chose. In the Videos tab, select a video to analyze its retention curve, duration, average retention, and the number of plays used in the analysis.",
  "Abra no computador para editar": "Open on a computer to edit",
  "Abra o app direto da tela inicial, sem precisar abrir o navegador": "Open the app directly from your home screen without opening the browser",
  "Abra o seletor do Google e marque os vídeos. Eles entram direto na fila de envio.": "Open the Google picker and select the videos. They go straight into the upload queue.",
  "Abre o vídeo em tela cheia ao clicar no overlay": "Opens the video in full screen when the overlay is clicked",
  "Abre uma URL ao clicar na notificação.": "Opens a URL when the notification is clicked.",
  "Abrindo preview do vídeo {value0}": "Opening preview for video {value0}",
  "Abrir": "Open",
  "Abrir em": "Open in",
  "Abrir em nova aba": "Open in a new tab",
  "Abrir em nova guia": "Open in a new tab",
  "Abrir link": "Open link",
  "Abrir link do botão em nova aba": "Open button link in a new tab",
  "Abrir menu": "Open menu",
  "Abrir menu de ações": "Open actions menu",
  "Abrir menu de conta": "Open account menu",
  "Abrir Modal de Incorporação": "Open Embed Dialog",
  "Abrir na mesma aba": "Open in the same tab",
  "Abrir nova aba": "Open new tab",
  "Abrir Original": "Open Original",
  "Abrir página": "Open page",
  "Abrir pasta": "Open folder",
  "Abrir playlist {value0}": "Open playlist {value0}",
  "Abrir URL": "Open URL",
  "Abrir URL em nova aba": "Open URL in a new tab",
  "Abrir vídeo agora": "Open video now",
  "Abrir Vídeos Compartilhados": "Open Shared Videos",
  "Academy": "Academy",
  "Academy com tutoriais": "Academy with tutorials",
  "Ação": "Action",
  "Ação & Destino": "Action & Destination",
  "Ação aplicada:": "Action applied:",
  "Ação Ativada": "Action Enabled",
  "Ação atualizada com sucesso!": "Action updated successfully!",
  "Ação criada com sucesso!": "Action created successfully!",
  "Ação de Play obrigatória, disparada no primeiro play do vídeo": "Required Play action, triggered on the video's first play",
  "Ação do botão": "Button action",
  "Ação excluída com sucesso!": "Action deleted successfully!",
  "Ação quando zerar": "Action when time runs out",
  "Ação:": "Action:",
  "Accordion de Estilo Avançado agora inicia aberto por padrão. Texto atualizado de \"overlay\" para \"Autoplay\".": "The Advanced Style accordion now opens by default. Text updated from \"overlay\" to \"Autoplay\".",
  "Aceita HTML e CSS inline. Scripts não são permitidos.": "Accepts HTML and inline CSS. Scripts are not allowed.",
  "Aceita Vimeo, Bunny, Cloudflare ou MP4 direto": "Accepts Vimeo, Bunny, Cloudflare, or a direct MP4",
  "Aceita: seusite.com, www.seusite.com ou https://seusite.com": "Accepts: yoursite.com, www.yoursite.com or https://yoursite.com",
  "Aceitar e adicionar": "Accept and add",
  "Aceite de uso": "Usage consent",
  "Aceito os termos de uso e a política de privacidade": "I accept the terms of use and privacy policy",
  "Acelere levemente o meio do vídeo": "Slightly speed up the middle of the video",
  "Acelere momentos menos importantes e destaque momentos chave com ritmo mais lento e foco.": "Speed up less important moments and highlight key moments with slower pacing and focus.",
  "Acessando...": "Accessing...",
  "Acessar": "Access",
  "Acessar central de ajuda": "Open help center",
  "Acessar o checkout não significa comprar. A Taxa de acesso ao checkout mede esse avanço no funil; ela é diferente da Conversão em venda. Para acompanhar vendas aprovadas e receita atribuída, use Conectar rastreamento, escolha a saída de checkout e a plataforma de vendas e siga as instruções para cadastrar o webhook na plataforma, direcionado às compras desse checkout. Sem conexão, os indicadores de vendas aparecem como “—”.": "Visiting checkout does not mean purchasing. The Checkout Visit Rate measures this step in the funnel; it differs from Sales Conversion. To track approved sales and attributed revenue, use Connect tracking, choose the checkout exit and sales platform, and follow the instructions to register the webhook for purchases from that checkout. Without a connection, sales indicators appear as “—”.",
  "Acessar vídeo": "Access video",
  "Acesse a sua conta": "Access your account",
  "Acesse Métricas para ver detalhes por vídeo": "Open Metrics for details by video",
  "Acesse Métricas para ver por vídeo": "Open Metrics to view by video",
  "Acesse o conteúdo e receba o link no seu e-mail": "Access the content and receive the link by email",
  "Acesse o vídeo": "Access video",
  "Acesse pelo menu lateral em Análises → Tempo Real": "Open Analytics → Real Time in the sidebar",
  "Acesse pelo seu avatar, no canto superior direito, em \"Membros\"": "Open \"Members\" through your avatar in the upper-right corner",
  "Acesse suas métricas e vídeos diretamente da tela inicial do seu dispositivo. Funciona offline e carrega instantaneamente!": "Access your metrics and videos directly from your device's home screen. Works offline and loads instantly!",
  "Acesse suas métricas mesmo sem conexão com a internet": "Access your metrics even without an internet connection",
  "Acesse Teste de hook para otimizar retenção": "Open Hook Testing to optimize retention",
  "Acesse uma trilha completa de aulas para dominar todos os recursos da Host VSL.": "Access a complete learning path to master every Host VSL feature.",
  "Acesse VSL Dinâmica no menu do painel e monte o primeiro caminho do seu funil.": "Open Dynamic VSL from the dashboard menu and build the first path in your funnel.",
  "Acessibilidade e retenção em um só recurso.": "Accessibility and retention in a single feature.",
  "Acesso bloqueado": "Access blocked",
  "Acesso de Suporte": "Support Access",
  "Acesso Facilitado": "Easy Access",
  "Acesso permitido": "Access allowed",
  "Acesso por pasta: libere só as pastas de vídeos que aquela pessoa precisa": "Folder access: allow only the video folders each person needs",
  "Acesso Rápido": "Quick Access",
  "Acesso Rota": "Route Access",
  "Acesso total, incluindo gestão de usuários": "Full access, including user management",
  "Acesso total, incluindo gestão de usuários e faturamento": "Full access, including user and billing management",
  "Acessos ao checkout": "Checkout visits",
  "acessos protegidos": "protected visits",
  "Acessos sem UTM aparecem como “Direto” na tabela, mas não têm curva de retenção no gráfico.": "Visits without UTMs appear as “Direct” in the table, but do not have a retention curve in the chart.",
  "Acessos únicos": "Unique visits",
  "Acessos únicos ao checkout": "Unique checkout visits",
  "Acessou a Sala": "Entered the Room",
  "Acima": "Above",
  "Acima de 65%:": "Above 65%:",
  "Acima de 70%:": "Above 70%:",
  "Acionar vendas simuladas": "Trigger simulated sales",
  "Ações": "Actions",
  "ações configuradas": "configured actions",
  "Ações Configuradas (": "Configured Actions (",
  "Ações de Pitch (quando a oferta aparece) e Checkout (clique no botão de compra) opcionais": "Optional Pitch (when the offer appears) and Checkout (purchase button click) actions",
  "Ações do vídeo": "Video actions",
  "Ações do vídeo {value0}": "Actions for video {value0}",
  "Ações geradas": "Actions generated",
  "Ações Necessárias": "Required Actions",
  "Acompanhe a performance detalhada do seu webinário.": "Track your webinar's detailed performance.",
  "Acompanhe a performance dos seus vídeos.": "Track your videos' performance.",
  "Acompanhe a saúde de cada pixel: registrando, mudo há mais de 24h ou aguardando o 1º disparo": "Track each pixel's health: recording, silent for over 24h, or awaiting its first event",
  "Acompanhe as métricas individuais de cada vídeo deste teste.": "Track individual metrics for each video in this test.",
  "Acompanhe cada lead em um pipeline visual com histórico completo.": "Track every lead in a visual pipeline with a complete history.",
  "Acompanhe cópias por dia, top estados e histórico completo de eventos": "Track daily copies, top states, and complete event history",
  "Acompanhe de forma visual e intuitiva cada etapa da jornada do espectador. O funil mostra desde os carregamentos da página até as conversões finais, com percentuais e valores absolutos para cada etapa.": "Visually and intuitively track every stage of the viewer journey. The funnel shows everything from page loads to final conversions, with percentages and absolute values for each stage.",
  "Acompanhe entradas, plays, escolhas, acessos às saídas e a retenção de cada vídeo nas métricas do fluxo.": "Track entries, plays, choices, exit visits, and retention for each video in flow metrics.",
  "Acompanhe métricas de compartilhamento": "Track sharing metrics",
  "Acompanhe o desempenho das suas VSL's em tempo real": "Track your VSL performance in real time",
  "Acompanhe os padrões que mais convertem": "Track the patterns that convert best",
  "Acompanhe qual variação converte mais.": "Track which variation converts best.",
  "Acompanhe quantos acessos cada proteção já bloqueou direto nos cards": "See how many visits each protection has blocked directly in the cards",
  "Acompanhe seu consumo de plays mensais": "Track your monthly play usage",
  "Acompanhe todas as atualizações e novos recursos da Host VSL": "Follow all Host VSL updates and new features",
  "Acompanhe todas as conversões em um só painel.": "Track all conversions in one dashboard.",
  "Acompanhe todas as vendas em tempo real": "Track all sales in real time",
  "Acompanhe visualizações, engajamento, cliques e outras métricas importantes para cada variante.": "Track views, engagement, clicks, and other important metrics for each variant.",
  "Acompanhe visualizações, engajamento, retenção e outras métricas importantes para cada introdução.": "Track views, engagement, retention, and other important metrics for each intro.",
  "Acumulado": "Cumulative",
  "Acumulado por todos os afiliados.": "Accumulated by all affiliates.",
  "Adapte o formato Atenção, Interesse, Desejo e Ação para sua narrativa em vídeo.": "Adapt the Attention, Interest, Desire, and Action framework to your video narrative.",
  "Add to favorites": "Add to favorites",
  "Adiciona blur sutil ao vídeo de fundo": "Adds subtle blur to the background video",
  "Adiciona botão para avançar 10 segundos no vídeo": "Adds a button to skip forward 10 seconds in the video",
  "Adiciona botão para retroceder 10 segundos no vídeo": "Adds a button to rewind 10 seconds in the video",
  "Adiciona efeito pulsante para chamar atenção": "Adds a pulsing effect to attract attention",
  "Adiciona sombras nos cards para maior profundidade": "Adds card shadows for greater depth",
  "Adiciona um botão nos controles que abre o seletor nativo de dispositivos do navegador (AirPlay no Safari, Chromecast no Chrome). Só aparece pra quem tem receptor compatível na rede.": "Adds a control button that opens the browser's native device picker (AirPlay in Safari, Chromecast in Chrome). Only appears for viewers with a compatible receiver on their network.",
  "Adiciona uma camada colorida sobre o vídeo quando o formulário aparece. A cor é definida em \"Background do Vídeo\" acima": "Adds a colored layer over the video when the form appears. The color is set in \"Video Background\" above",
  "Adicionada aba \"Parceiros\" com ícone Handshake no menu lateral desktop (Sidebar) e mobile (DrawerContent), posicionada após \"Membros\".": "Added a \"Partners\" tab with the Handshake icon to the desktop sidebar (Sidebar) and mobile menu (DrawerContent), positioned after \"Members\".",
  "Adicionamos um novo botão de transmissão para Smart TV nos controles do player. Com ele ativo, seu espectador clica e escolhe transmitir o vídeo pra uma Chromecast (no Chrome) ou Apple TV/AirPlay (no Safari) que esteja na mesma rede Wi-Fi. Ótimo pra ofertas high-ticket onde o cliente quer assistir junto com cônjuge ou sócio antes de fechar.": "We added a new Smart TV casting button to the player controls. When enabled, viewers can click it to cast the video to a Chromecast (in Chrome) or Apple TV/AirPlay (in Safari) on the same Wi-Fi network. Great for high-ticket offers where customers want to watch with their spouse or business partner before buying.",
  "Adicionando...": "Adding...",
  "Adicionar": "Add",
  "Adicionar 10 exemplos": "Add 10 examples",
  "Adicionar aos favoritos": "Add to favorites",
  "Adicionar Aula": "Add Lesson",
  "Adicionar Bônus": "Add Bonus",
  "Adicionar borda": "Add border",
  "Adicionar Campo Extra": "Add Extra Field",
  "Adicionar cartão": "Add Card",
  "Adicionar Cartão": "Add Card",
  "Adicionar classe": "Add class",
  "Adicionar imagem": "Add image",
  "Adicionar Intros": "Add Intros",
  "Adicionar legenda": "Add captions",
  "Adicionar Link": "Add Link",
  "Adicionar logo": "Add logo",
  "Adicionar Membro": "Add Member",
  "Adicionar Mini Hook": "Add Mini Hook",
  "Adicionar Módulo": "Add Module",
  "Adicionar novo cartão": "Add new card",
  "Adicionar novos campos": "Add new fields",
  "Adicionar opção": "Add option",
  "Adicionar pagamento": "Add payment",
  "Adicionar País": "Add Country",
  "Adicionar parâmetros UTM": "Add UTM parameters",
  "Adicionar pitch": "Add pitch",
  "Adicionar Pixel": "Add Pixel",
  "Adicionar Plataforma": "Add Platform",
  "Adicionar Plays ao Plano": "Add Plays to Plan",
  "Adicionar primeiro domínio": "Add first domain",
  "Adicionar Primeiro Membro": "Add First Member",
  "Adicionar Primeiro Vídeo": "Add First Video",
  "Adicionar Região": "Add Region",
  "Adicionar regra UTM": "Add UTM rule",
  "Adicionar Regra UTM": "Add UTM Rule",
  "Adicionar sombra": "Add shadow",
  "Adicionar sombra externa": "Add outer shadow",
  "Adicionar texto personalizado": "Add custom text",
  "Adicionar um botão abaixo do vídeo da playlist para enviar o usuário a um link externo.": "Add a button below the playlist video to send users to an external link.",
  "Adicionar UTM": "Add UTM",
  "Adicionar Variação": "Add Variation",
  "Adicionar vídeo": "Add video",
  "Adicionar vídeo por URL": "Add video by URL",
  "Adicionar vídeos": "Add videos",
  "Adicionar Vídeos": "Add Videos",
  "Adicionar...": "Add...",
  "Adicione a sua marca ao vídeo e controle posição, tamanho, transparência e link de destino.": "Add your brand to the video and control its position, size, transparency, and destination link.",
  "Adicione arquivos de legenda ao vídeo para melhorar acessibilidade e retenção do público.": "Add caption files to the video to improve accessibility and audience retention.",
  "Adicione as introduções que você deseja testar com o vídeo principal. Você pode adicionar quantas introduções desejar.": "Add the intros you want to test with the main video. You can add as many intros as you like.",
  "Adicione até": "Add up to",
  "Adicione aulas a este módulo no painel de edição": "Add lessons to this module in the editing panel",
  "Adicione Botões": "Add Buttons",
  "Adicione cidades para usar a variável {cidade}": "Add cities to use the {cidade} variable",
  "Adicione código HTML para visualizar": "Add HTML code to preview",
  "Adicione domínios para proteger sua VSL": "Add domains to protect your VSL",
  "Adicione e organize os vídeos da sua playlist": "Add and organize your playlist videos",
  "Adicione elementos de \"open loops\" para manter curiosidade": "Add open loops to maintain curiosity",
  "Adicione elementos de escassez": "Add scarcity elements",
  "Adicione elementos de urgência ou escassez antes do botão": "Add urgency or scarcity elements before the button",
  "Adicione elementos gráficos ou pausas dramáticas nos momentos pré-CTA para aumentar conversões.": "Add graphics or dramatic pauses before the CTA to increase conversions.",
  "Adicione elementos visuais": "Add visual elements",
  "Adicione elementos visuais para reforçar os pontos principais": "Add visual elements to reinforce key points",
  "Adicione essa oferta ao seu pedido agora e aproveite por apenas:": "Add this offer to your order now for only:",
  "Adicione essa oferta ao seu pedido antes de continuar": "Add this offer to your order before continuing",
  "Adicione este cupom no checkout do plano que você gostar.": "Apply this coupon at checkout for your preferred plan.",
  "Adicione headlines persuasivas ao player.": "Add persuasive headlines to the player.",
  "Adicione imagens específicas para desktop e mobile": "Add separate images for desktop and mobile",
  "Adicione introduções ao seu teste para visualizar métricas.": "Add intros to your test to view metrics.",
  "Adicione legendas .VTT ou .SRT ao seu vídeo.": "Add .VTT or .SRT captions to your video.",
  "Adicione legendas aos seus vídeos com suporte a arquivos .VTT e .SRT. Edite textos e tempos diretamente no painel, reordene blocos e escolha entre 4 animações de exibição.": "Add captions to your videos with .VTT and .SRT file support. Edit text and timing directly in the panel, reorder blocks, and choose from 4 display animations.",
  "Adicione legendas para melhorar a acessibilidade.": "Add subtitles to improve accessibility.",
  "Adicione legendas sincronizadas ao seu vídeo. Suporta .SRT e .VTT.": "Add synchronized captions to your video. Supports .SRT and .VTT.",
  "Adicione links de termos, privacidade, etc.": "Add links to terms, privacy policies, etc.",
  "Adicione nomes para usar a variável {nome}": "Add names to use the {nome} variable",
  "Adicione o produto para usar a variável {produto}": "Add a product to use the {produto} variable",
  "Adicione observações internas sobre este pagamento.": "Add internal notes about this payment.",
  "Adicione observações sobre esta regra...": "Add notes about this rule...",
  "Adicione padrões de interrupção": "Add pattern interrupts",
  "Adicione pelo menos 1 vídeo para ativar": "Add at least 1 video to enable",
  "Adicione pelo menos um nome": "Add at least one name",
  "Adicione pelo menos uma cidade": "Add at least one city",
  "Adicione pelo menos uma opção antes de pausar.": "Add at least one option before pausing.",
  "Adicione profundidade e destaque ao player.": "Add depth and emphasis to the player.",
  "Adicione sua logo marca no vídeo": "Add your brand logo to the video",
  "Adicione títulos chamativos com upload de imagem e A/B test integrado": "Add eye-catching titles with image uploads and built-in A/B testing",
  "Adicione um botão de compra ou call-to-action": "Add a purchase or call-to-action button",
  "Adicione um botão secundário, como WhatsApp": "Add a secondary button, such as WhatsApp",
  "Adicione um pixel para começar a rastrear conversões nos seus vídeos.": "Add a pixel to start tracking conversions on your videos.",
  "Adicione um vídeo": "Add a video",
  "Adicione uma borda animada e personalizada": "Add a custom animated border",
  "Adicione uma borda colorida em volta do thumbnail para destacar": "Add a colored border around the thumbnail to make it stand out",
  "Adicione uma conta para receber seus saques.": "Add an account to receive your withdrawals.",
  "Adicione uma descrição para ajudar a lembrar do objetivo deste teste...": "Add a description to help you remember the purpose of this test...",
  "Adicione uma mensagem": "Add a message",
  "Adicione uma mensagem extra no rodapé (opcional)": "Add an extra footer message (optional)",
  "Adicione uma pergunta de engajamento aos 25s para reter atenção": "Add an engagement question at 25s to maintain attention",
  "Adicione uma saída de checkout no editor para conectar o rastreamento.": "Add a checkout exit in the editor to connect tracking.",
  "Adicione vários hooks com tempo de início e fim independentes": "Add multiple hooks with independent start and end times",
  "Adicione vídeos": "Add videos",
  "Adicione vídeos a esta pasta para começar a organizar seu conteúdo.": "Add videos to this folder to start organizing your content.",
  "Adicione vídeos antes e depois do conteúdo principal para aquecer, conduzir e converter espectadores.": "Add videos before and after the main content to warm up, guide, and convert viewers.",
  "Adicione vídeos da sua biblioteca para criar a sequência da playlist.": "Add videos from your library to create the playlist sequence.",
  "Adicione vídeos para começar a criar sua playlist": "Add videos to start creating your playlist",
  "Adicione vídeos para usar este recurso.": "Add videos to use this feature.",
  "Adicione vídeos primeiro": "Add videos first",
  "Adicione VITE_GOOGLE_CLIENT_ID e VITE_GOOGLE_DEVELOPER_KEY no .env e reinicie o servidor.": "Add VITE_GOOGLE_CLIENT_ID and VITE_GOOGLE_DEVELOPER_KEY to .env and restart the server.",
  "Administrador": "Administrator",
  "Afiliado": "Affiliate",
  "Afiliado copia o vídeo com um clique e já pode usar sem upload": "Affiliates copy the video in one click and can use it without uploading",
  "Afiliado Gerente": "Affiliate Manager",
  "Afiliado vendedor": "Affiliate seller",
  "Afiliados": "Affiliates",
  "Ag:": "Branch:",
  "Agência": "Branch",
  "Agência/Conta": "Branch/Account",
  "Agências de Marketing": "Marketing Agencies",
  "Agendada": "Scheduled",
  "Agendado": "Scheduled",
  "Agendamento": "Scheduling",
  "Agendamento de recarga cancelado.": "Scheduled top-up canceled.",
  "Agendando...": "Scheduling...",
  "Agendar Oferta": "Schedule Offer",
  "Agende ofertas e eventos nesses períodos para maximizar resultados.": "Schedule offers and events during these periods to maximize results.",
  "Agora a HostVSL também fala com o Google Ads. Você cadastra o ID de conversão da sua conta (AW-) e o rótulo de cada ação que quer medir — o play do vídeo, o momento em que a oferta aparece e o clique no botão de compra. A partir daí, você enxerga dentro do próprio Google Ads quais campanhas levam as pessoas a assistir e a clicar na sua oferta.": "HostVSL now connects with Google Ads too. Enter your account's conversion ID (AW-) and the label for each action you want to measure — video plays, when the offer appears, and purchase button clicks. Then see directly in Google Ads which campaigns bring people to watch and click your offer.",
  "Agora adicione vídeos à sua playlist.": "Now add videos to your playlist.",
  "Agora escolha o fim do intervalo": "Now choose the end of the range",
  "Agora não": "Not now",
  "Agora seus vídeos pausam automaticamente quando o espectador sai da aba do navegador. Ao retornar, a reprodução continua exatamente de onde parou, sem perder nenhum segundo de conteúdo.": "Your videos now pause automatically when viewers leave the browser tab. When they return, playback resumes exactly where it stopped, without losing a second of content.",
  "Agora você pode compartilhar seus vídeos com afiliados por link. O afiliado copia o vídeo direto no painel com um clique, sem precisar baixar no Drive ou fazer upload demorado. Você acompanha quem copiou e toda a atividade do compartilhamento.": "You can now share your videos with affiliates through a link. Affiliates can copy the video directly into their dashboard with one click, without downloading from Drive or waiting for long uploads. You can track who copied it and all sharing activity.",
  "Agora você pode compartilhar seus vídeos diretamente com membros da sua equipe ou afiliados. Ideal para co-produtores que precisam distribuir conteúdo sem perder o controle.": "You can now share your videos directly with team members or affiliates. Ideal for co-producers who need to distribute content while retaining control.",
  "Agora você pode exibir avisos de compra por cima da sua VSL, no estilo prova social ao vivo. Você escreve o texto do aviso com nome, cidade e produto, escolhe a plataforma de venda que aparece ao lado e deixa as notificações rodando enquanto o vídeo toca. Dá pra segurar os avisos nos primeiros minutos e só então começar o rodízio, ajustando o intervalo entre eles e quanto tempo cada um fica na tela. E, se quiser, a notificação vira um link clicável que abre a sua oferta em uma nova aba.": "You can now display purchase notifications over your VSL as live social proof. Write the notification text with a name, city, and product, choose the sales platform shown alongside it, and let notifications cycle while the video plays. Delay notifications for the first few minutes, then start the rotation, adjusting the interval and how long each stays on screen. You can also turn the notification into a clickable link that opens your offer in a new tab.",
  "Agora você pode importar vídeos diretamente da sua conta do Google Drive, sem precisar baixar primeiro pro computador. No modal de envio, escolha \"Google Drive\" como origem, conecte sua conta com segurança e selecione os vídeos que quiser mandar pra plataforma.": "You can now import videos directly from your Google Drive account without downloading them to your computer first. In the upload dialog, choose \"Google Drive\" as the source, securely connect your account, and select the videos you want to upload.",
  "Agora você pode personalizar a caixa de autoplay de forma visual e intuitiva. Arraste para mover, use os handles para redimensionar e veja as alterações em tempo real no preview do player.": "You can now customize the autoplay box visually and intuitively. Drag to move it, use the handles to resize it, and see changes in real time in the player preview.",
  "Agora você pode personalizar seu vídeo com as opções do editor": "You can now customize your video using the editor options",
  "agregado": "aggregated",
  "Aguardando 1ª venda": "Awaiting first sale",
  "Aguardando 1º disparo": "Awaiting first send",
  "Aguardando dados": "Awaiting data",
  "Aguardando dados de visualização para determinar o desempenho dos vídeos.": "Awaiting view data to determine video performance.",
  "Aguardando dados de visualização para gerar análise de performance.": "Awaiting view data to generate performance analysis.",
  "Aguardando dados de visualização para gerar o gráfico de retenção.": "Awaiting view data to generate the retention chart.",
  "Aguardando pagamento.": "Awaiting payment.",
  "Aguardando primeiro evento": "Awaiting first event",
  "Aguardando seleção": "Awaiting selection",
  "Aguardando seleção...": "Awaiting selection...",
  "Aguardando visualizações": "Awaiting views",
  "Aguardar clique do espectador": "Wait for viewer click",
  "Aguarde enquanto buscamos os dados do teste": "Please wait while we fetch the test data",
  "Aguarde enquanto buscamos seus vídeos": "Please wait while we fetch your videos",
  "Aguarde enquanto preparamos seu vídeo": "Please wait while we prepare your video",
  "Aguarde os envios atuais terminarem ou cancele alguns para enviar novos vídeos.": "Wait for current uploads to finish or cancel some to upload new videos.",
  "Aguarde os envios atuais terminarem ou cancele alguns.": "Wait for current uploads to finish or cancel some.",
  "Aguarde pelo menos 300 visualizações por intro para dados confiáveis": "Wait for at least 300 views per intro for reliable data",
  "Aguarde pelo menos 7 dias para que o teste colete dados suficientes": "Wait at least 7 days for the test to collect enough data",
  "Aguarde um momento": "Please wait a moment",
  "Ainda não há conversões registradas neste período para gerar um insight.": "No conversions recorded in this period yet to generate an insight.",
  "Ainda não há dados de retenção": "No retention data yet",
  "Ainda não há dados de retenção para as variações deste teste. Assim que forem coletados, a curva comparativa aparecerá aqui.": "There is no retention data for this test's variations yet. The comparison curve will appear here as soon as data is collected.",
  "Ainda não há dados suficientes": "Not enough data yet",
  "Ainda não há plays deste vídeo no período.": "This video has no plays in this period yet.",
  "Ainda não há visitas neste período. As métricas aparecem quando o fluxo publicado recebe visitas.": "There are no visits in this period yet. Metrics appear when the published flow receives visits.",
  "Ainda não identificamos sites ou páginas enviando tráfego para este vídeo. Quando houver acessos externos, as referências aparecerão aqui.": "We have not identified any sites or pages sending traffic to this video yet. Referrers will appear here when external visits occur.",
  "Ainda não temos dados de conversão suficientes neste período.": "We do not have enough conversion data for this period yet.",
  "Ainda não temos dados suficientes para gerar métricas avançadas.": "We do not have enough data to generate advanced metrics yet.",
  "Ainda não temos tráfego suficiente neste período.": "We do not have enough traffic for this period yet.",
  "Ainda sem dados aqui": "No data here yet",
  "Ainda tem dúvidas": "Still have questions",
  "Ajuda": "Help",
  "Ajuda sobre autoplay": "Autoplay help",
  "Ajuda: {value0}": "Help: {value0}",
  "Ajustamos o intervalo para manter a ordem correta.": "We adjusted the interval to keep the correct order.",
  "Ajustar automaticamente o último valor para fechar 100%": "Automatically adjust the last value to total 100%",
  "Ajustar valor": "Adjust value",
  "Ajuste a aparência do overlay de autoplay": "Adjust the autoplay overlay appearance",
  "Ajuste a configuração para gerar horários": "Adjust the settings to generate time slots",
  "Ajuste a copy de abertura (gancho, avatar ou história)": "Adjust the opening copy (hook, avatar, or story)",
  "Ajuste a distribuição para 100% para continuar.": "Adjust the distribution to 100% to continue.",
  "Ajuste a visibilidade dos controles do player.": "Adjust player control visibility.",
  "Ajuste cor, desfoque e intensidade.": "Adjust color, blur and intensity.",
  "Ajuste o período e tente novamente.": "Adjust the period and try again.",
  "Ajuste o player para cada tipo de dispositivo.": "Adjust the player for each device type.",
  "Ajuste o tamanho e espaçamento do formulário": "Adjust the form size and spacing",
  "Ajuste o volume do som da notificação (0-100%).": "Adjust notification sound volume (0–100%).",
  "Ajuste os filtros ou cadastre uma despesa manual.": "Adjust filters or add an expense manually.",
  "Ajuste os percentuais de tráfego para cada vídeo": "Adjust traffic percentages for each video",
  "Ajuste os tempos: Início define quando as opções aparecem; Final, que é opcional, define quando o vídeo pausa para a escolha. Se Início ficar vazio, as opções aparecem no fim do vídeo. Se o visitante não escolher, o último quadro permanece com as opções disponíveis.": "Adjust timing: Start sets when options appear; End, which is optional, sets when the video pauses for a choice. If Start is empty, options appear at the end of the video. If visitors do not choose, the last frame remains with options available.",
  "Ajuste título, subtítulo, texto do botão, mensagem de agradecimento, estilo, cor, posição e tamanho": "Adjust title, subtitle, button text, thank-you message, style, color, position, and size",
  "Ajuste velocidade e visibilidade dos controles.": "Adjust speed and visibility of the controls.",
  "Ajustes automáticos de layout e interação por tela": "Automatic layout and interaction adjustments for each screen",
  "Ajustes finos": "Fine tuning",
  "Ajustes rápidos": "Quick tweaks",
  "Alertas importantes": "Important warnings",
  "Alertas quando seus vídeos tiverem picos de engajamento": "Alerts when your videos have engagement spikes",
  "Algo deu errado": "Something went wrong",
  "Algo deu errado. Recuperando...": "Something went wrong. Recovering...",
  "Alguns arquivos não são vídeos e foram ignorados.": "Some files are not videos and were skipped.",
  "Alinhada com quem busca escala, performance e operação profissional.": "Aligned with those seeking scale, performance, and professional operations.",
  "Alinhamento": "Alignment",
  "Alinhamento do Logo": "Logo Alignment",
  "Alinhar à direita": "Align right",
  "Alinhar à esquerda": "Align left",
  "Alinhe melhor o gancho curiosidade com o tema central": "Align the curiosity hook more closely with the main topic",
  "Alta Conversão Garantida": "Guaranteed High Conversion",
  "Alta Reprodução + Alto Engajamento = Copy matadora": "High PlayRate + High Engagement = Killer Copy",
  "Alta Taxa de Reprodução + Engajamento": "High PlayRate + Engagement",
  "Alterações futuras no vídeo": "Future video changes",
  "Alterações não publicadas": "Unpublished changes",
  "Alterações não salvas": "Unsaved changes",
  "Alterações pendentes": "Pending changes",
  "Alterações salvas": "Changes saved",
  "Alterações salvas com sucesso": "Changes saved successfully",
  "Alterar": "Change",
  "Alterar estilo": "Change style",
  "Alterar foto": "Change photo",
  "Alterar número": "Change number",
  "Alterar plano": "Change plan",
  "Alterar Senha": "Change Password",
  "Alterar texto": "Change text",
  "Alterar vídeo": "Change video",
  "Altere a data e horário de encerramento automático do teste.": "Change the test's automatic end date and time.",
  "Altere a quantidade de clicks de incremento para este usuário.": "Change the number of incremental clicks for this user.",
  "Altere seu plano atual": "Change your current plan",
  "Alternar modo teatro": "Toggle theater mode",
  "Alternativo:": "Alternative:",
  "Alto engajamento": "High engagement",
  "Alto Engajamento": "High Engagement",
  "Alto volume": "High volume",
  "Altura visual da barra durante a reprodução": "Visual bar height during playback",
  "America/New York": "America/New York",
  "America/São Paulo": "America/São Paulo",
  "amostra baixa": "small sample",
  "Ana, João, Maria, Pedro, Lucas": "Ana, João, Maria, Pedro, Lucas",
  "Analisando…": "Analyzing…",
  "Análise competitiva": "Competitive analysis",
  "Analise conversões": "Analyze conversions",
  "Análise de comportamento de usuários com mapas de calor e gravações de sessões.": "User behavior analysis with heatmaps and session recordings.",
  "Análise de Custos por Usuário": "Cost Analysis by User",
  "Análise de Desempenho": "Performance Analysis",
  "Análise de Locais": "Location Analysis",
  "Analise de onde vem sua audiência e como ela se comporta": "Analyze where your audience comes from and how it behaves",
  "Análise de Performance": "Performance Analysis",
  "Análise de Retenção": "Retention Analysis",
  "Análise Detalhada": "Detailed Analysis",
  "Análise detalhada de performance e engajamento": "Detailed performance and engagement analysis",
  "Análise detalhada do desempenho desta introdução": "Detailed analysis of this intro's performance",
  "Análise Inteligente": "Smart Analysis",
  "Analise o mapa de calor por dia e hora para enxergar padrões": "Analyze the heatmap by day and hour to identify patterns",
  "Analise o mapa de calor por dia e hora para enxergar padrões de audiência em segundos": "Analyze the heatmap by day and hour to spot audience patterns in seconds",
  "Analise os elementos que estão gerando mais engajamento": "Analyze the elements generating the most engagement",
  "Analise os pontos de queda": "Analyze drop-off points",
  "Analise retenção, plays, conversão e desempenho em uma visão comparativa completa com dados reais": "Analyze retention, plays, conversions, and performance in a complete comparison view with real data",
  "Análises": "Analytics",
  "Análises inteligentes baseadas nos seus dados": "Smart analysis based on your data",
  "Analítico para recomendação.": "Analytics for recommendations.",
  "Analytics por etapa e evento": "Analytics by step and event",
  "Anima o botão em um pulso contínuo para chamar atenção": "Animates the button with a continuous pulse to attract attention",
  "Animação": "Animation",
  "Animação de entrada": "Enter animation",
  "Animação e Timing": "Animation and Timing",
  "Animação Pulsar": "Pulse animation",
  "Animações suaves de entrada e saída sem quebrar a imersão": "Smooth entrance and exit animations without breaking immersion",
  "ANO": "YEAR",
  "Anônimo": "Anonymous",
  "Antecipe o Pitch": "Move the Pitch Earlier",
  "Anterior": "Previous",
  "Antes de copiar para sua conta, confirme os termos de uso.": "Before copying to your account, confirm the terms of use.",
  "Antes do principal": "Before the main video",
  "Antes e depois": "Before and after",
  "Anti-Plágio": "Anti-Plagiarism",
  "Ao adicionar o connector da HostVSL, cole a chave no campo de header": "When adding the HostVSL connector, paste the key into the header field",
  "Ao ativar a sua conta, ganhará acesso imediato ao seu painel administrativo para obter o seu link e começar a indicar.": "When you activate your account, you will immediately gain access to your dashboard to get your link and start referring.",
  "Ao ativar, a headline será exibida diretamente sobre o vídeo conforme suas configurações.": "When enabled, the headline will appear directly over the video according to your settings.",
  "Ao cancelar sua assinatura:": "When you cancel your subscription:",
  "Ao clicar na notificação, abrir esta URL em nova aba.": "On click, open this URL in a new tab.",
  "Ao clicar nesse botão você aceita e concorda com nossos termos de uso": "By clicking this button, you accept and agree to our terms of use",
  "Ao clicar, abrir link": "On click, open link",
  "Ao confirmar, sua assinatura será cancelada imediatamente e o acesso será encerrado.": "Upon confirmation, your subscription will be canceled immediately and your access will end.",
  "Ao continuar, você concorda com os": "By continuing, you agree to the",
  "Ao editar, o último vídeo será compensado automaticamente": "When editing, the last video will be automatically adjusted",
  "Ao finalizar": "When it ends",
  "Ao finalizar, a velocidade com melhor engajamento será definida como principal.": "When finished, the speed with the best engagement will be set as primary.",
  "Ao finalizar, o tráfego volta para a VSL Principal. Esta ação não pode ser desfeita.": "After finishing, traffic returns to the Main VSL. This action cannot be undone.",
  "Ao finalizar, o vídeo volta ao início automaticamente, mantendo a reprodução em loop.": "When finished, the video returns to the start automatically, keeping playback on loop.",
  "Ao me inscrever, concordo em receber comunicações e aceito a política de privacidade.": "By registering, I agree to receive communications and accept the privacy policy.",
  "Ao Pausar": "On Pause",
  "Ao pausar o vídeo": "When the video is paused",
  "Ao Reproduzir": "On Play",
  "ao seu vídeo. O espectador poderá ativar ou desativar a legenda pelo botão": "to your video. Viewers can enable or disable captions using the",
  "Ao terminar o vídeo, mostre uma contagem regressiva e leve o espectador ao checkout": "When the video ends, display a countdown and take the viewer to checkout",
  "ao vivo": "live",
  "Ao vivo — {count} pessoas assistindo agora": "Live — {count} people watching now",
  "Aos 100% Visualizados": "At 100% Viewed",
  "Aos 25% Visualizados": "At 25% Viewed",
  "Aos 50% Visualizados": "At 50% Viewed",
  "Aparece na sidebar do player público": "Appears in the public player's sidebar",
  "Aparece no header e sidebar do player público": "Appears in the public player's header and sidebar",
  "Aparecer após iniciar o vídeo": "Appear after video starts",
  "Aparecer em": "Appear at",
  "Aparência": "Appearance",
  "Aparência do link de recusa exibido abaixo do botão.": "Appearance of the decline link shown below the button.",
  "Aparência do Player": "Player appearance",
  "Aparência dos Cards": "Card Appearance",
  "Aparência dos Controles": "Controls appearance",
  "Aparência geral do formulário": "Overall form appearance",
  "Apenas 3 passos simples para começar a ganhar": "Just 3 simple steps to start earning",
  "Apenas em um trecho específico": "Only during a specific segment",
  "Apenas exibir o aviso": "Just show the warning",
  "Apenas visualização de vídeos e métricas": "View-only access to videos and metrics",
  "Aplica overlay escuro para destacar o CTA": "Applies a dark overlay to highlight the CTA",
  "Aplica uma sombra sob o botão para destacá-lo do fundo": "Applies a shadow below the button to make it stand out from the background",
  "Aplicação": "Application",
  "Aplicação & Metadados": "Application & Metadata",
  "Aplicada em barra de controle, play, volume e botões principais": "Applied to control bar, play, volume and main buttons",
  "Aplicada em ícones secundários e textos do player": "Applied to secondary icons and player texts",
  "Aplicada no botão e detalhes": "Applied to button and details",
  "Aplicado": "Applied",
  "Aplicando...": "Applying...",
  "Aplicar": "Apply",
  "Aplicar como padrão": "Apply as default",
  "Aplicar Configurações": "Apply Settings",
  "Aplicar desfoque na imagem de fundo (blur 8px)": "Blur the background image (8px blur)",
  "Aplicar em {value0} {value1}": "Apply to {value0} {value1}",
  "Aplicar leve desfoque": "Apply slight blur",
  "Aplicar Template": "Apply Template",
  "Aplique as estratégias vencedoras nos outros vídeos": "Apply winning strategies to other videos",
  "Aplique configurações padrão em vários vídeos de uma só vez para acelerar seu fluxo.": "Apply default settings to multiple videos at once to speed up your workflow.",
  "Após 15 dias": "After 15 days",
  "Após a ativação, terá acesso instantâneo a um link parametrizado exclusivo para divulgar nas suas redes ou site.": "After activation, you will have instant access to a unique tagged link to share on your social media or website.",
  "Após identificar um vencedor, crie um novo teste usando aquele como controle vs novas variações.": "After identifying a winner, create a new test using it as the control against new variations.",
  "Após o envio": "After upload",
  "Após o vídeo de entrada": "After the entry video",
  "App instalado com sucesso!": "App installed successfully!",
  "App já instalado!": "App already installed!",
  "Aprenda as melhores estratégias de marketing digital": "Learn the best digital marketing strategies",
  "Aprenda as melhores estratégias e técnicas neste curso completo. Conteúdo exclusivo desenvolvido para transformar seus resultados.": "Learn the best strategies and techniques in this complete course. Exclusive content designed to transform your results.",
  "Aprenda no seu ritmo, direto do menu Academy.": "Learn at your own pace from the Academy menu.",
  "Aprenda sobre legendas": "Learn about subtitles",
  "Aprendizado": "Learning",
  "Aprimoradores de Conversão": "Conversion Boosters",
  "Aprofunde no storytelling": "Develop the storytelling",
  "Aproveite essa condição especial": "Take advantage of this special offer",
  "Aqui ficam todos os recursos para personalizar seu player. Ative controles, botões, headline e muito mais.": "Here are all the features to customize your player. Enable controls, buttons, headlines, and more.",
  "Aqui você define as introduções.": "Define the intros here.",
  "Área de membros não encontrada": "Member area not found",
  "Área de upload de vídeo. Pressione Enter para selecionar um arquivo": "Video upload area. Press Enter to select a file",
  "Área restrita a administradores.": "Area restricted to administrators.",
  "Área restrita a parceiros e gestores.": "Area restricted to partners and managers.",
  "Área restrita exclusivamente para administradores.": "Area restricted exclusively to administrators.",
  "Área segura": "Secure area",
  "Área segura visual para garantir visibilidade em todos os dispositivos": "Visual safe area to ensure visibility on all devices",
  "Argentina": "Argentina",
  "Arial": "Arial",
  "Armazenamento cheio. Reduza o tamanho das imagens (logo, favicon, thumbnails) ou remova playlists antigas.": "Storage full. Reduce image sizes (logo, favicon, thumbnails) or remove old playlists.",
  "Armazenamento:": "Storage:",
  "Arquitetura de gerenciamento de estado da HostVSL": "HostVSL state management architecture",
  "Arquitetura Zustand": "Zustand Architecture",
  "Arquivado": "Archived",
  "Arquivo": "File",
  "Arquivo da legenda": "Subtitle file",
  "Arquivo excede o limite de {value0}MB": "File exceeds the {value0}MB limit",
  "Arquivo exportado com sucesso": "File exported successfully",
  "Arquivo grande demais": "File too large",
  "Arquivo inválido ou corrompido. Nenhuma legenda encontrada.": "Invalid or corrupted file. No subtitles found.",
  "Arquivo leve": "Lightweight file",
  "Arquivo maior que {n}MB": "File larger than {n}MB",
  "Arquivo muito grande": "File too large",
  "Arquivo muito grande. Máximo: 20 MB": "File too large. Max: 20 MB",
  "Arquivo muito grande. Tamanho máximo: 5GB.": "File too large. Maximum size: 5GB.",
  "Arrastando...": "Dragging...",
  "Arraste a caixa para qualquer posição dentro do player": "Drag the box anywhere within the player",
  "Arraste arquivos aqui ou clique": "Drag files here or click",
  "Arraste e solte o vídeo aqui": "Drag and drop the video here",
  "Arraste e solte ou escolha arquivos do seu computador.": "Drag and drop or choose files from your computer.",
  "Arraste e solte seu vídeo aqui": "Drag and drop your video here",
  "Arraste e solte vídeos entre pastas": "Drag and drop videos between folders",
  "Arraste e solte vídeos para carregar": "Drag and drop videos to upload",
  "Arraste o vídeo aqui ou clique no botão abaixo para selecionar": "Drag the video here or click the button below to select",
  "Arraste os sliders ou digite valores. A soma sempre será ajustada para 100%.": "Drag the sliders or enter values. The total will always be adjusted to 100%.",
  "Arraste ou clique para enviar": "Drag or click to upload",
  "Arraste para enviar": "Drag and drop or click to upload",
  "Arraste para reordenar, configure obrigatoriedade e placeholders": "Drag to reorder, configure required fields and placeholders",
  "Arraste seu arquivo ou clique para enviar": "Drag your file or click to upload",
  "Arraste seu vídeo aqui ou clique no botão abaixo para selecionar": "Drag your video here or click the button below to select",
  "Arraste seu vídeo aqui ou clique para enviar um arquivo": "Drag your video here or click to upload a file",
  "Arraste sua imagem de fundo": "Drag your background image",
  "Arraste um vídeo aqui ou clique para enviar": "Upload Video",
  "Arraste um vídeo da lista para cá ou use": "Drag a video from the list here or use",
  "Arraste um vídeo para o quadro para criar uma etapa com ele.": "Drag a video onto the canvas to create a step with it.",
  "Arraste uma imagem ou clique para selecionar": "Drag an image or click to select",
  "Arraste vídeos aqui": "Drag videos here",
  "Arraste vídeos da biblioteca para organizá-los aqui.": "Drag videos from the library to organize them here.",
  "Arredondado": "Rounded",
  "Arredondado (16px)": "Rounded (16px)",
  "Arredondamento": "Corner radius",
  "Arredondamento da Borda": "Border Radius",
  "Arredondamento dos cantos": "Corner radius",
  "Arredondamento dos Cards": "Card Corner Radius",
  "As alterações aparecerão aqui em tempo real": "Changes will appear here in real time",
  "As alterações foram salvas com sucesso.": "Changes were saved successfully.",
  "As alterações não foram salvas.": "Changes were not saved.",
  "As alterações não salvas serão perdidas.": "Unsaved changes will be lost.",
  "As comissões são pagas mensalmente via PIX ou transferência bancária, desde que o cliente indicado mantenha o plano ativo.": "Commissions are paid monthly via PIX or bank transfer, provided the referred customer keeps their plan active.",
  "As configurações ainda não foram salvas. Clique no botão \"Aplicar\" no canto superior direito para iniciar o teste.": "Settings have not been saved yet. Click \"Apply\" in the upper-right corner to start the test.",
  "As configurações da logo foram salvas com sucesso": "Logo settings were saved successfully",
  "As configurações da thumbnail de pausa foram salvas com sucesso": "Pause thumbnail settings were saved successfully",
  "As configurações de legenda foram aplicadas com sucesso.": "Caption settings were applied successfully.",
  "As configurações de velocidade foram salvas com sucesso": "Speed settings were saved successfully",
  "As configurações do botão de ação foram salvas com sucesso": "Action button settings were saved successfully",
  "As configurações foram aplicadas com sucesso.": "Settings were applied successfully.",
  "As configurações foram salvas com sucesso": "Settings were saved successfully",
  "As configurações são salvas individualmente por dispositivo.": "Settings are saved separately for each device.",
  "As cores indicam horários com": "Colors indicate times with",
  "As cores mais intensas indicam horários com maior": "More intense colors indicate times with higher",
  "As cores mais intensas indicam horários com maior volume de": "More intense colors indicate times with a higher volume of",
  "As cores mais intensas indicam horários com maior volume de plays.": "More intense colors indicate times with a higher play volume.",
  "As curvas de retenção aparecerão assim que houver visualizações no teste.": "Retention curves will appear as soon as the test receives views.",
  "as demais estão na tabela abaixo": "the others are in the table below",
  "As imagens foram enviadas e salvas com sucesso": "Images were successfully uploaded and saved",
  "As informações aparecerão quando houver cópias do vídeo": "Information will appear when the video is copied",
  "As linhas mostram a porcentagem de espectadores que continuam assistindo em cada momento do vídeo": "The lines show the percentage of viewers still watching at each point in the video",
  "As métricas aparecerão quando houver visualizações nos vídeos do teste": "Metrics will appear when the test videos receive views",
  "As métricas começam quando o fluxo é publicado.": "Metrics begin when the flow is published.",
  "As métricas da Jornada aparecem aqui assim que os espectadores começarem a assistir aos vídeos de entrada e saída.": "Journey metrics appear here as soon as viewers start watching the entry and exit videos.",
  "As mudanças já estão visíveis na URL pública.": "Changes are now visible at the public URL.",
  "As opções precisam aparecer antes da pausa.": "Options must appear before the pause.",
  "As opções que levam a ela ficam sem destino. O vídeo continua na lista do fluxo.": "Options leading to it will have no destination. The video remains in the flow's list.",
  "As personalizações serão aplicadas ao abrir o vídeo.": "Customizations will be applied when the video opens.",
  "As senhas não coincidem": "Passwords do not match",
  "As senhas não conferem": "Passwords do not match",
  "AS senhas não correspondem!": "Passwords do not match!",
  "As senhas precisam ser iguais.": "The passwords must be the same.",
  "As solicitações de saque dos afiliados aparecerão aqui.": "Affiliate withdrawal requests will appear here.",
  "Asia/Tokyo": "Asia/Tokyo",
  "Assim que alguém der play numa VSL (com som), o ponto aparece aqui no mapa.": "As soon as someone plays a VSL (with sound), a point appears here on the map.",
  "Assim que o teste começar a receber visualizações, você verá a comparação de retenção entre as introduções aqui.": "Once the test starts receiving views, you will see a retention comparison between the intros here.",
  "Assim que suas visualizações começarem, mostraremos os dispositivos e origens.": "Once views start coming in, we will show devices and sources.",
  "Assim que um evento for detectado, ele aparece aqui.": "As soon as an event is detected, it appears here.",
  "Assinatura": "Subscription",
  "Assinatura atualizada com sucesso.": "Subscription updated successfully.",
  "Assinatura cancelada com sucesso": "Subscription canceled successfully",
  "Assinatura criada com sucesso": "Subscription created successfully",
  "Assistido": "Watched",
  "Assistido em média": "Average watched",
  "assistindo agora": "watching now",
  "Assistir de novo": "Watch again",
  "Assistir do início": "Watch from the start",
  "Assistir na Smart TV": "Watch on Smart TV",
  "Assistir Novamente": "Watch Again",
  "Assistir tutorial": "Watch tutorial",
  "Assistiram até o fim": "Watched to the end",
  "At least one thumbnail URL is required": "At least one thumbnail URL is required",
  "Atalhos": "Shortcuts",
  "até": "to",
  "Até": "To",
  "Até 23:59": "Until 23:59",
  "Atenção": "Attention",
  "Atenção antes de criar o teste": "Before creating the test",
  "Atenção:": "Attention:",
  "Atendimento": "Support",
  "Ativa": "Active",
  "Ativa a reprodução automática do vídeo": "Enables automatic video playback",
  "Ativa o som ao detectar ação do visitante (clique, scroll ou toque)": "Enables sound when visitor activity is detected (click, scroll, or touch)",
  "Ativa tanto as áreas de linguagem quanto as de processamento sensorial": "Activates both language and sensory processing areas",
  "Ativada": "Enabled",
  "Ativadas": "Enabled",
  "Ativando métricas": "Activating metrics",
  "Ativar": "Activate",
  "Ativar acesso grátis": "Activate free access",
  "Ativar Ações Sincronizadas": "Enable Synced Actions",
  "Ativar agora": "Activate now",
  "Ativar Autoplay": "Enable Autoplay",
  "ATIVAR AUTOPLAY": "ENABLE AUTOPLAY",
  "Ativar Borda": "Enable Border",
  "Ativar borda no player": "Enable player border",
  "Ativar botão": "Enable button",
  "Ativar botão de ação": "Enable action button",
  "Ativar Captura por Tempo": "Enable Timed Capture",
  "Ativar com teste grátis": "Activate with free trial",
  "Ativar compartilhamento": "Enable sharing",
  "Ativar Continuar Assistindo": "Enable Continue Watching",
  "Ativar Exibição por Dispositivo": "Enable Display by Device",
  "Ativar horários de silêncio": "Enable quiet hours",
  "Ativar link de afiliado": "Enable affiliate link",
  "Ativar Logo": "Enable Logo",
  "Ativar Minha Conta de Afiliado": "Activate My Affiliate Account",
  "Ativar notificações": "Enable notifications",
  "Ativar Notificações Push": "Enable Push Notifications",
  "Ativar o plano": "Activate plan",
  "Ativar Perfil Gratuitamente": "Activate Profile for Free",
  "Ativar Pixel": "Enable Pixel",
  "Ativar Rastreamento de Afiliados": "Enable Affiliate Tracking",
  "Ativar reprodução automática": "Enable autoplay",
  "Ativar segundo botão": "Enable second button",
  "Ativar som": "Enable sound",
  "Ativar sombra": "Enable shadow",
  "Ativar Spark Points": "Enable Spark Points",
  "Ativar tema do player": "Enable player theme",
  "Ativar temporizador": "Enable timer",
  "Ativar teste automático": "Enable auto test",
  "Ativar teste automático com múltiplas velocidades": "Enable automatic test with multiple speeds",
  "Ativar teste de velocidade": "Enable speed test",
  "Ativar Velocidade": "Enable Speed",
  "Ativar velocidade personalizada": "Enable custom speed",
  "Ativar VSLeads": "Enable VSLeads",
  "Ativável por vídeo na personalização.": "Can be enabled per video in customization.",
  "Ative a estratégia para copiar o código": "Enable the strategy to copy the code",
  "Ative a exibição por dispositivo para personalizar Desktop, Tablet e Mobile.": "Enable display by device to customize Desktop, Tablet, and Mobile.",
  "Ative a recarga para nunca ficar sem plays": "Enable top-ups so you never run out of plays",
  "Ative a sua conta gratuitamente, partilhe o seu link exclusivo e construa uma nova fonte de rendimento acompanhando tudo em tempo real através de um painel analítico completo.": "Activate your account for free, share your unique link, and build a new source of income while tracking everything in real time through a complete analytics dashboard.",
  "Ative as notificações para receber alertas em tempo real sobre conversões, métricas e atualizações importantes.": "Enable notifications to receive real-time alerts about conversions, metrics, and important updates.",
  "Ative as notificações primeiro para enviar testes.": "Enable notifications first to send tests.",
  "Ative com um clique direto no painel de recursos": "Enable with one click in the features panel",
  "Ative com um clique no painel de recursos do vídeo": "Enable with one click in the video features panel",
  "Ative comportamentos extras do Autoplay": "Enable extra Autoplay behaviors",
  "Ative comportamentos extras do botão": "Enable extra button behaviors",
  "Ative na aba \"Controles\" da personalização do vídeo, na opção \"Assistir na Smart TV\"": "Enable \"Watch on Smart TV\" in the \"Controls\" tab of video customization",
  "Ative na aba \"Controles\" da personalização do vídeo, na opção \"Preview na Timeline\"": "Enable \"Timeline Preview\" in the \"Controls\" tab of video customization",
  "Ative na personalização do vídeo e simule a contagem no preview do player ao lado": "Enable in video customization and simulate the countdown in the player preview alongside it",
  "Ative na personalização do vídeo, na categoria Conversão, em \"Feedback do Vídeo\"": "Enable \"Video Feedback\" under Conversion in video customization",
  "Ative na personalização do vídeo, na opção \"Jornada de Conversão\"": "Enable \"Conversion Journey\" in video customization",
  "Ative na personalização do vídeo, na opção \"Notificação de Vendas\"": "Enable \"Sales Notification\" in video customization",
  "Ative o autoplay na aba Configuração para configurar testes A/B": "Enable autoplay in the Settings tab to configure A/B tests",
  "Ative o autoplay para ver o preview": "Enable autoplay to see the preview",
  "Ative o bloco de saída para visualizar suas métricas aqui.": "Enable the exit block to view its metrics here.",
  "Ative o botão de ação na aba Configuração para configurar a exibição": "Enable the action button in the Configuration tab to configure its display",
  "Ative o botão de ação na aba Configuração para personalizar o estilo": "Enable the action button in the Configuration tab to customize its style",
  "Ative o botão para ver o preview": "Enable the button to see the preview",
  "Ative o formulário VSLeads para capturar emails e informações dos seus visitantes.": "Enable the VSLeads form to capture visitor emails and information.",
  "Ative o recurso acima para pausar o vídeo quando o visitante sair da aba do navegador.": "Enable the feature above to pause the video when visitors leave the browser tab.",
  "Ative o recurso acima para pausar o vídeo quando o visitante sair da aba.": "Enable the feature above to pause the video when the visitor leaves the tab.",
  "Ative o recurso acima para reiniciar o vídeo automaticamente ao chegar ao fim.": "Enable the feature above to restart the video automatically when it reaches the end.",
  "Ative o recurso de headline para visualizar as métricas": "Enable the headline feature to view metrics",
  "Ative o recurso para configurar": "Enable the feature to configure",
  "Ative o recurso para ver o preview": "Enable the feature to see the preview",
  "Ative o Smart Autoplay na aba \"Configuração\" para personalizar o estilo visual.": "Enable Smart Autoplay in the \"Configuration\" tab to customize its appearance.",
  "Ative o Smart Autoplay para personalizar o estilo visual.": "Enable Smart Autoplay to customize its appearance.",
  "Ative o som": "Enable sound",
  "Ative o switch acima para começar a configurar suas legendas.": "Turn on the switch above to start configuring your subtitles.",
  "Ative os controles do player para o espectador.": "Enable player controls for the viewer.",
  "Ative ou desative o formulário de captura neste vídeo. Quando ativo, o formulário será exibido no momento configurado.": "Enable or disable the capture form for this video. When enabled, the form appears at the configured time.",
  "Ative ou desative os campos que deseja coletar no formulário": "Enable or disable the fields you want to collect in the form",
  "Ative para exibir a barra de progresso no vídeo.": "Enable to display the progress bar in the video.",
  "Ative para exibir o formulário de captura de dados neste vídeo no momento configurado. Quando ativo, o formulário será exibido automaticamente.": "Enable to display the data capture form in this video at the configured time. When enabled, the form will appear automatically.",
  "Ative para rastrear eventos e conversões em plataformas de anúncios": "Enable to track events and conversions on advertising platforms",
  "Atividade Recente": "Recent Activity",
  "ativo": "active",
  "Ativo": "Active",
  "ATIVO": "ACTIVE",
  "Ativo · 1 notificação a cada {freq}s · {pos}": "Active · 1 notification every {freq}s · {pos}",
  "ativos": "active",
  "Ativos": "active",
  "Atraia atenção com um título impactante": "Attract attention with a compelling title",
  "Atraso inicial": "Initial delay",
  "Atraso inicial ({value}s)": "Initial delay ({value}s)",
  "Atraso inicial de até 3 minutos, intervalo de 5 segundos a 5 minutos e duração de 1 a 20 segundos": "Initial delay up to 3 minutes, interval from 5 seconds to 5 minutes, and duration from 1 to 20 seconds",
  "Atribuição por Último Clique": "Last-Click Attribution",
  "Atualização de Pagamento": "Payment Update",
  "Atualização de toda documentação para usar Azul Host (#1D4FFF) como cor primária única. Corrigidas inconsistências entre DESIGN_SYSTEM.md, FEATURE_CONFIGS_STANDARD.md, PWA_README.md e colors.ts.": "Updated all documentation to use Host Blue (#1D4FFF) as the single primary color. Fixed inconsistencies between DESIGN_SYSTEM.md, FEATURE_CONFIGS_STANDARD.md, PWA_README.md, and colors.ts.",
  "Atualização do Pagamento": "Payment Update",
  "Atualização do sistema": "System update",
  "Atualização em tempo real": "Real-time update",
  "Atualização em tempo real dos resultados do teste": "Real-time test result updates",
  "atualizações registradas": "recorded updates",
  "Atualizado": "Updated",
  "Atualizado em": "Updated on",
  "Atualizado:": "Updated:",
  "Atualizando...": "Updating...",
  "Atualizar": "Update",
  "Atualizar Clicks": "Update Clicks",
  "Atualizar dados": "Update data",
  "Atualizar Documentação": "Update Documentation",
  "Atualizar Pagamento": "Update Payment",
  "Atualizar Permissões": "Update Permissions",
  "Atualizar Senha": "Update Password",
  "Atualize as informações do cartão.": "Update your card information.",
  "Atualize seus dados de contato": "Update your contact details",
  "Atualize seus dados pessoais e avatar": "Update your personal details and avatar",
  "Atualize sua senha e configurações de segurança": "Update your password and security settings",
  "Audiência": "Audience",
  "Audiência em Tempo Real": "Real-Time Audience",
  "Audiência Predominantemente Mobile": "Predominantly Mobile Audience",
  "Audiência Simulada": "Simulated Audience",
  "Áudio": "Audio",
  "Auditoria": "Audit",
  "Auditoria Anti-Fraude": "Anti-Fraud Audit",
  "Auditoria de Membros": "Member Audit",
  "aula": "lesson",
  "Aula": "Lesson",
  "Aula {value0}": "Lesson {value0}",
  "Aula Concluída": "Lesson Completed",
  "Aula concluída! 🎉": "Lesson completed! 🎉",
  "aula disponível": "lesson available",
  "Aula Gratuita - Marketing": "Free Lesson - Marketing",
  "Aula não encontrada": "Lesson not found",
  "aulas": "lessons",
  "Aulas": "Lessons",
  "Aulas (": "Lessons (",
  "aulas concluídas": "lessons completed",
  "Aulas curtas e objetivas com player premium integrado": "Short, focused lessons with a built-in premium player",
  "aulas disponíveis": "lessons available",
  "Aulas do Curso": "Course Lessons",
  "Aulas exclusivas para acelerar sua evolução": "Exclusive lessons to accelerate your progress",
  "Aulas exclusivas para aumente suas conversões imediatamente.": "Exclusive lessons to increase your conversions immediately.",
  "Aumenta retenção em vídeos longos": "Increases retention in long videos",
  "Aumentar 5%": "Increase by 5%",
  "Aumentar valor": "Increase value",
  "Aumente a retenção com um vídeo gancho no autoplay": "Boost retention with a hook video in autoplay",
  "Aumento de 35% na retenção da VSL": "35% increase in VSL retention",
  "Autenticado com sucesso!": "Authenticated successfully!",
  "Auto": "Auto",
  "Auto usa o formato do vídeo da etapa inicial.": "Auto uses the initial step's video format.",
  "Auto-ajustado": "Automatically adjusted",
  "Auto-balancear": "Auto-balance",
  "Auto-fechar ao enviar": "Auto-close on submit",
  "Auto-gerado": "Automatically generated",
  "Auto-indicação ou práticas abusivas de SPAM resultarão no cancelamento imediato das comissões e da conta.": "Self-referrals or abusive SPAM practices will result in immediate cancellation of commissions and the account.",
  "Auto-play Próxima Aula": "Autoplay Next Lesson",
  "Automação de emails e fluxos de trabalho para marketing e vendas.": "Email automation and workflows for marketing and sales.",
  "Automático": "Automatic",
  "Automatize emails personalizados, escale experiências únicas para clientes e transforme leads em receita.": "Automate personalized emails, scale unique customer experiences, and turn leads into revenue.",
  "Automatize mensagens de texto, áudio e vídeo, recupere vendas perdidas de Pix e boletos, compras canceladas e carrinhos abandonados, crie chatbots, envie mensagens em massa, rastreie vendas e mais com nossas 271 funções.": "Automate text, audio, and video messages; recover lost PIX and boleto sales, canceled purchases, and abandoned carts; create chatbots; send bulk messages; track sales; and more with our 271 features.",
  "Automatize tarefas integrando mais de 5.000 aplicativos diferentes.": "Automate tasks by integrating over 5,000 different apps.",
  "Autoplay": "Autoplay",
  "Autoplay ativado": "Autoplay enabled",
  "Autoplay desativado": "Autoplay disabled",
  "Autoplay e controles não podem estar ativos ao mesmo tempo.": "Autoplay and controls cannot be enabled at the same time.",
  "Autoplay e Teste A/B": "Autoplay and A/B Testing",
  "Autoplay foi desativado automaticamente. Autoplay e controles não podem estar ativos ao mesmo tempo.": "Autoplay was disabled automatically. Autoplay and controls cannot be enabled at the same time.",
  "AutoplayStyleSection - Accordion Aberto por Padrão": "AutoplayStyleSection - Accordion Open by Default",
  "Avaliações": "Ratings",
  "Avalie o contexto do seu conteúdo - vídeos técnicos podem funcionar melhor em velocidades mais baixas": "Consider your content context — technical videos may perform better at slower speeds",
  "Avançado": "Advanced",
  "Avançar": "Next",
  "Avançar 10 segundos": "Skip forward 10 seconds",
  "Avançar 10s": "Forward 10s",
  "Avançar para Intros em Teste": "Continue to Intros Being Tested",
  "Avançaram ao conteúdo": "Continued to content",
  "Avatar": "Avatar",
  "Avisa que o vídeo iniciou automaticamente.": "Notifies that the video started automatically.",
  "Avisos": "Notices",
  "AWS": "AWS",
  "Azul Host claro - hover states": "Light Host Blue - hover states",
  "Azul Host escuro - estados pressionados": "Dark Host Blue - pressed states",
  "Azul Host oficial - cor principal": "Official Host Blue - primary color",
  "Backend": "Backend",
  "Background": "Background",
  "Background Botão": "Button Background",
  "Background do Vídeo": "Video Background",
  "Badge \"Sessão atualizada hoje\"": "\"Session updated today\" badge",
  "Badge personalizado": "Custom badge",
  "Badges de urgência": "Urgency badges",
  "Baixa amostra": "Small sample",
  "Baixando {value0} vídeo{value1}...": "Downloading {value0} video{value1}...",
  "Baixando seus vídeos do Google Drive...": "Downloading your videos from Google Drive...",
  "Baixar": "Download",
  "Baixar comprovante": "Download receipt",
  "Baixar fatura": "Download invoice",
  "Baixar modelo (.TXT)": "Download template (.TXT)",
  "Baixar QR Code": "Download QR Code",
  "Baixe o arquivo modelo para ver o formato correto": "Download the template file to see the correct format",
  "Baixe um exemplo simples para preencher suas legendas.": "Download a simple example to fill in your subtitles.",
  "Baixo": "Low",
  "Baixo Direita": "Bottom Right",
  "Baixo Esquerda": "Bottom Left",
  "Banco": "Bank",
  "Bancos Vinculados": "Linked Banks",
  "Banner": "Banner",
  "Banner hero": "Hero banner",
  "Barra de Controles": "Control Bar",
  "Barra de progresso": "Progress Bar",
  "Barra de Progresso": "Progress Bar",
  "Barra Fake": "Fake Bar",
  "Barra fake foi desativada automaticamente. Barra fake e controles não podem estar ativos ao mesmo tempo.": "The fake bar was disabled automatically. The fake bar and controls cannot be enabled at the same time.",
  "Barra Inferior": "Bottom Bar",
  "Barras": "Bars",
  "Base (opcional)": "Base (optional)",
  "Base preparada para liberar novas funcionalidades com mais velocidade": "Foundation prepared to release new features faster",
  "Base preparada para novas funcionalidades com mais velocidade": "Foundation prepared for faster new features",
  "Base: últimos 7 dias": "Based on: last 7 days",
  "Baseado no desempenho do período": "Based on performance in the period",
  "Bem-vindo": "Welcome",
  "Bem-vindo ao HostVSL": "Welcome to HostVSL",
  "Bem-vindo de volta,": "Welcome back,",
  "Benefícios do Programa": "Program Benefits",
  "Biblioteca": "Library",
  "Biblioteca Host VSL": "Host VSL Library",
  "Bloco de oferta": "Offer block",
  "blog.exemplo.com": "blog.example.com",
  "Bloq.": "Blocked",
  "Bloqueada": "Blocked",
  "Bloqueadas": "Blocked",
  "Bloqueado": "Blocked",
  "Bloqueados": "Blocked",
  "Bloquear": "Block",
  "Bloquear acesso": "Block access",
  "Bloquear fechamento (segundos)": "Prevent closing (seconds)",
  "Bloquear fechar até enviar": "Prevent closing until submission",
  "Bloquear número": "Block number",
  "Bloquear pause": "Prevent pausing",
  "Bloquear por Domínio": "Block by Domain",
  "Bloquear Proxy/VPN": "Block Proxy/VPN",
  "Bloquear selecionados": "Block selected",
  "Bloquear visualização": "Block viewing",
  "Bloqueia acessos suspeitos usando proxy, VPN ou mascaramento de localização.": "Blocks suspicious visits using a proxy, VPN, or location masking.",
  "Bloqueie a exibição dos vídeos fora do seu site.": "Block video playback outside your website.",
  "Bloqueie ou remova o acesso na hora em que alguém sair do time": "Block or remove access immediately when someone leaves the team",
  "Bloqueio por dispositivo (desktop, celular, tablet) e por VPN/Proxy": "Blocking by device (desktop, mobile, tablet) and VPN/Proxy",
  "Bloqueios detectados": "Blocks detected",
  "Blur de Fundo (Glass Effect)": "Background Blur (Glass Effect)",
  "Boa Performance": "Good Performance",
  "Bold": "Bold",
  "Bom": "Good",
  "Bom desempenho": "Good Performance",
  "Bom Desempenho": "Good Performance",
  "Bônus": "Bonus",
  "Bônus (até 6)": "Bonuses (up to 6)",
  "Bônus por tempo limitado": "Limited-time bonus",
  "Borda": "Border",
  "Borda branca": "White border",
  "Borda customizada": "Customize Border",
  "Borda Customizada": "Customize Border",
  "Borda do player": "Player Border",
  "Borda do Player": "Player Border",
  "Bordas arredondadas": "Rounded corners",
  "Bordas Arredondadas:": "Rounded Corners:",
  "Bordas padrão": "Default borders",
  "Bordas Personalizadas": "Custom Borders",
  "Border Radius": "Border Radius",
  "Border-radius de botões": "Button border radius",
  "Border-radius de cards": "Card border radius",
  "Border-radius de dropdowns": "Dropdown border radius",
  "Border-radius de modais": "Dialog border radius",
  "Border-radius de switch cards": "Switch card border radius",
  "Botão": "Button",
  "Botão \"Ir Agora\"": "\"Go Now\" Button",
  "Botão \"Ir Agora\" opcional, pra quem já decidiu e não quer esperar a contagem terminar": "Optional \"Go Now\" button for viewers who have decided and do not want to wait for the countdown",
  "Botão \"Pular\"": "\"Skip\" Button",
  "Botão adicionado": "Button added",
  "Botão ativo": "Button enabled",
  "Botão continuar": "Continue button",
  "Botão CTA": "CTA Button",
  "Botão de ação": "Action Button",
  "Botão de Ação": "Action Button",
  "Botão de Ação (CTA)": "Action Button (CTA)",
  "Botão de ação atualizado": "Action button updated",
  "Botão de aceite com um link de recusa discreto abaixo.": "Accept button with a subtle decline link below.",
  "Botão de pular": "Skip button",
  "Botão de pular com contagem regressiva no vídeo de entrada": "Skip button with a countdown in the entry video",
  "Botão de Thumb": "Thumbnail Button",
  "Botão desativado": "Button disabled",
  "Botão discreto sobre o vídeo": "Discreet button over the video",
  "Botão não visível neste momento": "Button not visible at this time",
  "Botão para transmitir o vídeo": "Button to cast the video",
  "Botão play pequeno": "Small play button",
  "Botão Play Pequeno": "Small play button",
  "Botão Principal": "Primary Button",
  "Botão Principal (CTA)": "Primary Button (CTA)",
  "Botão reiniciar": "Restart button",
  "Botão removido": "Button removed",
  "Botão WhatsApp": "WhatsApp Button",
  "Botões das opções": "Option buttons",
  "Botões Inteligentes com Tempo e Ação": "Smart Buttons with Timing and Actions",
  "Braip": "Braip",
  "Branco": "White",
  "Brasil": "Brazil",
  "Brasília (GMT-3)": "Brasília (GMT-3)",
  "breadcrumb": "breadcrumb",
  "Breadcrumb": "Breadcrumb",
  "BRL": "BRL",
  "BRL + Taxas estimadas": "BRL + Estimated fees",
  "broip": "broip",
  "Broip lidera com 53% das conversões hoje.": "Broip leads with 53% of conversions today.",
  "Build Tool": "Build Tool",
  "Bunny": "Bunny",
  "Busca rápida por aula em qualquer módulo": "Quick lesson search in any module",
  "Buscando...": "Searching...",
  "Buscar": "Search",
  "Buscar aula...": "Search lessons...",
  "Buscar comentário": "Search comments",
  "Buscar domínio...": "Search domains...",
  "Buscar e selecionar idiomas": "Search and select languages",
  "Buscar e selecionar países": "Search and select countries",
  "Buscar e selecionar regiões": "Search and select regions",
  "Buscar e-mail...": "Search email...",
  "Buscar em {value0}": "Search in {value0}",
  "Buscar fluxo": "Search flows",
  "Buscar fluxo pelo nome": "Search flows by name",
  "Buscar integração...": "Search integrations...",
  "Buscar intro...": "Search intros...",
  "Buscar legenda...": "Search subtitle...",
  "Buscar Mini-Hook": "Search Mini-Hook",
  "Buscar origem...": "Search sources...",
  "Buscar por e-mail": "Search by email",
  "Buscar por E-mail": "Search by Email",
  "Buscar por email...": "Search by email...",
  "Buscar por nome ou email...": "Search by name or email...",
  "Buscar por nome, e-mail ou telefone": "Search by name, email, or phone",
  "Buscar por título, pasta ou tag...": "Search by title, folder, or tag...",
  "Buscar por URL, Token ou Vídeo": "Search by URL, Token, or Video",
  "Buscar recurso...": "Search features...",
  "Buscar Registro por E-mail": "Search Record by Email",
  "Buscar URL, domínio ou página": "Search URL, domain, or page",
  "Buscar Usuário": "Search User",
  "Buscar Usuário por E-mail": "Search User by Email",
  "Buscar vídeo...": "Search videos...",
  "Buscar vídeo…": "Search videos…",
  "Buscar vídeos": "Search videos",
  "Buscar vídeos ou pastas…": "Search videos or folders…",
  "Buscar vídeos...": "Search videos...",
  "Buscar...": "Search...",
  "Busque e selecione múltiplos vídeos de uma vez": "Search and select multiple videos at once",
  "Busque um usuário para gerenciar nível, status, plano e cliques operacionais.": "Search for a user to manage their level, status, plan, and operational clicks.",
  "Busque, crie, edite ou exclua registros de incremento condicional de clicks por usuário.": "Search, create, edit, or delete conditional click increment records by user.",
  "Button text is required": "Button text is required",
  "Button text too long": "Button text too long",
  "C. no botão": "Button color",
  "C. no Botão": "Button color",
  "Cabeçalho desktop": "Desktop header",
  "Cabeçalho mobile": "Mobile header",
  "Cache limpo! Recarregando...": "Cache cleared! Reloading...",
  "Cada etapa é um vídeo com uma pergunta e até 4 opções. Cada opção leva a outra etapa ou a uma saída, como o checkout ou o WhatsApp. Você escolhe quando as opções aparecem e se o vídeo pausa até o visitante responder.": "Each step is a video with a question and up to 4 options. Each option leads to another step or an exit, such as checkout or WhatsApp. Choose when options appear and whether the video pauses until visitors answer.",
  "Cada linha mostra a % de pessoas que continuam assistindo ao longo do tempo.": "Each line shows the percentage of people who continue watching over time.",
  "Cada linha representa um tipo de introdução testada.": "Each line represents a type of intro tested.",
  "Cada opção pode levar a outro vídeo ou a uma saída, como uma oferta, um checkout ou o WhatsApp.": "Each option can lead to another video or an exit, such as an offer, checkout, or WhatsApp.",
  "Cada visitante vê um começo diferente e, ao final, a VSL principal continua automaticamente, como se fosse um único vídeo.": "Each visitor sees a different opening, then the main VSL continues automatically as if it were a single video.",
  "cadastrado ainda.": "registered yet.",
  "Cadastrar": "Register",
  "Cadastre este webhook na plataforma, para as compras deste checkout:": "Register this webhook on the platform for purchases from this checkout:",
  "Cadastre quantas pessoas precisar, cada uma com o próprio e-mail e a própria senha": "Add as many people as needed, each with their own email and password",
  "Cadastre um cartão antes de comprar": "Add a card before purchasing",
  "Cadastre-se": "Sign up",
  "Cadastro": "Registration",
  "Cakto": "Cakto",
  "Calendário de Disponibilidade": "Availability Calendar",
  "Câmbio": "Exchange rate",
  "Campanha (Campaign)": "Campaign",
  "Campeão da Semana": "Weekly Winner",
  "Campo de cupom": "Coupon field",
  "Campo de Senha": "Password Field",
  "Campo desconhecido: {value0}": "Unknown field: {value0}",
  "Campo Extra": "Extra Field",
  "Campo não usado neste template": "Field not used in this template",
  "Campo obrigatório": "Required field",
  "Campo obrigatório para proteção por senha": "Required field for password protection",
  "Campos": "Fields",
  "Campos ativos:": "Active fields:",
  "Campos de Entrada": "Input Fields",
  "Campos do Formulário": "Form Fields",
  "Campos inválidos": "Invalid fields",
  "Campos obrigatórios": "Required fields",
  "Campos para Captura": "Capture Fields",
  "Campos Preenchidos": "Completed Fields",
  "Campos Selecionados": "Selected Fields",
  "Campos um abaixo do outro, com o botão em largura total": "Fields stacked vertically with a full-width button",
  "Cancelado": "Canceled",
  "Cancelamento confirmado": "Cancellation confirmed",
  "Cancelando...": "Canceling...",
  "Cancelar": "Cancel",
  "Cancelar Agendamento": "Cancel Schedule",
  "Cancelar Assinatura": "Cancel Subscription",
  "Cancelar edição": "Cancel editing",
  "Cancelar envio": "Cancel upload",
  "Cancelar o envio de": "Cancel upload of",
  "Cancelar uploads": "Cancel uploads",
  "Cantos Arredondados": "Rounded Corners",
  "Capa Principal (Hero)": "Main Cover (Hero)",
  "Capacidade e Acesso": "Capacity and Access",
  "Capacidade por slot (opcional)": "Capacity per slot (optional)",
  "Caps Lock está ativado": "Caps Lock is on",
  "Captura com E-mail": "Capture with Email",
  "Captura com Senha": "Capture with Password",
  "Captura de Dados": "Data Capture",
  "Captura de leads": "Lead Capture",
  "Captura de Leads": "Lead Capture",
  "Captura desativada": "Capture disabled",
  "Capturar E-mail": "Capture Email",
  "Capturar Nome": "Capture Name",
  "Capturar WhatsApp": "Capture WhatsApp",
  "Capturas nos Últimos 7 Dias": "Captures in the Last 7 Days",
  "caracteres": "characters",
  "Card com a sua cara: título, descrição, cores, tamanho, arredondamento e animação de entrada": "A card that matches your brand: title, description, colors, size, rounded corners, and entrance animation",
  "Card de CTA clicável estilo YouTube: título, descrição, botão e link pra sua oferta": "YouTube-style clickable CTA card: title, description, button, and link to your offer",
  "Card de métricas unificado": "Unified metrics card",
  "Card de parceiro premium": "Premium partner card",
  "Card de playlist": "Playlist card",
  "Card de teste na lista": "Test card in list",
  "Card de vídeo": "Video card",
  "Card sortável com slider": "Sortable card with slider",
  "Cards de métricas": "Metric cards",
  "Cards de regras com footer mostrando data de criação, toggle de ativação, modais de seleção de vídeo premium.": "Rule cards with a footer showing creation date, activation toggle, and premium video selection dialogs.",
  "Carregado": "Loaded",
  "Carregamento mais rápido no início do vídeo": "Faster loading at the beginning of the video",
  "Carregando análise de custos...": "Loading cost analysis...",
  "Carregando custos...": "Loading costs...",
  "Carregando dados da estratégia...": "Loading strategy data...",
  "Carregando dados de retenção...": "Loading retention data...",
  "Carregando dados do pagamento...": "Loading payment data...",
  "Carregando dados...": "Loading data...",
  "Carregando detalhes do compartilhamento…": "Loading sharing details…",
  "Carregando detalhes...": "Loading details...",
  "Carregando estratégias...": "Loading strategies...",
  "Carregando integrações...": "Loading integrations...",
  "Carregando logs...": "Loading logs...",
  "Carregando mais vídeos...": "Loading more videos...",
  "Carregando membros...": "Loading members...",
  "Carregando métricas...": "Loading metrics...",
  "Carregando o fluxo": "Loading flow",
  "Carregando o mapa…": "Loading map…",
  "Carregando pastas...": "Loading folders...",
  "Carregando plataformas": "Loading platforms",
  "Carregando plataformas...": "Loading platforms...",
  "Carregando proteções...": "Loading protections...",
  "Carregando rastreamentos...": "Loading tracking...",
  "Carregando recursos...": "Loading features...",
  "Carregando registros da rede...": "Loading network records...",
  "Carregando registros...": "Loading records...",
  "Carregando solicitações...": "Loading requests...",
  "Carregando vídeo...": "Loading video...",
  "Carregando vídeos...": "Loading videos...",
  "Carregando vídeos…": "Loading videos…",
  "Carregando...": "Loading...",
  "Carregar bloco": "Load block",
  "Carregar do celular": "Upload from phone",
  "Carregar um novo vídeo": "Upload a new video",
  "Carregaram o fluxo": "Loaded the flow",
  "Cartão": "Card",
  "Cartão adicionado com sucesso!": "Card added successfully!",
  "Cartão adicionado, mas não foi possível defini-lo como padrão.": "Card added, but it could not be set as default.",
  "Cartão atualizado com sucesso!": "Card updated successfully!",
  "Cartão expirado": "Card expired",
  "Cartão padrão atualizado!": "Default card updated!",
  "Cartão removido com sucesso!": "Card removed successfully!",
  "Cartão selecionado!": "Card selected!",
  "CartPanda": "CartPanda",
  "Catálogo moderno com fundo escuro e carrossel horizontal. Ideal para playlists longas.": "Modern catalog with a dark background and horizontal carousel. Ideal for long playlists.",
  "CC": "CC",
  "Celular": "Mobile phone",
  "Central": "Center",
  "Central de ajuda": "Help Center",
  "Central de Ajuda": "Help Center",
  "Centralizado": "Centered",
  "Centralizar": "Center",
  "Centro": "Center",
  "Centro Direita": "Center Right",
  "Centro Direito": "Middle Right",
  "Centro Esquerda": "Center Left",
  "Centro Esquerdo": "Middle Left",
  "CEP (00000-000)": "Postal code (00000-000)",
  "Certifique-se de que seu vídeo carrega rapidamente em todos os dispositivos e conexões.": "Make sure your video loads quickly on all devices and connections.",
  "Chama atenção sem poluir": "Attracts attention without clutter",
  "Chamada da oferta": "Offer callout",
  "Chamada de oferta com botão e link de saída.": "Offer callout with a button and exit link.",
  "Chamada Principal (CTA)": "Primary Call to Action (CTA)",
  "Chamar no chat": "Start a chat",
  "Chat": "Chat",
  "Chat com suporte": "Support chat",
  "Chat com Suporte": "Support Chat",
  "Chave": "Key",
  "Chave / Identificador": "Key / Identifier",
  "Chave copiada": "Key copied",
  "Chave criada": "Key created",
  "Chave de integração Payt (integration_key)": "Payt integration key (integration_key)",
  "Chave PIX": "PIX Key",
  "Chave PIX (CPF, E-mail, Celular ou Aleatória)": "PIX Key (CPF, Email, Mobile, or Random)",
  "Chave PIX cadastrada": "Registered PIX key",
  "Chave revogada": "Key revoked",
  "Chaves de API": "API Keys",
  "Checkout": "Checkout",
  "Checkout ÷ plays. Não confirma a compra.": "Checkout ÷ plays. Does not confirm a purchase.",
  "Checkout de alta conversão para negócios digitais.": "High-converting checkout for digital businesses.",
  "Checkout do plano": "Plan checkout",
  "Chegaram ao principal": "Reached the main video",
  "Chegou a Audiência em Tempo Real: um mapa-múndi que mostra, ao vivo, quem está assistindo às suas VSLs neste exato momento e de onde no mundo. Acompanhe quantas pessoas estão na sua oferta agora, quais vídeos estão bombando e de quais fontes de tráfego elas vieram — tudo atualizando sozinho.": "Real-Time Audience is here: a world map showing live who is watching your VSLs right now and where they are. Track how many people are viewing your offer, which videos are trending, and which traffic sources brought them — all updating automatically.",
  "Chegou a Contagem Final Inteligente: assim que o vídeo acaba, um card com contagem regressiva aparece e leva o espectador ao próximo passo, sem aquele silêncio depois do último argumento. Você define o tempo da contagem, escreve o título e a descrição do card e decide o desfecho — redirecionar automaticamente para o seu link ou apenas exibir o aviso, deixando a pessoa fechar e voltar ao vídeo. O card ainda combina com a sua marca: cores, tamanho, arredondamento e animação de entrada são todos ajustáveis.": "Smart Final Countdown is here: as soon as the video ends, a countdown card appears and takes viewers to the next step, avoiding silence after your final argument. Set the countdown duration, write the card title and description, and choose the outcome — automatically redirect to your link or simply display the notice, letting viewers close it and return to the video. The card also matches your brand: colors, size, rounded corners, and entrance animation are all adjustable.",
  "Chegou a integração com o TikTok Ads. Cadastre o ID do pixel e o token de acesso do seu Events Manager e a HostVSL passa a enviar ao TikTok os eventos de quem assiste às suas VSLs: visualização da página, play, retenção e tempo assistido. O envio é feito direto do nosso servidor pela API de eventos do TikTok, então você não precisa colar nenhum código extra na sua página e o seu token fica guardado com segurança.": "TikTok Ads integration is here. Register your pixel ID and Events Manager access token, and HostVSL will send TikTok events from your VSL viewers: page views, plays, retention, and watch time. Events are sent directly from our server through the TikTok Events API, so you do not need to add extra code to your page, and your token is stored securely.",
  "Chegou a Jornada de Conversão: agora você encaixa um vídeo de entrada antes da sua VSL principal e, se quiser, um vídeo de saída logo depois — tudo no estilo anúncio do YouTube. Use a entrada pra criar contexto, qualificar ou aquecer o lead antes do conteúdo principal, e a saída pra reforçar a oferta e chamar pra ação assim que o vídeo termina. Os vídeos saem da sua própria biblioteca, com botão de pular, card de CTA clicável e métricas de cada etapa.": "Conversion Journey is here: place an entry video before your main VSL and, optionally, an exit video right after it — in the style of a YouTube ad. Use the entry video to provide context, qualify, or warm up leads before the main content, and the exit video to reinforce your offer and call to action as soon as the video ends. Videos come from your own library, with a skip button, clickable CTA card, and metrics for each stage.",
  "Chegou no Pitch": "Reached the Pitch",
  "Chegou o recurso Picos de Horário. Agora você identifica com clareza quando seu público mais assiste, em quais dias e em quais faixas de horário.": "Peak Hours is here. Now you can clearly identify when your audience watches most, on which days and during which time slots.",
  "Chegou o recurso Picos de Horário. Agora você identifica com clareza quando seu público mais assiste, em quais dias e em quais faixas de horário. Isso permite publicar com mais precisão, otimizar suas campanhas e aumentar o desempenho do vídeo com base em dados reais.": "Peak Hours is here. Now you can clearly identify when your audience watches most, on which days and during which time slots. This lets you publish more precisely, optimize campaigns, and improve video performance using real data.",
  "Chegou o Storyboard, um novo recurso dos controles do player. Ao passar o mouse pela barra de progresso, o espectador vê uma miniatura do frame correspondente àquele instante do vídeo. Ajuda a encontrar rapidamente um trecho específico ou voltar pra um ponto de interesse.": "Storyboard is here, a new player controls feature. Hovering over the progress bar shows viewers a thumbnail of the frame at that point in the video. It helps them quickly find a specific section or return to a point of interest.",
  "Chrome": "Chrome",
  "Cidade": "City",
  "Cidade/UF": "City/State",
  "Cidades": "Cities",
  "Cinco etapas do funil: Carregamentos, Visualizações Únicas, Plays Únicos, Cliques no Botão e Conversões": "Five funnel stages: Loads, Unique Views, Unique Plays, Button Clicks, and Conversions",
  "Cinza claro": "Light gray",
  "Circular": "Circular",
  "Clarear 5%": "Lighten 5%",
  "Claro premium": "Premium light",
  "Clássico para satisfação rápida.": "Classic choice for quick satisfaction ratings.",
  "Claude no notebook": "Claude on your laptop",
  "Clean 2.0 — Template Horizontal": "Clean 2.0 — Horizontal Template",
  "Clean:": "Clean:",
  "Clicar para iniciar": "Click to start",
  "Clicaram em pular": "Clicked skip",
  "Clicaram no botão": "Clicked the button",
  "Clicaram para assistir": "Clicked to watch",
  "Click": "Click",
  "Click Here": "Click Here",
  "Click Rate": "Click Rate",
  "Click to activate sound": "Click to activate sound",
  "Clicks": "Clicks",
  "Clicks a Incrementar": "Clicks to Add",
  "Clicks atualizados com sucesso!": "Clicks updated successfully!",
  "Clicks Configurados:": "Configured Clicks:",
  "Clicks Restantes:": "Remaining Clicks:",
  "Clicou na Oferta": "Clicked the Offer",
  "Cliente assinou um plano de R$ 100/mês": "Customer subscribed to a R$ 100/month plan",
  "Cliente Stripe não encontrado": "Stripe customer not found",
  "Clientes Ativos": "Active Customers",
  "Clientes que assinaram através do seu link.": "Customers who subscribed through your link.",
  "Clique Aqui": "Click Here",
  "Clique aqui e ative agora!": "Click here and activate now!",
  "Clique Automático": "Automatic Click",
  "Clique do usuário abrirá:": "User click will open:",
  "Clique em \"Buscar por E-mail\" para localizar um registro existente, ou \"Novo Registro\" para criar um novo incremento.": "Click \"Search by Email\" to find an existing record, or \"New Record\" to create a new increment.",
  "Clique em \"Usar Esta Thumbnail\" para aplicar.": "Click \"Use This Thumbnail\" to apply.",
  "Clique no botão \"Buscar Usuário\" localizado no topo para pesquisar e gerenciar uma conta por e-mail.": "Click \"Search User\" at the top to search and manage an account by email.",
  "Clique no botão abaixo para visualizar o modal premium de incorporação de vídeo HostVSL.": "Click the button below to view the premium HostVSL video embed dialog.",
  "Clique no botão acima para instalar o app no seu dispositivo": "Click the button above to install the app on your device",
  "Clique no botão azul para abrir o upload e enviar seu primeiro vídeo.": "Click the blue button to open uploads and upload your first video.",
  "Clique ou arraste o arquivo .VTT ou .SRT": "Click or drag the .VTT or .SRT file",
  "Clique ou arraste o arquivo aqui": "Click or drag the file here",
  "Clique para ajustar o pitch": "Click to adjust the pitch",
  "Clique para alterar": "Click to change",
  "Clique para Editar": "Click to Edit",
  "Clique para editar tempo": "Click to edit time",
  "Clique para escolher. Máximo: 5MB": "Click to choose. Maximum: 5MB",
  "Clique para fazer upload": "Click to upload",
  "Clique para fazer upload (1920×700px)": "Click to upload (1920×700px)",
  "Clique para ouvir": "Click to listen",
  "Clique para selecionar .SRT ou .VTT": "Click to select .SRT or .VTT",
  "Clique para trocar": "Click to replace",
  "Clique para ver os uploads": "Click to view uploads",
  "cliques": "clicks",
  "Cliques": "Clicks",
  "Cliques CTA": "CTA Clicks",
  "cliques na oferta": "offer clicks",
  "Cliques no Botão": "Button Clicks",
  "Cliques no CTA": "CTA clicks",
  "Cliques no CTA de entrada": "Entry CTA clicks",
  "Cliques no CTA final": "Final CTA clicks",
  "Cliques sobre exibições": "Clicks over impressions",
  "Cliques Totais": "Total Clicks",
  "Cliques Únicos": "Unique Clicks",
  "Cliques:": "Clicks:",
  "Cloaker": "Cloaker",
  "Cloaker — Sistema de Regras": "Cloaker — Rule System",
  "Cloaker de VSL": "VSL Cloaker",
  "Cloaker de VSL reformulado": "Redesigned VSL Cloaker",
  "Cloaker VSL": "VSL Cloaker",
  "Clone páginas existentes em minutos para acelerar testes": "Clone existing pages in minutes to speed up testing",
  "Clone páginas validadas": "Clone proven pages",
  "Close": "Close",
  "Cloudflare": "Cloudflare",
  "Cobrança automática após 15 dias. Cancele a qualquer momento.": "Automatic billing after 15 days. Cancel anytime.",
  "Cód. Banco": "Bank Code",
  "Código": "Code",
  "Código copiado com sucesso!": "Code copied successfully!",
  "Código copiado para a área de transferência": "Code copied to clipboard",
  "Código copiado para a área de transferência!": "Code copied to clipboard!",
  "Código copiado!": "Code copied!",
  "Código Copiado!": "Code copied!",
  "Código copiado.": "Code copied.",
  "Código copiado. Cole na página onde o vídeo deve aparecer.": "Code copied. Paste it on the page where the video should appear.",
  "Código copiado. Ele só mostra o vídeo depois que o fluxo for publicado.": "Code copied. It only displays the video after the flow is published.",
  "Código copiado. O fluxo está pausado: o vídeo só aparece quando ele for retomado.": "Code copied. The flow is paused: the video will only appear when it is resumed.",
  "Código da Máquina": "Machine Code",
  "Código de acesso": "Access code",
  "Código de acesso é obrigatório": "Access code is required",
  "Código de E-mail": "Email Code",
  "Código de incorporação do fluxo para colar no site.": "Flow embed code to paste on your website.",
  "Código do fluxo": "Flow code",
  "Código do Funil": "Funnel Code",
  "Código do idioma (ex: pt, en, es)": "Language code (e.g., pt, en, es)",
  "Código enviado para seu e-mail!": "Code sent to your email!",
  "Código HTML": "HTML code",
  "Código HTML personalizado": "Custom HTML code",
  "Código inválido.": "Invalid code.",
  "Código JavaScript:": "JavaScript Code:",
  "Código reenviado!": "Code resent!",
  "cole": "paste",
  "Cole a integration_key configurada na Payt": "Paste the integration_key configured in Payt",
  "Cole a URL completa, incluindo https://.": "Paste the full URL, including https://.",
  "Cole a URL de webhook abaixo no painel": "Paste the webhook URL below into the dashboard",
  "Cole aqui o token gerado pela plataforma": "Paste the token generated by the platform here",
  "Cole este código onde deseja exibir o vídeo. A proteção será aplicada automaticamente conforme a regra configurada.": "Paste this code wherever you want the video to appear. Protection will be applied automatically according to the configured rule.",
  "Cole na página onde o vídeo deve aparecer. O código não muda quando você publica de novo.": "Paste it on the page where the video should appear. The code does not change when you publish again.",
  "Cole o código abaixo na tag": "Paste the code below into the tag",
  "Cole o código de acesso aqui": "Paste the access code here",
  "Cole o código em um bloco HTML da sua página de vendas. Publique a página e pronto: seu vídeo já estará no ar.": "Paste the code into an HTML block on your sales page. Publish the page and you're done: your video is live.",
  "Cole o código na sua landing page para ativar a proteção.": "Paste the code into your landing page to enable protection.",
  "Cole o ID do pixel fornecido pela plataforma de anúncios": "Paste the pixel ID provided by the advertising platform",
  "Cole o token do pixel": "Paste the pixel token",
  "Cole seu código HTML aqui...\nAceita HTML, CSS inline e scripts leves.": "Paste your HTML code here...\nAccepts HTML, inline CSS, and lightweight scripts.",
  "Cole seu código HTML aqui...&#10;Aceita HTML, CSS inline e scripts leves.": "Paste your HTML code here...&#10;Accepts HTML, inline CSS and lightweight scripts.",
  "Coleta Nome, E-mail, WhatsApp e ativa formulário no player.": "Collects Name, Email, WhatsApp and enables the form in the player.",
  "Coletando dados em tempo real": "Collecting data in real time",
  "Colete avaliações dos espectadores diretamente no player": "Collect viewer ratings directly in the player",
  "Coloque um vídeo de entrada antes da sua VSL e um de saída depois, no estilo anúncio do YouTube, pra conduzir o espectador até a próxima ação.": "Place an entry video before your VSL and an exit video after it, in the style of a YouTube ad, to guide viewers to the next action.",
  "Colunas": "Columns",
  "Colunas (": "Columns (",
  "Colunas visíveis": "Visible columns",
  "com": "with",
  "Com 100 indicações no plano Premium, você ganha": "With 100 referrals on the Premium plan, you earn",
  "Com a AdSniper você espiona em tempo real as ofertas que estão escalando na Meta Ads e descobre rapidamente quais criativos, ângulos e funis estão convertendo. Use o cupom 50%OFF e garanta 50% de desconto em qualquer plano.": "With AdSniper, monitor offers scaling on Meta Ads in real time and quickly discover which creatives, angles, and funnels are converting. Use the 50%OFF coupon to get 50% off any plan.",
  "Com as legendas ativadas, você pode adicionar arquivos": "With captions enabled, you can add files",
  "Com as legendas ativadas, você pode adicionar arquivos .SRT ou .VTT ao seu vídeo. O espectador poderá ativar ou desativar a legenda pelo botão CC nos controles.": "With subtitles enabled, you can add .SRT or .VTT files to your video. Viewers can toggle them via the CC button on the controls.",
  "Com base nos dados coletados,": "Based on the data collected,",
  "Com base nos dados reais, descubra qual introdução tem melhor performance e finalize o teste.": "Use real data to discover which intro performs best and finish the test.",
  "Com base nos dados reais, descubra qual variante tem melhor performance e finalize o teste quando tiver confiança.": "Use real data to discover which variant performs best and finish the test when you are confident.",
  "Com o Teste de hook, nossos usuários relatam em média:": "With hook testing, our users report an average of:",
  "Comandos Úteis": "Useful Commands",
  "Combine com Botão de Ação e Headline para reforçar a oferta": "Combine with Action Button and Headline to reinforce the offer",
  "começa com": "starts with",
  "Começa com": "Starts with",
  "Começa em": "Starts at",
  "Começar pela etapa": "Start from step",
  "Comece a usar direto pelo menu Ferramentas": "Start using it from the Tools menu",
  "Comece com seu primeiro Mini-Hook": "Start with your first Mini-Hook",
  "Comece com um vídeo perguntando “Qual é o seu maior desafio?”. A resposta “Estou começando” leva a uma explicação dos fundamentos; “Já vendo e quero crescer” leva a um vídeo mais avançado. Cada sequência pode terminar em uma oferta específica ou encaminhar a pessoa para conversar no WhatsApp. É o visitante quem escolhe a próxima etapa, sem sair do player entre os vídeos.": "Start with a video asking “What is your biggest challenge?”. The answer “I'm just starting” leads to an explanation of the basics; “I'm already selling and want to grow” leads to a more advanced video. Each sequence can end with a specific offer or direct visitors to a WhatsApp conversation. Visitors choose the next step without leaving the player between videos.",
  "Comece com uma pergunta intrigante ou uma afirmação surpreendente que gere interesse imediato.": "Start with an intriguing question or a surprising statement that sparks immediate interest.",
  "Comece conectando suas plataformas 🎯": "Start by connecting your platforms 🎯",
  "Comece criando sua primeira pasta para organizar seus vídeos": "Start by creating your first folder to organize your videos",
  "Comece dando um nome ao seu teste": "Start by naming your test",
  "Comece enviando seu primeiro vídeo para acompanhar métricas e performance.": "Start by uploading your first video to track metrics and performance.",
  "Comece enviando seu primeiro vídeo.": "Start by uploading your first video.",
  "Comece fazendo upload do seu primeiro vídeo.": "Start by uploading your first video.",
  "Comentários recentes": "Recent comments",
  "Comissão": "Commission",
  "Comissão do seller atualizada com sucesso!": "Seller commission updated successfully!",
  "Comissão do Seller:": "Seller Commission:",
  "Comissão Individual": "Individual Commission",
  "Comissão Recorrente": "Recurring Commission",
  "Comissão Recorrente Mensal (20%)": "Monthly Recurring Commission (20%)",
  "Comissões Recebidas": "Commissions Received",
  "comissões recorrentes": "recurring commissions",
  "Como acompanhar os resultados": "How to track results",
  "Como acompanho meus resultados?": "How do I track my results?",
  "Como ficará no vídeo": "How it will look in the video",
  "Como Funciona": "How It Works",
  "Como funciona a comparação de VSLs": "How VSL comparison works",
  "Como funciona a Proteção Anti-Plágio?": "How does Anti-Plagiarism Protection work?",
  "Como funciona a VSL Dinâmica": "How Dynamic VSL works",
  "Como funciona o pagamento da comissão?": "How are commissions paid?",
  "Como funciona o programa?": "How does the program work?",
  "Como funciona o recurso de legendas": "How captions work",
  "Como funciona o Teste de hook": "How hook testing works",
  "Como funciona o teste de velocidade?": "How does speed testing work?",
  "Como funciona o teste?": "How does the test work?",
  "Como funciona os plays extras": "How extra plays work",
  "Como funciona?": "How does it work?",
  "Como funcionam os testes A/B": "How A/B tests work",
  "Como funcionam os testes de introduções": "How intro tests work",
  "Como Ganhar Com Sua Rede": "How to Earn with Your Network",
  "Como interpretar o gráfico de retenção": "How to interpret the retention chart",
  "Como interpretar os testes de velocidade": "How to interpret speed tests",
  "Como interpretar?": "How to interpret?",
  "Como montar seu fluxo": "How to build your flow",
  "Como o vídeo começa": "How the video starts",
  "Como o vídeo deve se comportar quando o formulário aparece": "How the video should behave when the form appears",
  "Como podemos te ajudar?": "How can we help you?",
  "Como seu público está acessando": "How your audience accesses content",
  "Como seu público interagiu": "How your audience interacted",
  "Como subir seu primeiro vídeo": "How to upload your first video",
  "Como usar": "How to use",
  "Como Usar Headlines/Subheadlines": "How to Use Headlines/Subheadlines",
  "Como usar:": "How to use:",
  "Como você avalia este conteúdo?": "How would you rate this content?",
  "Como você deseja continuar?": "How would you like to continue?",
  "Como você deseja proteger seus vídeos?": "How would you like to protect your videos?",
  "Comp. Média da Conta": "Compare with Account Average",
  "Comp. Vídeo Anterior": "Compare with Previous Video",
  "Compacto": "Compact",
  "Comparação da retenção de audiência entre diferentes introduções": "Audience retention comparison between different intros",
  "Comparação da retenção de audiência entre diferentes vídeos": "Audience retention comparison between different videos",
  "Comparação de Plataformas": "Platform Comparison",
  "Comparação dos melhores horários por device": "Comparison of best times by device",
  "Comparação Visual": "Visual Comparison",
  "Comparado aos 30d anteriores": "Compared with the previous 30 days",
  "Comparar agora": "Compare now",
  "Comparar VSL": "Compare VSL",
  "Comparativo das Introduções": "Intro Comparison",
  "Comparativo de Performance": "Performance Comparison",
  "Comparativo dos Vídeos": "Video Comparison",
  "Comparativo por Variação": "Comparison by Variation",
  "Comparativo por Velocidade": "Comparison by Speed",
  "Compare como cada variação influencia a permanência da audiência ao longo do vídeo.": "Compare how each variation affects audience retention throughout the video.",
  "Compare como cada velocidade influencia a permanência da audiência ao longo do vídeo.": "Compare how each speed affects audience retention throughout the video.",
  "Compare diferentes aberturas do seu vídeo e descubra qual gera mais engajamento.": "Compare different openings for your video and discover which drives more engagement.",
  "Compare diferentes variações do seu vídeo e descubra qual converte melhor.": "Compare different variations of your video and discover which converts best.",
  "Compare horários recomendados com ranking de melhores faixas": "Compare recommended times with a ranking of the best slots",
  "Compare horários recomendados com ranking de melhores faixas para repetir o que já funciona": "Compare recommended times with a ranking of the best slots to repeat what already works",
  "Compare introduções, distribua o tráfego automaticamente e otimize sua conversão com dados reais": "Compare intros, distribute traffic automatically, and optimize conversions with real data",
  "Compare métricas de retenção nos primeiros 30 segundos": "Compare retention metrics in the first 30 seconds",
  "Compare métricas por período": "Compare metrics by period",
  "Compare no mínimo 3 velocidades diferentes para melhores resultados": "Compare at least 3 different speeds for better results",
  "Compare o desempenho das introduções ao longo do vídeo principal.": "Compare intro performance throughout the main video.",
  "Compare plataformas": "Compare platforms",
  "Compare plays, impressões e usuários únicos por fonte de tráfego.": "Compare plays, impressions, and unique users by traffic source.",
  "Compare resultados baseados na origem do tráfego (Facebook vs Instagram vs Email).": "Compare results by traffic source (Facebook vs Instagram vs Email).",
  "Compare suas VSLs lado a lado e descubra qual performa melhor": "Compare your VSLs side by side and discover which performs best",
  "Compare versões e descubra o que mais converte.": "Compare versions and discover what converts best.",
  "Compare VSLs, distribua o tráfego automaticamente e otimize sua conversão com dados reais": "Compare VSLs, distribute traffic automatically, and optimize conversions with real data",
  "Compartilhado por": "Shared by",
  "Compartilhamento de Vídeos com Equipe e Afiliados": "Video Sharing with Teams and Affiliates",
  "Compartilhamento desativado": "Sharing disabled",
  "Compartilhamento excluído com sucesso!": "Share deleted successfully!",
  "Compartilhamento não encontrado": "Share not found",
  "compartilhamentos": "shares",
  "Compartilhando vídeo": "Sharing video",
  "Compartilhar": "Share",
  "Compartilhar Vídeo com Afiliados": "Share Video with Affiliates",
  "Compartilhe o vídeo para começar a coletar avaliações dos espectadores.": "Share the video to start collecting viewer ratings.",
  "Compartilhe seu link": "Share your link",
  "Compartilhe vídeos com afiliados por link e acompanhe tudo.": "Share videos with affiliates by link and track everything.",
  "Compartilhe vídeos com link seguro": "Share videos with a secure link",
  "Compartilhe vídeos com seus afiliados para que eles possam divulgar suas ofertas. Acesse seus vídeos e clique em \"Compartilhar\" para começar.": "Share videos with your affiliates so they can promote your offers. Go to your videos and click \"Share\" to get started.",
  "Compatibilidade": "Compatibility",
  "Complete esta etapa para continuar": "Complete this step to continue",
  "Completude dos dados": "Data completeness",
  "Completude:": "Completeness:",
  "Component Stack:": "Component Stack:",
  "Componente": "Component",
  "Componentes e modais com padrão unificado": "Components and dialogs with a unified standard",
  "Componentes e modais com padrão unificado do novo front": "Components and dialogs following the new frontend's unified standard",
  "Componentes Principais": "Main Components",
  "Components": "Components",
  "Comportamento": "Behavior",
  "Comportamento de Envio": "Submission Behavior",
  "Comportamento de Loop": "Loop Behavior",
  "Comportamento de visualização dos leads": "Lead viewing behavior",
  "Comportamento do Modal": "Dialog Behavior",
  "Comportamento do Player": "Player Behavior",
  "Comportamento do Vídeo": "Video Behavior",
  "Comportamento do Vídeo de Fundo": "Background video behavior",
  "Comprados separadamente": "Purchased separately",
  "Comprar": "Buy",
  "Comprar agora": "Buy now",
  "Compras aprovadas na integração do fluxo": "Approved purchases in the flow integration",
  "Compre plays extras para continuar exibindo seus vídeos": "Buy extra plays to keep showing your videos",
  "Comprovante": "Receipt",
  "Comprovante ampliado": "Enlarged receipt",
  "Comprovante atual": "Current receipt",
  "Comprovante de pagamento": "Payment receipt",
  "Comprovante de Pagamento": "Payment Receipt",
  "Comprovante de Transferência": "Transfer Receipt",
  "computados.": "counted.",
  "Compute": "Compute",
  "concluído": "completed",
  "Concluído": "Completed",
  "Concluídos": "Completed",
  "Concluir": "Finish",
  "Conclusão da entrada": "Entry completion",
  "Conclusão da saída": "Exit completion",
  "Condição": "Condition",
  "Condição liberada apenas nesta janela.": "Offer available only during this window.",
  "Condição secundária": "Secondary terms",
  "Conectado": "Connected",
  "Conectado como": "Connected as",
  "Conectando...": "Connecting...",
  "Conectar": "Connect",
  "Conectar Google Drive": "Connect Google Drive",
  "Conectar Novo Pixel": "Connect New Pixel",
  "Conectar Plataforma": "Connect Platform",
  "Conectar rastreamento": "Connect tracking",
  "Conectar Rastreamento": "Connect Tracking",
  "Conecte com chat e notificações de vendas": "Connect with chat and sales notifications",
  "Conecte ferramentas de automação, analytics, CRM e muito mais.": "Connect automation, analytics, CRM tools, and more.",
  "Conecte o Google Ads às suas VSLs e envie as conversões de play, oferta e checkout para as suas campanhas.": "Connect Google Ads to your VSLs and send play, offer, and checkout conversions to your campaigns.",
  "Conecte pixels do Meta, Google e TikTok para rastrear conversões.": "Connect Meta, Google, and TikTok pixels to track conversions.",
  "Conecte seu rastreamento para ver o vídeo campeão.": "Connect tracking to see the winning video.",
  "Conecte seu Tracking para ver receita": "Connect Tracking to see revenue",
  "Conecte sua conta Google": "Connect your Google account",
  "Conecte sua conta Google com permissão somente de leitura — não tocamos em nada do seu Drive": "Connect your Google account with read-only access — we do not change anything in your Drive",
  "Conecte sua plataforma para acompanhar vendas e receita. Acesso ao checkout não confirma compra.": "Connect your platform to track sales and revenue. A checkout visit does not confirm a purchase.",
  "Conecte sua primeira plataforma de pagamentos": "Connect your first payment platform",
  "Conecte uma plataforma de conversão para ver vendas e receita por intro nas métricas do teste.": "Connect a conversion platform to see sales and revenue per intro in the test metrics.",
  "Conecte uma plataforma em Rastreamento para começar a acumular faturamento.": "Connect a platform in Tracking to start accumulating revenue.",
  "Conecte-se com o público através de histórias pessoais ou casos reais que despertem emoção.": "Connect with your audience through personal stories or real cases that evoke emotion.",
  "Config. Player": "Player Settings",
  "Configuração": "Configuration",
  "Configuração aplicada com sucesso": "Configuration applied successfully",
  "Configuração da thumbnail do vídeo": "Video thumbnail settings",
  "Configuração de Pixel": "Pixel Configuration",
  "Configuração de Velocidade Manual": "Manual Speed Configuration",
  "Configuração do Botão": "Button Setup",
  "Configuração dos vídeos": "Video settings",
  "Configuração guiada passo a passo": "Guided step-by-step configuration",
  "Configuração incompleta": "Incomplete configuration",
  "Configuração Manual": "Manual Configuration",
  "Configuração não encontrada": "Configuration not found",
  "Configuração Personalizada": "Custom configuration",
  "Configuração salva com sucesso.": "Configuration saved successfully.",
  "Configuração salva!": "Configuration saved!",
  "Configurações": "Settings",
  "Configurações aplicadas em {value0} vídeo(s)": "Settings applied to {value0} video(s)",
  "Configurações Avançadas": "Advanced Settings",
  "Configurações da barra de progresso": "Progress bar settings",
  "Configurações da Borda": "Border Settings",
  "Configurações da legenda": "Subtitle settings",
  "Configurações da logo atualizadas": "Logo settings updated",
  "Configurações da thumbnail salvas": "Thumbnail settings saved",
  "Configurações das Seções": "Section Settings",
  "Configurações de Captura de Dados": "Data Capture Settings",
  "Configurações de controle do player": "Player control settings",
  "Configurações de Idioma": "Language Settings",
  "Configurações de Notificações": "Notification Settings",
  "configurações de personalização atuais": "current customization settings",
  "Configurações de Recebimento": "Payout Settings",
  "Configurações de Sombra": "Shadow Settings",
  "Configurações de Temporizador": "Timer Settings",
  "Configurações importadas!": "Settings imported!",
  "Configurações Prime Video Dark": "Prime Video Dark Settings",
  "Configurações prontas. Clique em \"Aplicar\" para iniciar o teste.": "Settings ready. Click \"Apply\" to start the test.",
  "Configurações resetadas": "Settings reset",
  "Configurações salvas!": "Settings saved!",
  "Configurações Técnicas": "Technical settings",
  "Configurações técnicas e avançadas do player de vídeo.": "Technical and advanced video player settings.",
  "Configurar": "Configure",
  "Configurar Distribuição": "Configure Distribution",
  "Configurar Feedback do Vídeo": "Configure Video Feedback",
  "Configurar Funil": "Configure Funnel",
  "Configurar Integração": "Configure Integration",
  "Configurar integração com": "Configure integration with",
  "Configurar integração com Facebook": "Configure Facebook integration",
  "Configurar Pitch de Vendas": "Configure Sales Pitch",
  "Configurar Pixel": "Configure Pixel",
  "Configurar Pixels": "Configure Pixels",
  "Configurar Rastreamento": "Configure Tracking",
  "Configurar Recurso": "Configure Feature",
  "Configurar Tracking": "Configure Tracking",
  "Configure a distribuição de tráfego para continuar": "Configure traffic distribution to continue",
  "Configure a página de inscrição do seu webinário. As alterações aparecem na prévia em tempo real.": "Configure your webinar registration page. Changes appear in the preview in real time.",
  "Configure as informações essenciais do seu webinário.": "Configure your webinar's essential information.",
  "Configure as informações principais do seu webinário": "Configure your webinar's main information",
  "Configure bordas personalizadas no player.": "Configure custom player borders.",
  "Configure campos, estilo e comportamento da captura de leads": "Configure lead capture fields, style, and behavior",
  "Configure como o autoplay se comporta": "Configure how autoplay behaves",
  "Configure como o modal se comporta": "Configure dialog behavior",
  "Configure comportamentos específicos do player dependendo do dispositivo do espectador. Ofereça a melhor experiência em desktop, tablet e mobile de forma automática.": "Configure specific player behaviors based on the viewer's device. Automatically provide the best experience on desktop, tablet, and mobile.",
  "Configure CTAs no momento certo do vídeo.": "Configure CTAs at the right moment in the video.",
  "Configure domínios personalizados para seus vídeos.": "Configure custom domains for your videos.",
  "Configure e ative o teste para coletar dados": "Configure and activate the test to collect data",
  "Configure formulários de captura integrados ao seu vídeo.": "Configure capture forms integrated with your video.",
  "Configure integrações para enviar seus leads capturados": "Configure integrations to send your captured leads",
  "Configure limites e regras de entrada": "Configure limits and entry rules",
  "Configure manualmente ou execute testes A/B automáticos para otimizar o engajamento.": "Configure manually or run automatic A/B tests to optimize engagement.",
  "Configure no menu Pixel, na aba Configurações, no card \"Google Ads\"": "Configure the \"Google Ads\" card in the Pixel menu's Settings tab",
  "Configure no menu Pixel, na aba Configurações, no card \"TikTok\"": "Configure the \"TikTok\" card in the Pixel menu's Settings tab",
  "Configure o agendamento para ver a prévia": "Configure scheduling to see the preview",
  "Configure o botão de ação dos seus vídeos": "Configure your videos' action button",
  "Configure o botão de ação se desejar": "Configure the action button if you wish",
  "Configure o botão de inscrição": "Configure the registration button",
  "Configure o botão e visualize no preview": "Configure the button and check the preview",
  "Configure o call-to-action principal": "Configure the primary call to action",
  "Configure o comportamento de reprodução do vídeo.": "Configure video playback behavior.",
  "Configure o formulário para ver a prévia": "Configure the form to see the preview",
  "Configure o rastreamento de conversões para ver suas vendas aqui.": "Configure conversion tracking to see your sales here.",
  "Configure o termo de consentimento": "Configure the consent statement",
  "Configure o tracking de conversões para acompanhar receita, conversões e performance dos seus vídeos.": "Configure conversion tracking to track revenue, conversions, and video performance.",
  "Configure o vídeo para retornar automaticamente ao início quando terminar. Com Autoplay ativo, entra em loop contínuo. Caso contrário, fica pausado no início pronto para ser assistido novamente.": "Configure the video to automatically return to the beginning when it ends. With Autoplay enabled, it loops continuously. Otherwise, it pauses at the beginning, ready to watch again.",
  "Configure opções de qualidade adaptativa para diferentes velocidades de internet.": "Configure adaptive quality options for different internet speeds.",
  "Configure opções de reprodução automática": "Configure autoplay options",
  "Configure opções visuais e de comportamento do formulário": "Configure form appearance and behavior",
  "Configure os botões de reprodução e volume.": "Configure playback and volume buttons.",
  "Configure os controles disponíveis para o espectador.": "Configure the controls available to viewers.",
  "Configure os módulos e bônus no painel de edição": "Configure modules and bonuses in the editing panel",
  "Configure os textos do botão de ação": "Configure action button text",
  "Configure os valores da oferta": "Configure offer values",
  "Configure para recarregar plays automaticamente": "Set up automatic play top-ups",
  "Configure pixels de rastreamento para monitorar conversões": "Configure tracking pixels to monitor conversions",
  "Configure quando a headline aparece e desaparece": "Configure when the headline appears and disappears",
  "Configure rastreamento avançado para acompanhar todo o funil.": "Configure advanced tracking to monitor the entire funnel.",
  "Configure seu link de afiliado e ganhe comissões quando novos usuários se cadastrarem.": "Enter your affiliate link to earn commissions. The HostVSL logo will automatically appear in the upper right corner of the video.",
  "Configure seu primeiro funil": "Configure your first funnel",
  "Configure seu primeiro pixel": "Configure your first pixel",
  "Configure seu vídeo com recursos inteligentes para máxima conversão": "Configure your video with smart features for maximum conversions",
  "Configure sua headline para ver o preview no vídeo principal": "Configure your headline to see the preview in the main video",
  "Configure sua primeira proteção em poucos passos.": "Set up your first protection in a few steps.",
  "Configure sua Recarga Automática": "Set Up Automatic Top-Ups",
  "Configure suas legendas": "Set up your subtitles",
  "Configure tamanho e posição por dispositivo.": "Configure size and position per device.",
  "Configure testes A/B automáticos com diferentes velocidades para otimizar o engajamento do seu público.": "Configure automatic A/B tests with different speeds to optimize your audience engagement.",
  "Configure tudo em uma única jornada": "Configure everything in a single journey",
  "Configure um teste na aba \"Teste A/B\" para visualizar curvas de retenção.": "Configure a test in the \"A/B Test\" tab to view retention curves.",
  "Confira o player com as alterações atuais. Esta prévia não contabiliza plays. Saídas exibem o endereço de destino.": "Check the player with the current changes. This preview does not count plays. Exits display the destination address.",
  "Confira se o arquivo está publicado em:": "Check that the file is published at:",
  "Confirmar": "Confirm",
  "Confirmar cancelamento": "Confirm cancellation",
  "Confirmar Compra": "Confirm Purchase",
  "Confirmar e Sacar": "Confirm and Withdraw",
  "Confirmar e Sincronizar Banco": "Confirm and Sync Bank",
  "Confirmar exclusão": "Confirm deletion",
  "Confirmar Nova Senha": "Confirm New Password",
  "Confirmar Plataformas": "Confirm Platforms",
  "Confirmar Recarga": "Confirm Top-Up",
  "Confirmar Resgate": "Confirm Redemption",
  "Confirmar Seleção": "Confirm Selection",
  "Confirmar senha": "Confirm password",
  "Confirme abaixo para adicionar o vídeo à sua conta HostVSL.": "Confirm below to add the video to your HostVSL account.",
  "Confirme as variações e distribuição de tráfego antes de iniciar o teste.": "Confirm variations and traffic distribution before starting the test.",
  "Conforto": "Comfort",
  "Conheça a AdSniper com uma condição especial para usuários da Host VSL.": "Discover AdSniper with a special offer for Host VSL users.",
  "Conheça a Replic, a nossa ferramenta para criar e clonar sites de alta conversão em poucos minutos. Comece gratuitamente em apenas um clique, sem precisar cadastrar cartão de crédito, e ganhe velocidade para validar suas ofertas.": "Meet Replic, our tool for creating and cloning high-converting websites in minutes. Start for free in just one click, without adding a credit card, and validate your offers faster.",
  "Conheça os pilares da Host VSL e entenda como cada área se conecta para acelerar sua operação.": "Explore the pillars of Host VSL and understand how each area connects to accelerate your operations.",
  "Consentimento LGPD": "LGPD Consent",
  "Considere aumentar o tráfego para": "Consider increasing traffic to",
  "Considere o público-alvo: usuários mais técnicos geralmente são mais receptivos a velocidades mais rápidas.": "Consider your audience: more technical users are usually more receptive to faster speeds.",
  "Considere otimizar o início do pitch.": "Consider optimizing the beginning of the pitch.",
  "Considere storytelling": "Consider storytelling",
  "Considere substituir por uma das outras introduções que performam melhor": "Consider replacing it with one of the better-performing intros",
  "Considere testar campanhas neste horário para explorar oportunidades de crescimento.": "Consider testing campaigns at this time to explore growth opportunities.",
  "Consolida o resumo diário de métricas do período (dia de hoje é lido ao vivo)": "Consolidates the period's daily metrics summary (today is read live)",
  "Construa funil de vendas em minutos": "Build a sales funnel in minutes",
  "Construa quizzes em minutos com editor visual": "Build quizzes in minutes with a visual editor",
  "Construtor visual com etapas conectadas: cada vídeo pode ter uma pergunta e até quatro opções de resposta.": "Visual builder with connected steps: each video can have a question and up to four answer options.",
  "Consultores de Vendas": "Sales Consultants",
  "Consumo no seu plano": "Your plan usage",
  "Conta": "Account",
  "Conta apenas quem está realmente assistindo com o som ativo — audiência engajada de verdade": "Counts only people actually watching with sound enabled — a truly engaged audience",
  "Conta Bancária": "Bank Account",
  "Conta bancária definida como principal!": "Bank account set as primary!",
  "Conta Bancária Tradicional": "Traditional Bank Account",
  "Conta bancária vinculada com sucesso!": "Bank account linked successfully!",
  "Conta com dígito": "Account with check digit",
  "Conta corrente": "Checking account",
  "Conta criada com sucesso! Agora escolha seu plano para começar.": "Account created successfully! Now choose your plan to get started.",
  "Conta definida pelo usuário para recebimento.": "Account designated by the user for receiving payments.",
  "conta Google": "Google account",
  "Contador de \"assistindo agora\" que se atualiza sozinho a cada poucos segundos": "\"Watching now\" counter that updates automatically every few seconds",
  "Contagem": "Countdown",
  "Contagem base": "Base count",
  "Contagem Final Inteligente": "Smart Final Countdown",
  "Contagem Final salva": "Final Countdown saved",
  "Contagem regressiva de 3 a 60 segundos ao final do vídeo, sobreposta ao player ou em tela cheia": "Countdown from 3 to 60 seconds at the end of the video, overlaid on the player or full screen",
  "Container do Formulário": "Form Container",
  "Contas de Recebimento": "Payout Accounts",
  "Contas vinculadas": "Linked accounts",
  "Conte um pouco mais": "Tell us a little more",
  "contém": "contains",
  "Contém": "Contains",
  "Content Preview": "Content Preview",
  "Conteúdo": "Content",
  "Conteúdo (Content)": "Content",
  "Conteúdo de Continuar de onde parou": "Continue Watching content",
  "Conteúdo do Card": "Card Content",
  "Conteúdo HTML": "HTML content",
  "Conteúdo protegido": "Protected content",
  "Contexto Global": "Global Context",
  "Contexts": "Contexts",
  "Continuar": "Continue",
  "Continuar agora": "Continue now",
  "Continuar assistindo": "Continue Watching",
  "Continuar Assistindo": "Continue Watching",
  "Continuar assistindo?": "Continue watching?",
  "Continuar conectado": "Stay connected",
  "Continuar de onde parou": "Continue where you left off",
  "Continuar e Assistir": "Continue and Watch",
  "Continuar editando": "Continue editing",
  "Continuar enviando": "Continue uploading",
  "Continuar para o editor": "Continue to editor",
  "CONTINUAR SEM ESSA OFERTA": "CONTINUE WITHOUT THIS OFFER",
  "Continuar sem rastreamento": "Continue without tracking",
  "Continue Assistindo": "Continue Watching",
  "Continue com storytelling": "Continue with storytelling",
  "Continue para a próxima aula": "Continue to the next lesson",
  "Continue para personalizar seu vídeo": "Continue to customize your video",
  "Continue para personalizar seu vídeo com botões inteligentes e mais": "Continue to customize your video with smart buttons and more",
  "Continue refinando suas histórias. Adicione mais elementos emocionais, conflitos claros e resoluções satisfatórias.": "Keep refining your stories. Add more emotional elements, clear conflicts, and satisfying resolutions.",
  "Continue testando diferentes abordagens para descobrir o que ressoa melhor com seu público.": "Keep testing different approaches to discover what resonates best with your audience.",
  "Continue usando storytelling eficiente, já que sua curva de retenção mostra alta eficácia.": "Keep using effective storytelling, as your retention curve shows high effectiveness.",
  "Contornado": "Outlined",
  "Contraste adequado com o fundo": "Proper contrast with background",
  "Contraste adequado:": "Adequate contrast:",
  "Contraste insuficiente (": "Insufficient contrast (",
  "Contraste insuficiente: {value0}:1 (mínimo 4.5:1 para acessibilidade)": "Insufficient contrast: {value0}:1 (minimum 4.5:1 for accessibility)",
  "Controle a velocidade de reprodução.": "Control playback speed.",
  "Controle como o player aparece em cada dispositivo: Desktop, Tablet e Celular": "Control how the player appears on each device: Desktop, Tablet, and Mobile",
  "Controle de volume": "Volume control",
  "Controle de Volume": "Volume control",
  "Controle em quais dispositivos o vídeo será exibido: desktop, tablet ou celular.": "Control which devices display the video: desktop, tablet, or mobile.",
  "Controle o acesso com toggle de ativação, limite de cópias e data de expiração": "Control access with an activation toggle, copy limit, and expiration date",
  "Controle o que é mostrado no formulário": "Control what appears in the form",
  "Controle por localização": "Control by location",
  "Controle por origem de tráfego": "Control by traffic source",
  "Controle quando as opções aparecem, quando o vídeo pausa e se é possível assistir novamente à última etapa.": "Control when options appear, when the video pauses, and whether viewers can watch the last step again.",
  "Controle quem pode assistir sua VSL por localização, dispositivo e comportamento.": "Control who can watch your VSL by location, device, and behavior.",
  "Controle quem pode copiar seus vídeos": "Control who can copy your videos",
  "Controle total sobre a aparência do seu autoplay.": "Full control over autoplay appearance.",
  "Controles": "Controls",
  "Controles Adicionais": "Additional Controls",
  "Controles de Reprodução": "Playback controls",
  "Controles desabilitados": "Controls disabled",
  "Controles desativados automaticamente. Barra fake e controles não podem estar ativos ao mesmo tempo.": "Controls disabled automatically. The fake bar and controls cannot be enabled at the same time.",
  "Controles do player": "Player controls",
  "Controles do Player": "Player controls",
  "Controles do Vídeo": "Video Controls",
  "Controles foram desabilitados automaticamente ao ativar autoplay": "Controls were automatically disabled when enabling autoplay",
  "Controles foram desativados automaticamente. Autoplay e controles não podem estar ativos ao mesmo tempo.": "Controls were disabled automatically. Autoplay and controls cannot be enabled at the same time.",
  "Controles Principais": "Main controls",
  "conv": "conv",
  "Conv": "Conv",
  "Conv:": "Conv:",
  "conv.": "conv.",
  "Conv.": "Conv.",
  "Conversão": "Conversion",
  "CONVERSÃO": "CONVERSION",
  "Conversão de abertura": "Opening conversion",
  "Conversão em venda": "Sales conversion",
  "Conversão final": "Final conversion",
  "Conversão por Dia": "Conversion by Day",
  "Conversão por Horário": "Conversion by Hour",
  "Conversão Total do Funil": "Total Funnel Conversion",
  "Conversão:": "Conversion:",
  "Converse com a gente!": "Talk to us!",
  "Conversion Rate": "Conversion Rate",
  "conversões": "conversions",
  "Conversões": "Conversions",
  "Conversões & Receita": "Conversions & Revenue",
  "Conversões ÷ Plays únicos no período": "Conversions ÷ Unique plays in the period",
  "Conversões dividido por visualizações": "Conversions divided by views",
  "Conversões e receita rastreadas pelas plataformas conectadas": "Conversions and revenue tracked by connected platforms",
  "Conversões hoje": "Conversions today",
  "Conversões por dia e horário": "Conversions by day and time",
  "Conversões Totais": "Total Conversions",
  "Conversões:": "Conversions:",
  "Converta seu texto para o formato aceito.": "Convert your text to the accepted format.",
  "Converter para VTT": "Convert to VTT",
  "convertido": "converted",
  "Convidado em:": "Invited on:",
  "Convidar Cliente": "Invite Customer",
  "Convidar Parceiro": "Invite Partner",
  "Convide clientes e vendedores para a Host VSL e receba comissões automáticas sempre que sua rede gerar resultados.": "Invite customers and sellers to Host VSL and receive automatic commissions whenever your network delivers results.",
  "Convite enviado com sucesso!": "Invitation sent successfully!",
  "cópia": "copy",
  "Copiada": "Copied",
  "Copiado": "Copied",
  "Copiado com sucesso!": "Copied successfully!",
  "Copiado para a área de transferência": "Copied to clipboard",
  "Copiado!": "Copied!",
  "Copiando de:": "Copying from:",
  "Copiando…": "Copying…",
  "Copiar": "Copy",
  "Copiar chave": "Copy key",
  "Copiar código": "Copy Code",
  "Copiar Código": "Copy Code",
  "Copiar código de embed": "Copy embed code",
  "Copiar código de incorporação": "Copy embed code",
  "Copiar código de incorporação do vídeo": "Copy video embed code",
  "Copiar Código de Integração": "Copy Integration Code",
  "Copiar código de performance": "Copy performance code",
  "Copiar código JS": "Copy JS code",
  "Copiar código performance": "Copy performance code",
  "Copiar cupom": "Copy coupon",
  "Copiar dados": "Copy data",
  "Copiar Detalhes": "Copy Details",
  "Copiar e-mail": "Copy email",
  "Copiar Embed": "Copy Embed",
  "Copiar Insight": "Copy Insight",
  "Copiar link": "Copy link",
  "Copiar para minha conta": "Copy to my account",
  "Copiar telefone": "Copy phone number",
  "Copiar token": "Copy token",
  "Copiar URL": "Copy URL",
  "Copiar webhook": "Copy webhook",
  "cópias": "copies",
  "Cópias (7d)": "Copies (7d)",
  "Cópias por Dia": "Copies per Day",
  "Copie agora. Por segurança, não guardamos a chave — só uma impressão digital dela, que não tem volta. Esta é a única vez que a chave \"": "Copy it now. For security, we do not store the key — only an irreversible fingerprint. This is the only time the key \"",
  "Copie o código abaixo e cole onde deseja incorporar o player com o botão de ação configurado.": "Copy the code below and paste it where you want to embed the player with the configured action button.",
  "Copie o código do teste e atualize o embed no seu site para que ele comece a rodar.": "Copy the test code and update the embed on your site to start running it.",
  "Copie o código do teste e atualize o embed no seu site. Término: {value0}": "Copy the test code and update the embed on your site. Ends: {value0}",
  "Cor": "Color",
  "Cor 1": "Color 1",
  "Cor 2": "Color 2",
  "Cor ao passar o mouse": "Hover color",
  "Cor atual:": "Current color:",
  "Cor Base": "Base Color",
  "Cor da barra": "Bar color",
  "Cor da Barra": "Bar Color",
  "Cor da borda": "Border color",
  "Cor da Borda": "Border color",
  "Cor da Descrição": "Description Color",
  "Cor da Headline": "Headline Color",
  "Cor da letra": "Text color",
  "Cor da pergunta": "Question color",
  "Cor da sombra": "Shadow color",
  "Cor da Subheadline": "Subheadline color",
  "Cor de destaque": "Accent color",
  "Cor de Destaque (botões e elementos interativos)": "Accent Color (buttons and interactive elements)",
  "Cor de fundo": "Background color",
  "Cor de Fundo": "Background color",
  "Cor de Fundo do Card": "Card Background Color",
  "Cor de fundo dos controles": "Controls background color",
  "Cor de fundo e opacidade da barra inferior.": "Bottom bar background color and opacity.",
  "Cor do botão": "Button color",
  "Cor do Botão": "Button color",
  "Cor do Círculo": "Circle Color",
  "Cor do Corpo": "Body Color",
  "Cor do destaque": "Highlight color",
  "Cor do fundo": "Background color",
  "Cor do Fundo": "Background color",
  "Cor do Header": "Header Color",
  "Cor do Ícone": "Icon color",
  "Cor do ícone e do texto": "Icon and text color",
  "Cor do Número": "Number Color",
  "Cor do play grande": "Large Play Button Color",
  "Cor do Play Grande": "Large Play Button Color",
  "Cor do Progresso": "Progress Color",
  "Cor do rodapé": "Footer Color",
  "Cor do Rodapé": "Footer Color",
  "Cor do texto": "Text color",
  "Cor do Texto": "Text color",
  "Cor do texto no overlay": "Overlay text color",
  "Cor do Título": "Title Color",
  "Cor dos controles": "Control Colors",
  "Cor dos Controles": "Control Colors",
  "Cor e espessura de cada texto. O tamanho é definido no card de Conteúdo.": "Color and weight of each text element. Size is set in the Content card.",
  "Cor personalizada": "Custom color",
  "Cor Personalizada": "Custom Color",
  "Cor Primária": "Primary color",
  "Cor principal": "Main color",
  "Cor Principal": "Main Color",
  "Cor Secundária": "Secondary color",
  "Cor Sólida": "Solid color",
  "Cor sólida uniforme": "Uniform solid color",
  "Cor, espessura e arredondamento da borda.": "Border color, thickness and corner radius.",
  "Cores": "Colors",
  "Cores do Autoplay": "Autoplay colors",
  "Cores do Botão": "Button colors",
  "Cores do overlay": "Overlay colors",
  "Cores do Overlay": "Overlay colors",
  "Cores do Player": "Player colors",
  "Cores do segundo botão em estado normal e ao passar o mouse.": "Second button colors in normal and hover states.",
  "Cores do Texto": "Text Colors",
  "Cores do trilho, do preenchimento e do texto exibido sobre a barra.": "Colors for the track, fill, and text displayed over the bar.",
  "Cores e Estilos": "Colors and Styles",
  "Cores Principais": "Primary Colors",
  "Corrigida borda azul do vídeo selecionado que estava sendo cortada no modal de upload. Adicionado padding ao grid e substituído ring por border sólida.": "Fixed the selected video's blue border being clipped in the upload dialog. Added grid padding and replaced the ring with a solid border.",
  "Corrigido bug onde isFinalStep calculava incorretamente, fazendo o botão Iniciar Teste aparecer na etapa 2. Alterado de currentStep === totalSteps - 1 para currentStep === totalSteps.": "Fixed incorrect isFinalStep calculation that caused the Start Test button to appear at step 2. Changed currentStep === totalSteps - 1 to currentStep === totalSteps.",
  "Corrigir agora →": "Fix now →",
  "Corrigir Problemas": "Fix Issues",
  "Corrija e tente de novo.": "Fix it and try again.",
  "CPF": "CPF",
  "Cpf Cadastrado": "Registered CPF",
  "CPF inválido.": "Invalid CPF.",
  "cpf:": "cpf:",
  "Crescimento de 27% nos cliques em botões de ação": "27% increase in action button clicks",
  "Crescimento vs Período Anterior": "Growth vs Previous Period",
  "Cria conexão emocional e aumenta a memorização do conteúdo": "Creates an emotional connection and improves content recall",
  "Criada em": "Created on",
  "Criado em": "Created on",
  "Criado em:": "Created on:",
  "Criado por": "Created by",
  "Criando": "Creating",
  "Criando conta...": "Creating account...",
  "Criando cópia do vídeo na sua conta...": "Creating a copy of the video in your account...",
  "Criando teste...": "Creating test...",
  "Criando uma Nova Feature": "Creating a New Feature",
  "Criando...": "Creating...",
  "Criar": "Create",
  "Criar A/B": "Create A/B",
  "Criar Ação": "Create Action",
  "Criar Captura": "Create Capture",
  "Criar Captura com E-mail": "Create Email Capture",
  "Criar Captura com Senha": "Create Password Capture",
  "Criar Captura de Dados": "Create Data Capture",
  "Criar chave": "Create key",
  "Criar Componentes e Página": "Create Components and Page",
  "Criar conta grátis": "Create free account",
  "Criar e abrir o editor": "Create and open editor",
  "Criar fluxo": "Create flow",
  "Criar Formulário com E-mail": "Create Email Form",
  "Criar Funil": "Create Funnel",
  "Criar minha Playlist": "Create my Playlist",
  "Criar minha primeira proteção": "Create my first protection",
  "Criar Mini-Hook": "Create Mini-Hook",
  "Criar Nova Ação": "Create New Action",
  "Criar nova pasta": "Create new folder",
  "Criar Nova Playlist": "Create New Playlist",
  "Criar nova senha": "Create new password",
  "Criar novo teste": "Create new test",
  "Criar novo Teste A/B": "Create new A/B Test",
  "Criar novo Teste de hook": "Create new Hook Test",
  "Criar Novo Vídeo": "Create New Video",
  "Criar o Store (se necessário)": "Create the Store (if needed)",
  "Criar pasta": "Create folder",
  "Criar Playlist": "Create Playlist",
  "Criar Primeira Ação": "Create First Action",
  "Criar primeira chave": "Create first key",
  "Criar primeira pasta": "Create first folder",
  "Criar Primeira Pasta": "Create First Folder",
  "Criar primeiro Mini-Hook": "Create first Mini-Hook",
  "Criar Primeiro Webinário": "Create First Webinar",
  "Criar proteção": "Create protection",
  "Criar Proteção": "Create Protection",
  "Criar Quiz": "Create Quiz",
  "Criar Registro": "Create Record",
  "Criar Regra": "Create Rule",
  "Criar Regra UTM": "Create UTM Rule",
  "Criar saída": "Create exit",
  "Criar seu primeiro teste": "Create your first test",
  "Criar Sites": "Create Websites",
  "Criar Sites com a Replic": "Create Websites with Replic",
  "Criar teste": "Create test",
  "Criar Teste": "Create Test",
  "Criar Teste A/B": "Create A/B Test",
  "Criar Teste de Hook": "Create Hook Test",
  "Criar Teste de Introdução": "Create Intro Test",
  "Criar Teste de Introduções": "Create Intro Test",
  "Criar Teste de Velocidade": "Create Speed Test",
  "Criar Variação": "Create Variation",
  "Criar Webinário": "Create Webinar",
  "Crie capturas com e-mail ou senha, conecte integrações e acompanhe relatórios completos dos leads gerados.": "Create email or password capture forms, connect integrations, and track complete reports on generated leads.",
  "Crie e clone páginas em poucos minutos com a Replic, sem cartão de crédito.": "Create and clone pages in minutes with Replic, without a credit card.",
  "Crie e clone sites com IA que permite personalizar e hospedar páginas web em segundos.": "Create and clone websites with AI that lets you customize and host web pages in seconds.",
  "Crie funis de conversão para entender como seus visitantes se comportam ao longo do vídeo.": "Create conversion funnels to understand how visitors behave throughout the video.",
  "Crie funis de vídeo em que o visitante escolhe o caminho até a compra": "Create video funnels where visitors choose their path to purchase",
  "Crie funis interativos de vendas para todos os nichos.": "Create interactive sales funnels for every niche.",
  "Crie jornadas interativas com botões que levam a vídeos diferentes.": "Create interactive journeys with buttons leading to different videos.",
  "Crie páginas de alta conversão em poucos cliques.": "Create high-converting pages in a few clicks.",
  "Crie páginas de captura em cima dos seus vídeos, colete leads e acompanhe o desempenho em tempo real.": "Create capture pages over your videos, collect leads, and track performance in real time.",
  "Crie pastas e subpastas ilimitadas": "Create unlimited folders and subfolders",
  "Crie pelo menos 2 variações para continuar": "Create at least 2 variations to continue",
  "Crie proteções num passo a passo simples, do vídeo às regras": "Create protections with a simple step-by-step process, from video to rules",
  "Crie quizzes interativos para qualificar leads e aumentar conversão com a FunnelX.": "Create interactive quizzes with FunnelX to qualify leads and increase conversions.",
  "Crie regras para filtrar e redirecionar tráfego com base em critérios": "Create rules to filter and redirect traffic based on criteria",
  "Crie seu primeiro teste": "Create your first test",
  "Crie seu primeiro teste A/B": "Create your first A/B test",
  "Crie seu primeiro teste A/B para comparar diferentes versões de vídeos.": "Create your first A/B test to compare different video versions.",
  "Crie seu primeiro teste de hook": "Create your first hook test",
  "Crie seu primeiro webinário e comece a converter mais leads com experiências interativas.": "Create your first webinar and start converting more leads through interactive experiences.",
  "Crie seu primeiro webinário para começar a acompanhar métricas detalhadas de desempenho.": "Create your first webinar to start tracking detailed performance metrics.",
  "Crie Seu Teste de Hook": "Create Your Hook Test",
  "Crie sites do zero com blocos prontos e premium": "Create sites from scratch using ready-made premium blocks",
  "Crie sua conta": "Create your account",
  "Crie sua conta agora!": "Create your account now",
  "Crie sua Playlist": "Create your Playlist",
  "Crie sua primeira ação para começar": "Create your first action to get started",
  "Crie sua primeira variação": "Create your first variation",
  "Crie um Funil Poderoso que permite 1X1 baseado em eventos e disparos em massa multicanais. É tudo o que você precisa para mandar a mensagem certa na hora certa e maximizar as suas vendas!": "Create a Powerful Funnel for one-to-one communication based on events and multichannel bulk sends. Everything you need to send the right message at the right time and maximize sales!",
  "Crie um gancho emocional": "Create an emotional hook",
  "Crie um teste para otimizar a velocidade do seu vídeo.": "Create a test to optimize your video speed.",
  "Crie um título que prometa valor real e seja irresistível para seu público-alvo. Considere incluir números ou resultados específicos.": "Create a title that promises real value and is irresistible to your target audience. Consider including numbers or specific results.",
  "Crie uma chave para conectar o Claude à sua conta e perguntar sobre as métricas dos seus vídeos por conversa.": "Create a key to connect Claude to your account and ask about your video metrics in a conversation.",
  "Crie uma coleção organizada de vídeos": "Create an organized video collection",
  "Crie uma pasta": "Create a folder",
  "Crie uma proteção para controlar quem pode assistir sua VSL, bloquear tráfego suspeito e redirecionar acessos inválidos para um vídeo alternativo.": "Create protection to control who can watch your VSL, block suspicious traffic, and redirect invalid visits to an alternative video.",
  "Crie uma subpasta ou adicione vídeos para organizar seu conteúdo": "Create a subfolder or add videos to organize your content",
  "Crie vídeos de entrada e saída para conduzir o espectador até a próxima ação": "Create entry and exit videos to guide viewers to the next action",
  "Crie webinários ao vivo, simulados ou just-in-time": "Create live, simulated, or just-in-time webinars",
  "Critério de vitória": "Victory criteria",
  "Crítico": "Critical",
  "CSV": "CSV",
  "CSV (.csv)": "CSV (.csv)",
  "CSV exportado com sucesso": "CSV exported successfully",
  "CSV exportado com sucesso!": "CSV exported successfully!",
  "CSV exportado!": "CSV exported!",
  "CTA centralizado": "Centered CTA",
  "CTA do vídeo de entrada": "Entry video CTA",
  "CTA do vídeo de saída": "Exit video CTA",
  "CTR": "CTR",
  "CTR do CTA final": "Final CTA CTR",
  "CTR Geral": "Overall CTR",
  "Cupom aplicado": "Coupon applied",
  "Cupom aplicado:": "Coupon applied:",
  "Cupom de desconto": "Discount coupon",
  "Cupom de desconto (opcional)": "Discount coupon (optional)",
  "Cupom de desconto aplicado": "Discount coupon applied",
  "Cupom e sorteio (visual apenas no MVP)": "Coupon and giveaway (visual only in the MVP)",
  "Cupom exclusivo 50%OFF para 50% de desconto em qualquer plano": "Exclusive 50%OFF coupon for 50% off any plan",
  "Cupom inválido": "Invalid coupon",
  "Cupom inválido. Corrija ou remova o cupom para continuar.": "Invalid coupon. Correct or remove it to continue.",
  "Cupom promocional aplicado automaticamente e não pode ser removido.": "Promotional coupon applied automatically and cannot be removed.",
  "Curva de Retenção": "Retention curve",
  "Curva de retenção ao longo do vídeo": "Retention curve throughout the video",
  "Curva de retenção do vídeo ao longo do tempo": "Video retention curve over time",
  "Curva de retenção por origem de tráfego": "Retention curve by traffic source",
  "Custo atualizado com sucesso!": "Cost updated successfully!",
  "Custo excluído!": "Cost deleted!",
  "Custo médio por usuário": "Average cost per user",
  "Custo Médio/Usuário": "Average Cost/User",
  "Custo total plataforma": "Total platform cost",
  "Custo Total Plataforma": "Total Platform Cost",
  "Custo Usuários": "User Costs",
  "Custom": "Custom",
  "Custom icon": "Custom icon",
  "Custom overlay": "Custom overlay",
  "customer id:": "customer id:",
  "Custos": "Costs",
  "Custos de Infraestrutura": "Infrastructure Costs",
  "Custos por Usuário": "Costs by User",
  "CVC": "CVC",
  "CVC inválido": "Invalid CVC",
  "D = Desativado": "D = Disabled",
  "da {value0}": "of {value0}",
  "da audiência ainda está assistindo (": "of the audience is still watching (",
  "da sua plataforma": "of your platform",
  "Dados": "Data",
  "Dados (": "Data (",
  "Dados Bancários": "Bank Details",
  "Dados bancários inválidos na Stripe.": "Invalid bank details in Stripe.",
  "Dados cadastrais obrigatórios exigidos pela Stripe Connect.": "Required registration details requested by Stripe Connect.",
  "Dados coletados de 01/05/2024 a 15/05/2024 · Total de 1.262 visitantes": "Data collected from May 1, 2024 to May 15, 2024 · Total of 1,262 visitors",
  "Dados de retenção, engajamento e conversão são coletados para cada intro.": "Retention, engagement, and conversion data are collected for each intro.",
  "Dados do pagamento não encontrados.": "Payment data not found.",
  "Dados do titular": "Account holder details",
  "Dados do vídeo não encontrados": "Video data not found",
  "Dados em tempo real sobre desempenho de captura para este vídeo": "Real-time capture performance data for this video",
  "Dados enviados! Sua conta está em análise temporária pela Stripe.": "Details submitted! Your account is temporarily under review by Stripe.",
  "Dados Gerais": "General Information",
  "Dados insuficientes": "Insufficient data",
  "Dados para Pagamento": "Payment Details",
  "Dados por timezone configurável": "Data by configurable time zone",
  "Dados resetados com sucesso!": "Data reset successfully!",
  "Dados simulados": "Simulated data",
  "Dados usados para validação da sua conta de recebimento.": "Data used to validate your payout account.",
  "Dark Members 2.0 — Template Premium": "Dark Members 2.0 — Premium Template",
  "Das {value0} pessoas que deram play, {value1} converteram.": "Of the {value0} people who played the video, {value1} converted.",
  "Das {value0} pessoas que viram seu vídeo, {value1} deram play.": "Of the {value0} people who saw your video, {value1} played it.",
  "Dashboard": "Dashboard",
  "Dashboard — 6 Cards Premium": "Dashboard — 6 Premium Cards",
  "Dashboard financeiro com totais, gráficos e listagem de custos AWS + despesas manuais.": "Financial dashboard with totals, charts, and a list of AWS costs + manual expenses.",
  "Dashboard principal (vídeos)": "Main dashboard (videos)",
  "Dashboard redesenhado com 6 cards executivos: Overview, TopVSL, PitchHealth, Engagement, ConversionsRevenue, Audience. Altura fixa 260px, skeletons com shimmer.": "Dashboard redesigned with 6 executive cards: Overview, TopVSL, PitchHealth, Engagement, ConversionsRevenue, Audience. Fixed 260px height and shimmer skeletons.",
  "Data": "Date",
  "Data da próxima cobrança": "Next billing date",
  "Data de Captura": "Capture Date",
  "Data de Nascimento": "Date of Birth",
  "Data do Convite": "Invitation Date",
  "Data e Hora": "Date and Time",
  "Data e Horário": "Date and Time",
  "Data Fetching": "Data Fetching",
  "Data inicial e data final são obrigatórias": "Start date and end date are required",
  "Data inválida": "Invalid date",
  "Data não disponível": "Date not available",
  "Data Solicitação": "Request Date",
  "Data/Hora": "Date/Time",
  "DDD": "Area code",
  "de": "from",
  "De": "From",
  "Dê acesso ao seu painel para quem trabalha com você, com permissões definidas recurso por recurso.": "Give dashboard access to the people you work with, with permissions defined for each feature.",
  "De até 20% do valor do plano de assinatura do indicado.": "Up to 20% of the referred customer's subscription plan price.",
  "de Conteúdo": "of Content",
  "De quem viu as opções": "Of those who saw the options",
  "De R$": "From R$",
  "de retenção": "retention",
  "de taxa de conversão": "conversion rate",
  "Dê um nome ao fluxo. Cada fluxo é um funil de vídeos curtos em que o visitante escolhe o próprio caminho.": "Name the flow. Each flow is a funnel of short videos where visitors choose their own path.",
  "Dê um nome para o seu teste de introduções. Escolha um nome descritivo que ajude você a identificar este teste no futuro.": "Name your intro test. Choose a descriptive name that will help you identify this test in the future.",
  "Dê um nome que lembre onde a chave vai ser usada. É por ele que você vai saber qual revogar quando tiver mais de uma.": "Choose a name that reminds you where the key will be used. This helps you know which one to revoke when you have more than one.",
  "de variação": "variation",
  "Defina a capa ideal para seu vídeo.": "Set the ideal cover for your video.",
  "Defina a data, duração e fuso. Nós cuidamos do resto.": "Set the date, duration, and time zone. We handle the rest.",
  "Defina a etapa inicial. Em cada etapa, selecione o vídeo, escreva a pergunta e adicione as respostas. Conecte cada resposta a outra etapa ou crie uma saída com o endereço de destino; você também escolhe se a página abre na mesma aba ou em uma nova.": "Set the initial step. For each step, select the video, write the question, and add answers. Connect each answer to another step or create an exit with a destination address; also choose whether the page opens in the same tab or a new one.",
  "Defina a ordem das variações": "Set variation order",
  "Defina a porcentagem de tráfego que cada intro receberá no teste.": "Set the traffic percentage each intro will receive in the test.",
  "Defina a porcentagem de tráfego que cada vídeo receberá no teste.": "Set the traffic percentage each video will receive in the test.",
  "Defina a senha que liberará o acesso ao vídeo": "Set the password that unlocks video access",
  "Defina a senha que o usuário precisará digitar para acessar o vídeo": "Set the password users must enter to access the video",
  "Defina antes quando as opções aparecem.": "First set when options appear.",
  "Defina as cores do botão e do texto em estado normal e ao passar o mouse.": "Set button and text colors for normal and hover states.",
  "Defina como o tráfego será distribuído": "Set how traffic is distributed",
  "Defina como o tráfego será distribuído entre as introduções. O total deve ser exatamente 100%.": "Set how traffic will be distributed among intros. The total must be exactly 100%.",
  "Defina como o tráfego será distribuído entre os vídeos selecionados. O total deve ser exatamente 100%.": "Set how traffic will be distributed among selected videos. The total must be exactly 100%.",
  "Defina como os campos são exibidos no player": "Set how fields appear in the player",
  "Defina imagens estratégicas para reforçar a atenção.": "Set strategic images to boost attention.",
  "Defina imagens estratégicas para reforçar atenção, retenção e conversão em momentos específicos do vídeo.": "Set strategic images to reinforce attention, retention, and conversion at specific moments in the video.",
  "Defina limites de cópias e expiração": "Set copy limits and expiration",
  "Defina o comportamento do player por aparelho.": "Set player behavior by device.",
  "Defina o momento e o comportamento que será executado no vídeo": "Set the timing and behavior to apply in the video",
  "Defina o momento em que a oferta aparece no vídeo. Cada vídeo pode ter até": "Set when the offer appears in the video. Each video can have up to",
  "Defina o momento exato onde sua oferta principal aparece no vídeo": "Set the exact moment your main offer appears in the video",
  "Defina o nível de cada recurso: sem acesso, visualização ou edição": "Set each feature's level: no access, view, or edit",
  "Defina o que acontece quando o espectador envia o feedback.": "Set what happens when viewers submit feedback.",
  "Defina o ritmo de alteração da audiência para deixar a simulação mais natural.": "Set the pace of audience changes to make the simulation more natural.",
  "Defina o tempo que o formulário será exibido durante o vídeo. O vídeo será pausado neste momento até que o formulário seja preenchido.": "Set when the form appears during the video. The video will pause at this point until the form is completed.",
  "Defina o texto e link do seu CTA.": "Set the text and link for your CTA.",
  "Defina o vídeo Principal": "Set the Main video",
  "Defina onde esta regra será aplicada": "Set where this rule applies",
  "Defina quando a oferta será exibida": "Set when the offer appears",
  "Defina quando e como as sessões acontecem": "Set when and how sessions take place",
  "Defina quando o botão aparecerá no vídeo.": "Choose when the button shows up in the video.",
  "Defina quando o formulário deve aparecer (formato min:seg)": "Set when the form should appear (min:sec format)",
  "Defina quando o teste deve encerrar": "Set when the test should end",
  "Defina se o vídeo deve voltar ao início automaticamente quando a reprodução terminar.": "Set whether the video should automatically return to the beginning when playback ends.",
  "Defina título e identificação da oferta": "Set the offer title and identification",
  "Defina um percentual exclusivo para este seller. Deixe vazio para usar a comissão padrão global.": "Set an exclusive percentage for this seller. Leave empty to use the global default commission.",
  "Defina um valor em \"Base\" para exibir um contador numérico junto com a mensagem.": "Set a \"Base\" value to display a numeric counter alongside the message.",
  "Defina uma data limite para o link funcionar": "Set an expiration date for the link",
  "Defina uma data para encerrar o teste automaticamente.": "Set a date to end the test automatically.",
  "Defina uma data para encerrar o teste e selecionar a melhor velocidade.": "Set a date to end the test and select the best speed.",
  "Defina uma velocidade fixa ou rode um teste automático para descobrir a melhor.": "Set a fixed speed or run an automatic test to find the best one.",
  "Defina uma velocidade fixa ou rode um teste automático.": "Set a fixed speed or run an auto test.",
  "Define a primeira impressão antes do play": "Defines the first impression before playback",
  "Define o horário de referência para a sessão": "Sets the session reference time",
  "Define quando o formulário de senha será exibido durante o vídeo": "Sets when the password form appears during the video",
  "Define se o vídeo repete automaticamente.": "Whether the video repeats automatically.",
  "Definição do Vídeo Base": "Base Video Definition",
  "Definir": "Set",
  "Definir como atual": "Set as current",
  "Definir como cartão padrão": "Set as default card",
  "Definir como início": "Set as start",
  "Definir como padrão/principal": "Set as default/primary",
  "Definir como principal": "Set as primary",
  "Definir pitch": "Set pitch",
  "Definir trecho do autoplay": "Set autoplay segment",
  "Definir URL": "Set URL",
  "Deixe vazio para exibir apenas a mensagem, sem contador numérico.": "Leave empty to display only the message without a numeric counter.",
  "Deixe vazio para ilimitado": "Leave empty for unlimited",
  "Deixe vazio para infinito": "Leave empty for infinite",
  "Deixe vazio para usar o nome da playlist": "Leave empty to use the playlist name",
  "Delay Adicional (ms)": "Additional Delay (ms)",
  "Delay sincronizado com vídeo": "Delay synchronized with video",
  "Deletando...": "Deleting...",
  "Deletar": "Delete",
  "demais origens": "other sources",
  "Demo: Modal de Incorporação": "Demo: Embed Dialog",
  "Demonstração do dashboard Host VSL": "Host VSL dashboard demo",
  "Dentro do formulário": "Inside the form",
  "Depoimento de Cliente": "Customer Testimonial",
  "Depois": "After",
  "Depois do principal": "After the main video",
  "Depois você envia os vídeos e monta as etapas no editor.": "Then upload the videos and build the steps in the editor.",
  "Deram play": "Played",
  "Desabilitado enquanto o Teste Automático estiver ativo.": "Disabled while Automatic Test is active.",
  "Desabilitar controles": "Disable controls",
  "Desaparecer em": "Disappear at",
  "Desativa completamente os controles do player, deixando apenas o vídeo visível.": "Completely disables player controls, leaving only the video visible.",
  "Desativada": "Disabled",
  "Desativadas": "Disabled",
  "Desativado": "Disabled",
  "Desativados": "Disabled",
  "Desativar": "Disable",
  "Desativar captura": "Disable capture",
  "Desativar compartilhamento": "Disable sharing",
  "Desativar CTA": "Disable CTA",
  "Desativar recorrência": "Disable recurrence",
  "Desative para pausar a ação sem removê-la": "Disable to pause the action without removing it",
  "Desbloquear": "Unblock",
  "Descer opção {value0}": "Move option {value0} down",
  "Desconectar": "Disconnect",
  "Desconhecido": "Unknown",
  "Desconto": "Discount",
  "Desconto Exclusivo para Seus Clientes": "Exclusive Discount for Your Customers",
  "Descreva o conteúdo da sua playlist...": "Describe your playlist content...",
  "Descreva o objetivo deste teste...": "Describe the purpose of this test...",
  "Descreva o problema que você encontrou com este compartilhamento.": "Describe the problem you encountered with this share.",
  "Descreva o problema...": "Describe the problem...",
  "Descrição": "Description",
  "Descrição (opcional)": "Description (optional)",
  "Descrição / Rodapé": "Description / Footer",
  "Descrição da Aula": "Lesson Description",
  "Descrição da aula será exibida aqui. Esta é uma descrição de exemplo para demonstrar o layout do modal.": "The lesson description will appear here. This is a sample description to demonstrate the dialog layout.",
  "Descrição da Playlist": "Playlist Description",
  "Descrição da Transação": "Transaction Description",
  "Descrição do Episódio": "Episode Description",
  "Descubra criativos, ângulos e funis vencedores": "Discover winning creatives, angles, and funnels",
  "Descubra o horário campeão do período com o melhor volume de plays": "Discover the period's winning time with the highest play volume",
  "Descubra o horário campeão do período com o melhor volume de plays e visualizações": "Discover the period's winning time with the highest play and view volume",
  "Descubra ofertas validadas na Meta com a AdSniper e ganhe 50% OFF com o cupom 50%OFF.": "Discover proven Meta offers with AdSniper and get 50% OFF with coupon 50%OFF.",
  "Descubra os criativos e ofertas mais escaladas no META": "Discover the most scaled creatives and offers on META",
  "Descubra os melhores horários para publicar seus vídeos com o novo recurso de Picos de Horários. Analise dados de performance por dia da semana e faixa horária para otimizar suas campanhas.": "Discover the best times to publish your videos with the new Peak Hours feature. Analyze performance data by day of the week and time slot to optimize your campaigns.",
  "Descubra quais introduções engajam melhor sua audiência": "Discover which intros engage your audience best",
  "Descubra qual performa melhor": "Discover which performs best",
  "Descubra quando seu público mais assiste seus vídeos.": "Discover when your audience watches your videos most.",
  "Desde": "Since",
  "Deseja aproveitar essa oportunidade?": "Want to take this opportunity?",
  "Deseja realmente excluir esta ação?": "Do you really want to delete this action?",
  "Desempenho Baixo": "Low Performance",
  "Desempenho consolidado por plataforma de pagamento": "Consolidated performance by payment platform",
  "Desempenho diário": "Daily performance",
  "Desempenho do Seu Teste A/B": "Your A/B Test Performance",
  "Desempenho do Seu Teste de Introduções": "Your Intro Test Performance",
  "Desempenho do vídeo exibido antes do principal.": "Performance of the video shown before the main video.",
  "Desempenho do vídeo exibido depois do principal.": "Performance of the video shown after the main video.",
  "Desempenho financeiro das suas VSLs": "Your VSLs' financial performance",
  "Desempenho Médio": "Average Performance",
  "Desempenho por vídeo": "Performance by video",
  "Desfazer": "Undo",
  "Desfocar fundo": "Blur background",
  "Desfoque": "Blur",
  "Design responsivo otimizado para mobile": "Responsive design optimized for mobile",
  "Design System": "Design System",
  "Desktop": "Desktop",
  "Desktop:": "Desktop:",
  "Deslizar": "Slide",
  "Deslizar para cima": "Slide up",
  "Deslocamento Horizontal": "Horizontal Offset",
  "Deslocamento Vertical": "Vertical Offset",
  "Desmarcar": "Deselect",
  "Desmarcar todas": "Deselect all",
  "Desperte curiosidade nos primeiros segundos": "Spark curiosity in the first few seconds",
  "Despesa cadastrada com sucesso!": "Expense added successfully!",
  "Despesa recorrente": "Recurring expense",
  "Despesas Manuais": "Manual Expenses",
  "Destaca o botão central de play": "Highlights the central play button",
  "Destaque": "Highlight",
  "Destaque o player com borda e sombra.": "Highlight the player with border and shadow.",
  "Destaque o player com bordas modernas e flexíveis, sem perder a identidade visual.": "Make the player stand out with modern, flexible borders while preserving your visual identity.",
  "Destaque o player com uma borda elegante sem pesar no visual.": "Make the player stand out with an elegant border without adding visual clutter.",
  "Destaque pontos de decisão": "Highlight decision points",
  "Destaque sutil do overlay": "Subtle overlay accent",
  "Destaque visual para chamar atenção": "Visual emphasis to attract attention",
  "Destaques de Performance": "Performance Highlights",
  "Destino": "Destination",
  "Destino da opção {value0}": "Destination for option {value0}",
  "Destino URL": "Destination URL",
  "Desvanecer": "Fade",
  "Detalhamento de Custos": "Cost Breakdown",
  "Detalhamento de visualizações por navegador e sistema operacional.": "Views broken down by browser and operating system.",
  "Detalhamento por Fonte": "Breakdown by Source",
  "Detalhar por dispositivo": "Break down by device",
  "Detalhar por dispositivo →": "Break down by device →",
  "Detalhes": "Details",
  "Detalhes da": "Details of",
  "Detalhes da Estratégia": "Strategy Details",
  "Detalhes da integração": "Integration details",
  "Detalhes da referência": "Referrer details",
  "Detalhes da solicitação enviada pelo afiliado.": "Details of the request submitted by the affiliate.",
  "Detalhes de {value0}": "Details for {value0}",
  "Detalhes de Conversões": "Conversion Details",
  "Detalhes de Receita": "Revenue Details",
  "Detalhes de Taxa de Conversão": "Conversion Rate Details",
  "Detalhes de Ticket Médio": "Average Order Value Details",
  "Detalhes do erro (aberto por padrão)": "Error details (open by default)",
  "Detalhes do erro copiados para a área de transferência!": "Error details copied to clipboard!",
  "Detalhes do feedback": "Feedback details",
  "Detalhes do Pagamento": "Payment Details",
  "Detalhes do Ponto": "Point Details",
  "Detalhes do Usuário": "User Details",
  "Detalhes do vídeo": "Video details",
  "Detalhes por Cidade": "Details by City",
  "Detalhes por Dispositivo": "Details by Device",
  "Detalhes por Estado": "Details by State",
  "Detalhes por Navegador": "Details by Browser",
  "Detalhes por País": "Details by Country",
  "Detalhes técnicos": "Technical details",
  "Detalhes Técnicos": "Technical Details",
  "Detectado automaticamente": "Automatically detected",
  "Detectar Interação": "Detect Interaction",
  "Deutsch": "Deutsch",
  "Deve conter letra maiúscula": "Must contain an uppercase letter",
  "Deve conter letra minúscula": "Must contain a lowercase letter",
  "Deve conter número": "Must contain a number",
  "Deve ter no máximo 100 caracteres": "Must be no longer than 100 characters",
  "dia": "dAY",
  "DIA": "DAY",
  "Dia Campeão": "Winning Day",
  "Dia da semana com melhor desempenho": "Best-performing day of the week",
  "Diagonal (↘)": "Diagonal (↘)",
  "Diagrama de Fluxo": "Flow Diagram",
  "Diário": "Daily",
  "dias": "days",
  "Dias da semana": "Days of the week",
  "dias de teste": "days of testing",
  "dias restantes": "days remaining",
  "Dica de Melhoria": "Improvement Tip",
  "Dica para melhor qualidade": "Tip for better quality",
  "Dica:": "Tip:",
  "Dica: Amplie o período no calendário.": "Tip: Expand the period in the calendar.",
  "Dica: clique na caixa no player para mover e redimensionar.": "Tip: click the box in the player to move and resize.",
  "Dica: Configure um teste na aba 'Automático' para visualizar métricas comparativas por velocidade.": "Tip: Configure a test in the 'Automatic' tab to view comparative metrics by speed.",
  "Dicas de Otimização": "Optimization Tips",
  "Dicas para testes ideais": "Tips for ideal testing",
  "Diferença": "Difference",
  "Diferença Percentual:": "Percentage Difference:",
  "Diferença Significativa:": "Significant Difference:",
  "Dificulte cópias do seu conteúdo e proteja sua propriedade intelectual.": "Make your content harder to copy and protect your intellectual property.",
  "Digital Guru": "Digital Guru",
  "Digite": "Enter",
  "Digite a descrição da aula...": "Enter the lesson description...",
  "Digite a mensagem que será exibida ao usuário bloqueado": "Enter the message displayed to blocked users",
  "Digite a senha": "Enter the password",
  "Digite a senha de acesso": "Enter the access password",
  "Digite a senha para acessar o vídeo": "Enter the password to access the video",
  "Digite apenas números. Ex: 130 = 01:30": "Enter numbers only. E.g., 130 = 01:30",
  "Digite as informações do cartão.": "Enter card information.",
  "Digite e pressione Enter": "Type and press Enter",
  "Digite o código de 4 dígitos": "Enter the 4-digit code",
  "Digite o e-mail": "Enter the email",
  "Digite o e-mail completo": "Enter the full email address",
  "Digite o e-mail completo do usuário": "Enter the user's full email address",
  "Digite o ID do pixel": "Enter the pixel ID",
  "Digite o nome completo": "Enter the full name",
  "Digite o nome da sua playlist": "Enter your playlist name",
  "Digite o nome impresso no cartão": "Enter the name printed on the card",
  "Digite o novo nome": "Enter the new name",
  "Digite o novo nome do vídeo": "Enter the new video name",
  "Digite o novo texto": "Type the new text",
  "Digite o subtítulo": "Enter the subtitle",
  "Digite o tempo no formato mm:ss (ex: 01:30 para 1 minuto e 30 segundos)": "Enter the time in mm:ss format (e.g., 01:30 for 1 minute and 30 seconds)",
  "Digite o texto da subheadline (opcional)": "Type the subheadline text (optional)",
  "Digite o texto principal...": "Type the main text...",
  "Digite o texto secundário...": "Type the secondary text...",
  "Digite o título do vídeo": "Enter the video title",
  "Digite qualquer mensagem. Use {nome}, {cidade} e {produto} opcionalmente para personalizar.": "Enter any message. Optionally use {nome}, {cidade}, and {produto} to personalize it.",
  "Digite seu cupom": "Enter your coupon",
  "Digite seu token...": "Enter your token...",
  "Digite sua nova senha para concluir a recuperação de acesso.": "Enter your new password to complete account recovery.",
  "Digite um domínio válido. Ex: seusite.com": "Enter a valid domain. Ex: yoursite.com",
  "Digite um e-mail válido": "Enter a valid email",
  "Digite um nome para a pasta": "Enter a folder name",
  "Digite um nome para a variação": "Type a name for the variation",
  "Digite um nome para identificar este Mini-Hook.": "Enter a name to identify this Mini-Hook.",
  "Digite um nome para identificar sua playlist": "Enter a name to identify your playlist",
  "Digite uma expressão regular válida": "Enter a valid regular expression",
  "Digite uma URL válida": "Enter a valid URL",
  "Dimensões": "Dimensions",
  "Diminuir valor": "Decrease value",
  "Direção": "Direction",
  "Direcione seus espectadores com um CTA no momento certo.": "Guide your viewers with a CTA at the right moment.",
  "Direita": "Right",
  "Direto / sem origem": "Direct / no source",
  "Discreto": "Subtle",
  "Dispara no clique do botão de compra": "Triggers on purchase button click",
  "Dispara no primeiro play do vídeo": "Triggers on the video's first play",
  "Dispara quando a oferta aparece": "Triggers when the offer appears",
  "Disponível agora no menu Ferramentas.": "Available now in the Tools menu.",
  "Disponível apenas em vídeos novos — enviados a partir de agora": "Available only for new videos — uploaded from now on",
  "Disponível no modal \"Importar vídeos\" do seu painel.": "Available in the \"Import videos\" dialog in your dashboard.",
  "Disponível para saque": "Available to withdraw",
  "Disponível só nestes locais.": "Available only in these locations.",
  "Disponível somente nesta página": "Available only on this page",
  "Dispositivo": "Device",
  "Dispositivo mais usado": "Most-used device",
  "Dispositivo principal": "Primary device",
  "Dispositivo:": "Device:",
  "Dispositivos": "Devices",
  "Dispositivos & Navegadores": "Devices & Browsers",
  "Dispositivos & Origem": "Devices & Source",
  "Dispositivos permitidos": "Allowed devices",
  "Distância do formulário em relação às bordas do vídeo": "Distance between the form and video edges",
  "Distribua promessas de valor ao longo do vídeo: 'Em breve vou mostrar como...', 'No próximo ponto você vai descobrir...'": "Spread promises of value throughout the video: 'Coming up, I'll show you how...', 'In the next section, you'll discover...'",
  "Distribua seus vídeos com velocidade e controle.": "Distribute videos with speed and control.",
  "Distribua seus vídeos com velocidade e controle. Menos etapas, mais escala para sua operação com afiliados.": "Distribute videos with speed and control. Fewer steps, more scale for your affiliate operations.",
  "Distribuição": "Distribution",
  "Distribuição atualizada": "Distribution updated",
  "Distribuição das avaliações": "Rating distribution",
  "Distribuição de acessos": "Visit distribution",
  "Distribuição de tráfego": "Traffic distribution",
  "Distribuição de Tráfego": "Traffic distribution",
  "Distribuição de tráfego atualizada com sucesso!": "Traffic distribution updated successfully!",
  "Distribuição de tráfego atualizada!": "Traffic distribution updated!",
  "Distribuição de tráfego:": "Traffic distribution:",
  "Distribuição de visualizações e engajamento por dispositivo.": "Distribution of views and engagement by device.",
  "Distribuição de visualizações e engajamento por origem do tráfego.": "Distribution of views and engagement by traffic source.",
  "Distribuição drag-and-drop": "Drag-and-drop distribution",
  "Distribuição horária dos plays do dia": "Hourly distribution of the day's plays",
  "Distribuição inválida: {value0}% (deve somar 100%)": "Invalid distribution: {value0}% (must total 100%)",
  "Distribuição por Categoria": "Distribution by Category",
  "Distribuição por Cidades": "Distribution by City",
  "Distribuição por Dia da Semana": "Distribution by Day of the Week",
  "Distribuição por Dispositivo": "Distribution by Device",
  "Distribuição por Dispositivos": "Distribution by Device",
  "Distribuição por Estados": "Distribution by State",
  "Distribuição por Fonte": "Distribution by Source",
  "Distribuição por fonte de tráfego": "Distribution by traffic source",
  "Distribuição por Navegadores": "Distribution by Browser",
  "Distribuição por Países": "Distribution by Country",
  "Distribuição por Tipo": "Distribution by Type",
  "Distribuição por tipo de dispositivo": "Distribution by device type",
  "Distribuição proporcional dos custos de infraestrutura por usuário com base em métricas de consumo (retenção, plays, vídeos).": "Proportional distribution of infrastructure costs per user based on usage metrics (retention, plays, videos).",
  "Distribuição válida: 100%": "Valid distribution: 100%",
  "Dividir igualmente": "Split equally",
  "do seu tráfego vem de dispositivos móveis.": "of your traffic comes from mobile devices.",
  "do vídeo": "of the video",
  "do vídeo.": "of the video.",
  "Document indisponível (SSR?)": "Document unavailable (SSR?)",
  "Documentação - Padronização Cores #1D4FFF": "Documentation - #1D4FFF Color Standardization",
  "Documentação enviada e associada com sucesso para análise!": "Documentation successfully submitted and linked for review!",
  "Documentação Homologada": "Approved Documentation",
  "Documentação HostVSL": "HostVSL Documentation",
  "Documentação técnica": "Technical documentation",
  "Documento fiscal oficial emitido pelo processador bancário.": "Official tax document issued by the payment processor.",
  "Dois botões empilhados, para opções com textos longos.": "Two stacked buttons for options with long text.",
  "Dois botões lado a lado, com o mesmo peso visual.": "Two side-by-side buttons with equal visual weight.",
  "Dom": "SUN",
  "DOM": "SUN",
  "Domingo 10-12h: Alta consistência, mas baixa saturação": "Sunday 10:00–12:00: High consistency but low saturation",
  "domínio": "domain",
  "Domínio adicionado com sucesso": "Domain added successfully",
  "Domínio atualizado com sucesso": "Domain updated successfully",
  "Domínio exato": "Exact domain",
  "Domínio já cadastrado.": "Domain already registered.",
  "Domínio removido com sucesso": "Domain removed successfully",
  "dominio.com": "domain.com",
  "Domínios": "Domains",
  "Domínios cadastrados": "Registered domains",
  "dos seus usuários usam": "of your users use",
  "Download": "Download",
  "Download CSV": "Download CSV",
  "Download iniciado": "Download started",
  "Download iniciado com sucesso": "Download started successfully",
  "Drag and Drop": "Drag and Drop",
  "Drop no final pode apontar problema na oferta ou no CTA.": "A drop at the end may indicate a problem with the offer or CTA.",
  "Dropdown de seleção de vídeo agora herda largura exata do botão trigger usando CSS variable do Radix. Aplicados estilos premium: border #E6E8EC, radius 10px, shadow, altura 48px por item.": "Video selection dropdown now inherits the trigger button's exact width using a Radix CSS variable. Applied premium styles: #E6E8EC border, 10px radius, shadow, and 48px height per item.",
  "Dubai (GMT+4)": "Dubai (GMT+4)",
  "Dupla Escolha": "Dual Choice",
  "Duplicando…": "Duplicating…",
  "Duplicar": "Duplicate",
  "Duplicar pasta": "Duplicate folder",
  "duração": "duration",
  "Duração": "Duration",
  "Duração ({value}s)": "Duration ({value}s)",
  "Duração (minutos)": "Duration (minutes)",
  "Duração da contagem regressiva": "Countdown duration",
  "Duração da exibição (segundos)": "Display duration (seconds)",
  "Duração do teste": "Test duration",
  "Duração do Teste": "Test duration",
  "Duração mínima do teste": "Minimum test duration",
  "Duração total do vídeo. Vídeos mais curtos geralmente têm maior taxa de visualização completa.": "Total video duration. Shorter videos generally have higher completion rates.",
  "Duração: {value0}": "Duration: {value0}",
  "Duration must be at least 1 second": "Duration must be at least 1 second",
  "Duration too long": "Duration too long",
  "e as métricas dele. O código colado nos sites para de funcionar. Não dá para desfazer.": "and its metrics. The code embedded on sites will stop working. This cannot be undone.",
  "E comece a transformar vídeos em conversões reais.": "And start turning videos into real conversions.",
  "e congela a tela. O espectador não pode pular nem voltar, apenas clicar no botão para seguir.": "and freezes the screen. Viewers cannot skip or go back, only click the button to continue.",
  "é igual a": "equals",
  "É necessário definir uma senha.": "A password must be defined.",
  "É necessário selecionar um vídeo.": "A video must be selected.",
  "É necessário ter pelo menos 2 variações para criar um teste A/B": "At least 2 variations are required to create an A/B test",
  "e Negócios": "and Business",
  "É o checkout": "This is the checkout",
  "e Parceiros": "and Partners",
  "É um programa onde você indica a Host VSL e recebe 20% de comissão recorrente sobre os planos ativados pelos clientes que você indicar.": "A program where you refer Host VSL and receive 20% recurring commission on plans activated by the customers you refer.",
  "E-mail": "Email",
  "E-mail Cadastrado": "Registered Email",
  "E-mail copiado!": "Email copied!",
  "E-mail Corporativo ou Pessoal": "Business or Personal Email",
  "E-mail da Conta PayPal": "PayPal Account Email",
  "E-mail do cliente": "Customer email",
  "E-mail do Usuário": "User Email",
  "E-mail é obrigatório": "Email is required",
  "E-mail inválido": "Invalid email",
  "E-mail muito longo": "Email too long",
  "E-mail PayPal cadastrado": "Registered PayPal email",
  "E-mail vinculado ao registro": "Email linked to the record",
  "E-mail:": "Email:",
  "Economia de tempo significativa comparado a criar múltiplas páginas de teste": "Significant time savings compared with creating multiple test pages",
  "Edge": "Edge",
  "Edição": "Editing",
  "Edição dinâmica": "Dynamic editing",
  "Edição inline de texto e tempos diretamente no painel": "Inline editing of text and timing directly in the panel",
  "Editar": "Edit",
  "Editar {value0}": "Edit {value0}",
  "Editar Ação": "Edit Action",
  "Editar captura": "Edit capture",
  "Editar Captura com E-mail": "Edit Email Capture",
  "Editar Captura com Senha": "Edit Password Capture",
  "Editar Captura de Dados": "Edit Data Capture",
  "Editar clicks": "Edit clicks",
  "Editar Clicks": "Edit Clicks",
  "Editar Clicks —": "Edit Clicks —",
  "Editar Configuração": "Edit Configuration",
  "Editar conteúdo VTT": "Edit VTT content",
  "Editar Custo": "Edit Cost",
  "Editar Distribuição de Tráfego": "Edit Traffic Distribution",
  "Editar domínio": "Edit domain",
  "Editar fluxo": "Edit flow",
  "Editar Formulário com E-mail": "Edit Email Form",
  "Editar informações do vídeo": "Edit video information",
  "Editar intro": "Edit intro",
  "Editar legenda": "Edit subtitle",
  "Editar Membro": "Edit Member",
  "Editar membro {value0}": "Edit member {value0}",
  "Editar pagamento": "Edit payment",
  "Editar País": "Edit Country",
  "Editar Permissão": "Edit Permission",
  "Editar permissões": "Edit permissions",
  "Editar Permissões": "Edit Permissions",
  "Editar Pixel": "Edit Pixel",
  "Editar Playlist": "Edit Playlist",
  "Editar proteção": "Edit protection",
  "Editar Região": "Edit Region",
  "Editar término do teste": "Edit test end date",
  "Editar texto": "Edit text",
  "Editar tráfego": "Edit traffic",
  "Editar valor": "Edit value",
  "Editar Variação": "Edit Variation",
  "Editar Variação de Headline": "Edit Headline Variation",
  "Editar vídeo": "Edit video",
  "Edite texto e estilo direto no painel, com preview em tempo real": "Edit text and style directly in the panel with a real-time preview",
  "Editor": "Editor",
  "Editor da VSL Dinâmica (um store por editor)": "Dynamic VSL editor (one store per editor)",
  "Editor de playlist": "Playlist editor",
  "Editor unificado": "Unified editor",
  "Editor unificado inline para todos os templates, eliminando navegação entre páginas. Configurações específicas aparecem inline por template.": "Unified inline editor for all templates, eliminating navigation between pages. Template-specific settings appear inline.",
  "Editor visual intuitivo, sem necessidade de código": "Intuitive visual editor, no coding required",
  "EditorServicesContext ausente": "EditorServicesContext missing",
  "EditorStoreContext ausente": "EditorStoreContext missing",
  "Eduzz": "Eduzz",
  "Efeito ao passar o mouse": "Hover effect",
  "Efeito de foco ao passar o mouse: destaca a barra selecionada e suaviza as demais": "Hover focus effect: highlights the selected bar and softens the others",
  "Efeitos": "Effects",
  "Efeitos e Recursos": "Effects and Features",
  "Ei, novidade boa por aqui! A gente trabalhou nos bastidores e entregou uma melhoria de performance completa na abertura dos vídeos. Resultado: carregamento mais rápido, menos travamentos e uma experiência muito melhor pra quem assiste o seu conteúdo.": "Good news! We worked behind the scenes to deliver a complete performance improvement for video loading. The result: faster loading, fewer freezes, and a much better experience for everyone watching your content.",
  "Ele perderá acesso imediatamente.": "They will lose access immediately.",
  "Ele pode ter sido excluído.": "It may have been deleted.",
  "Elementos extras para aumentar conversão": "Extra elements to increase conversions",
  "Em {value0} {value1}": "In {value0} {value1}",
  "Em aberto": "Open",
  "Em Análise": "Under Review",
  "Em Análise Preventiva": "Under Preventive Review",
  "Em andamento": "In progress",
  "Em breve novos parceiros estarão disponíveis.": "New partners will be available soon.",
  "Em criação": "Being created",
  "Em desenvolvimento": "In development",
  "Em desenvolvimento...": "In development...",
  "em execução": "running",
  "Em execução": "Running",
  "em rascunho": "in draft",
  "em receita": "in revenue",
  "Em tempo personalizado": "At a custom time",
  "Em teste": "In testing",
  "em todas as variações, evitando diferenças no tamanho do player.": "across all variations, avoiding differences in player size.",
  "em todos os planos": "on all plans",
  "Em uso": "In use",
  "em vendas": "in sales",
  "Email": "Email",
  "Email do usuário": "User email",
  "Email já cadastrado, por favor insira um email diferente, ou recupere sua senha!": "Email already registered. Enter a different email or recover your password!",
  "Email:": "Email:",
  "Embaixo": "Below",
  "Embed": "Embed",
  "Embed Code Modal — Premium": "Embed Code Modal — Premium",
  "Embed para Performance": "Performance Embed",
  "Emojis": "Emojis",
  "Emojis personalizáveis para cada pasta": "Customizable emojis for each folder",
  "Empresa (Opcional)": "Company (Optional)",
  "Empresa {value0} não encontrada no sistema.": "Company {value0} not found in the system.",
  "Empresa muito longa": "Company name too long",
  "Encerra o teste e deleta a configuração de A/B test.": "Ends the test and deletes its A/B test configuration.",
  "Encerra o teste e mantém a variação vencedora ativa.": "Ends the test and keeps the winning variation active.",
  "Encerrado": "Ended",
  "Encerrando...": "Ending...",
  "encontrado": "found",
  "Encurte os primeiros 30 segundos e vá direto ao ponto. Elimine qualquer informação que não seja absolutamente essencial.": "Shorten the first 30 seconds and get straight to the point. Remove any information that is not absolutely essential.",
  "Endereço da página": "Page address",
  "Endereço inválido: use uma URL http:// ou https://": "Invalid address: use an http:// or https:// URL",
  "Endereço Residencial": "Home Address",
  "Engajamento": "Engagement",
  "Engajamento ao Longo do Tempo": "Engagement Over Time",
  "Engajamento Médio": "Average Engagement",
  "Engajamento Médio (%)": "Average Engagement (%)",
  "Engajamento:": "Engagement:",
  "English": "English",
  "Entenda como funcionam os plays extras do seu plano e como utilizá-los a seu favor.": "Understand how extra plays work in your plan and how to make the most of them.",
  "Entenda como sua audiência acessa seu conteúdo": "Understand how your audience accesses your content",
  "Entenda de onde vem sua audiência e como ela se comporta": "Understand where your audience comes from and how it behaves",
  "Entenda onde seu funil converte, onde perde leads e o impacto em cada campanha.": "Understand where your funnel converts, where it loses leads, and the impact on each campaign.",
  "Entenda onde sua audiência cai e onde a conversão acontece.": "Understand where your audience drops off and where conversions happen.",
  "Entenda os indicadores que importam e tome decisões baseadas em dados.": "Understand the indicators that matter and make data-driven decisions.",
  "Entenda qual VSL performa melhor com base em métricas claras.": "Understand which VSL performs best based on clear metrics.",
  "Entendendo os padrões de engajamento do seu vídeo": "Understanding your video's engagement patterns",
  "Entendi": "Got it",
  "Entendi, vamos começar!": "Got it, let's start!",
  "Entrada direta na sala": "Direct room entry",
  "Entradas": "Entries",
  "Entrando...": "Signing in...",
  "Entrar": "Sign in",
  "Entrar como suporte": "Sign in as support",
  "Entrar na Sala": "Enter the Room",
  "Entre 15 e 480 minutos": "Between 15 and 480 minutes",
  "Entre 45% e 65%:": "Between 45% and 65%:",
  "Entre 50% e 70%:": "Between 50% and 70%:",
  "Entre com as credenciais do cliente e o código de acesso fornecido.": "Enter the customer's credentials and the provided access code.",
  "Entre em contato com nosso time e torne-se um parceiro Host VSL hoje mesmo!": "Contact our team and become a Host VSL partner today!",
  "Entrega de replay automática": "Automatic replay delivery",
  "Entregue a experiência ideal em qualquer tela.": "Deliver the ideal experience on any screen.",
  "Enviado": "Sent",
  "Enviamos um código de 4 dígitos para seu e-mail. Digite-o abaixo para continuar.": "We sent a 4-digit code to your email. Enter it below to continue.",
  "Enviando ·": "Uploading ·",
  "Enviando Arquivos e Homologando...": "Uploading Files and Validating...",
  "Enviando frente do documento para a Stripe...": "Uploading document front to Stripe...",
  "Enviando para o servidor...": "Uploading to server...",
  "Enviando seu vídeo...": "Uploading your video...",
  "Enviando verso do documento para a Stripe...": "Uploading document back to Stripe...",
  "Enviando vídeo...": "Uploading video...",
  "Enviando...": "Sending...",
  "Enviando…": "Sending…",
  "Enviar": "Send",
  "Enviar código": "Send code",
  "Enviar comprovante": "Upload receipt",
  "Enviar Convite": "Send Invitation",
  "Enviar Documento de Identidade para Validação": "Submit Identity Document for Validation",
  "Enviar e entrar na sala": "Submit and enter the room",
  "Enviar e ir para página de obrigado": "Submit and go to thank-you page",
  "Enviar feedback": "Submit feedback",
  "Enviar Ícone (SVG recomendado)": "Upload icon (SVG recommended)",
  "Enviar Imagem": "Upload image",
  "Enviar Imagem/GIF": "Upload Image/GIF",
  "Enviar Logo (220x60)": "Upload Logo (220x60)",
  "Enviar mensagem automática quando a oferta abrir": "Send an automatic message when the offer opens",
  "Enviar meu primeiro vídeo": "Upload my first video",
  "Enviar Notificação Teste": "Send Test Notification",
  "Enviar novo vídeo": "Upload new video",
  "Enviar primeiro vídeo": "Upload first video",
  "Enviar Vídeo": "Upload Video",
  "Enviar vídeos": "Upload videos",
  "Envie a lista de pitches.": "Send the list of pitches.",
  "Envie acessos bloqueados para um vídeo alternativo, URL segura ou mensagem personalizada.": "Send blocked visitors to an alternative video, a safe URL, or a custom message.",
  "Envie o arquivo .VTT ou .SRT com as legendas sincronizadas.": "Upload the .VTT or .SRT file with synchronized subtitles.",
  "Envie o favicon": "Upload the favicon",
  "Envie os eventos das suas VSLs para o TikTok Ads e otimize as campanhas com base em quem assistiu de verdade.": "Send your VSL events to TikTok Ads and optimize campaigns based on people who actually watched.",
  "Envie os vídeos dentro do próprio fluxo e aguarde o processamento. Eles ficam na biblioteca desse fluxo, separados de Meus vídeos. Arraste um vídeo para o quadro ou use a opção Usar em nova etapa.": "Upload videos within the flow and wait for processing. They remain in that flow's library, separate from My Videos. Drag a video onto the canvas or use Use in a new step.",
  "Envie ou consulte o comprovante deste pagamento.": "Upload or view this payment's receipt.",
  "Envie seu primeiro vídeo ou ative o rastreamento para ver seu desempenho.": "Upload your first video or enable tracking to see your performance.",
  "Envie seu primeiro vídeo para começar": "Upload your first video to get started",
  "Envie seu primeiro vídeo para começar a acompanhar a performance.": "Upload your first video to start tracking performance.",
  "Envie seu primeiro vídeo para ver o engajamento.": "Upload your first video to see engagement.",
  "Envie seu vídeo": "Upload your video",
  "Envie sua logo": "Upload your logo",
  "Envie um arquivo .VTT ou .SRT com as legendas sincronizadas. Ambos os formatos são suportados.": "Upload a .VTT or .SRT file with synchronized subtitles. Both formats are supported.",
  "Envie um vídeo para ver a saúde do seu pitch.": "Upload a video to see your pitch health.",
  "Envie uma imagem ou GIF para continuar.": "Upload an image or GIF to continue.",
  "Envie uma imagem ou GIF para seu autoplay": "Upload an image or GIF for autoplay",
  "Envie uma imagem para o template personalizado": "Upload an image for the custom template",
  "Envie uma imagem para substituir o vídeo.": "Upload an image to replace the video.",
  "Envie uma imagem válida do comprovante.": "Upload a valid receipt image.",
  "Envie vídeos do seu computador com upload rápido e seguro.": "Upload videos from your computer quickly and securely.",
  "Envio pausado": "Upload paused",
  "Envio pelo servidor: visualização da página, play, retenção e tempo assistido": "Server-side sending: page views, plays, retention, and watch time",
  "Episode {value0}": "Episode {value0}",
  "Episódio": "Episode",
  "Episódio {value0}": "Episode {value0}",
  "episódios": "episodes",
  "Episódios": "Episodes",
  "Episódios (": "Episodes (",
  "episódios •": "episodes •",
  "Equilíbrio ideal": "Ideal balance",
  "Erro": "Error",
  "Erro ao adicionar domínio": "Error adding domain",
  "Erro ao adicionar pixel": "Error adding pixel",
  "Erro ao adicionar pixel!": "Error adding pixel!",
  "Erro ao adicionar vídeos": "Error adding videos",
  "Erro ao alterar plano.": "Error changing plan.",
  "Erro ao alterar senha": "Error changing password",
  "Erro ao alterar senha.": "Error changing password.",
  "Erro ao alterar senha. Tente novamente.": "Error changing password. Please try again.",
  "Erro ao alterar status": "Error changing status",
  "Erro ao alterar status do link": "Error changing link status",
  "Erro ao aplicar alterações": "Error applying changes",
  "Erro ao aplicar configurações": "Error applying settings",
  "Erro ao aplicar cupom": "Error applying coupon",
  "Erro ao ativar oferta": "Error activating offer",
  "Erro ao ativar teste A/B": "Error activating A/B test",
  "Erro ao atualizar": "Error updating",
  "Erro ao atualizar assinatura": "Error updating subscription",
  "Erro ao atualizar clicks.": "Error updating clicks.",
  "Erro ao atualizar cliques.": "Error updating clicks.",
  "Erro ao atualizar comissão do seller.": "Error updating seller commission.",
  "Erro ao atualizar domínio": "Error updating domain",
  "Erro ao atualizar estratégia": "Error updating strategy",
  "Erro ao atualizar nível.": "Error updating level.",
  "Erro ao atualizar os dados cadastrais.": "Error updating registration details.",
  "Erro ao atualizar pagamento.": "Error updating payment.",
  "Erro ao atualizar permissões. Tente novamente.": "Error updating permissions. Please try again.",
  "Erro ao atualizar pixel": "Error updating pixel",
  "Erro ao atualizar status.": "Error updating status.",
  "Erro ao atualizar título": "Error updating title",
  "Erro ao atualizar tráfego": "Error updating traffic",
  "Erro ao baixar o vídeo": "Error downloading video",
  "Erro ao baixar o vídeo. Tente novamente.": "Error downloading video. Please try again.",
  "Erro ao buscar assinaturas": "Error fetching subscriptions",
  "Erro ao buscar cartões": "Error fetching cards",
  "Erro ao buscar compartilhamentos": "Error fetching shares",
  "Erro ao buscar dados do usuário": "Error fetching user data",
  "Erro ao buscar informações": "Error fetching information",
  "Erro ao buscar informações do pagamento.": "Error fetching payment information.",
  "Erro ao buscar métricas do teste": "Error fetching test metrics",
  "Erro ao buscar o vídeo": "Error fetching video",
  "Erro ao buscar pixels": "Error fetching pixels",
  "Erro ao buscar registro.": "Error fetching record.",
  "Erro ao buscar testes de velocidade": "Error fetching speed tests",
  "Erro ao buscar usuário.": "Error fetching user.",
  "Erro ao buscar vídeos": "Error fetching videos",
  "Erro ao cancelar assinatura": "Error canceling subscription",
  "Erro ao cancelar assinatura.": "Error canceling subscription.",
  "Erro ao carregar a imagem": "Error loading image",
  "Erro ao carregar compartilhamentos": "Error loading shares",
  "Erro ao carregar configuração": "Error loading configuration",
  "Erro ao carregar dados da rede.": "Error loading network data.",
  "Erro ao carregar detalhes": "Error loading details",
  "Erro ao carregar detalhes do usuário.": "Error loading user details.",
  "Erro ao carregar estratégia": "Error loading strategy",
  "Erro ao carregar estratégias": "Error loading strategies",
  "Erro ao carregar imagem": "Error loading image",
  "Erro ao carregar membros.": "Error loading members.",
  "Erro ao carregar metadados do vídeo": "Error loading video metadata",
  "Erro ao carregar métodos de pagamento.": "Error loading payment methods.",
  "Erro ao carregar métricas": "Error loading metrics",
  "Erro ao carregar métricas do vídeo": "Error loading video metrics",
  "Erro ao carregar métricas:": "Error loading metrics:",
  "Erro ao carregar regras": "Error loading rules",
  "Erro ao carregar relatório de custos por usuário.": "Error loading cost-per-user report.",
  "Erro ao carregar respostas": "Error loading responses",
  "Erro ao carregar seu extrato de comissões.": "Error loading your commission statement.",
  "Erro ao carregar testes:": "Error loading tests:",
  "Erro ao carregar vídeos": "Error loading videos",
  "Erro ao carregar vídeos com captura de leads": "Error loading videos with lead capture",
  "Erro ao coletar balanço de auditoria.": "Error collecting audit balance.",
  "Erro ao compartilhar": "Error sharing",
  "Erro ao compartilhar vídeo": "Error sharing video",
  "Erro ao comprimir favicon": "Error compressing favicon",
  "Erro ao comprimir logo": "Error compressing logo",
  "Erro ao consolidar resumo de métricas.": "Error consolidating metrics summary.",
  "Erro ao copiar": "Error copying",
  "Erro ao copiar código": "Code copy error",
  "Erro ao criar a chave": "Error creating key",
  "Erro ao criar assinatura": "Error creating subscription",
  "Erro ao criar cartão": "Error creating card",
  "Erro ao criar conta. Tente novamente.": "Error creating account. Try again.",
  "Erro ao criar fatura": "Error creating invoice",
  "Erro ao criar integração": "Error creating integration",
  "Erro ao criar link": "Error creating link",
  "Erro ao criar link de compartilhamento": "Error creating sharing link",
  "Erro ao criar pasta": "Error creating folder",
  "Erro ao criar proteção": "Error creating protection",
  "Erro ao criar registro.": "Error creating record.",
  "Erro ao criar teste": "Error creating test",
  "Erro ao criar teste A/B": "Error creating A/B test",
  "Erro ao criar teste automático": "Error creating automatic test",
  "Erro ao criar teste de velocidade": "Error creating speed test",
  "Erro ao criar token de suporte": "Error creating support token",
  "Erro ao definir cartão padrão": "Error setting default card",
  "Erro ao definir conta como principal.": "Error setting account as primary.",
  "Erro ao definir método como padrão.": "Error setting method as default.",
  "Erro ao deletar cartão": "Error deleting card",
  "Erro ao deletar método de pagamento.": "Error deleting payment method.",
  "Erro ao deletar pixel": "Error deleting pixel",
  "Erro ao deletar teste": "Error deleting test",
  "Erro ao deletar teste de velocidade": "Error deleting speed test",
  "Erro ao desativar recorrência.": "Error disabling recurrence.",
  "Erro ao enviar código de recuperação.": "Error sending recovery code.",
  "Erro ao enviar código de recuperação. Tente novamente.": "Error sending recovery code. Please try again.",
  "Erro ao enviar convite. Tente novamente.": "Error sending invitation. Please try again.",
  "Erro ao enviar e-mail de recuperação": "Error sending recovery email",
  "Erro ao enviar legenda.": "Error uploading captions.",
  "Erro ao excluir": "Delete error",
  "Erro ao excluir alguns trackings.": "Error deleting some tracking entries.",
  "Erro ao excluir compartilhamento": "Error deleting share",
  "Erro ao excluir pasta": "Error deleting folder",
  "Erro ao excluir registro.": "Error deleting record.",
  "Erro ao excluir tracking. Tente novamente.": "Error deleting tracking. Please try again.",
  "Erro ao excluir vídeo": "Error deleting video",
  "Erro ao excluir.": "Error deleting.",
  "Erro ao exportar dados": "Error exporting data",
  "Erro ao fazer login": "Error signing in",
  "Erro ao fazer login de suporte": "Error signing in as support",
  "Erro ao fazer login. Tente novamente.": "Login error. Try again.",
  "Erro ao fazer login. Verifique suas credenciais.": "Login error. Check your credentials.",
  "Erro ao fazer logout": "Error signing out",
  "Erro ao finalizar teste": "Error finishing test",
  "Erro ao gerar PDF. Tente novamente.": "Error generating PDF. Please try again.",
  "Erro ao gerar thumbnail": "Error generating thumbnail",
  "Erro ao importar": "Error importing",
  "Erro ao limpar cache": "Error clearing cache",
  "Erro ao mover vídeo para a pasta": "Error moving video to folder",
  "Erro ao obter URL de download": "Error getting download URL",
  "Erro ao processar arquivo": "Error processing file",
  "Erro ao processar cartão": "Error processing card",
  "Erro ao processar compartilhamento": "Error processing share",
  "Erro ao processar compra": "Error processing purchase",
  "Erro ao processar pagamento.": "Error processing payment.",
  "Erro ao realizar cadastro": "Error registering",
  "Erro ao reenviar código.": "Error resending code.",
  "Erro ao reenviar código. Tente novamente.": "Error resending code. Please try again.",
  "Erro ao remover cartão": "Error removing card",
  "Erro ao remover domínio": "Error removing domain",
  "Erro ao remover legenda.": "Error removing captions.",
  "Erro ao remover logo": "Error removing logo",
  "Erro ao remover thumbnail": "Error removing thumbnail",
  "Erro ao remover vídeo da pasta": "Error removing video from folder",
  "Erro ao renomear": "Rename error",
  "Erro ao renomear pasta": "Error renaming folder",
  "Erro ao renomear vídeo": "Error renaming video",
  "Erro ao renovar token": "Error renewing token",
  "Erro ao revogar a chave": "Error revoking key",
  "Erro ao salvar": "Error saving",
  "Erro ao salvar custo.": "Error saving cost.",
  "Erro ao salvar estratégia": "Error saving strategy",
  "Erro ao salvar método de pagamento.": "Error saving payment method.",
  "Erro ao salvar tracking. Tente novamente.": "Error saving tracking. Please try again.",
  "Erro ao salvar velocidade manual": "Error saving manual speed",
  "Erro ao selecionar todos os vídeos": "Error selecting all videos",
  "Erro ao selecionar vídeo do teste": "Error selecting test video",
  "Erro ao sincronizar com AWS.": "Error syncing with AWS.",
  "Erro ao validar código": "Error validating code",
  "Erro ao validar código. Tente novamente.": "Error validating code. Please try again.",
  "Erro de autenticação": "Authentication error",
  "Erro de validação": "Validation error",
  "Erro desconhecido": "Unknown error",
  "Erro inesperado ao ativar oferta": "Unexpected error activating offer",
  "Erro inesperado ao cancelar assinatura.": "Unexpected error canceling subscription.",
  "Erro inesperado ao processar compra": "Unexpected error processing purchase",
  "Erro inesperado. Tente novamente.": "Unexpected error. Please try again.",
  "Erro interno no servidor ao salvar conta.": "Internal server error saving account.",
  "Erro no formulário": "Form error",
  "Erro no Módulo Headline": "Error in Headline Module",
  "Erro no upload": "Upload error",
  "Erro: Suba novamente o vídeo": "Error: Upload the video again",
  "Erros de Reprodução": "Playback Errors",
  "Esc": "Esc",
  "Escala com impacto": "Scale with impact",
  "Escala leve": "Light scale",
  "Escolha a etapa inicial do fluxo para pré-visualizar.": "Choose the initial flow step to preview.",
  "Escolha a etapa inicial do fluxo.": "Choose the flow's initial step.",
  "Escolha a origem dos vídeos para começar.": "Choose the video source to get started.",
  "Escolha a plataforma de anúncios que deseja integrar": "Choose the advertising platform you want to integrate",
  "Escolha a VSL protegida e um vídeo alternativo para os acessos bloqueados": "Choose the protected VSL and an alternative video for blocked visits",
  "Escolha ao menos uma origem de tráfego para comparar as curvas de retenção.": "Choose at least one traffic source to compare retention curves.",
  "Escolha como a legenda aparece no player.": "Choose how the subtitle appears in the player.",
  "Escolha como deseja capturar os dados antes do usuário acessar seu vídeo.": "Choose how to capture data before users access your video.",
  "Escolha como o formulário será exibido sobre o vídeo": "Choose how the form appears over the video",
  "Escolha como o player será exibido neste dispositivo.": "Choose how the player appears on this device.",
  "Escolha como os campos serão organizados": "Choose how fields are arranged",
  "Escolha do Template": "Template Selection",
  "Escolha entre bloquear ou liberar seus vídeos em países e regiões específicas. Esta proteção ajuda a controlar onde seu conteúdo será disponibilizado.": "Choose whether to block or allow your videos in specific countries and regions. This protection helps control where your content is available.",
  "Escolha entre um formato de texto ou imagem personalizados.": "Choose between custom text or image formats.",
  "Escolha manualmente a velocidade de reprodução do vídeo.": "Manually choose the video playback speed.",
  "Escolha manualmente a velocidade desejada para o seu vídeo. Ideal para testes diretos e controle total sobre a reprodução.": "Manually choose the desired speed for your video. Ideal for direct testing and full control.",
  "Escolha o arranjo do bloco de oferta que aparece abaixo do vídeo.": "Choose the layout of the offer block below the video.",
  "Escolha o canto do vídeo, o tamanho, as cores e o arredondamento, com som de caixa registradora opcional": "Choose the video corner, size, colors, and rounding, with an optional cash register sound",
  "Escolha o desfecho: redirecionar automaticamente para o seu link ou apenas exibir o aviso": "Choose the outcome: redirect automatically to your link or simply show the notice",
  "Escolha o estilo visual do botão de play do seu player.": "Choose your player's play button visual style.",
  "Escolha o ícone": "Choose icon",
  "Escolha o modelo da sua Playlist": "Choose your Playlist template",
  "Escolha o momento ideal do feedback.": "Choose the ideal time for feedback.",
  "Escolha o tema": "Choose the theme",
  "Escolha o tipo de captura": "Choose the capture type",
  "Escolha o tipo e preencha com atenção os dados para repasse.": "Choose the type and carefully enter payout details.",
  "Escolha o trecho que será exibido como gancho no autoplay.": "Choose the segment shown as the autoplay hook.",
  "Escolha o vídeo a integrar": "Choose the video to integrate",
  "Escolha o vídeo base (sem introdução) onde as aberturas serão testadas.": "Choose the base video (without an intro) to test openings on.",
  "Escolha o vídeo do seu webinar": "Choose your webinar video",
  "Escolha o vídeo onde o formulário será exibido": "Choose the video where the form appears",
  "Escolha o vídeo que será protegido com senha": "Choose the video to protect with a password",
  "Escolha onde exibir no vídeo": "Choose where to display it in the video",
  "Escolha onde suas conversões são processadas.": "Choose where your conversions are processed.",
  "Escolha os vídeos direto da sua biblioteca, sem precisar de um novo upload": "Choose videos directly from your library without a new upload",
  "Escolha os vídeos no Google Drive": "Choose videos in Google Drive",
  "Escolha os vídeos que deseja comparar": "Choose the videos to compare",
  "Escolha os vídeos que deseja comparar lado a lado.": "Choose videos to compare side by side.",
  "Escolha os vídeos que você deseja comparar. Cada visitante verá apenas um deles durante o teste.": "Choose the videos you want to compare. Each visitor will see only one during the test.",
  "Escolha outro vídeo para esta etapa.": "Choose another video for this step.",
  "Escolha quando o card aparece: no final do vídeo, ao pausar ou em um tempo personalizado": "Choose when the card appears: at the end of the video, when paused, or at a custom time",
  "Escolha seu idioma preferido para o aplicativo": "Choose your preferred language for the application",
  "Escolha seu plano": "Choose your plan",
  "Escolha um cartão ou adicione um novo.": "Choose a card or add a new one.",
  "Escolha um estilo pronto ou ajuste manualmente abaixo.": "Choose a preset style or adjust it manually below.",
  "Escolha um ícone e uma cor para personalizar sua pasta": "Choose an icon and color to customize your folder",
  "Escolha um modelo abaixo para começar": "Choose a template below to get started",
  "Escolha um modelo visual para o overlay": "Choose a visual template for the overlay",
  "Escolha um período de até {value0} dias.": "Choose a period of up to {value0} days.",
  "Escolha um template para a variação": "Choose a template for the variation",
  "Escolha um template pré-configurado para começar rapidamente": "Choose a preset template to get started quickly",
  "Escolha um vídeo": "Choose a video",
  "Escolha um vídeo acima para visualizar os relatórios de captura.": "Choose a video above to view capture reports.",
  "Escolha um vídeo da biblioteca": "Choose a video from the library",
  "Escolha um vídeo da biblioteca para substituir o original.": "Choose a video from the library to replace the original.",
  "Escolha um vídeo da sua biblioteca para continuar.": "Choose a video from your library to continue.",
  "Escolha um vídeo para exibir no autoplay": "Choose a video to show in autoplay",
  "Escolha um vídeo processado da sua biblioteca e aplique personalizações avançadas": "Choose a processed video from your library and apply advanced customizations",
  "Escolha uma das opções abaixo": "Choose an option below",
  "Escolha uma das opções abaixo para receber suporte.": "Choose an option below to receive support.",
  "Escolha uma data e horário para encerrar o teste.": "Choose a date and time to end the test.",
  "Escolha uma opção": "Choose an option",
  "Escolha uma opção abaixo para continuar": "Choose an option below to continue",
  "Escolher Arquivo": "Choose File",
  "Escolher arquivos": "Choose files",
  "Escolher intervalo": "Choose range",
  "Escolher pitch": "Choose pitch",
  "Escolher vídeos no Drive": "Choose videos in Drive",
  "Esconder Início": "Hide start",
  "Escopo de aplicação": "Application scope",
  "Escreva o texto com nome, cidade e produto — use a sugestão automática ou a sua própria lista": "Write text with name, city, and product — use the automatic suggestion or your own list",
  "Escurecer 5%": "Darken 5%",
  "Escurecer automaticamente": "Automatically darken",
  "Escurecido": "Darkened",
  "Escurecimento": "Dimming",
  "Escurecimento atrás das opções": "Dimming behind options",
  "Espaçamento Externo (Offset)": "Outer Spacing (Offset)",
  "Espaçamento Interno": "Inner Spacing",
  "Español": "Español",
  "espectadores": "viewers",
  "Espectadores": "Viewers",
  "espectadores ·": "viewers ·",
  "Espere! Oferta especial": "Wait! Special offer",
  "Espere! Temos uma condição especial para você": "Wait! We have a special offer for you",
  "Espessura": "Width",
  "Espessura da barra": "Bar thickness",
  "Espessura da Borda": "Border Width",
  "Espessura da Linha (1-6px)": "Line Thickness (1–6px)",
  "Espionar Ofertas com a AdSniper": "Explore Offers with AdSniper",
  "Esqueceu sua senha?": "Forgot your password?",
  "Esquerda": "Left",
  "Essa atualização deixa a Host VSL ainda mais alinhada com quem busca escala, performance e operação profissional.": "This update aligns Host VSL even more closely with those seeking scale, performance, and professional operations.",
  "Essa condição está disponível somente nesta página": "This offer is available only on this page",
  "Essa referência representa": "This referrer represents",
  "Essas configurações não afetam o funcionamento do vídeo.": "These settings do not affect how the video works.",
  "Essas opções são usadas apenas quando o redirecionamento automático estiver ativo.": "These options are used only when automatic redirect is enabled.",
  "Esse tempo passa da duração do vídeo.": "This time exceeds the video duration.",
  "Esse vídeo não pôde ser baixado. Os outros continuam.": "This video could not be downloaded. The others will continue.",
  "Esse vídeo não pode ser transmitido a partir deste navegador.": "This video cannot be cast from this browser.",
  "Essencial": "Essential",
  "Esses locais serão bloqueados.": "These locations will be blocked.",
  "Esta ação irá encerrar o teste A/B de introduções e fixar a intro atual como definitiva. Esta ação não pode ser desfeita.": "This will end the intro A/B test and make the current intro permanent. This action cannot be undone.",
  "Esta ação irá encerrar o teste de introduções e nenhum dado adicional será coletado. Você poderá visualizar os resultados, mas não poderá reativar o teste.": "This will end the intro test and no additional data will be collected. You can view results but cannot reactivate the test.",
  "Esta ação irá excluir permanentemente este teste e todos os seus dados. Esta ação não pode ser desfeita.": "This action will permanently delete this test and all its data. This action cannot be undone.",
  "Esta ação irá restaurar todas as configurações para os valores padrão.": "This will restore all settings to their default values.",
  "Esta ação não bloqueia vídeos já incorporados anteriormente.": "This action does not block previously embedded videos.",
  "Esta ação não pode ser desfeita. A introdução \"": "This action cannot be undone. Intro \"",
  "Esta ação não pode ser desfeita. A playlist será removida permanentemente.": "This action cannot be undone. The playlist will be permanently removed.",
  "Esta ação não pode ser desfeita. O teste \"": "This action cannot be undone. Test \"",
  "Esta ação remove a pasta e suas subpastas da sua organização. Os vídeos não serão apagados do sistema.": "This removes the folder and its subfolders from your organization. Videos will not be deleted from the system.",
  "está apresentando os melhores resultados.": "is delivering the best results.",
  "está com melhor desempenho": "is performing better",
  "Esta é uma visualização de como seu vídeo será exibido para o público.": "This is a preview of how your video will appear to the public.",
  "Esta etapa (repetir)": "This step (repeat)",
  "Esta integração está ativa e funcionando": "This integration is active and working",
  "Esta integração está desativada": "This integration is disabled",
  "Esta introdução está ativa e coletando dados. Continue monitorando o desempenho.": "This intro is active and collecting data. Keep monitoring performance.",
  "Esta introdução está com desempenho inferior. Revise o conteúdo ou considere substituí-la.": "This intro is underperforming. Review the content or consider replacing it.",
  "Esta introdução está performando melhor porque o storytelling ativa mais áreas do cérebro do espectador:": "This intro is performing better because storytelling activates more areas of viewers' brains:",
  "Esta introdução está performando melhor que as outras no teste. Considere aumentar o tráfego direcionado a ela.": "This intro is performing better than others in the test. Consider sending it more traffic.",
  "Esta introdução está performando muito bem em termos de retenção. Continue aplicando os mesmos princípios em seus próximos vídeos.": "This intro is performing very well in terms of retention. Keep applying the same principles in your next videos.",
  "Esta pasta está vazia": "This folder is empty",
  "Esta pasta não possui vídeos": "This folder has no videos",
  "Esta pasta não tem vídeos.": "This folder has no videos.",
  "Esta playlist ainda não possui vídeos.": "This playlist has no videos yet.",
  "Esta regra pode conflitar com outras regras existentes.": "This rule may conflict with existing rules.",
  "Esta seção será expandida com novas funcionalidades:": "This section will be expanded with new features:",
  "Esta seção será implementada em breve.": "This section will be implemented soon.",
  "Esta será a senha que os usuários precisarão digitar para desbloquear o vídeo": "This is the password users will need to enter to unlock the video",
  "Esta versão do player não aceita pré-visualização.": "This player version does not support previews.",
  "Estabilidade até 1min sugere boa narrativa.": "Stability up to 1 minute suggests a good narrative.",
  "Estado": "State",
  "Estado Normal": "Normal State",
  "Estados": "States",
  "Estamos preparando este vídeo para compartilhamento. Em instantes ele ficará disponível em": "We are preparing this video for sharing. It will be available shortly in",
  "Estamos prontos para analisar": "We are ready to analyze",
  "estão desativados. Sem eles, a legenda ficará sempre visível na tela quando ativada e o espectador não terá como desligar.": "are disabled. Without them, captions stay visible on screen when enabled and viewers cannot turn them off.",
  "Estas sugestões são baseadas nas métricas de reprodução, engajamento e conversão.": "These suggestions are based on play, engagement, and conversion metrics.",
  "Este ajuste sobrescreve o modelo selecionado": "This adjustment overrides the selected template",
  "Este código inclui proteção ativa para:": "This code includes active protection for:",
  "Este compartilhamento não está disponível": "This share is unavailable",
  "Este compartilhamento não está mais disponível": "This share is no longer available",
  "Este é o saldo liberado baseado nas indicações da sua carteira que você pode transferir imediatamente.": "This is the available balance from your referrals that you can transfer immediately.",
  "Este é o vídeo usado na estratégia de captura. Clique em Editar para alterar configurações.": "This is the video used in the capture strategy. Click Edit to change settings.",
  "Este é um horário de pico. Mantenha seus anúncios e campanhas ativos durante este período.": "This is a peak time. Keep your ads and campaigns active during this period.",
  "Este e-mail já foi convidado": "This email has already been invited",
  "Este e-mail já possui um registro de incremento.": "This email already has an increment record.",
  "Este fluxo ainda não tem vídeos.": "This flow has no videos yet.",
  "Este fluxo foi alterado em outra aba ou por outra pessoa.": "This flow was changed in another tab or by someone else.",
  "Este fluxo não existe ou foi excluído.": "This flow does not exist or was deleted.",
  "Este GIF é pesado ({size}) e pode impactar a fluidez do preview. Recomendamos usar um GIF mais leve ou reduzir as dimensões.": "This GIF is heavy ({size}) and may impact preview fluidity. We recommend using a lighter GIF or reducing dimensions.",
  "Este link atingiu o limite máximo de cópias permitido. Entre em contato com o produtor.": "This link has reached its maximum allowed copies. Contact the producer.",
  "Este link de compartilhamento não existe ou foi removido.": "This sharing link does not exist or was removed.",
  "Este link de compartilhamento pertence ao vídeo:": "This sharing link belongs to the video:",
  "Este link expirou e não está mais disponível. Solicite um novo link ao produtor.": "This link has expired and is no longer available. Request a new link from the producer.",
  "Este mês": "This month",
  "Este Mini-Hook se sobrepõe a \"{name}\" no mesmo intervalo.": "This Mini-Hook overlaps with \"{name}\" in the same interval.",
  "Este nome será usado para identificar o teste na lista": "This name will identify the test in the list",
  "Este painel mostra quando seu público mais assiste ou carrega seu vídeo. Plays Únicos representam sessões deduplicadas; Visualizações Únicas, impressões deduplicadas. Use os horários mais fortes para agendar campanhas e posts.": "This panel shows when your audience most often watches or loads your video. Unique Plays represent deduplicated sessions; Unique Views represent deduplicated impressions. Use peak times to schedule campaigns and posts.",
  "Este parâmetro UTM já está sendo usado por outra regra.": "This UTM parameter is already used by another rule.",
  "Este preview mostra como seus controles aparecerão no player real. As cores e configurações são aplicadas instantaneamente.": "This preview shows how your controls will appear in the actual player. Colors and settings apply instantly.",
  "Este script acelera o carregamento do vídeo no seu site.": "This script speeds up video loading on your site.",
  "Este teste ainda não foi iniciado.": "This test has not started yet.",
  "Este teste ainda não possui dados suficientes para análise. Os dados começam a ser gerados assim que os vídeos forem visualizados.": "This test does not have enough data for analysis yet. Data starts being generated as soon as the videos receive views.",
  "Este teste está ativo e recebendo tráfego": "This test is active and receiving traffic",
  "Este teste está em andamento. Clique em 'Ver Teste' para acompanhar os resultados em tempo real.": "This test is running. Click 'View Test' to track results in real time.",
  "Este teste foi finalizado.": "This test has ended.",
  "Este teste não possui vídeos associados.": "This test has no associated videos.",
  "Este token não é mais válido.": "This token is no longer valid.",
  "Este usuário já está tem contana plataforma.": "This user already has an account on the platform.",
  "Este vídeo é propriedade intelectual do": "This video is the intellectual property of",
  "Este vídeo está em uso numa etapa. Troque o vídeo da etapa antes de excluir.": "This video is used in a step. Change the step's video before deleting it.",
  "Este vídeo já está sendo usado nesta plataforma.": "This video is already used on this platform.",
  "Este vídeo não está mais no fluxo.": "This video is no longer in the flow.",
  "Este vídeo pertence à sua conta. Não é necessário copiá-lo — você já tem acesso completo a ele na seção": "This video belongs to your account. You do not need to copy it — you already have full access to it in the section",
  "Estilo": "Style",
  "Estilo Avançado": "Advanced style",
  "Estilo avançado autoplay": "Advanced autoplay style",
  "Estilo da Barra": "Bar style",
  "Estilo da Headline": "Headline style",
  "Estilo da legenda": "Subtitle style",
  "Estilo da Subheadline": "Subheadline style",
  "Estilo das legendas": "Caption style",
  "Estilo de borda (preset)": "Border style (preset)",
  "Estilo do Autoplay": "Autoplay style",
  "Estilo do botão": "Button style",
  "Estilo do Botão": "Button Style",
  "Estilo do card": "Card style",
  "Estilo do destaque": "Highlight style",
  "Estilo do Fundo": "Background Style",
  "Estilo do Ícone": "Icon style",
  "Estilo dos inputs do formulário": "Form input style",
  "Estilo e Comportamento": "Style and behavior",
  "Estilo TikTok": "TikTok style",
  "Estilos Rápidos": "Quick Styles",
  "Estimativa sobre o total": "Estimated share of total",
  "Estimativa:": "Estimate:",
  "Estratégia ativa": "Active strategy",
  "Estratégia ativada": "Strategy activated",
  "Estratégia atualizada": "Strategy updated",
  "Estratégia atualizada com sucesso ✅": "Strategy updated successfully",
  "Estratégia criada com sucesso": "Strategy created successfully",
  "Estratégia de Captura": "Capture Strategy",
  "Estratégia desativada": "Strategy disabled",
  "Estratégia não encontrada ou tipo inválido.": "Strategy not found or invalid type.",
  "Estratégia removida": "Strategy removed",
  "Estratégias e recomendações para otimizar seus testes e melhorar os resultados.": "Strategies and recommendations to optimize your tests and improve results.",
  "Estratégias para otimizar a retenção de \"": "Strategies to optimize retention for \"",
  "Estrelas": "Stars",
  "Estrutura de Diretórios": "Directory Structure",
  "Estruture seu conteúdo em formato de história com início (problema), meio (agravamento) e fim (solução).": "Structure your content as a story with a beginning (problem), middle (escalation), and end (solution).",
  "Estude os concorrentes bem-sucedidos para inspiração (sem copiar diretamente).": "Study successful competitors for inspiration (without copying them directly).",
  "etapa": "step",
  "Etapa": "Step",
  "Etapa · {value0}": "Step · {value0}",
  "Etapa inicial": "Initial step",
  "Etapa sem nome": "Unnamed step",
  "etapas": "steps",
  "Etapas da jornada do lead": "Lead journey stages",
  "EUA": "USA",
  "Europe/London": "Europe/London",
  "Event handlers inline não são permitidos.": "Inline event handlers are not allowed.",
  "Evento": "Event",
  "Evento começa em:": "Event starts in:",
  "Evento de Disparo": "Trigger Event",
  "evento(s) nas últimas 24h (": "event(s) in the last 24h (",
  "evento(s), mas nenhum nas últimas 24h (último:": "event(s), but none in the last 24h (last:",
  "eventos": "events",
  "Eventos": "Events",
  "Eventos de Interação": "Interaction Events",
  "Eventos enviados": "Events sent",
  "Eventos enviados:": "Events sent:",
  "Evite conclusões precipitadas com poucos dados - espere atingir os valores mínimos recomendados.": "Avoid hasty conclusions with little data — wait until you reach the recommended minimums.",
  "Evite ofertar sessões em horários sensíveis": "Avoid offering sessions during sensitive hours",
  "Evite sobrepor partes importantes": "Avoid covering important areas",
  "Evolução da entrada": "Entry trends",
  "Evolução da nota média": "Average rating trends",
  "Evolução das referências": "Referrer trends",
  "Evolução de Conversões": "Conversion Trends",
  "Evolução nos últimos 12 meses": "Trends over the last 12 months",
  "Ex: #FF0000, block, 20px": "E.g.: #FF0000, block, 20px",
  "Ex: 0001": "E.g.: 0001",
  "Ex: 12345-6": "E.g.: 12345-6",
  "Ex: 123456-7": "E.g.: 123456-7",
  "Ex: 1234567890123456": "E.g.: 1234567890123456",
  "Ex: 150": "E.g.: 150",
  "Ex: 71 99999-8888": "E.g.: 71 99999-8888",
  "Ex: Acesse todos os módulos do curso...": "E.g.: Access all course modules...",
  "Ex: Agende agora sem custos": "E.g.: Schedule now for free",
  "Ex: Ao vivo agora": "E.g.: Live now",
  "Ex: Assista até o final para descobrir o método": "E.g.: Watch until the end to discover the method",
  "Ex: Assista até o final para descobrir o método que está gerando vendas todos os dias": "E.g.: Watch until the end to discover the method generating sales every day",
  "Ex: ativo, visivel, destaque": "E.g.: active, visible, highlight",
  "Ex: Autoplay Moderno, Conversão Limpa...": "E.g.: Modern Autoplay, Clean Conversion...",
  "Ex: Bem-vindo ao Curso": "E.g.: Welcome to the Course",
  "Ex: Bônus Exclusivos": "E.g.: Exclusive Bonuses",
  "Ex: Botão de Checkout": "E.g.: Checkout Button",
  "Ex: Brasil, EUA": "E.g.: Brazil, USA",
  "Ex: color, background, display": "E.g.: color, background, display",
  "Ex: Comece sua jornada de transformação": "E.g.: Start your transformation journey",
  "Ex: Como Ganhar R$ 10.000 por Mês com Marketing Digital": "E.g.: How to Earn R$ 10,000 per Month with Digital Marketing",
  "Ex: Comprar Agora": "E.g.: Buy Now",
  "Ex: Concorra a um iPhone 15": "E.g.: Enter to win an iPhone 15",
  "Ex: Continuar Assistindo": "E.g.: Continue Watching",
  "Ex: Continue agora mesmo": "E.g.: Continue right now",
  "Ex: Copie este vídeo para começar a divulgar...": "E.g.: Copy this video to start promoting...",
  "Ex: Curso Completo de Marketing": "E.g.: Complete Marketing Course",
  "Ex: Curso Completo de Marketing Digital": "E.g.: Complete Digital Marketing Course",
  "Ex: Curso Premium": "e.g. Premium Course",
  "Ex: Diagnóstico Comercial Gratuito": "E.g.: Free Business Assessment",
  "ex: dominio.com ou dominio.com/pagina": "e.g.: domain.com or domain.com/page",
  "Ex: facebook": "E.g.: facebook",
  "Ex: Funil Low Ticket / Campanha Fevereiro": "E.g.: Low-Ticket Funnel / February Campaign",
  "Ex: google, facebook, newsletter": "E.g.: google, facebook, newsletter",
  "Ex: Headline Moderna, Conversão Limpa...": "E.g.: Modern Headline, Clean Conversion...",
  "Ex: IPINFO API, Amazon EC2...": "E.g.: IPINFO API, Amazon EC2...",
  "Ex: João Silva": "E.g.: João Silva",
  "Ex: joao@email.com": "E.g.: joao@email.com",
  "Ex: Libere o acesso ao vídeo": "E.g.: Unlock video access",
  "Ex: Marketing, VSLs, Tutoriais...": "E.g.: Marketing, VSLs, Tutorials...",
  "Ex: Materiais extras para acelerar seus resultados": "E.g.: Extra materials to accelerate your results",
  "Ex: Módulos Iniciais": "E.g.: Initial Modules",
  "Ex: Mostrar botão de compra": "E.g.: Show buy button",
  "Ex: Oferta Black Friday 2024": "E.g.: Black Friday 2024 Offer",
  "Ex: Olá! Tenho interesse no conteúdo da sua playlist.": "E.g.: Hello! I'm interested in your playlist content.",
  "Ex: Plano Pro - 10k requests/mês": "E.g.: Pro Plan - 10k requests/month",
  "ex: Português": "e.g.: Portuguese",
  "Ex: Proteção principal": "E.g.: Main protection",
  "Ex: Próximo passo da sua jornada": "E.g.: The next step in your journey",
  "ex: pt-BR, zh-TW": "e.g.: pt-BR, zh-TW",
  "Ex: Reforço da promessa inicial": "E.g.: Reinforce initial promise",
  "Ex: Restam poucas vagas": "E.g.: Few spots left",
  "Ex: São Paulo, Rio de Janeiro": "E.g.: São Paulo, Rio de Janeiro",
  "Ex: Seu vídeo já começou": "E.g.: Your video has started",
  "Ex: Seus dados estão seguros conosco": "E.g.: Your data is safe with us",
  "Ex: SSL Seguro": "E.g.: Secure SSL",
  "Ex: Teste de Aberturas – Produto X": "E.g.: Opening Test – Product X",
  "Ex: Teste de Introduções - VSL Principal": "E.g.: Intro Test - Main VSL",
  "Ex: Teste de VSLs - Produto X": "E.g.: VSL Test - Product X",
  "Ex: Teste de VSLs – Produto X": "E.g.: VSL Test – Product X",
  "Ex: Toque para ativar o som": "E.g.: Tap to enable sound",
  "Ex: Última chance": "E.g.: Last chance",
  "Ex: utm_source": "E.g.: utm_source",
  "Ex: VSL Principal vs Variação Curta": "E.g.: Main VSL vs Short Variation",
  "Ex: Webinário de Lançamento Produto X": "E.g.: Product X Launch Webinar",
  "Ex.: Ative o som para melhor experiência": "E.g.: Enable sound for a better experience",
  "Ex.: Funil Emagrecimento 30D": "E.g.: 30-Day Weight Loss Funnel",
  "Ex.: Oferta principal": "E.g.: Main offer",
  "Ex.: Seu vídeo já começou": "E.g.: Your video has started",
  "Ex.: Toque para ativar o som": "E.g.: Tap to enable sound",
  "Excel (.xlsx)": "Excel (.xlsx)",
  "Excelente": "Excellent",
  "Excelente trabalho! Sua introdução está performando bem em todos os aspectos. A combinação de alta taxa de play e bom engajamento mostra que tanto seu thumbnail quanto seu conteúdo estão alinhados com as expectativas do público.": "Excellent work! Your intro is performing well in all areas. The combination of high play rate and good engagement shows your thumbnail and content match audience expectations.",
  "Excelente! Esta introdução com storytelling está performance muito bem. O formato narrativo cria uma conexão emocional com o espectador e mantém o engajamento alto. Continue usando histórias relevantes que ressoam com seu público-alvo.": "Excellent! This storytelling intro is performing very well. The narrative format creates an emotional connection with viewers and keeps engagement high. Keep using relevant stories that resonate with your target audience.",
  "Excluindo...": "Deleting...",
  "Excluir": "Delete",
  "Excluir {value0} pastas?": "Delete {value0} folders?",
  "Excluir a etapa \"": "Delete step \"",
  "Excluir Bônus?": "Delete Bonus?",
  "Excluir compartilhamento": "Delete share",
  "Excluir definitivamente": "Delete permanently",
  "Excluir Estratégia": "Delete Strategy",
  "Excluir etapa": "Delete step",
  "Excluir fluxo e vídeos": "Delete flow and videos",
  "Excluir fluxo e vídeos?": "Delete flow and videos?",
  "Excluir legenda": "Delete subtitle",
  "Excluir Mini-Hook?": "Delete Mini-Hook?",
  "Excluir Módulo?": "Delete Module?",
  "Excluir pasta": "Delete folder",
  "Excluir pasta?": "Delete folder?",
  "Excluir playlist?": "Delete playlist?",
  "Excluir registro": "Delete record",
  "Excluir saída": "Delete exit",
  "Excluir teste A/B?": "Delete A/B test?",
  "Excluir teste de hook?": "Delete hook test?",
  "Excluir teste de introduções?": "Delete intro test?",
  "Excluir Todos": "Delete All",
  "Excluir Tracking?": "Delete Tracking?",
  "Excluir variação?": "Delete variation?",
  "Excluir vídeo": "Delete video",
  "Excluir vídeo da playlist": "Delete video from playlist",
  "Excluir vídeo?": "Delete video?",
  "Excluir vídeos selecionados": "Delete selected videos",
  "Exemplo do endereço final": "Final address example",
  "Exemplo:": "Example:",
  "Exemplo: Se o webinário começa às 20h e alguém entra às 20:15, o vídeo inicia automaticamente no minuto 15.": "Example: If the webinar starts at 20:00 and someone joins at 20:15, the video automatically starts at minute 15.",
  "Exemplo: StatsCard": "Example: StatsCard",
  "exemplo.com": "example.com",
  "exemplo.com/vendas": "example.com/sales",
  "Exiba alertas de compras para gerar prova social em tempo real.": "Show purchase alerts to generate social proof in real time.",
  "Exiba imagens ou GIFs em momentos estratégicos do vídeo para reforçar a atenção": "Show images or GIFs at strategic moments in the video to reinforce attention",
  "Exiba imagens ou GIFs em momentos estratégicos.": "Show images or GIFs at strategic moments.",
  "Exiba legendas sincronizadas no seu vídeo. Suporta arquivos .SRT e .VTT.": "Show synchronized captions in your video. Supports .SRT and .VTT files.",
  "Exiba provas sociais de compras recentes enquanto o vídeo roda": "Show social proof of recent purchases while the video plays",
  "Exiba sua logomarca sobre o vídeo e aumente a visibilidade da sua marca.": "Display your logo over the video and increase brand visibility.",
  "Exiba sua logomarca sobre o vídeo.": "Display your logo over the video.",
  "Exiba um botão de ação durante o vídeo de entrada.": "Show an action button during the entry video.",
  "Exiba um botão de ação durante o vídeo de saída.": "Show an action button during the exit video.",
  "Exiba uma ou mais imagens/GIFs em momentos estratégicos do vídeo para reforçar a atenção.": "Show one or more images/GIFs at strategic moments in the video to reinforce attention.",
  "Exibe a barra de progresso na parte inferior do player": "Displays the progress bar at the bottom of the player",
  "Exibe a barra inferior com os controles do player. Quando desativada, os controles ficam ocultos mesmo com o tema personalizado.": "Displays the bottom bar with player controls. When disabled, controls stay hidden even with a custom theme.",
  "Exibe a headline diretamente sobre o vídeo.": "Shows the headline directly over the video.",
  "Exibe a logo da HostVSL no player e ativa o redirecionamento pelo seu link": "Displays the HostVSL logo on the player and enables redirection through your link",
  "Exibe a logo HostVSL e ativa seu link de afiliado.": "Shows the HostVSL logo and enables your affiliate link.",
  "Exibe controle deslizante de volume no player": "Displays a volume slider in the player",
  "Exibe miniaturas do vídeo ao passar o mouse na barra de progresso. Requer controles do player ativos (não funciona com a barra fake). Disponível apenas em vídeos processados após esta atualização.": "Displays video thumbnails when hovering over the progress bar. Requires active player controls (does not work with the fake bar). Available only for videos processed after this update.",
  "Exibe modal para retomar reprodução de onde o usuário parou.": "Displays a dialog to resume playback where the user left off.",
  "Exibe notificações de compra no player.": "Displays purchase notifications in the player.",
  "Exibe ou oculta os controles do player (play, pause, volume, etc.)": "Shows or hides player controls (play, pause, volume, etc.)",
  "Exibe sua logomarca sobre o vídeo.": "Displays your logo over the video.",
  "Exibe um botão para abrir o vídeo em uma janela flutuante (PiP), permitindo que o espectador continue assistindo enquanto navega em outras abas.": "Displays a button to open the video in a floating window (PiP), allowing viewers to keep watching while browsing other tabs.",
  "Exibe um botão permitindo que o usuário pule o preenchimento do formulário e continue assistindo o vídeo": "Displays a button allowing users to skip the form and continue watching the video",
  "Exibe um contador de pessoas assistindo no player.": "Displays a viewer counter in the player.",
  "Exibe uma barra visual no rodapé do player durante a reprodução.": "Displays a visual bar at the bottom of the player during playback.",
  "Exibe uma contagem regressiva ao final do vídeo e redireciona automaticamente.": "Shows a countdown at the end of the video and redirects automatically.",
  "Exibe uma imagem estática no lugar do player": "Shows a static image instead of the player",
  "Exibe uma mensagem sutil informando que o vídeo iniciou automaticamente.": "Displays a subtle message indicating the video started automatically.",
  "Exibição": "Display",
  "Exibição e Capacidade": "Display and Capacity",
  "Exibição por dispositivo": "Display by device",
  "Exibição por Dispositivo": "Display by device",
  "Exibição por dispositivo atualizada": "Device display updated",
  "Exibição:": "Display:",
  "Exibições de entrada": "Entry impressions",
  "Exibições de saída": "Exit impressions",
  "Exibido antes do principal para preparar o espectador.": "Shown before the main video to prepare viewers.",
  "Exibido após o principal para apresentar sua oferta.": "Shown after the main video to present your offer.",
  "Exibir barra": "Show bar",
  "Exibir barra de controles": "Show control bar",
  "Exibir borda": "Show border",
  "Exibir botão": "Show button",
  "Exibir botão de CTA abaixo do vídeo": "Show CTA button below the video",
  "Exibir contador regressivo": "Show countdown",
  "Exibir contagem regressiva": "Show countdown",
  "Exibir countdown antes do formulário": "Show countdown before the form",
  "Exibir depoimento": "Show testimonial",
  "Exibir em (minutos:segundos)": "Show at (minutes:seconds)",
  "Exibir esta primeiro": "Show this first",
  "Exibir legenda por padrão": "Show subtitles by default",
  "Exibir logo também no mobile": "Show logo on mobile too",
  "Exibir o formulário em um momento específico do vídeo": "Show the form at a specific moment in the video",
  "Exibir selos de segurança": "Show security badges",
  "Exibir senha em um momento específico": "Show password at a specific moment",
  "Exibir termo de consentimento": "Show consent statement",
  "Exibir texto sobre o banner": "Show text over the banner",
  "Exibir título": "Show title",
  "Exibir vídeo original": "Show original video",
  "Exibir Vídeo Original": "Show original video",
  "Expanda seu formulário com informações complementares": "Expand your form with additional information",
  "Experiência imersiva": "Immersive experience",
  "Experiência mais clara para reduzir erros e acelerar decisões": "A clearer experience to reduce errors and speed up decisions",
  "Experiência mais fluida para a sua audiência": "A smoother experience for your audience",
  "Experiência Nativa": "Native Experience",
  "Experimente storytelling": "Try storytelling",
  "Expira em": "Expires on",
  "Expiração do Link": "Link Expiration",
  "Expirada": "Expired",
  "Expirado": "Expired",
  "Explicação das métricas": "Metrics explanation",
  "Exportação concluída com sucesso!": "Export completed successfully!",
  "Exportando dados": "Exporting data",
  "Exportar": "Export",
  "Exportar CSV": "Export CSV",
  "Exportar CSV (linha)": "Export CSV (row)",
  "Exportar Dados": "Export Data",
  "Exportar Extrato CSV": "Export CSV Statement",
  "Exportar PDF": "Export PDF",
  "Exporte o histórico de eventos em CSV para seus relatórios": "Export event history as CSV for your reports",
  "Exporte os dados em CSV para usar em relatórios e rotinas de otimização": "Export data as CSV for reports and optimization routines",
  "Expressão regex inválida": "Invalid regex expression",
  "Expressão Regular (Regex)": "Regular Expression (Regex)",
  "Extra grande": "Extra large",
  "Extra-negrito": "Extra bold",
  "Extrato Administrativo": "Administrative Statement",
  "Extrato exportado!": "Statement exported!",
  "Extratos e Saques": "Statements and Withdrawals",
  "Extremamente rápido": "Extremely fast",
  "Faça login aqui": "Log in here",
  "Faça login para gerenciar testes de velocidade.": "Sign in to manage speed tests.",
  "Faça o upgrade agora e continue usando a HostVSL com player premium, recursos de conversão e mais limite de plays.": "Upgrade now and keep using HostVSL with a premium player, conversion features, and a higher play allowance.",
  "Faça perguntas diretas ao espectador em momentos de queda para reconquistar a atenção.": "Ask viewers direct questions at drop-off points to regain their attention.",
  "Faça sessões e botões surgirem no momento exato do vídeo.": "Make sections and buttons appear at the exact moment in the video.",
  "Faça seu site, gere textos persuasivos em segundos, potencialize o relacionamento com seu público por Whatsapp, Instagram, e-mail, SMS e converta mais com a leadlovers!": "Build your site, generate persuasive copy in seconds, strengthen audience relationships through WhatsApp, Instagram, email, and SMS, and convert more with leadlovers!",
  "Faça uma nova conta de parceiro e gere a sua conta de parceiro.": "Create a new partner account and generate your partner account.",
  "Faça upload de um ícone personalizado (opcional)": "Upload a custom icon (optional)",
  "Faça upload do primeiro vídeo para começar": "Upload the first video to get started",
  "Faça upload do seu primeiro vídeo e ajuste as configurações iniciais.": "Upload your first video and adjust initial settings.",
  "Faça upload do seu vídeo": "Upload your video",
  "Facebook": "Facebook",
  "Facilite o controle de tempo durante a reprodução.": "Make time control easier during playback.",
  "Fade In": "Fade In",
  "Fade suave": "Smooth fade",
  "Fade-in": "Fade-in",
  "Failed to get canvas context": "Failed to get canvas context",
  "Faixa de urgência": "Urgency strip",
  "Faixa de urgência e barra de progresso acima da oferta.": "Urgency strip and progress bar above the offer.",
  "Falar com especialista": "Talk to a specialist",
  "Falar no chat": "Start a chat",
  "Falar no WhatsApp": "Chat on WhatsApp",
  "Fale com nossa equipe e resolva em poucos minutos.": "Talk to our team and resolve it in minutes.",
  "Fale com nossa equipe.": "Talk to our team.",
  "Fale conosco no WhatsApp": "Contact us on WhatsApp",
  "Falha ao baixar {value0}: HTTP {value1}{value2}": "Failed to download {value0}: HTTP {value1}{value2}",
  "Falha ao carregar {value0}": "Failed to load {value0}",
  "Falha ao carregar o módulo Picker": "Failed to load the Picker module",
  "Falha ao carregar o player": "Failed to load player",
  "Falha ao carregar o vídeo": "Failed to load video",
  "Falha ao carregar vídeo": "Failed to load video",
  "Falha ao criar o teste": "Failed to create test",
  "Falha ao criar teste": "Failed to create test",
  "Falha ao enviar": "Failed to send",
  "Falha ao salvar alterações": "Failed to save changes",
  "Falha ao salvar configuração.": "Failed to save configuration.",
  "Falha ao subir a imagem. Tente novamente.": "Failed to upload image. Please try again.",
  "Falha em {value0}": "Failed at {value0}",
  "Falha no envio: {value0}": "Upload failed: {value0}",
  "Falha no processamento": "Processing failed",
  "Falhou": "Failed",
  "Falta resolver": "Needs resolution",
  "Família da Fonte": "Font family",
  "Fantasma": "Ghost",
  "fatura": "invoice",
  "Faturamento": "Revenue",
  "faturas": "invoices",
  "Favicon": "Favicon",
  "Favicon otimizado": "Optimized favicon",
  "Favicon preview": "Favicon preview",
  "Favoritos": "Favorites",
  "Fazer Upload e Solicitar Verificação": "Upload and Request Verification",
  "Fecha o vídeo com uma ação clara": "Closes the video with a clear action",
  "Fechamento bloqueado por": "Closing blocked for",
  "Fechando automaticamente...": "Closing automatically...",
  "Fechar": "Close",
  "Fechar automaticamente": "Close automatically",
  "Fechar automaticamente após envio bem-sucedido": "Close automatically after successful submission",
  "Fechar e voltar ao vídeo": "Close and go back to the video",
  "Fechar Interpretação": "Close Interpretation",
  "Fechar Janela": "Close Window",
  "Fechar recursos": "Close features",
  "Fechar sem copiar": "Close without copying",
  "Fechar tour": "Close tour",
  "Feed": "Feed",
  "Feed de vídeos": "Video feed",
  "Feed de vídeos com filtros inteligentes": "Video feed with smart filters",
  "Feedback do Vídeo": "Video Feedback",
  "Feedback do Vídeo salvo": "Video Feedback saved",
  "Ferramentas": "Tools",
  "Ferramentas · AdSniper": "Tools · AdSniper",
  "Ferramentas Administrativas": "Administrative Tools",
  "Ferramentas de Administrador": "Administrator Tools",
  "Ficará disponível como um vídeo enviado por você.": "It will be available as a video uploaded by you.",
  "ficou no topo": "came out on top",
  "Filled": "Filled",
  "Filtrar": "Filter",
  "Filtrar por período": "Filter by date range",
  "Filtrar por Provedor": "Filter by Provider",
  "Filtrar por status": "Filter by status",
  "Filtros": "Filters",
  "Filtros Avançados": "Advanced Filters",
  "Filtros avançados por nicho, formato e tempo no ar": "Advanced filters by niche, format, and time live",
  "Filtros de Período": "Period Filters",
  "Filtros por UTM (origem, campanha, conteúdo, etc.) para barrar tráfego de espionagem": "UTM filters (source, campaign, content, etc.) to block spying traffic",
  "fim": "end",
  "Fim": "End",
  "Fim da oferta (opcional)": "Offer end (optional)",
  "Fim da oferta deve ser após o início": "Offer end must be after the start",
  "Fim do dia": "End of day",
  "Final": "End",
  "Final (min:seg)": "End (min:sec)",
  "Final (opcional)": "End (optional)",
  "Final do período": "End of period",
  "Finalizado": "Finished",
  "Finalizados": "Completed",
  "Finalizando em breve:": "Ending soon:",
  "Finalizando processamento de dados": "Finishing data processing",
  "Finalizar": "Finish",
  "Finalizar agora?": "Finish now?",
  "Finalizar automaticamente": "Finish automatically",
  "Finalizar teste": "Finish Test",
  "Finalizar Teste": "Finish Test",
  "Finalizar teste A/B?": "Finish A/B test?",
  "Finalizar Teste de Introduções?": "Finish Intro Test?",
  "Finalizar teste de intros?": "Finish intro test?",
  "Finalize sua configuração para ativar o rastreamento.": "Complete your configuration to enable tracking.",
  "Finanças": "Finance",
  "Financeiro": "Finance",
  "Firefox": "Firefox",
  "Fluxo": "Flow",
  "Fluxo de Estado - Zustand Stores": "State Flow - Zustand Stores",
  "Fluxo excluído.": "Flow deleted.",
  "Fluxo não encontrado": "Flow not found",
  "Fluxo publicado": "Flow published",
  "Fluxo renomeado.": "Flow renamed.",
  "foi copiado para sua conta.": "was copied to your account.",
  "Fonte": "Font",
  "Fonte (Source)": "Source",
  "Fonte:": "Font:",
  "Fontes de Tráfego (UTM)": "Traffic Sources (UTM)",
  "Fontes de Tráfego (UTMs)": "Traffic Sources (UTMs)",
  "Footer com navegação": "Footer with navigation",
  "Fora (acima do formulário)": "Outside (above the form)",
  "Força da senha": "Password strength",
  "Forçando atualização...": "Forcing update...",
  "Forçar Atualização": "Force Update",
  "Forçar atualização completa (limpa cache e recarrega)": "Force full update (clears cache and reloads)",
  "Form de mudança da quantidade de clicks do usuário. É um valor numérico manipulável diretamente.": "Form for changing a user's click count. This is a numeric value that can be edited directly.",
  "Form de mudança de nível do usuário. Ela é setada com o nível atual do usuário automaticamente.": "Form for changing a user's level. It is automatically set to the user's current level.",
  "Form de mudança de status do usuário, aceitando os parâmetros operacionais de Ativo (A) ou Desativado (D).": "Form for changing a user's status, accepting the operational parameters Active (A) or Disabled (D).",
  "Form de mudança do plano/subscription do usuário, exibindo dinamicamente o nome do plano atual.": "Form for changing a user's plan/subscription, dynamically displaying the current plan name.",
  "Forma": "Shape",
  "Forma de pagamento": "Payment method",
  "Forma de Pagamento": "Payment Method",
  "Forma do Botão": "Button shape",
  "Formas de Pagamento": "Payment Methods",
  "Formato": "Format",
  "Formato AIDA adaptado": "Adapted AIDA Format",
  "Formato da Imagem": "Image format",
  "Formato da mensagem": "Message format",
  "Formato de arquivo não suportado. Use MP4, MOV, WEBM ou AVI.": "Unsupported file format. Use MP4, MOV, WEBM, or AVI.",
  "Formato de resposta inesperado do servidor.": "Unexpected server response format.",
  "Formato do vídeo": "Video format",
  "Formato inválido": "Invalid format",
  "Formato inválido. Use algo como seudominio.com.br.": "Invalid format. Use something like yourdomain.com.br.",
  "Formato inválido. Use JPG, PNG, WEBP ou GIF.": "Invalid format. Use JPG, PNG, WEBP or GIF.",
  "Formato inválido. Use PNG, JPG ou GIF.": "Invalid format. Use PNG, JPG, or GIF.",
  "Formato não suportado": "Unsupported format",
  "Formato não suportado. Use MP4, MOV ou WEBM.": "Unsupported format. Use MP4, MOV, or WEBM.",
  "Formato não suportado. Use PNG ou JPG": "Unsupported format. Use PNG or JPG",
  "Formato não suportado. Use PNG ou JPG.": "Unsupported format. Use PNG or JPG.",
  "Formato: minutos:segundos (exemplo: 00:15 para 15 segundos)": "Format: minutes:seconds (example: 00:15 for 15 seconds)",
  "Formatos aceitos: .VTT, .SRT": "Accepted formats: .VTT, .SRT",
  "Formatos aceitos: MP4, MOV, AVI": "Accepted formats: MP4, MOV, AVI",
  "Formatos aceitos: MP4, MOV, WEBM • até 5GB • H.264 recomendado": "Accepted formats: MP4, MOV, WEBM • up to 5GB • H.264 recommended",
  "Formatos suportados": "Supported formats",
  "Formatos suportados: MP4, MOV, AVI • Máximo 500MB": "Supported formats: MP4, MOV, AVI • Maximum 500MB",
  "formulário": "form",
  "Formulário": "Form",
  "Formulário não disponível para esta integração.": "Form unavailable for this integration.",
  "Formulário vertical": "Vertical form",
  "Fornece recursos para intermediar a relação entre consumidores, afiliados e produtores.": "Provides features to mediate relationships between consumers, affiliates, and producers.",
  "Fortaleça sua narrativa": "Strengthen your narrative",
  "Forte": "Strong",
  "Foto alterada": "Photo changed",
  "Foto removida": "Photo removed",
  "Français": "Français",
  "Freelancers e Profissionais": "Freelancers and Professionals",
  "Frente do Documento (Com Foto)": "Document Front (with Photo)",
  "Frequência": "Frequency",
  "Frequência ({value}s)": "Frequency ({value}s)",
  "Frequência de geração de sessões": "Session generation frequency",
  "Função de ativar/desativar em desenvolvimento.": "Enable/disable feature is in development.",
  "Função de duplicar em desenvolvimento.": "Duplicate feature is in development.",
  "Funciona ao final da reprodução do vídeo.": "Works at the end of video playback.",
  "Funciona com a Page Visibility API para máxima compatibilidade": "Works with the Page Visibility API for maximum compatibility",
  "Funciona com AirPlay no Safari (iPhone, iPad, Mac)": "Works with AirPlay in Safari (iPhone, iPad, Mac)",
  "Funciona com Chromecast no Chrome/Edge (Windows, Mac, Android)": "Works with Chromecast in Chrome/Edge (Windows, Mac, Android)",
  "Funciona Offline": "Works Offline",
  "Funciona quando o visitante troca de aba ou minimiza o navegador.": "Works when the visitor switches tabs or minimizes the browser.",
  "Funcionalidade de duplicação em breve.": "Duplication feature coming soon.",
  "Funcionalidade de excluir em desenvolvimento": "Delete feature in development",
  "Funcionalidade em desenvolvimento": "Feature in development",
  "Funcionalidades:": "Features:",
  "Fundo": "Background",
  "Fundo (Hover)": "Background (Hover)",
  "Fundo Botão": "Button background",
  "Fundo botão play": "Play button background",
  "Fundo botão restart": "Restart button background",
  "Fundo colorido": "Colored background",
  "Fundo com blur": "Blurred background",
  "Fundo da Headline": "Headline background",
  "Fundo de cards": "Card background",
  "Fundo de switch cards": "Switch card background",
  "Fundo do overlay": "Overlay background",
  "Fundo principal": "Main background",
  "Fundo Sólido": "Solid Background",
  "Fundo:": "Background:",
  "Funil": "Funnel",
  "Funil de Conversão": "Conversion Funnel",
  "Funil de Conversão nas Métricas": "Conversion Funnel in Metrics",
  "Funil de Vídeo": "Video Funnel",
  "Funil de Vídeos": "Video Funnel",
  "Funil de Vídeos (Dinâmico)": "Video Funnel (Dynamic)",
  "Funil dinâmico": "Dynamic Funnel",
  "Funil Dinâmico": "Dynamic Funnel",
  "Fuso atual:": "Current time zone:",
  "Fuso Horário": "Time Zone",
  "Futuras Integrações": "Future integrations",
  "G": "L",
  "Ganhe 20% de comissão sobre tudo enquanto o cliente estiver ativo.": "Earn 20% commission on everything while the customer remains active.",
  "Ganhe comissão recorrente": "Earn recurring commission",
  "Ganhe de Forma Recorrente com o Programa de Parcerias Host VSL": "Earn Recurring Income with the Host VSL Partner Program",
  "Ganhe de forma recorrente indicando a plataforma nº1 de VSLs do Brasil": "Earn recurring income by referring Brazil's #1 VSL platform",
  "Ganhos Estimados": "Estimated Earnings",
  "gapi indisponível após carregar api.js": "gapi unavailable after loading api.js",
  "Garanta essa condição especial agora": "Get this special offer now",
  "Garanta maior retenção iniciando o vídeo automaticamente.": "Increase retention by starting the video automatically.",
  "Garanta que cada segundo do seu vídeo seja assistido.": "Make sure every second of your video gets watched.",
  "Garantir minha vaga": "Reserve my spot",
  "Gargalo": "Bottleneck",
  "Georgia": "Georgia",
  "Gerado automaticamente": "Automatically generated",
  "Gerando link público": "Generating public link",
  "Gerando PDF...": "Generating PDF...",
  "Gerando token...": "Generating token...",
  "Gerando...": "Generating...",
  "Gerar Análise": "Generate Analysis",
  "Gerar Miniatura": "Generate Thumbnail",
  "Gerar novo token": "Generate new token",
  "Gere links de compartilhamento para que afiliados copiem seus vídeos rapidamente.": "Generate sharing links so affiliates can quickly copy your videos.",
  "Gere um link compartilhável para qualquer vídeo original do seu painel": "Generate a shareable link for any original video in your dashboard",
  "Gerencia tema light/dark/auto": "Manages light/dark/auto theme",
  "Gerenciar": "Manage",
  "Gerenciar compartilhamentos": "Manage shares",
  "Gerenciar formulários não enviados": "Manage unsubmitted forms",
  "Gerenciar Incremento de Clicks": "Manage Click Increments",
  "Gerenciar Ofertas": "Manage Offers",
  "Gerenciar rastreamento": "Manage tracking",
  "Gerencie e visualize seus últimos vídeos": "Manage and view your latest videos",
  "Gerencie o status da solicitação de saque.": "Manage the withdrawal request status.",
  "Gerencie os membros da sua equipe. Defina permissões de acesso por feature e por pasta.": "Manage your team members. Set access permissions by feature and folder.",
  "Gerencie os tipos de alertas que você deseja receber sobre suas métricas e conversões": "Manage the types of alerts you want about your metrics and conversions",
  "Gerencie pagamentos, solicitações e repasses da rede de afiliados.": "Manage payments, requests, and payouts for the affiliate network.",
  "Gerencie seus cartões e métodos de pagamento": "Manage your cards and payment methods",
  "Gerencie suas informações pessoais, segurança e preferências da conta.": "Manage your personal information and security",
  "Gerencie suas plataformas de venda integradas": "Manage your integrated sales platforms",
  "Gerencie, pesquise e organize sua biblioteca de vídeos": "Manage, search, and organize your video library",
  "Gestão com pastas": "Folder management",
  "Gestão de Custos": "Cost Management",
  "Gestão de leads integrada ao funil": "Lead management integrated with the funnel",
  "GIF animado": "Animated GIF",
  "GIF otimizado • {n}% mais leve": "GIF optimized • {n}% lighter",
  "GIF pesado pode impactar a fluidez do preview.": "Heavy GIF may impact preview fluidity.",
  "GIFs otimizados deixam o Mini-Hook mais fluido.": "Optimized GIFs make the Mini-Hook smoother.",
  "Go to next page": "Go to next page",
  "Go to previous page": "Go to previous page",
  "Google Ads": "Google Ads",
  "Google Drive": "Google Drive",
  "Google Identity Services não disponível": "Google Identity Services unavailable",
  "Google Picker não disponível": "Google Picker unavailable",
  "Grade": "Grid",
  "Gradiente": "Gradient",
  "Gráfico de Momento de Conversão no Vídeo para identificar os pontos de maior interesse": "Video Conversion Moment chart to identify the points of greatest interest",
  "Gráfico de retenção": "Retention chart",
  "Gráfico de visualizações": "Views chart",
  "Gráfico opcional": "Optional chart",
  "Gráficos": "Charts",
  "Grande": "Large",
  "Grátis, Segredo, Exclusivo, Novo": "Free, Secret, Exclusive, New",
  "group-[.toast]:text-muted-foreground": "group-[.toast]:text-muted-foreground",
  "Guia": "Guide",
  "Guia completo para criar headlines impactantes que convertem": "Complete guide to creating compelling headlines that convert",
  "Guia de Desenvolvimento": "Development Guide",
  "Guia prático para desenvolver novas features na HostVSL seguindo os padrões estabelecidos.": "Practical guide to developing new HostVSL features following established standards.",
  "Guia técnico completo • Última atualização:": "Complete technical guide • Last updated:",
  "Guias de snap para alinhamento preciso (centro, bordas)": "Snap guides for precise alignment (center, edges)",
  "há 1 dia": "1 day ago",
  "há 1 mês": "1 month ago",
  "Há 2 horas": "2 hours ago",
  "Há limite de indicações?": "Is there a referral limit?",
  "Há parâmetros com o mesmo nome.": "Some parameters have the same name.",
  "Habilita a personalização de bordas ao redor do vídeo.": "Enables customization of borders around the video.",
  "Habilita a sincronização inteligente de ações com o vídeo": "Enables smart action syncing with the video",
  "Habilita o botão de ação no vídeo selecionado": "Enables the action button on the selected video",
  "Habilitados": "Enabled",
  "Habilitar botão de pular": "Enable skip button",
  "Habilitar sorteio": "Enable giveaway",
  "HD": "HD",
  "Headline": "Enable Headline",
  "Headline não ativada": "Headline not enabled",
  "Headline por Dispositivo": "Headline by device",
  "Headline Principal": "Main headline",
  "Headline: \"": "Headline: \"",
  "Headlines são textos chamativos que aparecem sobre o vídeo para capturar atenção, transmitir uma mensagem principal e incentivar o espectador a continuar assistindo. Subheadlines complementam com informações adicionais.": "Headlines are eye-catching texts displayed over the video to attract attention, convey a main message, and encourage viewers to keep watching. Subheadlines provide additional information.",
  "Heatmap de horários": "Time heatmap",
  "Heatmap refinado com cores suavizadas, legenda de intensidade e tooltips premium com sombra unificada.": "Refined heatmap with softer colors, an intensity legend, and premium tooltips with a unified shadow.",
  "Herdando valores do Desktop. Altere para personalizar.": "Inheriting values from Desktop. Change to customize.",
  "Hero": "Hero",
  "Hero Banner": "Hero Banner",
  "Histórias pessoais ou cases de clientes geram mais conexão emocional e aumentam o interesse inicial.": "Personal stories or customer case studies create a stronger emotional connection and increase initial interest.",
  "Histórico de ações e eventos do sistema.": "System action and event history.",
  "Histórico de Eventos": "Event History",
  "Histórico de Faturas": "Invoice History",
  "Histórico de melhorias e novas funcionalidades implementadas na plataforma. Esta seção é atualizada automaticamente quando novas features são adicionadas.": "History of improvements and new platform features. This section updates automatically when new features are added.",
  "Histórico de Saques": "Withdrawal History",
  "Histórico de Testes": "My Tests",
  "Hoje": "Today",
  "Home": "Home",
  "Hora do dia": "Hour of day",
  "Horário": "Time",
  "Horário campeão do período": "Winning time of the period",
  "Horário com maior volume de espectadores": "Time with the highest viewer volume",
  "Horário com mais espectadores": "Time with the most viewers",
  "Horário de funcionamento das sessões": "Session operating hours",
  "Horário de início é obrigatório": "Start time is required",
  "Horário detectado:": "Detected time:",
  "Horário Mais Consistente": "Most Consistent Time",
  "Horário Mais Consistente (": "Most Consistent Time (",
  "Horário Mais Consistente (Conversão)": "Most Consistent Time (Conversion)",
  "Horário Mais Consistente (Volume)": "Most Consistent Time (Volume)",
  "Horários": "Times",
  "Horários alternativos recomendados": "Recommended alternative times",
  "Horários de pico": "Peak hours",
  "Horários de Pico": "Peak Hours",
  "Horários de pico por tipo de acesso": "Peak hours by access type",
  "Horários de Silêncio": "Quiet Hours",
  "Horários ideais por tipo de acesso": "Ideal times by access type",
  "Horizontal (→)": "Horizontal (→)",
  "Horizontal (campos lado a lado)": "Horizontal (side-by-side fields)",
  "Host VSL": "Host VSL",
  "Host VSL · Atualizações contínuas": "Host VSL · Continuous updates",
  "HostVSL": "HostVSL",
  "HostVSL Dashboard": "HostVSL Dashboard",
  "HostVSL Documentation v3.0 (Dinâmica) • Última atualização:": "HostVSL Documentation v3.0 (Dynamic) • Last updated:",
  "HostVSL é uma plataforma de hospedagem e gerenciamento de VSLs (Video Sales Letters) construída com tecnologias modernas para oferecer a melhor experiência em reprodução de vídeos de vendas.": "HostVSL is a VSL (Video Sales Letter) hosting and management platform built with modern technologies to deliver the best sales video playback experience.",
  "HostVSL Player - Plataforma completa para VSLs": "HostVSL Player - Complete VSL Platform",
  "hostvsl@email.com": "youremail@domain.com",
  "Hotmart": "Hotmart",
  "Houve uma instabilidade ao processar arquivos.": "There was an issue processing files.",
  "Hover": "Hover",
  "Hover Fundo": "Hover background",
  "Hover Texto": "Hover text",
  "hrs": "hrs",
  "HTML contains potentially dangerous content": "HTML contains potentially dangerous content",
  "HTML content too long (max 10,000 characters)": "HTML content too long (max 10,000 characters)",
  "HTML input must be a non-empty string": "HTML input must be a non-empty string",
  "HTML personalizado": "Custom HTML",
  "HTML Personalizado": "Custom HTML",
  "https://exemplo.com": "https://example.com",
  "https://exemplo.com.br": "https://example.com",
  "https://exemplo.com/oferta": "https://example.com/offer",
  "https://hostvsl.com/?ref=SEU_ID": "https://hostvsl.com/?ref=YOUR_ID",
  "https://seu-checkout.com": "https://your-checkout.com",
  "https://seusite.com": "https://yoursite.com",
  "ℹ️ Formulário configurado para aparecer em:": "ℹ️ Form configured to appear at:",
  "Ícone": "Icon",
  "Ícone de Exibição": "Display Icon",
  "Ícone de som": "Sound icon",
  "Ícone do Play": "Play icon",
  "Ícone personalizado": "Custom icon",
  "Ícone Personalizado": "Custom icon",
  "ID": "ID",
  "ID copiado!": "ID copied!",
  "ID da assinatura não encontrado.": "Subscription ID not found.",
  "ID da plataforma não encontrado": "Platform ID not found",
  "ID da regra": "Rule ID",
  "ID de conversão inválido. Use AW-123456789.": "Invalid conversion ID. Use AW-123456789.",
  "Id de etapa inválido": "Invalid step ID",
  "Id de opção inválido": "Invalid option ID",
  "Id de saída inválido": "Invalid exit ID",
  "ID do Afiliado": "Affiliate ID",
  "ID do cliente Stripe não encontrado": "Stripe customer ID not found",
  "ID do pagamento não fornecido.": "Payment ID not provided.",
  "ID do payout": "Payout ID",
  "ID do Pixel": "Pixel ID",
  "ID do Pixel *": "Pixel ID *",
  "ID do Plano": "Plan ID",
  "ID do usuário não encontrado": "User ID not found",
  "ID do Vídeo": "Video ID",
  "ID do vídeo não encontrado": "Video ID not found",
  "ID do vídeo não encontrado.": "Video ID not found.",
  "Id repetido: {value0}": "Duplicate ID: {value0}",
  "ID único do vídeo": "Unique video ID",
  "ID Usuário": "User ID",
  "ID Usuário:": "User ID:",
  "id:": "iD:",
  "ID:": "ID:",
  "Ideal para aulas e conteúdos rápidos.": "Ideal for lessons and short content.",
  "Ideal para campanhas em escala": "Ideal for campaigns at scale",
  "Ideal para tráfego quente e vídeos curtos": "Ideal for warm traffic and short videos",
  "Ideal para vídeos corporativos e educacionais": "Ideal for corporate and educational videos",
  "Ideal para vídeos de vitrine, demonstrações e VSLs em loop.": "Ideal for showcase videos, demos, and looping VSLs.",
  "Ideias personalizadas para otimizar \"": "Personalized ideas to optimize \"",
  "Identidade": "Identity",
  "Identidade Visual": "Visual Identity",
  "Identificação": "Identification",
  "Identificação da Ação": "Action Identification",
  "Identificamos uma retenção preventiva temporária ou simulação técnica em sua conta Connect. Nossa engenharia interna está validando os repasses junto à Stripe Connect. Nenhuma ação manual é necessária.": "We identified a temporary preventive hold or technical simulation in your Connect account. Our internal engineering team is validating payouts with Stripe Connect. No manual action is required.",
  "Identifique a melhor introdução para seu vídeo.": "Identify the best intro for your video.",
  "Identifique horários de pico automaticamente": "Identify peak hours automatically",
  "Identifique momentos específicos onde há queda acentuada de retenção e revise o conteúdo nesses pontos.": "Identify specific moments with sharp retention drops and review the content at those points.",
  "Identifique padrões de conversão por dia e horário": "Identify conversion patterns by day and time",
  "Idioma": "Language",
  "Idioma do navegador": "Browser language",
  "IDIOMAS": "LANGUAGES",
  "iFrame": "iFrame",
  "Ignorar": "Skip",
  "Igual a": "Equal to",
  "Igual no banco": "Same in database",
  "Imagem": "Image",
  "Imagem (favicon/logo)": "Image (favicon/logo)",
  "Imagem carregada": "Image loaded",
  "Imagem carregada com sucesso!": "Image uploaded successfully!",
  "Imagem de Capa (1920×700px recomendado)": "Cover Image (1920×700px recommended)",
  "Imagem de Fundo": "Background image",
  "Imagem de Fundo (Opcional)": "Background Image (Optional)",
  "Imagem Desktop": "Desktop image",
  "Imagem do Autoplay": "Autoplay image",
  "Imagem do autoplay atualizada": "Autoplay image updated",
  "Imagem do Continuar de onde parou": "Continue Watching image",
  "Imagem estática": "Static image",
  "Imagem Mobile": "Mobile image",
  "Imagem ou GIF": "Image or GIF",
  "Imagem quadrada PNG, recomendado 256×256 px": "Square PNG image, recommended 256×256 px",
  "Imagem real do momento em que os visitantes chegam ao seu vídeo": "Actual image of the moment visitors reach your video",
  "Imagem removida": "Image removed",
  "Imagem Substituta": "Replacement Image",
  "Imagens da Oferta": "Offer Images",
  "Imediato": "Immediate",
  "Impacto:": "Impact:",
  "Impede a publicação": "Prevents publishing",
  "Impede o espectador de pausar o vídeo": "Prevents viewers from pausing the video",
  "Implementação de registry centralizado para documentação auto-atualizada. Rotas, stores, componentes e design tokens agora são documentados dinamicamente.": "Implemented a centralized registry for automatically updated documentation. Routes, stores, components, and design tokens are now documented dynamically.",
  "Implementado drag-and-drop na distribuição de tráfego, badge de ordem (#1, #2, #3) nos cards de intros, e cards sortáveis com slider Radix idênticos ao Teste A/B.": "Implemented drag-and-drop traffic distribution, order badges (#1, #2, #3) on intro cards, and sortable cards with Radix sliders matching A/B Testing.",
  "Implemente storytelling": "Implement storytelling",
  "Importação de {value0} em desenvolvimento": "{value0} import in development",
  "Importando {value0} vídeo{value1}...": "Importing {value0} video{value1}...",
  "Importando do Google Drive": "Importing from Google Drive",
  "Importar": "Import",
  "Importar do Drive": "Import from Drive",
  "Importar vídeos": "Import videos",
  "Importar vídeos do Google Drive": "Import videos from Google Drive",
  "Importe vídeos direto da sua conta Google Drive.": "Import videos directly from your Google Drive account.",
  "Impostos": "Taxes",
  "Impostos Estimados": "Estimated Taxes",
  "Inativa": "Inactive",
  "Inativo": "Inactive",
  "Inativos": "Inactive",
  "Inclui 15 dias grátis": "Includes 15 days free",
  "Incluir botão externo": "Include external button",
  "Incorpore seu vídeo no site!": "Embed your video on your site!",
  "Increment Clicks": "Increment Clicks",
  "Indicação": "Referral",
  "Indicações": "Referrals",
  "Indicado para usuários avançados. Apenas HTML simples. Scripts não são permitidos.": "Recommended for advanced users. Simple HTML only. Scripts are not allowed.",
  "Indicador de Disponibilidade": "Availability Indicator",
  "Indicador de fuso horário": "Time zone indicator",
  "Indicadores Importantes": "Important Indicators",
  "Indique a plataforma nº1 de VSLs do Brasil e receba": "Refer Brazil's #1 VSL platform and receive",
  "Indique Clientes": "Refer Customers",
  "Indique e Ganhe": "Refer and Earn",
  "Indique e Ganhe e aumente seu valor para o Email.": "Refer and Earn and increase your value for Email.",
  "Indique Parceiros": "Refer Partners",
  "indisponível": "unavailable",
  "Inferior central": "Bottom center",
  "Inferior Centro": "Bottom Center",
  "Inferior Direita": "Bottom Right",
  "Inferior direito": "Bottom Right",
  "Inferior Direito": "Bottom Right",
  "Inferior Esquerda": "Bottom Left",
  "Inferior esquerdo": "Bottom Left",
  "Inferior Esquerdo": "Bottom Left",
  "Infinito": "Infinite",
  "Influenciadores e Educadores": "Influencers and Educators",
  "Informações atualizadas com sucesso": "Information updated successfully",
  "Informações Básicas": "Basic Information",
  "Informações de ajuda não disponíveis para esta etapa.": "Help information is not available for this step.",
  "Informações do Pagamento": "Payment Information",
  "Informações do vídeo": "Video information",
  "Informações Gerais": "General Information",
  "Informações Pessoais": "Personal Information",
  "Informações sobre sua assinatura e próxima cobrança": "Information about your subscription and next bill",
  "Informe a integration_key da Payt.": "Enter the Payt integration_key.",
  "Informe este token ao atendente para autorizar o acesso temporário à sua conta.": "Give this token to the support agent to authorize temporary access to your account.",
  "Informe no formato mm:ss ou hh:mm:ss.": "Enter in mm:ss or hh:mm:ss format.",
  "Informe o código de confirmação": "Enter the confirmation code",
  "Informe o ID de conversão (AW-) e um rótulo para cada ação de conversão criada no Google Ads": "Enter the conversion ID (AW-) and a label for each conversion action created in Google Ads",
  "Informe o ID do pixel e o token de acesso gerados no Events Manager do TikTok": "Enter the pixel ID and access token generated in TikTok Events Manager",
  "Informe o Rótulo (Label) da ação de Play do Google Ads.": "Enter the Label for the Google Ads Play action.",
  "Informe o token de": "Enter the token for",
  "Informe seu e-mail e enviaremos um código para redefinir sua senha.": "Enter your email and we will send a code to reset your password.",
  "Informe um endereço http:// ou https:// válido.": "Enter a valid http:// or https:// address.",
  "Informe um link válido iniciando com http:// ou https://.": "Enter a valid link starting with http:// or https://.",
  "Informe um nome para a proteção.": "Enter a name for the protection.",
  "Informe um nome para o teste.": "Enter a name for the test.",
  "Informe um valor válido.": "Enter a valid value.",
  "Informe uma URL para ativar o redirecionamento.": "Enter a URL to enable the redirect.",
  "Inicia o vídeo automaticamente ao entrar na página.": "Starts the video automatically when entering the page.",
  "Inicia o vídeo automaticamente quando o participante entra na sala.": "Automatically starts the video when participants enter the room.",
  "Inicia o vídeo com som sozinho, sem esperar o visitante clicar no aviso do autoplay. Navegadores só liberam som automático para quem já tem histórico na página — quando bloquearem, o aviso continua na tela e o primeiro toque em qualquer lugar libera o som.": "Starts the video with sound automatically, without waiting for visitors to click the autoplay notice. Browsers only allow automatic sound for visitors with previous page activity — when blocked, the notice stays on screen and the first touch anywhere enables sound.",
  "Iniciado em:": "Started on:",
  "Iniciado:": "Started:",
  "Iniciando...": "Starting...",
  "Iniciar": "Start",
  "Iniciar sem som": "Start muted",
  "Iniciar Teste": "Start Test",
  "Iniciar Teste A/B": "Start A/B Test",
  "Iniciar Teste A/B?": "Start A/B Test?",
  "Iniciar teste grátis": "Start free trial",
  "Iniciar vídeo principal automaticamente": "Start main video automatically",
  "Inicie com a dor principal + superação antes do depoimento": "Start with the main pain point + overcoming it before the testimonial",
  "Inicie com problema → solução → benefício nos primeiros 30 segundos": "Start with problem → solution → benefit in the first 30 seconds",
  "Inicie o teste na aba 'Teste A/B' para começar a coletar métricas.": "Start the test in the 'A/B Test' tab to begin collecting metrics.",
  "Inicie o vídeo automaticamente com a melhor experiência.": "Start the video automatically with the best experience.",
  "Início": "Start",
  "INÍCIO": "START",
  "Início (min:seg)": "Start (min:sec)",
  "Início (mm:ss)": "Start (mm:ss)",
  "Início automático:": "Automatic start:",
  "Início da headline": "Headline start",
  "Início da oferta": "Offer start",
  "Início da Sessão": "Session Start",
  "Início do dia": "Start of day",
  "Início do período": "Start of period",
  "Início, pausa e final podem ter imagens diferentes.": "Start, pause, and end can have different images.",
  "Início: quando as opções aparecem (vazio = fim do vídeo). Final: quando o vídeo pausa (opcional). Se o vídeo terminar sem escolha, ele congela no último quadro com as opções na tela.": "Start: when options appear (empty = end of video). End: when the video pauses (optional). If the video ends without a selection, it freezes on the last frame with options on screen.",
  "Inscrição realizada!": "Registration done!",
  "Inscrição/Plano modificado com sucesso!": "Subscription/Plan changed successfully!",
  "inscrições": "registrations",
  "Inserir:": "Insert:",
  "Insight copiado!": "Insight copied!",
  "Insights": "Insights",
  "Insights Automáticos": "Automatic Insights",
  "Insights de Dispositivo": "Device Insights",
  "Insira a senha para acessar o vídeo": "Enter the password to access the video",
  "Insira ganchos curtos ao longo do vídeo para aumentar retenção e reengajar o espectador.": "Insert short hooks throughout the video to increase retention and reengage viewers.",
  "Insira HTML simples. Scripts não são permitidos por segurança.": "Enter simple HTML. Scripts are not allowed for security reasons.",
  "Insira o nome do membro": "Enter the member's name",
  "Insira o nome que aparecerá como criador do conteúdo na Playlist": "Enter the name shown as the content creator in the Playlist",
  "Insira os dados para continuar assistindo": "Enter your details to continue watching",
  "Insira perguntas de engajamento": "Insert engagement questions",
  "Insira seu código HTML personalizado para o botão": "Enter your custom HTML code for the button",
  "Insira seu link de afiliado para ganhar comissões. A logo da HostVSL ficará disponível no canto superior direito do player e, ao clicar nela, seu link de afiliado será aberto em uma nova aba.": "Enter your affiliate link to earn commissions. The HostVSL logo will appear in the top-right corner of the player and clicking it opens your affiliate link in a new tab.",
  "Insira sua chave PIX aqui": "Enter your PIX key here",
  "Insira um e-mail válido": "Enter a valid email",
  "Inspiração direta para suas próximas VSLs e campanhas": "Direct inspiration for your next VSLs and campaigns",
  "Instalação não disponível": "Installation not available",
  "Instalando...": "Installing...",
  "Instalar": "Install",
  "Instalar Agora": "Install Now",
  "Instalar HostVSL": "Install HostVSL",
  "Instale o app para acesso rápido e funcionalidade offline": "Install the app for quick access and offline functionality",
  "Instale o HostVSL": "Install HostVSL",
  "Instituição Bancária": "Banking Institution",
  "Instituição Bancária (Cód. Banco)": "Banking Institution (Bank Code)",
  "Instruções para iPhone/iPad": "Instructions for iPhone/iPad",
  "Integração com {value0} configurada com sucesso.": "{value0} integration configured successfully.",
  "Integração com APIs de inteligência artificial para criação de conteúdo.": "Integration with artificial intelligence APIs for content creation.",
  "Integração configurada com sucesso": "Integration configured successfully",
  "Integração criada": "Integration created",
  "Integração criada. Configure o webhook na plataforma de vendas.": "Integration created. Configure the webhook on the sales platform.",
  "Integração de rastreamento": "Tracking integration",
  "Integração não configurada": "Integration not configured",
  "Integração nativa com VSLs e funis da Host VSL": "Native integration with Host VSL videos and funnels",
  "Integração salva com sucesso": "Integration saved successfully",
  "Integração vinculada. Vendas aprovadas são recebidas pelo webhook configurado na plataforma.": "Integration linked. Approved sales are received through the webhook configured on the platform.",
  "Integração/Real": "Integration/Real",
  "Integrações": "Integrations",
  "Integrações Disponíveis": "Available Integrations",
  "Integrar rastreamento": "Integrate tracking",
  "Integre Hotmart, Kirvano, Cakto, PerfectPay e muito mais.": "Integrate Hotmart, Kirvano, Cakto, PerfectPay, and more.",
  "Integre plataformas de pagamento e rastreie conversões dos seus vídeos de forma simples.": "Integrate payment platforms and easily track video conversions.",
  "Integre suas plataformas para acompanhar métricas de vendas e conversões.": "Integrate your platforms to track sales and conversion metrics.",
  "Intensidade": "Intensity",
  "Intensidade:": "Intensity:",
  "Intenso": "Intense",
  "Inter": "Inter",
  "Inter (Modern)": "Inter (Modern)",
  "Interação": "Interaction",
  "Interação com Vídeo": "Video interaction",
  "Intercale o talking head com imagens, gráficos ou textos para criar variação visual e manter atenção.": "Alternate talking-head footage with images, charts, or text to create visual variety and maintain attention.",
  "Interface otimizada que se comporta como um app nativo": "Optimized interface that behaves like a native app",
  "Intervalo": "Interval",
  "Intervalo de velocidades": "Speed range",
  "Intervalo de Velocidades": "Speed range",
  "Intervalo entre sessões": "Interval between sessions",
  "Intervalo entre uma notificação e outra.": "Interval between notifications.",
  "Intervalo testado:": "Tested interval:",
  "Intervalos": "Intervals",
  "intro": "intro",
  "Intro #": "Intro #",
  "Intro #{value0}": "Intro #{value0}",
  "Intro adicionada": "Intro added",
  "Intro atual": "Current intro",
  "Intro Curiosidade": "Curiosity Intro",
  "Intro Problema-Solução": "Problem-Solution Intro",
  "intro será rastreada": "intro will be tracked",
  "Intro Testemunho": "Testimonial Intro",
  "Introdução": "Intro",
  "introduções": "intros",
  "Introduções": "intros",
  "intros": "intros",
  "intros serão rastreadas": "intros will be tracked",
  "Invalid color code": "Invalid color code",
  "Invalid or unsafe HTML content": "Invalid or unsafe HTML content",
  "Invalid or unsafe URL": "Invalid or unsafe URL",
  "Invalid URL format": "Invalid URL format",
  "Invalid URL protocol": "Invalid URL protocol",
  "IP": "IP",
  "Ir Agora": "Go Now",
  "Ir para Meus Vídeos": "Go to My Videos",
  "Ir para pagamento": "Go to payment",
  "Ir para página da HostVSL (afiliado)": "Go to HostVSL page (affiliate)",
  "Ir para site": "Go to site",
  "Ir para Vídeos Compartilhados": "Go to Shared Videos",
  "Isso apaga o fluxo \"": "This deletes the flow \"",
  "Isso encerra o teste antes do término agendado e o tráfego volta para a VSL Principal. Esta ação não pode ser desfeita.": "This ends the test before the scheduled date and returns traffic to the Main VSL. This action cannot be undone.",
  "Isso interrompe o rastreamento deste vídeo. Esta ação não pode ser desfeita.": "This stops tracking this video. This action cannot be undone.",
  "Italiano": "Italiano",
  "Itálico": "Italic",
  "itens)": "items)",
  "Já copiado:": "Already copied:",
  "Já copiei, fechar": "I've copied it, close",
  "Já disponível na personalização dos seus vídeos.": "Now available in video customization.",
  "Já disponível no menu Cloaker do seu painel.": "Now available in your dashboard's Cloaker menu.",
  "Já disponível no menu Pixel do seu painel.": "Now available in your dashboard's Pixel menu.",
  "Já está disponível na personalização dos seus novos vídeos.": "Now available when customizing your new videos.",
  "Já está disponível no menu Análises do seu painel.": "Now available in your dashboard's Analytics menu.",
  "Já possui uma conta?": "Already have an account?",
  "Já registrou": "Already recorded",
  "Janela Diária": "Daily Window",
  "Janelas Campeãs de Conversão": "Winning Conversion Windows",
  "Janelas Campeãs de Receita": "Winning Revenue Windows",
  "JavaScript": "JavaScript",
  "João Silva": "João Silva",
  "Jornada de Conversão": "Conversion Journey",
  "Jornada de Conversão salva": "Conversion Journey saved",
  "JPG, PNG • até": "JPG, PNG • up to",
  "JPG, PNG ou WEBP • Máx 2MB": "JPG, PNG, or WEBP • Max 2MB",
  "JPG, PNG, WEBP e GIF • até 20 MB": "JPG, PNG, WEBP and GIF • up to 20 MB",
  "JS": "JS",
  "Just-in-Time": "Just-in-Time",
  "Kirvano": "Kirvano",
  "Kiwify": "Kiwify",
  "Labels simplificados: \"Controle de Volume\" → \"Volume\", \"Controle de Velocidade\" → \"Velocidade\", \"Esconder no Início\" → \"Esconder Início\".": "Simplified labels: \"Volume Control\" → \"Volume\", \"Speed Control\" → \"Speed\", \"Hide at Start\" → \"Hide Start\".",
  "Largura": "Width",
  "Lateral": "Side",
  "Lato (Professional)": "Lato (Professional)",
  "Layout": "Layout",
  "Layout do Formulário": "Form Layout",
  "Layout otimizado para mobile, tablet e desktop": "Layout optimized for mobile, tablet, and desktop",
  "Layout principal": "Main layout",
  "Layout responsivo de cápsula central com largura adaptativa por dispositivo": "Responsive centered pill layout with adaptive width per device",
  "Lead capturado com sucesso": "Lead captured successfully",
  "leads": "leads",
  "leads (": "leads (",
  "Leads Capturados": "Captured Leads",
  "Leads por Tipo": "Leads by Type",
  "Leads Recentes": "Recent Leads",
  "legenda": "subtitle",
  "Legenda adicionada com sucesso!": "Captions added successfully!",
  "Legenda excluída!": "Subtitle deleted!",
  "Legenda removida.": "Captions removed.",
  "legendas": "subtitles",
  "Legendas": "Subtitles",
  "Legendas adicionadas": "Captions added",
  "Legendas desativadas": "Captions disabled",
  "Legendas salvas": "Captions saved",
  "Leia atentamente as condições operacionais de repasse bancário.": "Read the bank payout operating conditions carefully.",
  "Leia com atenção os termos operacionais de comissionamento.": "Read the commission operating terms carefully.",
  "Lenta": "Slow",
  "Lento": "Slow",
  "Leva para": "Leads to",
  "Leve": "Light",
  "Li e aceito os": "I have read and accept the",
  "Li e concordo com as regras acima": "I have read and agree to the rules above",
  "Li e concordo com os termos acima": "I have read and agree to the terms above",
  "Lib.": "Allowed",
  "Libera acesso ao vídeo somente após preenchimento de senha definida.": "Unlocks video access only after the defined password is entered.",
  "Libera dopamina e mantém a atenção por mais tempo": "Releases dopamine and maintains attention longer",
  "Liberado": "Released",
  "Liberar": "Allow",
  "Liberar botão após": "Unlock button after",
  "Liberar ou bloquear por parâmetros UTM.": "Allow or block by UTM parameters.",
  "Libere ou bloqueie países ou regiões específicas.": "Allow or block specific countries or regions.",
  "Libere um editor com botões inteligentes, player customizado e máxima conversão.": "Unlock an editor with smart buttons, a custom player, and maximum conversions.",
  "Ligeiramente mais rápido": "Slightly faster",
  "Light": "Light",
  "Ligue o campo de comentário e peça nome, e-mail e WhatsApp junto com a nota": "Enable comments and ask for name, email, and WhatsApp alongside the rating",
  "Ligue vídeos curtos com perguntas e opções, leve cada visitante pela resposta dele até o checkout e veja onde cada um decide": "Connect short videos with questions and options, guide each visitor to checkout based on their answers, and see where each person decides",
  "Limite de {value0} vídeos por envio": "Limit of {value0} videos per upload",
  "Limite de Cópias": "Copy Limit",
  "Limite de cópias atingido": "Copy limit reached",
  "Limite de inscrições (opcional)": "Registration limit (optional)",
  "Limite do plano": "Plan limit",
  "Limite:": "Limit:",
  "Limpar": "Clear",
  "Limpar busca": "Clear search",
  "Limpar busca e filtros": "Clear search and filters",
  "Limpar Filtros": "Clear Filters",
  "Line": "Line",
  "Linha estável até 50% = storytelling eficiente.": "Stable line up to 50% = effective storytelling.",
  "Linha Fina": "Subheadline",
  "Linhas": "Rows",
  "Linhas por página:": "Rows per page:",
  "Link": "Link",
  "Link copiado!": "Link copied!",
  "Link criado com sucesso!": "Link created successfully!",
  "Link de {value0} não encontrado.": "{value0} link not found.",
  "Link de compartilhamento criado e copiado!": "Sharing link created and copied!",
  "Link de destino": "Destination link",
  "Link discreto": "Subtle link",
  "Link do botão": "Button link",
  "Link do Botão": "Button link",
  "Link do botão é obrigatório": "Button link is required",
  "Link do segundo botão": "Second button link",
  "Link expirado": "Link expired",
  "Link não encontrado": "Link not found",
  "Link público do webinário:": "Public webinar link:",
  "Link revogado com sucesso!": "Link revoked successfully!",
  "Link único para acessar seu webinário. Exemplo: /w/meu-webinar": "Unique link to access your webinar. Example: /w/my-webinar",
  "Link verificado • Seguro": "Verified link • Secure",
  "Links do Rodapé": "Footer Links",
  "Lisboa (GMT+0)": "Lisbon (GMT+0)",
  "Lista": "List",
  "Lista de cidades": "City list",
  "Lista de domínios autorizados a exibir seus vídeos": "List of domains authorized to display your videos",
  "Lista de nomes": "Name list",
  "Lista de playlists": "Playlist list",
  "Lista de Testes A/B": "A/B Test List",
  "Lista de Testes de Hook": "Hook Test List",
  "Lista personalizada": "Custom list",
  "Locais": "Locations",
  "Localização": "LOCATION",
  "LOCALIZAÇÃO": "LOCATION",
  "Localização atual": "Current location",
  "Lógica condicional para personalizar a jornada de cada lead": "Conditional logic to personalize each lead's journey",
  "Login Falhou": "Login Failed",
  "Login realizado com sucesso!": "Login successful!",
  "Logo": "Logo",
  "Logo {value0}": "Logo {value0}",
  "Logo atualizada": "Logo updated",
  "Logo da HostVSL será exibida no player.": "HostVSL logo will be shown on the player.",
  "Logo da Playlist": "Playlist Logo",
  "Logo do Webinário": "Webinar Logo",
  "Logo Marca": "Brand Logo",
  "Logo no Player": "Logo in Player",
  "Logo otimizado": "Logo optimized",
  "Logo personalizado": "Custom logo",
  "Logo Preview": "Logo Preview",
  "Logo removida": "Logo removed",
  "Logs Recentes": "Recent Logs",
  "Londres (GMT+0)": "London (GMT+0)",
  "Loop contínuo": "Continuous loop",
  "Loop contínuo quando combinado com Autoplay ativo": "Continuous loop when combined with active Autoplay",
  "Los Angeles (GMT-8)": "Los Angeles (GMT-8)",
  "Maior": "Larger",
  "maior audiência": "largest audience",
  "Maior Autoridade e Visibilidade": "Greater Authority and Visibility",
  "Maior duração": "Longest duration",
  "Maior eficiência": "Greater efficiency",
  "Maior faturamento": "Highest revenue",
  "maior número de conversões": "highest number of conversions",
  "Maior Ponto de Queda": "Largest Drop-Off Point",
  "Maior queda (16:00)": "Largest drop (16:00)",
  "maior receita gerada": "highest revenue generated",
  "Maior valor registrado em 30d": "Highest value recorded in 30 days",
  "Maior valor registrado no período": "Highest value recorded in the period",
  "Mais ações de {value0}": "More actions for {value0}",
  "Mais ativa": "Most active",
  "Mais detalhes": "More details",
  "Mais do que um player de vídeo": "More than a video player",
  "Mais natural e estável": "More natural and stable",
  "Mais opções": "More options",
  "Mais opções do vídeo {value0}": "More options for video {value0}",
  "Mais popular": "Most popular",
  "Mais Popular": "Most Popular",
  "Mais recente": "Most recent",
  "Mais recentes": "Most recent",
  "Mais reproduzido": "Most played",
  "Mais vistos": "Most viewed",
  "Major update": "Major update",
  "Mande vídeos direto da sua conta do Google Drive pra HostVSL, sem precisar baixar antes.": "Send videos directly from your Google Drive account to HostVSL without downloading first.",
  "Mantém o vídeo padrão neste dispositivo": "Keeps the default video on this device",
  "Mantenha a excelência": "Maintain excellence",
  "Mantenha a excelência narrativa": "Maintain narrative excellence",
  "Mantenha cada intro entre 30 segundos e 2 minutos": "Keep each intro between 30 seconds and 2 minutes",
  "Mantenha o gancho inicial que está funcionando bem": "Keep the initial hook that is working well",
  "Mantenha o público colado do início ao fim.": "Keep your audience engaged from start to finish.",
  "Mantenha sua conta protegida": "Keep your account protected",
  "Manter modal": "Keep dialog open",
  "Manter velocidade campeã após finalização": "Keep current embed",
  "Manual": "Manual",
  "Mapa ao vivo com os espectadores que estão assistindo agora, por cidade e país": "Live map of viewers watching now, by city and country",
  "Mapa de Calor (Conversão)": "Heatmap (Conversion)",
  "Mapa de Calor (Volume)": "Heatmap (Volume)",
  "Mapa de Calor Premium": "Premium Heatmap",
  "Mapa de calor semanal com plays e visualizações": "Weekly heatmap with plays and views",
  "Mapa de Rotas": "Route Map",
  "Marcador do pitch (opcional)": "Pitch marker (optional)",
  "Marcar agora": "Mark now",
  "Marcar aula como concluída": "Mark lesson as completed",
  "Marcar como Concluído": "Mark as Completed",
  "Marcar como lidas": "Mark as read",
  "Margem": "Margin",
  "Margens Internas (Padding):": "Inner Spacing (Padding):",
  "Master Class": "Master Class",
  "Master Class Host VSL": "Host VSL Master Class",
  "Máximo": "Maximum",
  "Máximo 140 caracteres": "Maximum 140 characters",
  "Máximo 8-10 palavras": "Max 8-10 words",
  "Máximo de": "Maximum of",
  "Máximo de 10 caracteres": "Maximum 10 characters",
  "Máximo de 5 modelos simultâneos permitidos": "Max 5 simultaneous templates allowed",
  "MB": "MB",
  "Meça a percepção real do conteúdo": "Measure real content perception",
  "Meça conversões do Google Ads (ID AW- + rótulo) nos eventos do seu VSL: play, progresso e clique no checkout.": "Measure Google Ads conversions (AW- ID + label) for VSL events: plays, progress, and checkout clicks.",
  "Meça eventos do TikTok Ads (Pixel Code) no seu VSL: visualização e clique no botão de compra.": "Measure TikTok Ads events (Pixel Code) on your VSL: views and purchase button clicks.",
  "Mede os acessos ao checkout. Não confirma uma compra; vendas dependem do rastreamento conectado.": "Measures checkout visits. Does not confirm a purchase; sales depend on connected tracking.",
  "média": "average",
  "Média": "Average",
  "Média assistida do vídeo": "Average video watched",
  "Média de Engajamento": "Average Engagement",
  "Média de quanto do vídeo foi assistido. Valores acima de 60% são considerados bons. Indica que o conteúdo manteve interesse contínuo.": "Average amount of video watched. Values above 60% are considered good. Indicates the content maintained continuous interest.",
  "Média geral": "Overall average",
  "média hoje": "today's average",
  "Média mensal:": "Monthly average:",
  "Medida de quanto tempo os usuários assistem ao vídeo em relação à duração total.": "Measure of how long users watch the video relative to the total duration.",
  "Médio": "Medium",
  "Meio": "Middle",
  "Meio (Medium)": "Medium",
  "Meio direito": "Middle right",
  "Meio esquerdo": "Middle left",
  "Melhor": "Best",
  "Melhor CTR": "Best CTR",
  "Melhor dia": "Best day",
  "Melhor escolha para campanhas ativas": "Best choice for active campaigns",
  "Melhor horário": "Best time",
  "Melhor janela": "Best window",
  "Melhor Janela por Dispositivo": "Best Window by Device",
  "Melhor momento": "Best time",
  "Melhor Momento de Engajamento": "Peak Engagement Moment",
  "Melhor para captar atenção e criar urgência": "Best for grabbing attention and creating urgency",
  "Melhor performance": "Best performance",
  "Melhor período de performance": "Best performance period",
  "Melhor plataforma": "Best platform",
  "melhor taxa de conversão": "best conversion rate",
  "Melhor vídeo do período:": "Best video of the period:",
  "Melhores Janelas": "Best Windows",
  "Melhores Janelas (Volume)": "Best Windows (Volume)",
  "Melhores práticas": "Best practices",
  "Melhoria": "Improvement",
  "Melhoria de performance completa na abertura dos vídeos — carregamento mais rápido e menos travamentos.": "Complete performance improvement for video startup — faster loading and fewer freezes.",
  "Membro": "Member",
  "Membro adicionado com sucesso!": "Member added successfully!",
  "Membro Atualizado": "Member Updated",
  "Membro atualizado com sucesso!": "Member updated successfully!",
  "Membro bloqueado com sucesso!": "Member blocked successfully!",
  "Membro Criado": "Member Created",
  "Membro desbloqueado com sucesso!": "Member unblocked successfully!",
  "Membro Removido": "Member Removed",
  "Membro removido com sucesso!": "Member removed successfully!",
  "Membros": "Members",
  "Membros da Rede": "Network Members",
  "Menor": "Smaller",
  "Menor desvio padrão no período": "Lowest standard deviation in the period",
  "Menos achismo, mais performance.": "Less guesswork, better performance.",
  "Menos travamentos durante a reprodução": "Fewer freezes during playback",
  "Mensagem": "Message",
  "Mensagem Adicional": "Additional Message",
  "Mensagem automática (opcional)": "Automatic message (optional)",
  "Mensagem da Notificação": "Notification Message",
  "Mensagem de agradecimento": "Thank-you message",
  "Mensagem de bloqueio": "Block message",
  "Mensagem de bloqueio deve ter no máximo 140 caracteres": "Block message must be no longer than 140 characters",
  "Mensagem de bloqueio é obrigatória": "Block message is required",
  "Mensagem de Erro": "Error Message",
  "Mensagem do chat": "Chat message",
  "Mensagem Exibida": "Displayed Message",
  "Mensagem obrigatória": "Message required",
  "Mensagem personalizada": "Custom message",
  "Mensagem Personalizada": "Custom message",
  "Mensagem Principal": "Primary Message",
  "Mensagem Secundária": "Secondary Message",
  "Mensagem:": "Message:",
  "Mensagens do Autoplay": "Autoplay messages",
  "mensal": "monthly",
  "Mensal": "Monthly",
  "Menu da pasta": "Folder menu",
  "Menu drawer mobile": "Mobile drawer menu",
  "Menu mobile": "Mobile menu",
  "Menu mobile com overlay click blocking, animações sincronizadas, plan card com progress bar animado, navegação reorganizada.": "Mobile menu with overlay click blocking, synchronized animations, a plan card with an animated progress bar, and reorganized navigation.",
  "MÊS": "MONTH",
  "Mês inválido": "Invalid month",
  "Mesma aba": "Same tab",
  "mesma proporção": "same aspect ratio",
  "Meta Ideal": "Ideal Target",
  "Meta Pixel": "Meta Pixel",
  "Meta-análise:": "Meta-analysis:",
  "Meta:": "Target:",
  "Metas alcançadas": "Goals achieved",
  "Metas Alcançadas": "Goals Achieved",
  "Método avançado JavaScript com todas as opções de personalização e controle do botão de ação.": "Advanced JavaScript method with all customization and action button control options.",
  "Método de pagamento adicionado com sucesso!": "Payment method added successfully!",
  "Método de pagamento definido como padrão!": "Payment method set as default!",
  "Método de pagamento removido.": "Payment method removed.",
  "Métrica": "Metric",
  "Métrica base:": "Base metric:",
  "Métrica de cliques atualizada com sucesso!": "Click metric updated successfully!",
  "Métricas": "Metrics",
  "Métricas — Padrão Visual Definitivo": "Metrics — Final Visual Standard",
  "Métricas (7 dias)": "Metrics (7 days)",
  "Métricas (últimos": "Metrics (last",
  "Métricas atualizadas para novo formato!": "Metrics updated to new format!",
  "Métricas de Picos de Horários": "Peak Hours Metrics",
  "Métricas de Teste": "Test Metrics",
  "Métricas de Uso": "Usage Metrics",
  "Métricas detalhadas": "Detailed metrics",
  "Métricas do fluxo": "Flow metrics",
  "Métricas do Teste": "Test Metrics",
  "Métricas do Teste A/B": "A/B Test Metrics",
  "Métricas do Teste de Introduções": "Intro Test Metrics",
  "Métricas do Vídeo": "Video Metrics",
  "Métricas do Webinário": "Webinar Metrics",
  "Métricas Individuais das Introduções": "Individual Intro Metrics",
  "Métricas por etapa: exibições, conclusão, quem pulou, quem chegou ao principal e cliques no CTA": "Metrics by stage: impressions, completion, skips, viewers reaching the main video, and CTA clicks",
  "Métricas Rastreadas:": "Tracked metrics:",
  "Métricas:": "Metrics:",
  "Meu Dispositivo": "My Device",
  "Meu Perfil": "My Profile",
  "Meu título personalizado": "My custom title",
  "Meu Vídeo": "My Video",
  "Meus clientes têm desconto?": "Do my customers get a discount?",
  "Meus Pixels": "My Pixels",
  "Meus vídeos": "My Videos",
  "Meus Vídeos": "My Videos",
  "Microguru e Tutor": "Microguru and Tutor",
  "min": "min",
  "Mín. 8 caracteres": "Min. 8 characters",
  "Minas Gerais": "Minas Gerais",
  "Minha Rede": "My Network",
  "Minhas Playlists": "My Playlists",
  "Mini Hook": "Mini Hook",
  "Mini Hooks": "Mini Hooks",
  "Mini Hooks salvos": "Mini Hooks saved",
  "Mini Hooks são pequenos blocos de texto que aparecem em momentos estratégicos do vídeo para reativar a atenção do espectador. Configure quantos quiser, defina o tempo de exibição e veja o impacto direto na retenção.": "Mini Hooks are short text blocks that appear at strategic moments in the video to regain viewer attention. Configure as many as you like, set display timing, and see the direct impact on retention.",
  "Mini-Hook": "Mini-Hook",
  "Mini-Hook atualizado com sucesso": "Mini-Hook updated successfully",
  "Mini-Hook criado com sucesso": "Mini-Hook created successfully",
  "Mini-Hook duplicado com sucesso": "Mini-Hook duplicated successfully",
  "Mini-Hook removido com sucesso": "Mini-Hook removed successfully",
  "Mini-Hooks": "Mini-Hooks",
  "Mini-preview do frame ao passar o mouse na barra de progresso": "Frame thumbnail preview when hovering over the progress bar",
  "Miniaturas ao passar o mouse na barra": "Thumbnails on progress bar hover",
  "Minimalista": "Minimalist",
  "Mínimo 6 caracteres": "Minimum 6 characters",
  "Mínimo: 2 variações": "Minimum: 2 variations",
  "minutos": "minutes",
  "Minutos": "Minutes",
  "minutos após o início": "minutes after the start",
  "MM / AA": "MM / YY",
  "mm:ss": "mm:ss",
  "MM/AA": "MM/YY",
  "Mobile": "Mobile",
  "Mobile Menu — Layout Final": "Mobile Menu — Final Layout",
  "Mobile:": "Mobile:",
  "Modal de código embed com tabs JavaScript/iFrame, cards de código com 160px altura fixa, botões de cópia integrados.": "Embed code dialog with JavaScript/iFrame tabs, fixed 160px code card height, and built-in copy buttons.",
  "Modele páginas com um clique e personalize do seu jeito.": "Model pages in one click and customize them your way.",
  "Modelo do bloco": "Block template",
  "Moderna": "Modern",
  "Moderno": "Modern",
  "Modo atualizado": "Mode updated",
  "modo compacto": "compact mode",
  "Modo de exibição": "Display mode",
  "Modo de Exibição": "Display mode",
  "Modo de Exibição da Thumbnail": "Thumbnail Display Mode",
  "Modo de filtragem": "Filtering mode",
  "Modo de teste para demonstrações": "Test mode for demonstrations",
  "Modo Educacional": "Educational Mode",
  "Modo foco": "Focus mode",
  "Modo foco: só a mesa em evidência": "Focus mode: highlight only the canvas",
  "Modo HTML": "HTML mode",
  "Modo HTML (Avançado)": "HTML mode (Advanced)",
  "Modo Imagem": "Image mode",
  "Modo Teste": "Test Mode",
  "Modo Texto": "Text mode",
  "Módulo": "Module",
  "Módulo 1 Primeiros passos": "Module 1 Getting started",
  "Módulo 2 Personalização": "Module 2 Customization",
  "Módulo 3 Recursos de conversão": "Module 3 Conversion features",
  "Módulo 4 Análises e performance": "Module 4 Analytics and performance",
  "Módulo 5 Plano e plays": "Module 5 Plan and plays",
  "Módulo não encontrado": "Module not found",
  "Módulos": "Modules",
  "Módulos (até 6)": "Modules (up to 6)",
  "Momento (min:seg)": "Time (min:sec)",
  "Momento de Exibição": "Display Time",
  "Momento do Vídeo": "Video Moment",
  "Momento do vídeo onde a audiência está mais engajada.": "The moment in the video when the audience is most engaged.",
  "Momento exato": "Exact moment",
  "Momentos específicos no vídeo onde uma quantidade significativa de espectadores para de assistir. Revise estes pontos para manter o engajamento.": "Specific moments in the video where a significant number of viewers stop watching. Review these points to maintain engagement.",
  "Momentos onde muitos espectadores abandonam o vídeo. Reduza este número para melhorar a retenção.": "Moments when many viewers leave the video. Reduce this number to improve retention.",
  "Monetizze": "Monetizze",
  "Monitoramento": "Monitoring",
  "Monitore conversões e eventos importantes do seu vídeo com pixels de rastreamento": "Track conversions and important video events with tracking pixels",
  "Monitore ofertas validadas que estão rodando na Meta agora": "Monitor proven offers running on Meta right now",
  "Monitore todas as visitas, conversões e registos gerados através do seu tráfego em tempo real no nosso dashboard.": "Monitor all visits, conversions, and registrations generated by your traffic in real time in our dashboard.",
  "Monospace": "Monospace",
  "Montserrat": "Montserrat",
  "Montserrat (Impact)": "Montserrat (Impact)",
  "More": "More",
  "More pages": "More pages",
  "Mostra o interesse inicial no vídeo. Gap alto = título forte, copy fraca.": "Shows initial interest in the video. A large gap = strong title, weak copy.",
  "Mostra o preço em destaque com a condição de pagamento.": "Highlights the price and payment terms.",
  "Mostra o progresso do vídeo": "Shows video progress",
  "Mostra o progresso visual": "Shows visual progress",
  "Mostra o progresso visual do vídeo": "Shows video progress visually",
  "Mostra o tempo atual e duração do vídeo": "Shows the current time and video duration",
  "Mostra os controles na parte inferior do player": "Shows controls at the bottom of the player",
  "Mostra os controles no rodapé do player": "Shows controls at the bottom of the player",
  "Mostra quanto o vídeo vencedor está à frente do segundo colocado nesta métrica.": "Shows how far the winning video is ahead of the runner-up on this metric.",
  "Mostra um botão para iniciar o vídeo principal manualmente.": "Shows a button to manually start the main video.",
  "Mostra um vídeo diferente apenas neste dispositivo": "Shows a different video only on this device",
  "Mostrando": "Showing",
  "Mostrando 20 de": "Showing 20 of",
  "Mostrando detalhes da integração {value0}": "Showing details for integration {value0}",
  "Mostrar": "Show",
  "Mostrar barra de progresso": "Show progress bar",
  "Mostrar barra na parte inferior após fechar": "Show bar at the bottom after closing",
  "Mostrar borda": "Show border",
  "Mostrar botão de legenda": "Show subtitle button",
  "Mostrar contagem regressiva": "Show countdown",
  "Mostrar controles": "Show controls",
  "Mostrar Controles": "Show controls",
  "Mostrar controles do vídeo durante o autoplay": "Show video controls during autoplay",
  "Mostrar durante todo o vídeo": "Show throughout the video",
  "Mostrar elemento": "Show element",
  "Mostrar em todo vídeo": "Show throughout the video",
  "Mostrar formulário em um momento específico do vídeo": "Show form at a specific moment in the video",
  "Mostrar ícone": "Show icon",
  "Mostrar Imagem": "Show image",
  "Mostrar letra A–D": "Show letter A–D",
  "Mostrar menos": "Show less",
  "Mostrar mensagem de agradecimento": "Show thank-you message",
  "Mostrar no quadro": "Show on canvas",
  "Mostrar novamente nos últimos 20 segundos": "Show again in the last 20 seconds",
  "Mostrar ou ocultar o título do formulário": "Show or hide the form title",
  "Mostrar plataforma": "Show platform",
  "Mostrar senha": "Show password",
  "Mostrar Sombras": "Show Shadows",
  "Mostrar Tempo": "Show Time",
  "Mostrar texto na barra": "Show text on bar",
  "Mostrar token": "Show token",
  "Mostre a plataforma de venda ao lado do aviso ou envie a sua própria logo": "Show the sales platform beside the notice or upload your own logo",
  "Mostre avisos de compra por cima da sua VSL e crie prova social enquanto o vídeo roda.": "Show purchase notifications over your VSL and generate social proof while the video plays.",
  "Mostre elementos que transmitam segurança": "Show elements that convey trust",
  "Mostre o avanço do vídeo e aumente a retenção.": "Show video progress and boost retention.",
  "Mostre um contador de pessoas assistindo o vídeo": "Show a counter of people watching the video",
  "Mostre um contador dinâmico de pessoas assistindo para gerar prova social durante o vídeo.": "Show a dynamic viewer counter to generate social proof during the video.",
  "Mostre vagas disponíveis ou progresso": "Show available spots or progress",
  "Mostre vendas recentes para criar prova social.": "Show recent sales to build social proof.",
  "Mostre visualmente o avanço do vídeo e aumente a retenção.": "Visually show video progress and increase retention.",
  "Mover": "Move",
  "Mover de pasta": "Move to folder",
  "Mover para": "Move to",
  "Mover para outra pasta": "Move to another folder",
  "Mover para...": "Move to...",
  "Mover pasta": "Move folder",
  "MP4, MOV • até 5GB": "MP4, MOV • up to 5GB",
  "MP4, MOV, AVI | Máximo: 100MB": "MP4, MOV, AVI | Maximum: 100MB",
  "MP4, MOV, AVI, WebM • Tamanho máximo: 100MB": "MP4, MOV, AVI, WebM • Maximum size: 100MB",
  "MP4, MOV, WEBM • Máximo 2GB": "MP4, MOV, WEBM • Maximum 2GB",
  "Mudanças Recentes": "Recent Changes",
  "Mudo há +24h": "Silent for 24h+",
  "Muito rápido": "Very fast",
  "Muito rápido ou muito lento": "Too fast or too slow",
  "Muito ruim": "Very poor",
  "Multiplicador de Velocidade": "Speed Multiplier",
  "Multiplique as suas vendas de forma automática com o chatbot que vende 24h por dia.": "Multiply your sales automatically with a chatbot that sells 24 hours a day.",
  "Na aba Métricas: nota média, total de respostas, distribuição, evolução e os comentários mais recentes": "In the Metrics tab: average rating, total responses, distribution, trends, and recent comments",
  "Na aba Tema, ajuste o visual do player. Escolha o formato, as cores da pergunta e dos botões, a posição das opções, o escurecimento do fundo, a borda, o progresso e os controles. Você pode começar com uma prévia sem som ou com um clique para iniciar.": "Adjust player appearance in the Theme tab. Choose the format, question and button colors, option position, background dimming, border, progress, and controls. You can start with a muted preview or a click to start.",
  "na barra inferior do Safari": "in the bottom Safari bar",
  "Na etapa {value0}, a opção \"{value1}\" aponta para uma saída que não existe.": "In step {value0}, option \"{value1}\" points to an exit that does not exist.",
  "Na etapa {value0}, a opção \"{value1}\" não leva a lugar nenhum.": "In step {value0}, option \"{value1}\" leads nowhere.",
  "Na etapa {value0}, duas opções têm o texto \"{value1}\".": "In step {value0}, two options have the text \"{value1}\".",
  "Na etapa {value0}, uma opção está sem texto.": "In step {value0}, an option has no text.",
  "Na mesma aba": "In the same tab",
  "Na Payt, cadastre esta URL para o evento de pagamento aprovado e use a mesma chave de integração.": "In Payt, register this URL for approved payment events and use the same integration key.",
  "Na playlist": "In the playlist",
  "Nada impede a publicação. Vale conferir os avisos.": "Nothing prevents publishing. Review the notices.",
  "Nada novo para publicar": "Nothing new to publish",
  "Não assistido": "Unwatched",
  "Não conectado": "Not connected",
  "Não Configurado": "Not Configured",
  "não contém": "does not contain",
  "Não definida": "Not defined",
  "Não encontramos aulas com os filtros selecionados. Tente ajustar sua busca ou explorar outras categorias.": "No lessons found with the selected filters. Try adjusting your search or exploring other categories.",
  "Não encontramos nenhuma pasta com \"": "No folders found with \"",
  "Não encontramos um cupom com esse nome.": "We could not find a coupon with that name.",
  "Não encontramos vídeos com \"{value0}\"": "No videos found with \"{value0}\"",
  "Não exibir localização": "Hide location",
  "Não existem testes de velocidade automáticos": "No automatic speed tests exist",
  "Não fechar automaticamente": "Do not close automatically",
  "Não foi possível abrir a transmissão": "Could not start casting",
  "Não foi possível abrir o fluxo": "Could not open the flow",
  "Não foi possível abrir o seletor": "Could not open the picker",
  "Não foi possível abrir o seletor AirPlay": "Could not open the AirPlay picker",
  "Não foi possível ativar o seu perfil de afiliado.": "Could not activate your affiliate profile.",
  "Não foi possível atualizar o nome do teste.": "Could not update the test name.",
  "Não foi possível atualizar o nome. Tente novamente.": "Could not update the name. Please try again.",
  "Não foi possível carregar a audiência ao vivo": "Could not load the live audience",
  "Não foi possível carregar a comparação": "Could not load the comparison",
  "Não foi possível carregar a lista de vídeos": "Could not load the video list",
  "Não foi possível carregar a lista de vídeos.": "Could not load the video list.",
  "Não foi possível carregar as aulas": "Could not load lessons",
  "Não foi possível carregar as métricas.": "Could not load metrics.",
  "Não foi possível carregar as plataformas.": "Could not load platforms.",
  "Não foi possível carregar as plataformas. Tente novamente.": "Could not load platforms. Please try again.",
  "Não foi possível carregar o player da VSL Dinâmica.": "Could not load the Dynamic VSL player.",
  "Não foi possível carregar os dados para edição.": "Could not load data for editing.",
  "Não foi possível carregar os vídeos. Tentar de novo": "Could not load videos. Try again",
  "Não foi possível carregar seus fluxos.": "Could not load your flows.",
  "Não foi possível carregar seus vídeos.": "Could not load your videos.",
  "Não foi possível carregar suas chaves": "Could not load your keys",
  "Não foi possível concluir. Tente novamente.": "Could not complete. Please try again.",
  "Não foi possível conectar": "Could not connect",
  "Não foi possível copiar as configurações. Tente novamente.": "Could not copy settings. Please try again.",
  "Não foi possível copiar o código.": "Could not copy the code.",
  "Não foi possível copiar o código. Tente novamente.": "Could not copy the code. Please try again.",
  "Não foi possível copiar o token.": "Could not copy the token.",
  "Não foi possível copiar. Copie o código pelo editor do fluxo.": "Could not copy. Copy the code from the flow editor.",
  "Não foi possível copiar. Selecione a URL para copiar.": "Could not copy. Select the URL to copy it.",
  "Não foi possível copiar. Selecione o código e copie manualmente.": "Could not copy. Select the code and copy it manually.",
  "Não foi possível copiar. Selecione o texto e copie manualmente.": "Could not copy. Select the text and copy it manually.",
  "Não foi possível criar a pasta": "Could not create the folder",
  "Não foi possível criar contexto do canvas": "Could not create canvas context",
  "Não foi possível criar o fluxo.": "Could not create the flow.",
  "Não foi possível criar o teste de velocidade": "Could not create the speed test",
  "Não foi possível criar o teste de velocidade.": "Could not create the speed test.",
  "Não foi possível criar o teste. Tente novamente.": "Could not create the test. Please try again.",
  "Não foi possível deletar o teste de velocidade.": "Could not delete the speed test.",
  "Não foi possível deletar o teste. Tente novamente.": "Could not delete the test. Please try again.",
  "Não foi possível desativar a captura.": "Could not disable capture.",
  "Não foi possível duplicar o vídeo. Tente novamente.": "Could not duplicate the video. Please try again.",
  "Não foi possível excluir o teste": "Could not delete test",
  "Não foi possível gerar a thumbnail. Tente novamente.": "Could not generate the thumbnail. Please try again.",
  "Não foi possível gerar o código": "Could not generate the code",
  "Não foi possível gerar o token. Tentar novamente.": "Could not generate the token. Try again.",
  "Não foi possível identificar o usuário. Faça login novamente.": "Could not identify the user. Please sign in again.",
  "Não foi possível processar este link. Tente novamente ou entre em contato com o produtor.": "Could not process this link. Try again or contact the producer.",
  "Não foi possível processar o saque.": "Could not process the withdrawal.",
  "Não foi possível renomear o fluxo.": "Could not rename the flow.",
  "Não foi possível renomear o teste.": "Could not rename the test.",
  "Não foi possível salvar a regra. Tente novamente.": "Could not save the rule. Please try again.",
  "Não foi possível salvar a velocidade": "Could not save the speed",
  "Não foi possível salvar as alterações. Tente novamente.": "Could not save changes. Please try again.",
  "Não foi possível salvar as configurações.": "Could not save settings.",
  "Não foi possível salvar o pitch. Tente novamente.": "Could not save the pitch. Please try again.",
  "Não foi possível salvar o rascunho. Tente novamente.": "Could not save the draft. Please try again.",
  "Não foi possível salvar. Tente novamente": "Could not save. Please try again",
  "Não foi salvo": "Not saved",
  "Não há capturas para os filtros aplicados. Tente ajustar os filtros ou selecione outro período.": "No captures match the applied filters. Try adjusting the filters or selecting another period.",
  "Não há dados de vídeos disponíveis para exibir o gráfico de retenção.": "No video data is available to display the retention chart.",
  "Não há dados para exportar.": "No data to export.",
  "Não há métricas para o período selecionado. Aguarde a coleta de dados ou ajuste o período.": "No metrics for the selected period. Wait for data collection or adjust the period.",
  "Não há visualizações com parâmetros UTM neste período. Use parâmetros UTM nas suas URLs para rastrear a origem do tráfego.": "No views with UTM parameters in this period. Use UTM parameters in your URLs to track traffic sources.",
  "Não informado": "Not provided",
  "Não possui um cadastro?": "Don't have an account?",
  "Não repetir": "Do not repeat",
  "Não salvo": "Not saved",
  "Não salvo (conflito)": "Not saved (conflict)",
  "Não selecionada": "Not selected",
  "não serão refletidas": "will not be reflected",
  "Não solicitar dados": "Do not request data",
  "Não, obrigado": "No, thanks",
  "NÃO, OBRIGADO": "NO, THANKS",
  "Não, obrigado. Quero continuar": "No, thanks. I want to continue",
  "Não, obrigado. Quero continuar sem essa oferta": "No, thanks. I want to continue without this offer",
  "Não! A participação no programa é 100% gratuita. Você só precisa se cadastrar e começar a indicar.": "No! Participation is 100% free. Just register and start referring.",
  "Não! Você pode fazer quantas indicações quiser. Quanto mais clientes ativos você tiver, maior será sua comissão recorrente mensal.": "No! You can make as many referrals as you like. The more active customers you have, the higher your monthly recurring commission.",
  "Narrativas bem estruturadas podem aumentar conversões em até 30%": "Well-structured narratives can increase conversions by up to 30%",
  "nas variações já criadas.": "in the variations already created.",
  "Navegação": "Navigation",
  "Navegação da série": "Series navigation",
  "Navegação do Vídeo": "Video navigation",
  "Navegação lateral": "Side navigation",
  "Navegação mais rápida e responsiva em qualquer tela": "Faster, more responsive navigation on any screen",
  "Navegação rápida com breadcrumbs": "Quick navigation with breadcrumbs",
  "Navegador": "Browser",
  "Navegador Principal": "Primary Browser",
  "Navegadores": "Browsers",
  "Navegadores e Sistemas": "Browsers and Systems",
  "navegue": "browse",
  "Nederlands": "Nederlands",
  "Negrito": "Bold",
  "Nenhum": "None",
  "Nenhum / Sem Plano Ativo": "None / No Active Plan",
  "Nenhum acesso está ativo agora.": "No active visits right now.",
  "Nenhum banco cadastrado.": "No banks registered.",
  "Nenhum bônus criado. Clique em \"Adicionar Bônus\" para começar.": "No bonuses created. Click \"Add Bonus\" to get started.",
  "Nenhum cartão cadastrado": "No cards registered",
  "Nenhum cartão selecionado": "No card selected",
  "Nenhum código extra na sua página: o token de acesso fica guardado só no servidor": "No extra code on your page: the access token stays only on the server",
  "Nenhum comentário encontrado com esse filtro.": "No comments found with this filter.",
  "Nenhum comprovante enviado": "No receipt uploaded",
  "Nenhum custo encontrado": "No costs found",
  "Nenhum dado de cidade disponível": "No city data available",
  "Nenhum dado de estado disponível": "No state data available",
  "Nenhum dado de funil disponível ainda": "No funnel data available yet",
  "Nenhum dado de localização disponível": "No location data available",
  "Nenhum dado de país disponível": "No country data available",
  "Nenhum dado disponível ainda": "No data available yet",
  "Nenhum dado encontrado": "No data found",
  "Nenhum dado encontrado para o período selecionado": "No data found for the selected period",
  "Nenhum dado encontrado para o período selecionado.": "No data found for the selected period.",
  "Nenhum disparo registrado ainda. Abra o VSL uma vez com som e recarregue esta tela. Se já abriu e nada aparece, confira se a URL vinculada é a página onde o vídeo roda.": "No events recorded yet. Open the VSL once with sound and reload this screen. If you already did and nothing appears, check that the linked URL is the page where the video plays.",
  "Nenhum dispositivo": "No device",
  "Nenhum dispositivo ainda": "No devices yet",
  "Nenhum dispositivo encontrado": "No devices found",
  "Nenhum domínio cadastrado": "No domains registered",
  "Nenhum domínio encontrado para \"": "No domains found for \"",
  "Nenhum envio ativo": "No active uploads",
  "Nenhum evento de clique foi registrado ainda.": "No click events recorded yet.",
  "Nenhum evento detectado ainda. Verifique se o pixel está instalado na página vinculada.": "No events detected yet. Check that the pixel is installed on the linked page.",
  "Nenhum evento encontrado para este filtro.": "No events found for this filter.",
  "Nenhum feedback recebido ainda": "No feedback received yet",
  "Nenhum fluxo encontrado com esse filtro.": "No flows found with this filter.",
  "Nenhum incremento de clicks foi encontrado para o e-mail informado. Você pode criar um novo registro clicando no botão abaixo.": "No click increment found for the provided email. You can create a new record by clicking the button below.",
  "Nenhum link definido.": "No link defined.",
  "Nenhum link encontrado para este vídeo": "No links found for this video",
  "Nenhum log disponível ainda": "No logs available yet",
  "Nenhum log encontrado com os filtros selecionados.": "No logs found with the selected filters.",
  "Nenhum membro encontrado": "No members found",
  "Nenhum membro encontrado na sua rede.": "No members found in your network.",
  "Nenhum membro encontrado. Adicione membros para gerenciar sua equipe.": "No members found. Add members to manage your team.",
  "Nenhum método de pagamento cadastrado.": "No payment methods registered.",
  "Nenhum Mini Hook adicionado ainda.": "No Mini Hooks added yet.",
  "Nenhum módulo criado. Clique em \"Adicionar Módulo\" para começar.": "No modules created. Click \"Add Module\" to get started.",
  "Nenhum módulo ou bônus ainda": "No modules or bonuses yet",
  "Nenhum país adicionado. Clique em \"Adicionar País\" para começar.": "No countries added. Click \"Add Country\" to get started.",
  "Nenhum parâmetro UTM foi registrado ainda.": "No UTM parameters recorded yet.",
  "Nenhum pixel": "No pixel",
  "Nenhum pixel configurado": "No pixels configured",
  "Nenhum pixel corresponde aos filtros selecionados.": "No pixels match the selected filters.",
  "Nenhum pixel encontrado": "No pixels found",
  "Nenhum problema encontrado no fluxo.": "No issues found in the flow.",
  "Nenhum recurso encontrado": "No features found",
  "Nenhum recurso encontrado para \"": "No features found for \"",
  "Nenhum registro de incremento cadastrado.": "No increment records registered.",
  "Nenhum registro encontrado": "No records found",
  "Nenhum registro encontrado para este e-mail. Você pode criar um novo.": "No records found for this email. You can create a new one.",
  "Nenhum registro selecionado": "No record selected",
  "Nenhum resultado": "No results",
  "Nenhum resultado encontrado": "No results found",
  "Nenhum resultado.": "No results.",
  "Nenhum selecionado": "None selected",
  "Nenhum teste A/B encontrado": "No A/B tests found",
  "Nenhum teste ativo": "No active test",
  "Nenhum teste ativo no momento": "No tests currently active",
  "Nenhum teste de introdução encontrado.": "No intro tests found.",
  "Nenhum teste de velocidade ativo.": "No active speed tests.",
  "Nenhum teste em execução": "No tests running",
  "Nenhum token ativo.": "No active tokens.",
  "Nenhum usuário selecionado": "No user selected",
  "Nenhum vídeo": "No videos",
  "Nenhum vídeo adicionado": "No videos added",
  "Nenhum vídeo adicionado a este teste ainda.": "No videos added to this test yet.",
  "Nenhum vídeo ainda. Envie os vídeos curtos de cada etapa do fluxo.": "No videos yet. Upload the short videos for each flow step.",
  "Nenhum vídeo alternativo selecionado": "No alternative video selected",
  "Nenhum vídeo compartilhado ainda": "No videos shared yet",
  "Nenhum vídeo de teste adicionado": "No test videos added",
  "Nenhum vídeo disponível": "No videos available",
  "Nenhum vídeo disponível para seleção": "No videos available for selection",
  "Nenhum vídeo disponível. Faça upload de um vídeo primeiro.": "No videos available. Upload a video first.",
  "Nenhum vídeo encontrado": "No videos found",
  "Nenhum vídeo encontrado neste teste A/B.": "No videos found in this A/B test.",
  "Nenhum vídeo encontrado para \"": "No videos found for \"",
  "Nenhum vídeo encontrado para “": "No videos found for “",
  "Nenhum vídeo encontrado para \"{value0}\"": "No videos found for \"{value0}\"",
  "Nenhum vídeo encontrado para análise de performance.": "No videos found for performance analysis.",
  "Nenhum vídeo encontrado.": "No videos found.",
  "Nenhum vídeo enviado ainda": "No videos uploaded yet",
  "Nenhum vídeo finalizado": "No completed videos",
  "Nenhum vídeo importado": "No videos imported",
  "Nenhum vídeo nesta pasta": "No videos in this folder",
  "Nenhum vídeo original selecionado": "No original video selected",
  "Nenhum vídeo selecionado": "No videos selected",
  "Nenhum vídeo selecionado para salvar": "No videos selected to save",
  "Nenhum webinário criado ainda": "No webinars created yet",
  "Nenhuma": "None",
  "Nenhuma ação configurada ainda": "No actions configured yet",
  "Nenhuma alteração foi feita em sua conta.": "No changes were made to your account.",
  "Nenhuma atualização por aqui": "No updates here",
  "Nenhuma aula adicionada ainda": "No lessons added yet",
  "Nenhuma aula ainda": "No lessons yet",
  "Nenhuma aula disponível": "No lessons available",
  "Nenhuma aula encontrada": "No lessons found",
  "Nenhuma aula encontrada.": "No lessons found.",
  "Nenhuma aula publicada nesta série ainda.": "No lessons published in this series yet.",
  "Nenhuma chave ainda": "No keys yet",
  "Nenhuma chave ativa": "No active keys",
  "Nenhuma conversão registrada ainda. Adicione plataformas e aguarde as primeiras conversões.": "No conversions recorded yet. Add platforms and wait for the first conversions.",
  "Nenhuma cópia registrada ainda": "No copies recorded yet",
  "Nenhuma fatura encontrada": "No invoices found",
  "Nenhuma fonte de tráfego detectada": "No traffic sources detected",
  "Nenhuma imagem disponível": "No images available",
  "Nenhuma integração encontrada para os filtros selecionados.": "No integrations found for the selected filters.",
  "Nenhuma integração encontrada.": "No integrations found.",
  "Nenhuma intro encontrada": "No intros found",
  "Nenhuma legenda encontrada para \"{q}\"": "No subtitles found for \"{q}\"",
  "Nenhuma métrica disponível": "No metrics available",
  "Nenhuma métrica disponível para o período selecionado.": "No metrics available for the selected period.",
  "Nenhuma novidade encontrada.": "No updates found.",
  "Nenhuma novidade por aqui": "Nothing new here",
  "Nenhuma opção leva a esta saída": "No options lead to this exit",
  "Nenhuma origem encontrada": "No sources found",
  "Nenhuma pasta criada": "No folders created",
  "Nenhuma plataforma selecionada. Adicione plataformas para visualizar os webhooks.": "No platforms selected. Add platforms to view webhooks.",
  "Nenhuma proteção criada ainda": "No protections created yet",
  "Nenhuma receita identificada": "No revenue identified",
  "Nenhuma região adicionada. Clique em \"Adicionar Região\" para começar.": "No regions added. Click \"Add Region\" to get started.",
  "Nenhuma regra criada": "No rules created",
  "Nenhuma regra criada ainda. Adicione condições para liberar ou bloquear acessos.": "No rules created yet. Add conditions to allow or block visits.",
  "Nenhuma regra UTM adicionada. Clique em \"Adicionar Regra UTM\" para começar.": "No UTM rules added. Click \"Add UTM Rule\" to get started.",
  "Nenhuma saída está marcada como checkout; a conversão não será medida.": "No exit is marked as checkout; conversions will not be measured.",
  "Nenhuma selecionada": "None selected",
  "Nenhuma solicitação encontrada": "No requests found",
  "Nenhuma transferência ou comissão localizada para esta conta no BD.": "No transfers or commissions found for this account in the database.",
  "Nenhuma variação configurada": "No variation configured",
  "Nenhuma venda registrada": "No sales recorded",
  "Neon": "Neon",
  "Netflix Dark": "Netflix Dark",
  "Networking": "Networking",
  "New feature": "New feature",
  "Next": "Next",
  "Next slide": "Next slide",
  "Ninguém assistindo agora": "Nobody watching right now",
  "Nível de Acesso": "Access Level",
  "Nível do usuário atualizado com sucesso!": "User level updated successfully!",
  "no 1º mês": "in the first month",
  "No final do teste, você pode fixar a intro com melhor desempenho.": "At the end of the test, you can lock in the best-performing intro.",
  "No final do vídeo": "At the end of the video",
  "No máximo {value0} parâmetros fixos": "Maximum {value0} fixed parameters",
  "no menu": "in the menu",
  "no menu esquerdo.": "in the left menu.",
  "No menu VSL Dinâmica, crie um fluxo e dê um nome para identificar seu funil. Esse nome é para sua organização no painel.": "In the Dynamic VSL menu, create a flow and name it to identify your funnel. This name helps you organize your dashboard.",
  "No modal de upload, escolha entre \"Upload do computador\" ou \"Google Drive\"": "In the upload dialog, choose \"Upload from computer\" or \"Google Drive\"",
  "no primeiro mês": "in the first month",
  "No tema, defina o formato do vídeo, as cores, o estilo das opções, a barra de progresso e como o vídeo começa (prévia sem som ou clicar para iniciar).": "In the theme, set video format, colors, option styles, the progress bar, and how the video starts (muted preview or click to start).",
  "no total).": "in total).",
  "Nome": "First Name",
  "Nome (opcional)": "Name (optional)",
  "Nome (só você vê)": "Name (only you can see it)",
  "Nome A-Z": "Name A–Z",
  "Nome alterado para \"{value0}\"": "Name changed to \"{value0}\"",
  "Nome atualizado": "Name updated",
  "Nome completo": "Full name",
  "Nome Completo": "Full Name",
  "Nome da Ação *": "Action name *",
  "Nome da Classe": "Class name",
  "Nome da etapa": "Step name",
  "Nome da legenda": "Caption name",
  "Nome da pasta": "Folder name",
  "Nome da Playlist": "Playlist Name",
  "Nome da Playlist *": "Playlist Name *",
  "Nome da proteção": "Protection name",
  "Nome da Variação": "Variation name",
  "Nome de parâmetro inválido": "Invalid parameter name",
  "Nome deve ter pelo menos 2 caracteres.": "Name must have at least 2 characters.",
  "Nome do Criador": "Creator Name",
  "Nome do Evento": "Event Name",
  "Nome do fluxo": "Flow name",
  "Nome do membro": "Member name",
  "Nome do parâmetro": "Parameter name",
  "Nome do produto": "Product name",
  "Nome do Serviço *": "Service Name *",
  "Nome do teste": "Test name",
  "Nome do Teste": "Test Name",
  "Nome do Teste *": "Test Name *",
  "Nome do Teste A/B": "A/B Test Name",
  "Nome do Titular da Conta": "Account Holder Name",
  "Nome do Usuário": "User Name",
  "Nome do vídeo": "Video name",
  "Nome do Vídeo": "Video name",
  "Nome do Webinário": "Webinar Name",
  "Nome do Webinário *": "Webinar Name *",
  "Nome é obrigatório": "Name is required",
  "Nome exibido ao lado do favicon": "Name displayed beside the favicon",
  "Nome igual ao documento": "Name as shown on the document",
  "Nome impresso no cartão": "Name printed on the card",
  "Nome interno": "Internal name",
  "Nome interno para identificação (não será exibido publicamente)": "Internal name for identification (not displayed publicly)",
  "Nome interno para identificação. Não será exibido ao público.": "Internal name for identification. Not displayed to the public.",
  "Nome muito longo": "Name too long",
  "Nome muito longo (máximo 80 caracteres)": "Name too long (maximum 80 characters)",
  "Nome não pode estar vazio": "Name cannot be empty",
  "Nome no cartão": "Name on card",
  "Nome obrigatório": "Name required",
  "Nome usado apenas para organização interna.": "Name used only for internal organization.",
  "Nome:": "Name:",
  "Nomes": "Names",
  "Normal": "Normal",
  "Normalizar por dia": "Normalize by day",
  "nos controles.": "in the controls.",
  "Nossa tecnologia de Cloaker protege sua VSL contra cópias de forma simples.": "Our Cloaker technology easily protects your VSL against copying.",
  "Nota 1 a 5": "Rating from 1 to 5",
  "Nota média": "Average rating",
  "Notas internas (opcional)": "Internal notes (optional)",
  "Notificação de teste": "Test notification",
  "Notificação de Vendas": "Sales Notification",
  "Notificação de Vendas salva": "Sales Notification saved",
  "Notificação enviada": "Notification sent",
  "Notificações": "Notifications",
  "Notificações ativadas!": "Notifications enabled!",
  "Notificações Ativas": "Notifications Enabled",
  "Notificações Bloqueadas": "Notifications Blocked",
  "Notificações Desativadas": "Notifications Disabled",
  "Notificações não disponíveis": "Notifications unavailable",
  "Notificações Push": "Push Notifications",
  "nova aba": "new tab",
  "Nova aba": "New tab",
  "Nova Captura": "New Capture",
  "Nova chave": "New key",
  "Nova chave de API": "New API key",
  "Nova data de término": "New end date",
  "Nova Despesa": "New Expense",
  "Nova funcionalidade disponível": "New feature available",
  "Nova integração com {value0} será criada": "A new {value0} integration will be created",
  "Nova pasta": "New folder",
  "Nova Pasta": "New folder",
  "Nova Permissão": "New Permission",
  "Nova Playlist": "New Playlist",
  "Nova proteção": "New protection",
  "Nova saída": "New exit",
  "Nova senha": "New Password",
  "Nova Senha": "New Password",
  "Nova senha deve ser diferente da atual": "New password must differ from the current one",
  "Nova Subpasta": "New Subfolder",
  "Nova tag...": "New tag...",
  "Nova Variação": "New Variation",
  "Nova Variação de Headline": "New Headline Variation",
  "Nova venda!": "New sale!",
  "Nova York (GMT-5)": "New York (GMT-5)",
  "Novas conversões": "New conversions",
  "Novas Conversões": "New Conversions",
  "Novidades": "Updates",
  "novo": "new",
  "Novo": "New",
  "Novo Dashboard Premium Host VSL 2.0": "New Host VSL 2.0 Premium Dashboard",
  "Novo Front Host VSL 2.0": "New Host VSL 2.0 Frontend",
  "Novo lead: João Silva": "New lead: João Silva",
  "Novo link gerado com sucesso!": "New link generated successfully!",
  "Novo Método de Pagamento": "New Payment Method",
  "Novo Mini-Hook": "New Mini-Hook",
  "Novo nome": "New name",
  "Novo Player de vídeo da HostVSL": "New HostVSL Video Player",
  "Novo recurso": "New feature",
  "Novo Registro": "New Record",
  "Novo Registro de Incremento": "New Increment Record",
  "Novo status": "New status",
  "Novo template de área de membros com hero banner 1920×700, módulos/bônus em grid, progress tracking persistente, CTAs por vídeo.": "New member area template with a 1920×700 hero banner, module/bonus grid, persistent progress tracking, and per-video CTAs.",
  "Novo template Prime Video Dark com hero banner, grid de aulas com paginação, modal de reprodução com navegação entre episódios.": "New Prime Video Dark template with a hero banner, paginated lesson grid, and playback dialog with episode navigation.",
  "Novo Teste": "New Test",
  "Novo Texto": "New text",
  "Novo token gerado.": "New token generated.",
  "Novo valor": "New value",
  "Novo Vídeo": "New Video",
  "Novo Webinário": "New Webinar",
  "Novos recursos no editor": "New editor features",
  "Novos recursos, melhorias e orientações para usar a HostVSL.": "New features, improvements, and guidance for using HostVSL.",
  "Numeração": "Numbering",
  "Número": "Number",
  "Número da Conta com DV": "Account Number with Check Digit",
  "Número de cliques no botão": "Number of button clicks",
  "Número de cliques nos elementos interativos do vídeo.": "Number of clicks on the interactive elements of the video.",
  "número de conversões": "number of conversions",
  "Número de Linhas": "Number of Rows",
  "Número de pessoas que clicaram no botão de ação (CTA) dentro do vídeo.": "Number of people who clicked the action button (CTA) within the video.",
  "Número de vezes que o vídeo foi iniciado por visitantes.": "Number of times visitors started the video.",
  "Número de visitantes únicos que ativaram este evento": "Number of unique visitors who triggered this event",
  "Número de visitantes únicos que visualizaram o vídeo.": "Number of unique visitors who viewed the video.",
  "Número do cartão": "Card number",
  "Número do Cartão": "Card Number",
  "Número do cartão inválido": "Invalid card number",
  "Número do WhatsApp": "WhatsApp number",
  "Número máximo de afiliados que podem copiar": "Maximum number of affiliates who can copy",
  "Número total de carregamentos do seu vídeo.": "Total number of video loads.",
  "Número total de cliques no botão de call-to-action (CTA) do vídeo.": "Total number of clicks on the video's call-to-action (CTA) button.",
  "Número total de cliques recebidos por este evento": "Total clicks received by this event",
  "Número total de vendas confirmadas pelas plataformas de pagamento": "Total sales confirmed by payment platforms",
  "Número total de vezes que o play foi dado no vídeo.": "Total number of times the video was played.",
  "Número total de vezes que o vídeo foi carregado, independente se foi assistido ou não.": "Total number of video loads, whether watched or not.",
  "Números principais em métricas": "Key metric figures",
  "Números principais em toda área de Métricas ajustados para font-weight 500, criando hierarquia visual mais clara e premium.": "Key figures throughout Metrics adjusted to font-weight 500, creating a clearer, more premium visual hierarchy.",
  "Nunito (Rounded)": "Nunito (Rounded)",
  "O \"Vídeo Principal\" é o arquivo sem introdução. Depois, você adiciona as intros que serão tocadas antes dele para medir qual abertura gera mais atenção e conversão.": "The \"Main Video\" is the file without an intro. You then add intros to play before it to measure which opening generates the most attention and conversions.",
  "O app já está instalado ou seu navegador não suporta instalação.": "The app is already installed or your browser does not support installation.",
  "O arquivo deve ter no máximo 100MB": "File must be at most 100MB",
  "O arquivo deve ter no máximo 100MB.": "The file must be no larger than 100MB.",
  "O arquivo deve ter no máximo 500KB": "The file must be no larger than 500KB",
  "O arquivo foi baixado com sucesso.": "The file was downloaded successfully.",
  "O arquivo precisa ter até 10MB.": "The file must be 10MB or smaller.",
  "O botão foi removido do thumbnail de pausa": "The button was removed from the pause thumbnail",
  "O botão será aplicado automaticamente ao vídeo ativo no preview": "The button will be applied automatically to the active video in the preview",
  "O botão será exibido após este tempo de reprodução do vídeo": "The button will appear after this amount of video playback",
  "O botão só aparece pra quem tem um dispositivo compatível na rede — sem poluir o player de quem não usa": "The button appears only for viewers with a compatible device on their network — keeping other viewers' players uncluttered",
  "O CEP deve conter exatamente 8 dígitos.": "The postal code must contain exactly 8 digits.",
  "O código de incorporação foi copiado para a área de transferência": "The embed code was copied to the clipboard",
  "O código de incorporação foi copiado para a área de transferência.": "Embed code copied to clipboard.",
  "O código de integração foi copiado para a área de transferência.": "The integration code was copied to the clipboard.",
  "O código de segurança está incorreto.": "The security code is incorrect.",
  "O código do teste A/B foi copiado para a área de transferência.": "The A/B test code has been copied to the clipboard.",
  "O código foi copiado para a área de transferência.": "The code was copied to the clipboard.",
  "O código que já está nos seus sites passa a mostrar esta versão nas próximas visitas. Não precisa colar de novo.": "The code already on your sites will show this version on future visits. You do not need to paste it again.",
  "O contador oscilará dentro deste intervalo durante o vídeo.": "The counter will fluctuate within this range during the video.",
  "O CPF deve conter exatamente 11 dígitos.": "The CPF must contain exactly 11 digits.",
  "O cupom aplicado na sua assinatura é mantido na ativação.": "The coupon applied to your subscription is retained on activation.",
  "O dashboard foi completamente redesenhado com cards executivos de métricas, feed de vídeos em tempo real e insights de performance. Uma experiência visual nível Apple para gerenciar seus vídeos.": "The dashboard has been completely redesigned with executive metric cards, a real-time video feed, and performance insights. An Apple-level visual experience for managing your videos.",
  "O domínio \"": "The domain \"",
  "O download do arquivo CSV começará em instantes.": "The CSV download will begin shortly.",
  "O ecossistema definitivo": "The ultimate ecosystem",
  "O editor da VSL Dinâmica precisa de uma tela com pelo menos 1024 px. A lista e as métricas funcionam no celular.": "The Dynamic VSL editor requires a screen at least 1024 px wide. The list and metrics work on mobile.",
  "O endereço salvo continua o anterior.": "The previously saved address remains unchanged.",
  "O engajamento em mobile está": "Mobile engagement is",
  "O engajamento está baixo. Isso significa que as pessoas estão desistindo cedo do vídeo. Considere revisar os primeiros 15 segundos - eles são críticos! Adicione um 'gancho' atrativo no início e evite introduções longas.": "Engagement is low. People are leaving the video early. Consider reviewing the first 15 seconds — they are critical! Add an attractive hook at the start and avoid long intros.",
  "O estilo será controlado pelo código HTML inserido na aba Configuração. Use CSS inline ou classes personalizadas para estilizar seu botão.": "The style is controlled by the HTML code entered in the Configuration tab. Use inline CSS or custom classes to style your button.",
  "O fim deve ser 0 ou maior/igual ao início.": "End must be 0 or greater than or equal to start.",
  "O fluxo ainda não tem etapas.": "The flow has no steps yet.",
  "O fluxo ainda não tem opções.": "The flow has no options yet.",
  "O fluxo ainda não tem saídas.": "The flow has no exits yet.",
  "O fluxo continua em rascunho.": "The flow remains a draft.",
  "O fluxo pode ter no máximo {value0} etapas.": "The flow can have up to {value0} steps.",
  "O fluxo pode ter no máximo {value0} saídas.": "The flow can have up to {value0} exits.",
  "O fluxo tem": "The flow has",
  "O formato de história tem provado ser muito eficaz para manter o engajamento do início ao fim.": "Story format has proven highly effective at maintaining engagement from start to finish.",
  "O formato narrativo está funcionando bem! Continue contando histórias que se conectam emocionalmente com seu público.": "The narrative format is working well! Keep telling stories that connect emotionally with your audience.",
  "O gráfico será atualizado quando houver atividade": "The chart will update when there is activity",
  "O HostVSL está sendo instalado": "HostVSL is being installed",
  "O HostVSL está sendo instalado no seu dispositivo.": "HostVSL is being installed on your device.",
  "O ícone do HostVSL aparecerá na sua tela inicial": "The HostVSL icon will appear on your home screen",
  "O ícone será exibido automaticamente conforme a plataforma.": "The icon will appear automatically based on the platform.",
  "O ideal: curva lenta e constante, mantendo acima de 50% até o minuto 1.": "Ideal: a slow, steady curve, staying above 50% until minute 1.",
  "O iFrame é a forma mais simples de incorporar, mas oferece menos customização.": "iFrame is the simplest way to embed, but offers less customization.",
  "O início deve ser maior ou igual a zero.": "Start must be greater than or equal to zero.",
  "O JavaScript oferece mais customização e integração com eventos.": "JavaScript offers more customization and event integration.",
  "O link da playlist foi copiado": "Playlist link copied",
  "O link da playlist foi copiado para a área de transferência.": "The playlist link was copied to the clipboard.",
  "O link de afiliado é obrigatório quando o recurso está ativado.": "The affiliate link is required when the feature is enabled.",
  "O link para {value0} já está na sua área de transferência.": "The link to {value0} is already on your clipboard.",
  "O Meta Pixel é uma ferramenta de automação de marketing que ajuda a aumentar a conversão de vendas e a retenção de clientes.": "Meta Pixel is a marketing automation tool that helps increase sales conversions and customer retention.",
  "O nome da estratégia foi atualizado com sucesso.": "The strategy name was updated successfully.",
  "O nome da pasta não pode estar vazio": "Folder name cannot be empty",
  "O nome da playlist precisa ter pelo menos 3 caracteres": "Playlist name must be at least 3 characters",
  "O nome deve ter pelo menos 2 caracteres": "Name must be at least 2 characters",
  "O nome do seu teste não pode estar vazio.": "Your test name cannot be empty.",
  "O nome do teste foi atualizado com sucesso.": "The test name has been updated successfully.",
  "O nome do teste precisa ter pelo menos 3 caracteres": "Test name must be at least 3 characters",
  "O número definido em \"Base\" será exibido automaticamente após a mensagem.": "The number set in \"Base\" will automatically appear after the message.",
  "O pitch precisa de ajustes urgentes.": "The pitch needs urgent adjustments.",
  "O pixel do Facebook é uma ferramenta de análise que permite medir a eficácia da sua publicidade ao compreender as ações que as pessoas realizam no seu site.": "The Facebook pixel is an analytics tool that measures advertising effectiveness by understanding the actions people take on your site.",
  "O pixel foi conectado com sucesso.": "The pixel was connected successfully.",
  "O pixel foi configurado e ativado com sucesso.": "The pixel was configured and enabled successfully.",
  "O pixel foi desativado com sucesso.": "The pixel was disabled successfully.",
  "O pixel foi removido com sucesso.": "The pixel was removed successfully.",
  "O principal começa logo após o vídeo de entrada.": "The main video starts immediately after the entry video.",
  "O produtor desativou este compartilhamento. Entre em contato com ele para solicitar um novo link.": "The producer disabled this share. Contact them to request a new link.",
  "O que acontece ao terminar ou pular.": "What happens when it ends or is skipped.",
  "O que acontece após o usuário enviar o formulário": "What happens after the user submits the form",
  "O que acontece quando a regra for atendida": "What happens when the rule matches",
  "O que é o Programa de Parcerias Host VSL?": "What is the Host VSL Partner Program?",
  "O que vai acontecer": "What will happen",
  "O que você vai aprender:": "What you will learn:",
  "O rascunho continua salvo. Só a publicação fica bloqueada até resolver.": "The draft remains saved. Only publishing is blocked until this is resolved.",
  "O rascunho é salvo sozinho e não muda o que está no ar. Pré-visualize, publique e cole o código na sua página. O código é sempre o mesmo: publicar de novo atualiza o vídeo no site.": "The draft saves automatically and does not change the live version. Preview, publish, and paste the code on your page. The code stays the same: publishing again updates the video on your site.",
  "O recurso foi desativado com sucesso.": "The feature was disabled successfully.",
  "O servidor recusou este vínculo. Preencha primeiro o 'Perfil Comercial' à esquerda antes de adicionar o banco.": "The server rejected this link. Complete the 'Business Profile' on the left before adding the bank.",
  "O sistema de rotas é gerenciado pelo React Router v6. Todas as rotas principais são protegidas pelo componente ProtectedRoute que verifica autenticação.": "Routing is managed by React Router v6. All main routes are protected by the ProtectedRoute component, which checks authentication.",
  "O sistema distribuirá o tráfego entre as introduções selecionadas, garantindo uma amostra estatística válida.": "The system distributes traffic among the selected intros, ensuring a valid statistical sample.",
  "O sistema distribuirá o tráfego entre os vídeos selecionados, garantindo uma amostra estatística válida.": "The system distributes traffic among the selected videos, ensuring a valid statistical sample.",
  "O Smart Autoplay exibe um vídeo automático antes do usuário clicar para assistir. Ideal para aumentar retenção e curiosidade.": "Smart Autoplay displays an automatic video before users click to watch. Ideal for increasing retention and curiosity.",
  "O status do teste foi atualizado.": "The test status has been updated.",
  "O template da mensagem não pode estar vazio": "Message template cannot be empty",
  "O tempo de Pitch é:": "The Pitch time is:",
  "O tempo de saída precisa ser maior que o tempo de entrada.": "End time must be greater than start time.",
  "O tempo do pitch foi salvo com sucesso.": "Pitch time was saved successfully.",
  "O tempo informado é maior que a duração do vídeo.": "The entered time exceeds the video duration.",
  "O teste A/B foi excluído com sucesso.": "The A/B test has been deleted successfully.",
  "O teste A/B foi finalizado com sucesso.": "The A/B test was finished successfully.",
  "O Teste de hook alterna automaticamente entre intros diferentes e coleta dados como retenção e cliques.": "Hook Testing automatically rotates different intros and collects retention and click data.",
  "O teste de introduções foi finalizado com sucesso.": "The intro test was finished successfully.",
  "O teste de velocidade foi criado e está coletando dados": "The speed test was created and is collecting data",
  "O teste está coletando dados em tempo real": "The test is collecting data in real time",
  "O teste foi excluído com sucesso.": "The test has been deleted successfully.",
  "O teste roda normalmente, mas sem as métricas de conversão das plataformas de pagamento.": "The test runs normally, but without payment platform conversion metrics.",
  "O teste será encerrado e a variação principal será aplicada. Esta ação não pode ser desfeita.": "The test will end and the primary variation will be applied. This action cannot be undone.",
  "O teste só encerra quando você clicar em \"Finalizar Teste\".": "The test only ends when you click \"Finish Test\".",
  "O teste usará as": "The test will use the",
  "O texto da legenda não pode estar vazio.": "Subtitle text cannot be empty.",
  "O texto foi copiado para a área de transferência.": "The text was copied to the clipboard.",
  "O texto principal que aparece no formulário": "The main text shown in the form",
  "O título deve ter no máximo 100 caracteres": "Title must be no longer than 100 characters",
  "O token é de uso único, expira em 30 minutos e não dá acesso ao seu e-mail ou senha.": "The token is single-use, expires in 30 minutes, and does not grant access to your email or password.",
  "O total deve ser 100%. Atualmente: {value0}%": "The total must be 100%. Currently: {value0}%",
  "O URL deve iniciar com https://": "URL must start with https://",
  "O vídeo": "The video",
  "O vídeo \"": "The video \"",
  "O vídeo ainda está processando.": "The video is still processing.",
  "O vídeo começará exatamente no horário agendado. Participantes que entrarem depois verão o vídeo já em andamento.": "The video starts exactly at the scheduled time. Participants joining later will see the video already in progress.",
  "O vídeo da etapa {value0} ainda está processando.": "The video for step {value0} is still processing.",
  "O vídeo da etapa {value0} não existe mais neste fluxo.": "The video for step {value0} no longer exists in this flow.",
  "o vídeo de saída começa assim que o principal termina, conduzindo o espectador para a próxima ação.": "the exit video starts as soon as the main video ends, guiding viewers to the next action.",
  "O vídeo deve ter no máximo 2GB": "The video must be no larger than 2GB",
  "O vídeo deve ter no máximo 500MB": "The video must be no larger than 500MB",
  "O vídeo foi adicionado à sua conta com sucesso. Os plays serão contabilizados no seu plano.": "The video was added to your account successfully. Plays count against your plan.",
  "O vídeo foi movido para a pasta selecionada.": "The video was moved to the selected folder.",
  "O vídeo foi removido da playlist.": "The video was removed from the playlist.",
  "O vídeo inicia no momento correspondente ao horário atual": "The video starts at the point corresponding to the current time",
  "O vídeo pausa ao sair da aba e retoma automaticamente ao retornar.": "The video pauses when leaving the tab and resumes automatically on return.",
  "O vídeo pausa após o envio do formulário": "The video pauses after form submission",
  "O vídeo pausa após o usuário enviar a senha correta": "The video pauses after the user enters the correct password",
  "O vídeo pausa automaticamente quando o visitante sai da aba, retomando ao voltar.": "The video automatically pauses when visitors leave the tab and resumes when they return.",
  "O vídeo pausa quando o formulário aparecer": "The video pauses when the form appears",
  "O vídeo pausa quando o formulário de senha aparece": "The video pauses when the password form appears",
  "O vídeo que mais gerou receita": "The video that generated the most revenue",
  "O vídeo selecionado não está disponível": "The selected video is unavailable",
  "O vídeo selecionado, será exibido após todas as introduções testadas.": "The selected video will play after all tested intros.",
  "O vídeo será pausado automaticamente nesse tempo": "The video will automatically pause at this time",
  "OAuth cancelado": "OAuth canceled",
  "Obrigado pelo seu feedback!": "Thank you for your feedback!",
  "Obrigado por nos informar!": "Thank you for letting us know!",
  "Obrigatório": "Required",
  "Observação interna": "Internal note",
  "Observação:": "Note:",
  "Observe a taxa de cliques em botões de ação": "Watch the click-through rate on action buttons",
  "Observe se a diferença se mantém constante ao longo de diversos dias.": "Check whether the difference remains consistent over several days.",
  "Ocorreu um erro ao carregar o conteúdo. Verifique sua conexão e tente novamente.": "An error occurred loading the content. Check your connection and try again.",
  "Ocorreu um erro ao carregar o vídeo": "An error occurred loading the video",
  "Ocorreu um erro ao configurar a integração.": "An error occurred configuring the integration.",
  "Ocorreu um erro ao criar o teste. Tente novamente.": "An error occurred creating the test. Please try again.",
  "Ocorreu um erro ao gerar o gráfico de retenção. Por favor, tente novamente mais tarde.": "An error occurred generating the retention chart. Please try again later.",
  "Ocorreu um erro ao processar a ativação.": "An error occurred processing activation.",
  "Ocorreu um erro ao remover a logo": "An error occurred removing the logo",
  "Ocorreu um erro ao remover a thumbnail": "An error occurred removing the thumbnail",
  "Ocorreu um erro ao salvar as configurações. Tente novamente.": "An error occurred saving settings. Please try again.",
  "Ocorreu um erro ao salvar suas alterações": "An error occurred saving your changes",
  "Ocorreu um erro inesperado ao carregar as configurações de headline.": "An unexpected error occurred loading headline settings.",
  "Ocorreu um erro inesperado ao carregar esta página. Tente recarregar ou limpar o cache.": "An unexpected error occurred loading this page. Try reloading or clearing the cache.",
  "Ocorreu um erro inesperado. Por favor, recarregue a página.": "An unexpected error occurred. Please reload the page.",
  "Ocorreu um erro. Tente novamente.": "An error occurred. Please try again.",
  "Oculta os controles até a primeira interação": "Hides controls until the first interaction",
  "Ocultar": "Hide",
  "Ocultar elemento": "Hide element",
  "Ocultar Feedback": "Hide Feedback",
  "Ocultar modal": "Hide dialog",
  "Ocultar Pause": "Hide pause",
  "Ocultar senha": "Hide password",
  "Ocultar token": "Hide token",
  "Ocultar Vídeo": "Hide video",
  "Ofereça vantagens especiais para quem comprar com você (ex. bônus exclusivo com link).": "Offer special benefits to people who buy through you (e.g., an exclusive bonus with a link).",
  "Oferta": "Offer",
  "Oferta ativada! Plano atualizado com sucesso.": "Offer activated! Plan updated successfully.",
  "Oferta com Preço": "Priced Offer",
  "Oferta com Progresso": "Offer with Progress",
  "Oferta com Riscado": "Offer with Strikethrough Price",
  "Oferta disponível somente nesta página": "Offer available only on this page",
  "Oferta Especial": "Special Offer",
  "Oferta Especial Liberada!": "Special Offer Unlocked!",
  "OFERTA ESPECIAL PARA VOCÊ": "SPECIAL OFFER FOR YOU",
  "Oferta exclusiva": "Exclusive offer",
  "Oferta expirada": "Offer expired",
  "Oferta relâmpago": "Flash offer",
  "Oferta termina em": "Offer ends in",
  "OFERTA ÚNICA!": "ONE-TIME OFFER!",
  "oferta visível": "offer visible",
  "Ofertas": "Offers",
  "Ofertas nos Vídeos": "Video Offers",
  "offline": "offline",
  "Offset Horizontal": "Horizontal Offset",
  "Offset Vertical": "Vertical Offset",
  "Olá, {value0}": "Hello, {value0}",
  "Onde o formulário será exibido sobre o vídeo": "Where the form appears over the video",
  "Online": "Online",
  "Only safe HTML elements are allowed. Scripts and event handlers will be removed.": "Only safe HTML elements are allowed. Scripts and event handlers will be removed.",
  "Ontem": "Yesterday",
  "Oops! Page not found": "Oops! Page not found",
  "Opacidade": "Opacity",
  "Opacidade ao passar o mouse": "Opacity on hover",
  "Opacidade do fundo": "Background opacity",
  "Opacidade:": "Opacity:",
  "Opaco": "Opaque",
  "Opção": "Option",
  "Opção de recusa": "Decline option",
  "opções": "options",
  "Opções": "Options",
  "Opções avançadas": "Advanced options",
  "Opções de personalização em breve.": "Customization options coming soon.",
  "Open Sans": "Open Sans",
  "Open Sans (Classic)": "Open Sans (Classic)",
  "Opera": "Opera",
  "Operador": "Operator",
  "Operador é obrigatório": "Operator is required",
  "Operador obrigatório": "Operator required",
  "Oportunidades Escondidas": "Hidden Opportunities",
  "Optimize sua thumbnail": "Optimize your thumbnail",
  "Ordem atualizada": "Order updated",
  "Ordem atualizada!": "Order updated!",
  "Ordenar por": "Sort by",
  "ORDENAR POR": "SORT BY",
  "Organize e personalize os campos de inscrição (arraste para reordenar)": "Organize and customize registration fields (drag to reorder)",
  "Organize por campanha ou grupo": "Organize by campaign or group",
  "Organize seus vídeos como nunca antes com o novo sistema hierárquico de pastas. Crie pastas, subpastas, arraste e solte vídeos para organizar seu conteúdo de forma profissional.": "Organize your videos like never before with the new hierarchical folder system. Create folders and subfolders, and drag and drop videos to organize content professionally.",
  "Organize seus vídeos criando pastas e subpastas": "Organize your videos with folders and subfolders",
  "Organize seus vídeos em sequência e compartilhe com seu público": "Organize your videos in sequence and share with your audience",
  "Organize seus vídeos em sequências e publique com 1 clique.": "Organize your videos into sequences and publish with 1 click.",
  "Orientação do Formulário": "Form Orientation",
  "Origem": "Source",
  "Origem (Source)": "Source",
  "origem detectada": "source detected",
  "Origem dos Leads": "Lead Sources",
  "Origem dos visitantes": "Visitor sources",
  "Origem principal:": "Primary source:",
  "Origem Top": "Top Source",
  "Origens": "Sources",
  "Origens (": "Sources (",
  "origens com curva de retenção": "sources with retention curves",
  "Origens de Tráfego": "Traffic Sources",
  "origens detectadas": "sources detected",
  "Origens no gráfico": "Sources in chart",
  "origens no gráfico. Veja todas na tabela abaixo.": "sources in the chart. See all in the table below.",
  "Original": "Original",
  "Original:": "Original:",
  "Os": "The",
  "Os 3 dígitos no verso do cartão": "The 3 digits on the back of the card",
  "Os dados de dispositivos aparecerão após os primeiros acessos.": "Device data will appear after the first visits.",
  "Os dados estão sendo atualizados para o novo período": "Data is being updated for the new period",
  "Os dados estão sendo exportados em CSV": "Data is being exported as CSV",
  "Os dados são atualizados a cada 15 minutos.": "Data updates every 15 minutes.",
  "Os dados serão exibidos aqui quando houver interações com o seu conteúdo.": "Data will appear here when people interact with your content.",
  "Os downloads falharam. Tente novamente.": "Downloads failed. Please try again.",
  "Os plays serão consumidos do seu plano.": "Plays will be deducted from your plan.",
  "Os primeiros 15 segundos são críticos. Considere testar diferentes abordagens com Teste de hook.": "The first 15 seconds are critical. Consider testing different approaches with Hook Testing.",
  "Os relatórios de performance ficarão disponíveis aqui após a criação de estratégias.": "Performance reports will be available here after strategies are created.",
  "Os serviços de segurança da Stripe estão carregando. Aguarde.": "Stripe security services are loading. Please wait.",
  "Os seus saldos acumulados são liquidados diretamente na sua carteira configurada de forma segura e pontual.": "Your accumulated balances are settled directly into your configured wallet securely and on time.",
  "Os sites que já têm o código passam a mostrar esta versão nas próximas visitas.": "Sites that already have the code will show this version on future visits.",
  "Os testes A/B de headlines requerem que o autoplay esteja ativado para garantir que os usuários vejam as variações antes de interagir com o vídeo.": "Headline A/B tests require autoplay to be enabled so users see variations before interacting with the video.",
  "Os testes de velocidade permitem comparar diferentes configurações para encontrar a melhor para seu público.": "Speed tests allow you to compare different configurations to find the best one for your audience.",
  "Os testes de velocidade permitem que você faça testes A/B de diferentes velocidades de reprodução para encontrar a configuração ideal para engajamento e conversões.": "Speed tests allow you to A/B test different playback speeds to find the optimal setting for engagement and conversions.",
  "Os uploads em andamento serão cancelados. Esta ação não pode ser desfeita.": "Uploads in progress will be canceled. This action cannot be undone.",
  "Os vídeos foram salvos com sucesso.": "Videos saved successfully.",
  "Os vídeos são enviados dentro do fluxo e ficam só nele: não aparecem em \"Meus vídeos\". Assim que terminam de processar, já podem ser usados nas etapas.": "Videos are uploaded within the flow and stay only there: they do not appear in \"My Videos\". Once processing finishes, they can be used in steps.",
  "Oswald": "Oswald",
  "Oswald (Bold)": "Oswald (Bold)",
  "Other": "Other",
  "Otimização": "Optimization",
  "Otimizando…": "Optimizing…",
  "Otimizar automaticamente": "Auto-optimize",
  "Otimizar Introdução": "Optimize Intro",
  "Otimize a experiência mobile sem comprometer o desktop": "Optimize the mobile experience without compromising desktop",
  "Otimize o Início": "Optimize the Opening",
  "Otimize suas ofertas com base em dados de performance": "Optimize your offers based on performance data",
  "ou": "or",
  "ou clique no botão abaixo para escolher seus arquivos": "or click the button below to choose your files",
  "ou clique no botão abaixo para selecionar": "or click the button below to select",
  "ou clique para selecionar": "or click to select",
  "ou clique para selecionar do seu computador": "or click to select from your computer",
  "Ou envie um WhatsApp para:": "Or send a WhatsApp message to:",
  "ou importe de": "or import from",
  "ou R$ 154,68 à vista": "or R$ 154,68 upfront",
  "Ou URL de destino (opcional)": "Or destination URL (optional)",
  "outras regras...": "other rules...",
  "Outro": "Other",
  "Outro idioma…": "Other language…",
  "Outros": "Others",
  "Overlay de Pausa": "Pause Overlay",
  "Overlay de Vídeo": "Video Overlay",
  "Overlay drag visual": "Visual overlay dragging",
  "Overlay escuro (VTurb)": "Dark overlay (VTurb)",
  "Overlay escuro para leitura": "Dark overlay for readability",
  "Overlay personalizado": "Custom overlay",
  "P": "S",
  "padrão": "default",
  "Padrão": "Default",
  "Padrão de Uso": "Usage Pattern",
  "Padrão do player": "Player default",
  "Padrão global": "Global default",
  "Padrão Host": "Host Default",
  "Padrões de interrupção": "Pattern interrupts",
  "Padronizar configurações": "Standardize settings",
  "Pagamento 100% seguro": "100% secure payment",
  "Pagamento Atualizado": "Payment Updated",
  "Pagamento atualizado com sucesso!": "Payment updated successfully!",
  "Pagamento Criado": "Payment Created",
  "Pagamento criptografado e processado com segurança.": "Encrypted and securely processed payment.",
  "Pagamento Falhou": "Payment Failed",
  "Pagar agora": "Pay now",
  "Página": "Page",
  "Página {value0}": "Page {value0}",
  "Página específica": "Specific page",
  "Página externa": "External page",
  "Página não encontrada": "Page not found",
  "Páginas ultra rápidas em HTML": "Ultra-fast HTML pages",
  "pagination": "pagination",
  "Pago": "Paid",
  "Pague faturas em aberto e baixe as anteriores": "Pay outstanding invoices and download previous ones",
  "Painéis": "Panels",
  "Painel lateral": "Side panel",
  "País": "Country",
  "País das regiões": "Country for regions",
  "País é obrigatório": "Country is required",
  "País e região obrigatórios": "Country and region required",
  "País e região são obrigatórios": "Country and region are required",
  "País não encontrado": "Country not found",
  "País obrigatório": "Country required",
  "País sem regiões mapeadas": "Country has no mapped regions",
  "País:": "Country:",
  "País: {value0}": "Country: {value0}",
  "Países": "Countries",
  "Palavra por palavra": "Word by word",
  "Para acompanhar conversões, conecte o Rastreamento.": "Connect Tracking to monitor conversions.",
  "Para alto volume de tráfego": "For high traffic volume",
  "para aumentar a retenção na marca de 1:45, onde ocorre uma queda significativa no engajamento.": "to increase retention at 1:45, where engagement drops significantly.",
  "para cada intro. Sem isso, a plataforma não envia as conversões. Você também encontra estas URLs em": "for each intro. Without this, the platform does not send conversions. You can also find these URLs in",
  "Para começar com mais limite": "Start with a higher allowance",
  "para começar o fluxo.": "to start the flow.",
  "para confirmar": "to confirm",
  "Para conteúdos educativos, priorize o engajamento; para vendas, priorize a taxa de conversão": "For educational content, prioritize engagement; for sales, prioritize conversion rate",
  "para escalar VSLs.": "to scale VSLs.",
  "Para exibir a thumbnail de início, desabilite a reprodução automática.": "Disable autoplay to display the starting thumbnail.",
  "Para finalizar": "To finish",
  "para melhorar o carregamento.": "to improve loading.",
  "Para melhores resultados, use vídeos com a": "For best results, use videos with the",
  "Para onde o botão HTML vai redirecionar o visitante.": "Where the HTML button redirects visitors.",
  "Para onde o visitante vai ao escolher uma opção: checkout, WhatsApp ou outra página.": "Where visitors go when choosing an option: checkout, WhatsApp, or another page.",
  "Para operações com alto volume": "For high-volume operations",
  "Para otimizar ainda mais, considere aumentar o ritmo ou adicionar elementos visuais entre 45-60% do vídeo.": "To optimize further, consider increasing the pace or adding visual elements between 45–60% of the video.",
  "Para pausar o vídeo, a etapa precisa de pelo menos uma opção.": "The step needs at least one option to pause the video.",
  "Para pausar o vídeo, defina quando as opções aparecem.": "Set when options appear to pause the video.",
  "Para que as alterações da headline funcionem, você precisa copiar o código do vídeo depois de salvar e colar no seu site.": "For headline changes to work, copy the video code after saving and paste it on your site.",
  "Para que as alterações do botão de ação abaixo do vídeo funcionem, você precisa copiar o código do vídeo depois de salvar e colar no seu site.": "For changes to the action button below the video to work, copy the video code after saving and paste it on your site.",
  "Para resultados confiáveis, espere pelo menos 100-200 visualizações por variação.": "For reliable results, wait for at least 100–200 views per variation.",
  "Para usar a Barra de Progresso personalizada, desative os controles do player.": "To use the custom Progress Bar, disable the player controls.",
  "Para visualizar todos os dados de receita, conversões e desempenho, conecte sua plataforma de pagamento. É rápido e seguro.": "Connect your payment platform to see all revenue, conversion, and performance data. It's quick and secure.",
  "Para VSLs de venda, recomendamos exibir o feedback apenas no final ou após o pitch para não interromper a conversão.": "For sales VSLs, we recommend showing feedback only at the end or after the pitch to avoid interrupting conversions.",
  "Parabéns!": "Congratulations!",
  "Parabéns! 🏆": "Congratulations! 🏆",
  "Parabéns! A sua conta de afiliado foi ativada.": "Congratulations! Your affiliate account is active.",
  "Parado": "Stopped",
  "Parâmetro": "Parameter",
  "Parâmetro da UTM": "UTM parameter",
  "Parâmetro obrigatório": "Parameter required",
  "Parâmetro UTM": "UTM Parameter",
  "Parâmetro UTM é obrigatório": "UTM parameter is required",
  "Parâmetros": "Parameters",
  "Parâmetros fixos": "Fixed parameters",
  "Parceiros": "Partners",
  "Parceiros — Página Premium 10/10": "Partners — Premium 10/10 Page",
  "Parceiros oficiais": "Official Partners",
  "Parceiros Oficiais": "Official Partners",
  "Parcerias": "Partnerships",
  "Parece que este link não é válido. Verifique e tente novamente.": "This link doesn't look valid. Please check and try again.",
  "Paris (GMT+1)": "Paris (GMT+1)",
  "Participantes entram direto na sala sem preencher formulário": "Participants enter the room directly without filling out a form",
  "Pasta": "Folder",
  "Pasta criada": "Folder created",
  "Pasta criada.": "Folder created.",
  "Pasta excluída": "Folder deleted",
  "Pasta excluída.": "Folder deleted.",
  "Pasta não encontrada": "Folder not found",
  "Pasta personalizada criada": "Custom folder created",
  "Pasta renomeada": "Folder renamed",
  "Pasta renomeada com sucesso!": "Folder renamed successfully!",
  "Pasta renomeada.": "Folder renamed.",
  "Pasta vazia": "Empty folder",
  "Pastas": "Folders",
  "Pastas específicas": "Specific folders",
  "Pastas Hierárq.": "Hierarchical Folders",
  "pausa": "pause",
  "Pausa": "Pause",
  "Pausa automática ao detectar que o espectador saiu da aba": "Automatic pause when viewers leave the tab",
  "Pausa Inteligente": "Smart Pause",
  "Pausa inteligente ativada": "Smart pause enabled",
  "Pausa inteligente desativada": "Smart pause disabled",
  "Pausa o vídeo ao sair da aba e retoma ao voltar automaticamente.": "Pauses the video when viewers leave the tab and resumes automatically when they return.",
  "Pausa o vídeo automaticamente quando o espectador sai da aba do navegador.": "Automatically pauses the video when viewers leave the browser tab.",
  "Pausa o vídeo quando o espectador sai da aba.": "Pauses the video when the viewer leaves the tab.",
  "Pausado": "Paused",
  "Pausados": "Paused",
  "Pausar": "Pause",
  "Pausar ao abrir a senha": "Pause when password form opens",
  "Pausar ao enviar senha": "Pause after password submission",
  "Pausar em (min:seg)": "Pause at (min:sec)",
  "Pausar fluxo": "Pause flow",
  "Pausar vídeo ao abrir": "Pause video on opening",
  "Pausar vídeo ao enviar": "Pause video on submission",
  "PayPal (E-mail)": "PayPal (Email)",
  "PDF gerado com sucesso!": "PDF generated successfully!",
  "PDF pronto para impressão": "PDF ready for printing",
  "Pendente": "Pending",
  "Pequeno": "Small",
  "Percentual": "Percentage",
  "Percentual da largura do player": "Percentage of player width",
  "Percentual de espectadores que ainda assistia no momento do pitch": "Percentage of viewers still watching at the pitch",
  "Percentual de espectadores que ainda assistiam quando cada pitch começou.": "Percentage of viewers still watching when each pitch began.",
  "Percentual de visitantes que clicaram para iniciar o vídeo. Melhore sua thumbnail para aumentar este número.": "Percentage of visitors who clicked to start the video. Improve your thumbnail to increase this number.",
  "Percentual de visitantes que clicaram play no vídeo. Valores acima de 70% são considerados bons. Impactada principalmente pelo thumbnail e título.": "Percentage of visitors who clicked play on the video. Values above 70% are considered good. Mainly affected by the thumbnail and title.",
  "Percentual de visitantes que iniciaram o vídeo": "Percent of visitors who started the video",
  "Percentual do vídeo {value0}": "Percentage for video {value0}",
  "Percentual médio assistido dos vídeos": "Average percentage of videos watched",
  "Percentual médio de retenção do vídeo assistido": "Average retention percentage of the video watched",
  "Percentual médio do vídeo que foi assistido pelos espectadores.": "Average percentage of the video watched by viewers.",
  "Percepção do conteúdo ao longo do período.": "Perception of content over the period.",
  "Perda no fim = oferta fraca ou muito longa.": "Loss at the end = weak or overly long offer.",
  "Perdendo": "Losing",
  "Perfect Pay": "Perfect Pay",
  "Perfeito para vendas e call-to-actions": "Perfect for sales and call-to-actions",
  "Perfil": "Profile",
  "Perfil Comercial": "Business Profile",
  "Perfil comercial updated e saques liberados!": "Business profile updated and withdrawals enabled!",
  "Perfil do usuário": "User profile",
  "Perfil salvo": "Profile saved",
  "Perfis ideais para o programa de parcerias": "Ideal profiles for the partner program",
  "Performance de Engajamento": "Engagement Performance",
  "Performance neste horário": "Performance at this time",
  "Pergunta (opcional)": "Question (optional)",
  "Perguntas Frequentes": "Frequently Asked Questions",
  "Pergunte a quem assistiu o que achou da sua VSL e receba a nota dentro do próprio player.": "Ask viewers what they thought of your VSL and receive their ratings inside the player.",
  "Período": "Period",
  "Período *": "Period *",
  "Período atualizado": "Period updated",
  "Período campeão": "Winning period",
  "Período não definido": "Period not set",
  "Permissão": "Permission",
  "Permissão Alterada": "Permission Changed",
  "Permissão é obrigatória": "Permission is required",
  "Permissão necessária": "Permission required",
  "Permissão:": "Permission:",
  "Permissões agrupadas por área: Vídeos, Conversão, Análises, Otimização, Proteção e Conta": "Permissions grouped by area: Videos, Conversion, Analytics, Optimization, Protection, and Account",
  "Permissões atualizadas com sucesso!": "Permissions updated successfully!",
  "Permissões limitadas atribuídas.": "Limited permissions assigned.",
  "Permissões por Recurso": "Permissions by Feature",
  "Permita interação com o vídeo e aumente controle, retenção e experiência do usuário.": "Configure the video playback behavior.",
  "Permita ou bloqueie a reprodução dos seus vídeos com base na localização.": "Allow or block video playback based on location.",
  "Permita que espectadores avaliem o vídeo e acompanhe a percepção real do conteúdo.": "Allow viewers to rate the video and track real perceptions of the content.",
  "Permita que o espectador retome de onde parou.": "Allow viewers to resume where they left off.",
  "Permita que o usuário controle a velocidade do vídeo": "Allow users to control video speed",
  "Permita uma observação após a nota.": "Allow a comment after the rating.",
  "Permite ajustar a velocidade do vídeo": "Allows video speed adjustment",
  "Permite ajustar o áudio": "Lets you adjust audio",
  "Permite assistir em janela flutuante": "Allows viewing in a floating window",
  "Permite entrada direta na sala sem formulário de login. Ideal para tráfego qualificado.": "Allows direct room entry without a login form. Ideal for qualified traffic.",
  "Permite expandir o vídeo para tela cheia": "Allows expanding the video to full screen",
  "Permite pular o vídeo de entrada.": "Allows skipping the entry video.",
  "Permite pular rapidamente trechos": "Allows quickly skipping segments",
  "Permite que o espectador ative ou desative": "Lets the viewer enable or disable",
  "Permite que o espectador retome o vídeo de onde parou.": "Lets the viewer resume the video where they left off.",
  "Permite que o usuário continue de onde parou": "Allows users to resume where they left off",
  "Permite que o usuário continue sem preencher o formulário": "Allows users to continue without filling out the form",
  "Permite que o vídeo reinicie automaticamente quando terminar": "Allows the video to restart automatically when it ends",
  "Permite que usuários retomem o vídeo de onde pararam": "Lets users resume the video from where they stopped",
  "Permite que visitantes entrem direto na sala sem fazer login. Útil para maximizar acessos, mas reduz a captação de leads.": "Allows visitors to enter the room directly without signing in. Useful for maximizing visits, but reduces lead capture.",
  "Permite reiniciar automaticamente o vídeo assim que ele terminar.": "Allows automatic video restart as soon as it ends.",
  "Permitidas": "Allowed",
  "Permitido": "Allowed",
  "Permitido: {value0}": "Allowed: {value0}",
  "Permitidos": "Allowed",
  "Permitir": "Allow",
  "Permitir apenas": "Allow only",
  "Permitir apenas e-mails de domínios específicos": "Allow emails only from specific domains",
  "Permitir comentário após avaliação": "Allow comments after rating",
  "Permitir entrada até (minutos após início)": "Allow entry until (minutes after start)",
  "Permitir fechar no \"X\"": "Allow closing with \"X\"",
  "Permitir repetir este vídeo ao terminar.": "Allow this video to repeat when it ends.",
  "Permitir selecionados": "Allow selected",
  "Persistência": "Persistence",
  "Persistência:": "Persistence:",
  "Persistir como barra fixa": "Keep as a fixed bar",
  "Personalização": "Customization",
  "Personalização da Logo": "Logo Customization",
  "Personalização Total": "Full Customization",
  "Personalização Visual": "Visual customization",
  "Personalizações": "Personalizations",
  "Personalizado": "Custom",
  "Personalizar": "Personalize",
  "Personalizar Caixa do Autoplay": "Customize Autoplay Box",
  "Personalizar Logo…": "Customize Logo…",
  "Personalizar Tema": "Customize Theme",
  "Personalizar Vídeo": "Customize Video",
  "Personalizar Vídeos": "Customize Videos",
  "Personalize a aparência da página de inscrição": "Customize the registration page appearance",
  "Personalize a aparência do Autoplay": "Customize the Autoplay appearance",
  "Personalize a barra de progresso do player.": "Customize the player progress bar.",
  "Personalize a exibição das legendas no player.": "Customize how subtitles are displayed in the player.",
  "Personalize as cores do botão.": "Customize the button colors.",
  "Personalize as cores dos elementos do formulário": "Customize form element colors",
  "Personalize as cores e aparência do player.": "Customize player colors and appearance.",
  "Personalize as cores e espessura da barra de progresso.": "Customize progress bar colors and thickness.",
  "Personalize as cores, opacidade e bordas dos controles do player para combinar com sua marca.": "Customize player control colors, opacity, and borders to match your brand.",
  "Personalize as mensagens do feedback.": "Customize feedback messages.",
  "Personalize cores dos controles e da barra inferior.": "Customize colors of controls and the bottom bar.",
  "Personalize cores, animações e efeitos visuais": "Customize colors, animations and visual effects",
  "Personalize estilo, cor e posição do card.": "Customize card style, color, and position.",
  "Personalize formato, cores, botões, borda, barra de progresso e a forma de iniciar o player, com opções adaptadas ao mobile.": "Customize format, colors, buttons, border, progress bar, and how the player starts, with options adapted for mobile.",
  "Personalize headline e subheadline": "Customize headline and subheadline",
  "Personalize o comportamento do player para cada tipo de dispositivo": "Customize player behavior for each device type",
  "Personalize o Player": "Customize the Player",
  "Personalize o player de forma independente para cada tipo de dispositivo": "Customize the player independently for each device type",
  "Peso da Fonte": "Font Weight",
  "Peso:": "Weight:",
  "Pesquisar nesta pasta...": "Search this folder...",
  "Pesquisar novidades...": "Search updates...",
  "Pesquisar vídeo ou pasta...": "Search videos or folders...",
  "Pesquisar vídeos": "Search videos",
  "Pesquisar...": "Search...",
  "Pessoal": "Personal",
  "Pessoas cadastradas através dos seus links.": "People registered through your links.",
  "Pessoas que assistiram": "People who watched",
  "Pessoas únicas": "Unique people",
  "Pico Absoluto": "Absolute Peak",
  "Pico Absoluto (": "Absolute Peak (",
  "Pico Absoluto (Volume)": "Absolute Peak (Volume)",
  "Pico Absoluto de Conversão": "Absolute Conversion Peak",
  "Pico de audiência": "Audience peak",
  "Pico no horário de maior audiência": "Peak during the busiest audience time",
  "Picos de Horário nas Métricas do Vídeo": "Peak Hours in Video Metrics",
  "Picture-in-Picture": "Picture-in-Picture",
  "Pill": "Pill",
  "Pitch": "PITCH",
  "PITCH": "PITCH",
  "Pitch atualizado": "Pitch updated",
  "Pitch atualizado com sucesso!": "Pitch updated successfully!",
  "Pitch não configurado — clique para definir": "Pitch not configured — click to set",
  "Pitch:": "Pitch:",
  "pitches.": "pitches.",
  "Pixel": "Pixel",
  "Pixel adicionado com sucesso!": "Pixel added successfully!",
  "Pixel ativo": "Active pixel",
  "Pixel atualizado": "Pixel updated",
  "Pixel atualizado com sucesso!": "Pixel updated successfully!",
  "Pixel conectado": "Pixel connected",
  "Pixel configurado": "Pixel configured",
  "Pixel configurado com sucesso!": "Pixel configured successfully!",
  "Pixel desativado": "Pixel disabled",
  "Pixel do Google Ads": "Google Ads Pixel",
  "Pixel do TikTok": "TikTok Pixel",
  "Pixel excluído com sucesso!": "Pixel deleted successfully!",
  "Pixel ID": "Pixel ID",
  "Pixel ID deve ter 15-16 dígitos numéricos": "Pixel ID must contain 15–16 numeric digits",
  "Pixel ID do TikTok inválido. Use o ID alfanumérico do Events Manager.": "Invalid TikTok Pixel ID. Use the alphanumeric ID from Events Manager.",
  "Pixel removido": "Pixel removed",
  "Pixels & Integrações": "Pixels & Integrations",
  "Pixels ativos": "Active pixels",
  "Pixels Ativos": "Active Pixels",
  "Pixels Cadastrados": "Registered Pixels",
  "Placeholder": "Placeholder",
  "Placeholder do comentário": "Comment placeholder",
  "Plano": "Plan",
  "Plano {value0}": "{value0} plan",
  "Plano {value0} ativado com sucesso! Aproveite os 15 dias grátis!": "{value0} plan activated successfully! Enjoy 15 days free!",
  "Plano / Subscription": "Plan / Subscription",
  "Plano / Valor": "Plan / Price",
  "Plano Ativo": "Active Plan",
  "Plano Ativo — {value0}": "Active Plan — {value0}",
  "Plano Atual": "Current Plan",
  "Plano inativo": "Inactive plan",
  "Plano indisponível no momento": "Plan currently unavailable",
  "Plano mais rápido": "Faster plan",
  "Plano Selecionado": "Selected Plan",
  "Plataforma": "Platform",
  "Plataforma conectada. Aguardando primeiros eventos de venda.": "Platform connected. Awaiting first sales events.",
  "plataforma configurada": "platform configured",
  "Plataforma de comunicação para atendimento ao cliente e marketing.": "Communication platform for customer service and marketing.",
  "Plataforma de e-commerce para lojas online e pagamentos.": "E-commerce platform for online stores and payments.",
  "Plataforma de origem das conversões registradas. Clique para ver detalhes de cada plataforma.": "Source platform for recorded conversions. Click to see details for each platform.",
  "Plataforma de vendas": "Sales platform",
  "Plataforma para email marketing e automação de campanhas.": "Email marketing and campaign automation platform.",
  "Plataforma:": "Platform:",
  "Plataformas": "Platforms",
  "plataformas atingido": "platform limit reached",
  "Plataformas conectadas": "Connected platforms",
  "plataformas configuradas": "platforms configured",
  "plataformas para comparar": "platforms to compare",
  "Play": "Play",
  "Play após carregar a página": "Play after page load",
  "Play extra por R$ 0,02": "Extra play for R$ 0,02",
  "Play Grande": "Large Play",
  "Play Pequeno": "Small Play",
  "Play rate": "Play rate",
  "Play Rate": "Play Rate",
  "Play Rate do Dia": "Daily Play Rate",
  "Play Rate hoje": "Play Rate today",
  "Play Rate Médio": "Average Play Rate",
  "Play Rate:": "Play Rate:",
  "Play, som e tela cheia": "Play, sound, and full screen",
  "PLAYER": "PLAYER",
  "Player com sua Identidade Visual": "Player with Your Visual Identity",
  "Player de Vídeo": "Video Player",
  "Player grande + lista lateral (desktop) ou lista abaixo (mobile). Layout limpo e profissional.": "Large player + side list (desktop) or list below (mobile). Clean, professional layout.",
  "Player premium desbloqueado": "Premium player unlocked",
  "Player Simulado": "Simulated player",
  "Playfair Display (Elegant)": "Playfair Display (Elegant)",
  "Playlist com {value0}MB. Considere usar imagens menores para evitar problemas.": "Playlist size is {value0}MB. Consider smaller images to avoid issues.",
  "Playlist criada!": "Playlist created!",
  "Playlist excluída": "Playlist deleted",
  "Playlist não encontrada": "Playlist not found",
  "Playlist salva!": "Playlist saved!",
  "Playlist sem título": "Untitled playlist",
  "Playlist vazia": "Empty playlist",
  "Playlists": "Playlists",
  "Playlists — Sistema Unificado de Edição": "Playlists — Unified Editing System",
  "Playrate": "Playrate",
  "PlayRate": "PlayRate",
  "plays": "plays",
  "Plays": "plays",
  "Plays ÷ visualizações": "Plays ÷ views",
  "plays analisados": "plays analyzed",
  "Plays divididos pelas visualizações únicas do dia": "Plays divided by the day's unique views",
  "plays extras": "extra plays",
  "Plays extras": "Extra plays",
  "Plays extras adquiridos": "Extra plays purchased",
  "Plays Extras Adquiridos": "Extra Plays Purchased",
  "Plays hoje": "Plays today",
  "plays inclusos por mês": "plays included per month",
  "Plays restantes": "Plays remaining",
  "Plays Totais": "Total Plays",
  "plays únicos": "unique plays",
  "Plays únicos": "Unique plays",
  "Plays Únicos": "Unique plays",
  "Plays únicos por dia e horário": "Unique plays by day and time",
  "Plays únicos por usuário": "Unique plays per user",
  "Plays únicos:": "Unique plays:",
  "plays utilizados": "plays used",
  "Plays:": "Plays:",
  "Plugin de comércio eletrônico para WordPress.": "E-commerce plugin for WordPress.",
  "PNG 256×256px recomendado": "PNG 256×256px recommended",
  "PNG com fundo transparente • Máx. 1MB": "PNG with transparent background • Max 1MB",
  "PNG ou JPG · até 10MB": "PNG or JPG · up to 10MB",
  "PNG recomendado": "PNG recommended",
  "PNG transparente branco recomendado": "Transparent white PNG recommended",
  "PNG, JPG até 4MB": "PNG, JPG up to 4MB",
  "PNG, JPG ou SVG · até 2 MB": "PNG, JPG, or SVG · up to 2 MB",
  "PNG, JPG, GIF • Máx. 5MB": "PNG, JPG, GIF • Max 5MB",
  "Pode editar e adicionar vídeos": "Can edit and add videos",
  "Pode editar e adicionar vídeos, mas não gerenciar usuários": "Can edit and add videos but cannot manage users",
  "Pode impactar performance": "May impact performance",
  "Pode ver vídeos e métricas": "Can view videos and metrics",
  "Poderá solicitar o resgate dos seus valores acumulados assim que atingir o piso mínimo estipulado no extrato.": "You can request a withdrawal of your accumulated funds once you reach the minimum amount stated in your statement.",
  "Política de Cookies": "Cookie Policy",
  "Política de privacidade": "Privacy policy",
  "Política de Privacidade": "Privacy Policy",
  "Polski": "Polski",
  "Ponto crítico onde os espectadores abandonam o vídeo.": "Critical point where viewers leave the video.",
  "Ponto de entrada": "Entry point",
  "Ponto de Entrada": "Entry Point",
  "Ponto do pitch": "Pitch point",
  "Pontos de Queda": "Drop-Off Points",
  "Pontuação geral de engajamento baseada em múltiplos fatores: retenção, cliques e interações.": "Overall engagement score based on multiple factors: retention, clicks, and interactions.",
  "Pop / Destaque": "Pop / Highlight",
  "Poppins": "Poppins",
  "Poppins (Friendly)": "Poppins (Friendly)",
  "Popup bloqueado. Permita popups para exportar.": "Popup blocked. Allow popups to export.",
  "por": "by",
  "Por": "By",
  "Por Categoria": "By Category",
  "por dia e horário": "by day and time",
  "Por Dispositivo": "By Device",
  "Por etapa": "By step",
  "Por favor, anexe o comprovante de transferência.": "Please attach the transfer receipt.",
  "Por favor, corrija os erros antes de continuar.": "Please correct the errors before continuing.",
  "Por favor, digite um e-mail.": "Please enter an email.",
  "Por favor, envie um arquivo de vídeo.": "Please upload a video file.",
  "Por favor, informe o {value0}": "Please enter the {value0}",
  "Por favor, insira o nome completo (Nome e Sobrenome) exigido pela Stripe.": "Please enter the full name (First and Last Name) required by Stripe.",
  "Por favor, insira um nome para o teste.": "Please enter a name for the test.",
  "Por favor, preencha a chave PIX.": "Please enter the PIX key.",
  "Por favor, preencha o e-mail do PayPal.": "Please enter the PayPal email.",
  "Por favor, selecione ambos os arquivos (Frente e Verso) do seu documento.": "Please select both files (Front and Back) of your document.",
  "Por favor, selecione apenas arquivos de vídeo": "Please select only video files",
  "Por favor, selecione um arquivo de vídeo": "Please select a video file",
  "Por favor, selecione um país": "Please select a country",
  "Por favor, selecione um vídeo": "Please select a video",
  "Por favor, selecione um vídeo original": "Please select an original video",
  "Por favor, selecione um vídeo principal.": "Please select a main video.",
  "Por favor, selecione uma imagem válida (JPG, PNG, WEBP)": "Please select a valid image (JPG, PNG, WEBP)",
  "Por favor, selecione uma região": "Please select a region",
  "Por favor, verifique se a distribuição de tráfego soma 100%": "Please verify that traffic distribution totals 100%",
  "Por opção": "By option",
  "Por Provedor": "By Provider",
  "Por quanto tempo a notificação permanece visível.": "How long the notification stays visible.",
  "Por que o Storytelling Funciona?": "Why Does Storytelling Work?",
  "Por saída": "By exit",
  "Por Serviço": "By Service",
  "Por vídeo": "By video",
  "Porcentagem": "Percentage",
  "Porcentagem de espectadores ao longo do tempo": "Percentage of viewers over time",
  "Porcentagem de espectadores que continuam assistindo ao vídeo em cada momento. Quedas bruscas indicam pontos de abandono.": "Percentage of viewers still watching the video at each moment. Sharp drops indicate abandonment points.",
  "Porcentagem de pessoas que ainda estavam assistindo": "Percentage of people still watching",
  "Porcentagem de visualizações que resultaram em uma conversão (clique no botão de ação).": "Percentage of views resulting in a conversion (action button click).",
  "Porcentagem de visualizadores que iniciam a reprodução do vídeo.": "Percentage of viewers who start playing the video.",
  "Porcentagem média de tempo que os espectadores assistem. Um bom número é acima de 70%.": "Average percentage of time viewers watch. A good value is above 70%.",
  "Portugal": "Portugal",
  "Português (BR)": "Português (BR)",
  "Português (Brasil)": "Português (Brasil)",
  "Português (PT)": "Português (PT)",
  "Posição": "Position",
  "Posição da Notificação": "Notification Position",
  "Posição das opções": "Option position",
  "Posição do botão no vídeo": "Button position in the video",
  "Posição do Formulário": "Form Position",
  "Posição do modal": "Dialog position",
  "Posição do Título": "Title Position",
  "Posição e Tamanho": "Position and size",
  "Posição H (%)": "H Position (%)",
  "Posição média:": "Average position:",
  "Posição na tela": "Screen position",
  "Posição no player": "Position in the player",
  "Posição no Vídeo": "Position in Video",
  "Posição V (%)": "V Position (%)",
  "Posição:": "Position:",
  "Posicionamento": "Placement",
  "Posicionamento estratégico": "Strategic placement",
  "Posso ser parceiro como pessoa física?": "Can I become a partner as an individual?",
  "Powered by HostVSL": "Powered by HostVSL",
  "Pra ativar: copie novamente o código do seu vídeo e cole no lugar do antigo, lá onde ele está hospedado": "To enable: copy your video code again and replace the old code wherever it is hosted",
  "Pra liberar o recurso em um vídeo antigo, basta refazer o upload: o processamento gera o storyboard automaticamente": "To enable the feature on an older video, upload it again: processing generates the storyboard automatically",
  "Prazo de Cookies de infinitos": "Unlimited cookie duration",
  "Prazo mínimo de processamento das solicitações bancárias:": "Minimum processing time for bank requests:",
  "Pré-visualização": "Preview",
  "PRÉ-VISUALIZAÇÃO": "PREVIEW",
  "Pré-visualização do Header": "Header Preview",
  "Pré-visualização ilustrativa": "Illustrative preview",
  "Pré-visualização ilustrativa da barra de progresso": "Illustrative preview of the progress bar",
  "Pré-visualização ilustrativa do botão no vídeo": "Illustrative preview of the button in the video",
  "Pré-visualização ilustrativa do HTML personalizado": "Illustrative preview of the custom HTML",
  "Pré-Visualizações de Estilos": "Style previews",
  "Pré-visualizar": "Preview",
  "Pré-visualizar sala": "Preview room",
  "Precisa de ajuda para criar sua legenda?": "Need help creating your subtitles?",
  "Precisa de ajuda? Clique aqui": "Need help? Click here",
  "Precisamos de alguns dados para registrar sua resposta.": "We need a few details to record your response.",
  "Preciso pagar para participar?": "Do I need to pay to join?",
  "Preço antigo riscado e o novo em destaque — ancoragem de valor.": "Old price crossed out with the new price highlighted — value anchoring.",
  "Preço com desconto (opcional)": "Discounted price (optional)",
  "Preço com desconto deve ser menor que o original": "Discounted price must be lower than the original",
  "Preço em destaque": "Highlighted price",
  "Preço original (opcional)": "Original price (optional)",
  "Preço principal": "Main price",
  "Preço riscado": "Strikethrough price",
  "Preços": "Prices",
  "Preencha a data de nascimento completa.": "Enter your complete date of birth.",
  "Preencha abaixo para continuar assistindo.": "Fill out the form below to continue watching.",
  "Preencha as informações abaixo para configurar esta etapa": "Fill out the information below to configure this step",
  "Preencha Headline ou Subheadline.": "Fill in Headline or Subheadline.",
  "Preencha o e-mail.": "Enter the email.",
  "Preencha o nome do serviço.": "Enter the service name.",
  "Preencha para acessar o vídeo": "Fill out the form to access the video",
  "Preencha pelo menos um dos textos": "Fill in at least one text field",
  "Preencha seus dados": "Enter your details",
  "Preencha todos os campos antes de enviar.": "Fill out all fields before submitting.",
  "Preencha todos os campos da conta bancária.": "Fill out all bank account fields.",
  "Preencha todos os campos obrigatórios": "Fill in all required fields",
  "Preencha todos os campos para continuar.": "Fill out all fields to continue.",
  "Preencha todos os dados bancários obrigatórios.": "Fill out all required bank details.",
  "Preenchimento": "Fill",
  "Preferências salvas": "Preferences saved",
  "Preferências UI": "UI Preferences",
  "Premium": "Premium",
  "Preparando compartilhamento": "Preparing share",
  "Preparando download...": "Preparing download...",
  "Preparando QR Code": "Preparing QR Code",
  "Preset de estilo": "Style preset",
  "Pressionado": "Pressed",
  "Prévia": "Preview",
  "Prévia da página de inscrição": "Registration page preview",
  "Prévia da Página de Inscrição": "Registration Page Preview",
  "Prévia da Pasta": "Folder Preview",
  "Prévia do Botão": "Button preview",
  "Prévia em Tempo Real": "Real-Time Preview",
  "Prévia sem som": "Muted preview",
  "Preview": "Preview",
  "Preview configurado:": "Configured preview:",
  "Preview da Oferta": "Offer Preview",
  "Preview da thumbnail": "Thumbnail preview",
  "Preview de frames na timeline": "Frame preview on the timeline",
  "Preview de template": "Template preview",
  "Preview de vídeo": "Video preview",
  "Preview Dinâmico": "Dynamic Preview",
  "Preview disponível no player real": "Preview available in the real player",
  "Preview do Botão": "Button preview",
  "Preview do Gradiente": "Gradient Preview",
  "Preview do Player": "Player preview",
  "Preview do Vídeo": "Video Preview",
  "Preview em Tempo Real": "Real-Time Preview",
  "Preview em tempo real do seu template selecionado": "Real-time preview of your selected template",
  "Preview gerada automaticamente": "Preview generated automatically",
  "Preview:": "Preview:",
  "Preview: Como a oferta aparecerá no webinário": "Preview: How the offer appears in the webinar",
  "Previous": "Previous",
  "Previous slide": "Previous slide",
  "Prime Video Dark — Template Substituindo Netflix": "Prime Video Dark — Template Replacing Netflix",
  "Primeira página visualizada pelos visitantes": "First page viewed by visitors",
  "Primeiro nome": "First name",
  "Primeiro Nome": "First Name",
  "Primeiros passos": "Getting started",
  "Primitives": "Primitives",
  "Principais Origens de Tráfego": "Top Traffic Sources",
  "Principal": "Primary",
  "Principal gatilho de conversão": "Main conversion trigger",
  "Principal origem:": "Primary source:",
  "Princípios Básicos": "Basic Principles",
  "Prioridade": "Priority",
  "Prioridade da regra": "Rule priority",
  "Prioridade deve ser entre 1 e 10": "Priority must be between 1 and 10",
  "Privacidade": "Privacy",
  "Privacidade protegida": "Privacy protected",
  "problema": "problem",
  "problemas": "issues",
  "Problemas": "Issues",
  "Processado": "Processed",
  "Processamento seguro e imediato": "Secure and immediate processing",
  "Processando": "Processing",
  "Processando no servidor...": "Processing on server...",
  "Processando vídeo": "Processing video",
  "Processando vídeo...": "Processing video...",
  "Processando...": "Processing...",
  "Processando…": "Processing…",
  "Procure pelo ícone": "Look for the icon",
  "Programa de Afiliados Oficial": "Official Affiliate Program",
  "ProgressBarConfig - Remoção Borda Extra": "ProgressBarConfig - Extra Border Removal",
  "Progresso": "Progress",
  "Progresso de Configuração": "Setup Progress",
  "Progresso do teste": "Test progress",
  "Progresso do Teste": "Test progress",
  "Progresso Inicial (0-100%)": "Initial Progress (0–100%)",
  "Progresso salvo por aula e por módulo, com indicadores visuais": "Progress saved by lesson and module, with visual indicators",
  "Progresso:": "Progress:",
  "Projeção de Hoje": "Today's Projection",
  "Promessas de valor contínuas": "Ongoing promises of value",
  "Pronto para começar a faturar?": "Ready to start earning?",
  "Pronto para Começar a Ganhar?": "Ready to Start Earning?",
  "Pronto para editar": "Ready to edit",
  "Pronto para envio": "Ready to upload",
  "Pronto! Agora é só colar 🎉": "Done! Just paste it now 🎉",
  "Pronto! Depois disso, sua audiência já passa a aproveitar todas as melhorias": "Done! Your audience can now enjoy all the improvements",
  "Propriedade CSS": "CSS Property",
  "Proteção": "Protection",
  "Proteção Anti-Plágio de VSL": "VSL Anti-Plagiarism Protection",
  "Proteção atualizada": "Protection updated",
  "Proteção criada": "Protection created",
  "Proteção de Acesso": "Access Protection",
  "Proteção de Domínios": "Domain Protection",
  "Proteção Domínios": "Domain Protection",
  "Proteção excluída": "Protection deleted",
  "Proteção por Domínio": "Domain Protection",
  "Proteja suas campanhas e direcione tráfego com inteligência.": "Protect your campaigns and route traffic intelligently.",
  "Prova social no momento da oferta": "Social proof at the offer moment",
  "Provedor": "Provider",
  "Próxima": "Next",
  "Próxima aula": "Next lesson",
  "Próxima Aula": "Next Lesson",
  "Próxima aula em": "Next lesson in",
  "Próxima cobrança": "Next bill",
  "Próxima Renovação": "Next Renewal",
  "Próxima sessão aparecerá daqui a pelo menos": "The next session will appear in at least",
  "Próximas 24h": "Next 24h",
  "Próximas sessões": "Upcoming sessions",
  "Próximo": "Next",
  "Próximo episódio em": "Next episode in",
  "Próximo Pico": "Next Peak",
  "Próximo: Ordem": "Next: Order",
  "Próximo: Tráfego": "Next: Traffic",
  "Proxy/VPN": "Proxy/VPN",
  "Proxy/VPN bloqueado": "Proxy/VPN blocked",
  "Proxy/VPN liberado": "Proxy/VPN allowed",
  "Publicação rápida com domínio próprio ou subdomínio": "Quick publishing with your own domain or a subdomain",
  "Publicados": "Published",
  "Publicar": "Publish",
  "Publicar alterações": "Publish changes",
  "Publicar alterações?": "Publish changes?",
  "Publicar no chat": "Post in chat",
  "Publicar o fluxo?": "Publish the flow?",
  "Publique e Compartilhe": "Publish and Share",
  "Publique o fluxo, copie o Código do fluxo e cole na página onde o player deve aparecer. O rascunho é salvo automaticamente, mas só entra no ar quando você publica. Nas próximas alterações, publique novamente: o código de incorporação continua o mesmo.": "Publish the flow, copy the Flow Code, and paste it on the page where the player should appear. The draft saves automatically but goes live only when published. For later changes, publish again: the embed code stays the same.",
  "Pular": "Skip",
  "Pular →": "Skip →",
  "Pular Dados": "Skip Details",
  "Pular em": "Skip in",
  "Pular em {segundos}s": "Skip in {segundos}s",
  "Pular em {value0}": "Skip in {value0}",
  "Pularam": "Skipped",
  "Pulsar": "Pulse",
  "QR Code baixado!": "QR Code downloaded!",
  "Qua": "Wed",
  "QUA": "WED",
  "QUA • 16h-18h": "WED • 16:00–18:00",
  "QUA • 18h-20h": "WED • 18:00–20:00",
  "Quadro do fluxo": "Flow canvas",
  "Qual o valor das comissões?": "How much are the commissions?",
  "Qual opção combina mais com você?": "Which option suits you best?",
  "Qualidade": "Quality",
  "Qualidade adaptativa": "Adaptive quality",
  "Qualidade dos Leads": "Lead Quality",
  "Qualidade dos Leads (Score)": "Lead Quality (Score)",
  "Qualidade Média": "Average Quality",
  "Qualquer dúvida no caminho, é só chamar. Estamos aqui pra ajudar.": "If you have questions along the way, just reach out. We are here to help.",
  "Qualquer ferramenta que estiver usando esta chave perde o acesso na hora, e não há como reativá-la. Suas outras chaves continuam funcionando.": "Any tool using this key loses access immediately, and it cannot be reactivated. Your other keys keep working.",
  "Quando a headline aparece": "When the headline appears",
  "Quando a headline desaparece": "When the headline disappears",
  "Quando a regra for atendida": "When the rule matches",
  "Quando acessar": "When accessed",
  "Quando atingir": "When reaching",
  "Quando ativado, o vídeo reinicia do início ao clicar": "When enabled, the video restarts from the beginning on click",
  "Quando ativo, o espectador não consegue pausar o vídeo (clique, botão de pause). Funciona com ou sem controles e com autoplay.": "When enabled, viewers cannot pause the video (click or pause button). Works with or without controls and with autoplay.",
  "Quando espectadores avaliarem este vídeo, as respostas aparecerão aqui com nota média, comentários e distribuição das avaliações.": "When viewers rate this video, responses will appear here with the average rating, comments, and rating distribution.",
  "Quando esses dois indicadores estão altos, você tem um vídeo que atrai e mantém a atenção do início ao fim.": "When both indicators are high, you have a video that attracts and maintains attention from start to finish.",
  "Quando exibir": "When to show",
  "Quando exibir o CTA": "When to show the CTA",
  "Quando houver novidades, elas aparecem neste painel.": "Updates appear in this panel when available.",
  "Quando o formulário deve aparecer (formato: mm:ss)": "When the form should appear (format: mm:ss)",
  "Quando o vídeo atingir o tempo definido, ele será pausado automaticamente e a thumbnail de pausa será exibida.": "When the video reaches the set time, it automatically pauses and the pause thumbnail appears.",
  "Quando o vídeo de saída terminar, o player exibe um": "When the exit video ends, the player displays a",
  "Quando o vídeo termina, um card com contagem regressiva conduz o espectador direto pra sua oferta.": "When the video ends, a countdown card guides viewers straight to your offer.",
  "Quando o visitante rola a página e o vídeo sai da tela, ele vira uma caixinha no canto e continua tocando. Ao rolar de volta, o vídeo retorna ao lugar de origem.": "When visitors scroll and the video leaves the screen, it becomes a small floating box in the corner and keeps playing. When they scroll back, the video returns to its original location.",
  "Quando seu vídeo recebe mais interação": "When your video receives more interaction",
  "quando seus plays acabarem": "when your plays run out",
  "Quando tivermos atualizações, elas aparecem nesta tela.": "When updates are available, they appear on this screen.",
  "Quando um vídeo terminar o processamento, você verá aqui e poderá editá-lo.": "When a video finishes processing, you will see it here and can edit it.",
  "Quando você compartilhar um vídeo, ele aparecerá aqui com links e métricas.": "When you share a video, it appears here with links and metrics.",
  "Quantidade de clicks": "Number of clicks",
  "Quantidade de cliques nos botões de chamada para ação. Métrica final de conversão do vídeo.": "Number of clicks on call-to-action buttons. The video's final conversion metric.",
  "Quantidade de conversões registradas a partir deste vídeo.": "Number of conversions recorded from this video.",
  "Quantidade de pessoas diferentes que deram play no vídeo.": "Number of different people who played the video.",
  "Quantidade de pessoas diferentes que visualizaram o vídeo.": "Number of different people who viewed the video.",
  "Quantidade de vezes que o play foi clicado. A relação Plays/Visualizações gera a Taxa de Reprodução.": "Number of times play was clicked. Plays/Views produces the Play Rate.",
  "Quantidade de vezes que o vídeo foi carregado na página.": "Number of times the video loaded on the page.",
  "Quanto do seu vídeo é assistido em média pelos espectadores": "How much of your video viewers watch on average",
  "Quanto tempo em média os espectadores assistem ao seu vídeo": "How long viewers watch your video on average",
  "Quantos horários mostrar ao visitante": "How many time slots to show visitors",
  "Quarta 18-20h caiu 15% vs semana passada": "Wednesday 18:00–20:00 dropped 15% vs last week",
  "Quarta-feira, 16h-18h": "Wednesday, 16:00–18:00",
  "Quatro animações disponíveis: Nenhuma, Fade, Pop e Palavra por palavra": "Four animations available: None, Fade, Pop, and Word by word",
  "Que bom ter você por aqui": "Good to have you here",
  "Que tal adicionar seu primeiro vídeo aqui?": "How about adding your first video here?",
  "Queda": "Drop",
  "Queda acentuada nos primeiros 10-30s = problema no gancho.": "Sharp drop in the first 10–30s = hook problem.",
  "queda de": "drop of",
  "Queda de": "Drop of",
  "Queda em": "Drop at",
  "Quedas acentuadas no início indicam problema no gancho.": "Sharp drops at the start indicate a hook problem.",
  "Quedas suaves são normais. Quedas abruptas indicam problemas de conteúdo ou ritmo.": "Gradual drops are normal. Sudden drops indicate content or pacing issues.",
  "Quem assiste te diz o que mudar na próxima versão.": "Viewers tell you what to change in the next version.",
  "Quem está assistindo às suas VSLs agora, pelo mundo.": "Who is watching your VSLs around the world right now.",
  "Quem Pode Ser Parceiro": "Who Can Become a Partner",
  "Quem tem esta chave consegue ler as métricas dos seus vídeos. Guarde como guardaria uma senha e, se ela vazar, revogue na lista desta tela — a revogação vale na hora e não afeta suas outras chaves.": "Anyone with this key can read your video metrics. Store it like a password and, if it leaks, revoke it in the list on this screen — revocation takes effect immediately and does not affect your other keys.",
  "Quero acessar agora": "I want access now",
  "Quero aproveitar": "I want this offer",
  "QUERO APROVEITAR A OFERTA": "I WANT THIS OFFER",
  "QUERO CONTINUAR": "I WANT TO CONTINUE",
  "Quero Ser Parceiro Host VSL": "I Want to Become a Host VSL Partner",
  "Qui": "Thu",
  "QUI": "THU",
  "QUI • 10h-12h": "THU • 10:00–12:00",
  "QUI • 20h-22h": "THU • 20:00–22:00",
  "Quiz Interativo com FunnelX": "Interactive Quiz with FunnelX",
  "R$ 25/mês": "R$ 25/month",
  "Raio": "Radius",
  "Raio da borda": "Border radius",
  "Raio de Borda (Arredondamento)": "Border Radius (Rounding)",
  "Raio de canto:": "Corner radius:",
  "Raio do card": "Card radius",
  "Raio dos Cantos": "Corner Radius",
  "Ranking de Vídeos": "Video Ranking",
  "Rankings ao vivo: top vídeos, top lugares (com alternância país/estado) e top fontes de tráfego": "Live rankings: top videos, top locations (switch between country/state), and top traffic sources",
  "Rápida": "Fast",
  "Rápido": "Fast",
  "rascunho": "draft",
  "Rascunho": "Draft",
  "Rascunho descartado": "Draft discarded",
  "Rascunho salvo": "Draft saved",
  "Rascunhos": "Drafts",
  "Rastreamento": "Tracking",
  "Rastreamento com Pixel": "Pixel Tracking",
  "Rastreamento configurado": "Tracking configured",
  "Rastreamento de vendas": "Sales tracking",
  "Rastreamento de vendas por plataforma": "Sales tracking by platform",
  "Rastreamento e análise de tráfego para websites e aplicações.": "Traffic tracking and analysis for websites and applications.",
  "Rastreamento e Engajamento": "Tracking & Engagement",
  "Rastreamento parcial": "Partial tracking",
  "Rastreie eventos e integre com plataformas de anúncios.": "Track events and integrate advertising platforms.",
  "Rastreie receita": "Track revenue",
  "Reabrir se não enviado": "Reopen if not submitted",
  "React Query": "React Query",
  "React Renderers:": "React Renderers:",
  "React Version:": "React Version:",
  "Reafirme o benefício principal em múltiplos momentos do vídeo para manter o engajamento constante.": "Reinforce the main benefit at multiple moments in the video to maintain consistent engagement.",
  "Real": "Real",
  "Realize testes com pelo menos 100 visualizações por velocidade": "Run tests with at least 100 views per speed",
  "Reativar": "Reactivate",
  "Reativar plano": "Reactivate plan",
  "Recarga Automática": "Automatic Top-Up",
  "Recarga Automática Ativada": "Automatic Top-Up Enabled",
  "Recarga automática de {value0} plays ativada!": "Automatic top-up of {value0} plays enabled!",
  "Recarregar": "Reload",
  "Recarregar (sem cache)": "Reload (without cache)",
  "Recarregar página": "Reload page",
  "Recarregar Página": "Reload Page",
  "Recarregue a página para tentar de novo.": "Reload the page to try again.",
  "Receba 10% sobre todas as comissões geradas pelos vendedores indicados diretamente por você.": "Receive 10% of all commissions generated by sellers you refer directly.",
  "Receba 20% do valor de cada cliente ativo todos os meses.": "Receive 20% of the value of each active customer every month.",
  "Receba 25% todos os meses enquanto o cliente permanecer ativo na plataforma.": "Receive 25% every month while the customer remains active on the platform.",
  "Receba alertas em tempo real sobre conversões, métricas importantes e atualizações do sistema.": "Receive real-time alerts about conversions, important metrics, and system updates.",
  "Receba alertas quando houver novas conversões nos seus vídeos": "Receive alerts for new conversions on your videos",
  "Receba alertas sobre conversões, métricas e atualizações importantes em tempo real": "Receive real-time alerts about conversions, metrics, and important updates",
  "Receba notificações sobre os melhores horários de visualização": "Receive notifications about the best viewing times",
  "Receba recomendações personalizadas baseadas nos dados de retenção do seu vídeo.": "Receive personalized recommendations based on your video retention data.",
  "Receba seu link exclusivo e indique para sua audiência.": "Get your exclusive link and share it with your audience.",
  "Receba todos os meses enquanto os seus indicados continuarem ativos na plataforma.": "Get paid every month while your referrals remain active on the platform.",
  "Receba um insight automático com leitura rápida do comportamento": "Receive an automatic insight with a quick behavior summary",
  "Receba um insight automático com leitura rápida do comportamento do público": "Receive an automatic insight with a quick summary of audience behavior",
  "Receita": "Revenue",
  "Receita & Conversões (Tracking)": "Revenue & Conversions (Tracking)",
  "Receita atribuída": "Attributed revenue",
  "Receita das compras aprovadas": "Revenue from approved purchases",
  "receita gerada": "revenue Generated",
  "Receita Gerada": "Revenue Generated",
  "Receita total": "Total revenue",
  "Receita Total": "Total Revenue",
  "Receita total gerada a partir de conversões deste vídeo.": "Total revenue generated from conversions on this video.",
  "Receita:": "Revenue:",
  "Recentes": "Recent",
  "Recomeçar": "Restart",
  "Recomeçar após finalizar": "Restart after finishing",
  "Recomeçar o vídeo ao finalizar": "Restart video on end",
  "Recomeçar vídeo após o fim": "Restart video after the end",
  "Recomeçar Vídeo Após o Fim": "Restart video after the end",
  "Recomenda-se um mínimo de 800 plays únicos por variação para resultados estatisticamente significativos": "A minimum of 800 unique plays per variation is recommended for statistically significant results",
  "Recomendações:": "Recommendations:",
  "Recomendado": "Recommended",
  "Recomendado: 400×400 px": "Recommended: 400×400 px",
  "Recomendamos manter opcional.": "We recommend keeping it optional.",
  "Recomendamos usar um tom levemente mais escuro para o hover.": "We recommend a slightly darker shade for hover.",
  "Recomende a nossa plataforma e ganhe": "Recommend our platform and earn",
  "Reconsidere o estilo narrativo": "Reconsider the narrative style",
  "Recorrência desativada": "Recurrence disabled",
  "Recorrência desativada com sucesso!": "Recurrence disabled successfully!",
  "Recorrente": "Recurring",
  "Recuperar Acesso": "Recover Access",
  "Recurso Configurado": "Feature Configured",
  "Recurso desativado!": "Feature disabled!",
  "Recurso Horários — Premium 10/10": "Peak Hours Feature — Premium 10/10",
  "Recursos de Interação": "Interaction Features",
  "Recursos do player": "Player features",
  "Recursos Extras": "Extra Features",
  "Recusar": "Decline",
  "Redesign completo da página Parceiros seguindo PRD premium. Cards com altura fixa 212px, hover scale + blur, skeleton loading, fade-in animation, ícone chevron animado, acessibilidade completa.": "Complete Partners page redesign following the premium PRD. Cards with fixed 212px height, hover scale + blur, skeleton loading, fade-in animation, animated chevron icon, and full accessibility.",
  "Redigite a senha": "Retype Password",
  "Redimensione e reposicione a caixa de autoplay diretamente no player com arraste visual.": "Resize and reposition the autoplay box directly in the player by dragging it.",
  "Redimensione usando os handles nos cantos e laterais": "Resize using the corner and side handles",
  "Redirecionados": "Redirected",
  "Redirecionamento": "Redirect",
  "Redirecionamento Inteligente": "Smart Redirection",
  "Redirecionamentos": "Redirects",
  "Redirecionando para a lista de playlists...": "Redirecting to playlist list...",
  "Redirecionando para configuração de integrações...": "Redirecting to integration settings...",
  "Redirecionando para lista de estratégias...": "Redirecting to strategy list...",
  "Redirecionar automaticamente ao terminar": "Redirect automatically when finished",
  "Redirecionar para vídeo alternativo ou URL": "Redirect to alternative video or URL",
  "Redução de 42% na taxa de abandono nos primeiros 30 segundos": "42% reduction in abandonment in the first 30 seconds",
  "Reduza a introdução": "Shorten the intro",
  "Reduza o tempo até o CTA principal": "Reduce time to the main CTA",
  "Reduzido de {value0} para {value1}": "Reduced from {value0} to {value1}",
  "Reenviar código": "Resend code",
  "Reenviar código em": "Resend code in",
  "Reenviar convite": "Resend invitation",
  "Reenviar Convite": "Resend Invitation",
  "Reenviar convite para": "Resend invitation to",
  "Reexibir no final do vídeo": "Show again at the end of the video",
  "Referência": "Referrer",
  "Referência visual de onde começa o pitch da oferta": "Visual reference for where the offer pitch starts",
  "Reforce a curiosidade": "Reinforce curiosity",
  "Reforce a promessa inicial": "Reinforce the initial promise",
  "Reforce provas sociais antes da oferta": "Reinforce social proof before the offer",
  "Reformulamos o Cloaker da HostVSL, a proteção anti-plágio das suas VSLs. Você decide quem pode assistir ao vídeo original por país, região, origem do tráfego (UTM), dispositivo e bloqueio de VPN/Proxy — e quem não se encaixa nas regras é desviado automaticamente para um vídeo alternativo, sem nunca carregar a sua VSL real. Perfeito pra esconder sua oferta de concorrentes, espiões de anúncios e ferramentas de moderação.": "We redesigned HostVSL Cloaker, the anti-plagiarism protection for your VSLs. You decide who can watch the original video by country, region, traffic source (UTM), device, and VPN/Proxy blocking — anyone who does not match the rules is automatically redirected to an alternative video without loading your real VSL. Perfect for hiding your offer from competitors, ad spies, and moderation tools.",
  "Reformule o gancho inicial": "Rework the initial hook",
  "Refresh Token": "Refresh Token",
  "Regenerar": "Regenerate",
  "Regex inválido": "Invalid regex",
  "Região": "Region",
  "Região não encontrada": "Region not found",
  "Região:": "Region:",
  "Região: {value0}": "Region: {value0}",
  "Região/Estado": "Region/State",
  "Regiões": "REGIONS",
  "REGIÕES": "REGIONS",
  "Regiões ({value0})": "Regions ({value0})",
  "Regiões ainda não cadastradas para este país.": "Regions not yet registered for this country.",
  "Regional": "Regional",
  "Registrando ·": "Recording ·",
  "registro": "record",
  "Registro criado com sucesso!": "Record created successfully!",
  "Registro Encontrado": "Record Found",
  "Registro encontrado!": "Record found!",
  "Registro excluído com sucesso!": "Record deleted successfully!",
  "registro(s)": "record(s)",
  "registros": "records",
  "regra": "rule",
  "REGRA": "RULE",
  "Regra ativa": "Active rule",
  "Regra criada com sucesso": "Rule created successfully",
  "Regra desativada": "Disabled rule",
  "Regra do Cloaker": "Cloaker Rule",
  "Regra salva com sucesso": "Rule saved successfully",
  "Regra UTM": "UTM Rule",
  "Regras ativas": "Active rules",
  "Regras de cloaking": "Cloaking rules",
  "Regras de Operação": "Operating Rules",
  "Regras de UTM": "UTM Rules",
  "Regras e Distribuição de Comissão": "Commission Rules and Distribution",
  "Regras por país e região: libere só onde você vende ou bloqueie onde não quer aparecer": "Country and region rules: allow only where you sell or block where you do not want to appear",
  "Regular": "Regular",
  "Reinicia a sequência de notificações ao chegar ao fim.": "Restarts the notification sequence when it reaches the end.",
  "Reinicia automaticamente após exibir todas.": "Restarts automatically after showing all.",
  "Reinicia em": "Restarts in",
  "Reiniciar preview": "Restart preview",
  "Reiniciar tour": "Restart tour",
  "Reiniciar vídeo": "Restart video",
  "Reinício automático ativado": "Auto restart enabled",
  "Reinício automático desativado": "Auto restart disabled",
  "Relatório enviado com sucesso": "Report sent successfully",
  "Relatórios": "Reports",
  "Relatórios de Captura": "Capture Reports",
  "Remove completamente a interação com os controles do player": "Completely removes interaction with player controls",
  "Remove completamente o player neste dispositivo": "Completely removes the player on this device",
  "Remove distração visual": "Removes visual distraction",
  "Remove from favorites": "Remove from favorites",
  "Remove todos os controles do player": "Removes all player controls",
  "Removendo...": "Removing...",
  "Remover": "Remove",
  "Remover {value0} do gráfico": "Remove {value0} from chart",
  "Remover arquivo?": "Remove file?",
  "Remover cartão": "Remove card",
  "Remover classe": "Remove class",
  "Remover da pasta": "Remove from folder",
  "Remover do teste": "Remove from test",
  "Remover domínio": "Remove domain",
  "Remover domínio?": "Remove domain?",
  "Remover dos favoritos": "Remove from favorites",
  "Remover foto": "Remove photo",
  "Remover foto de perfil": "Remove profile photo",
  "Remover imagem": "Remove image",
  "Remover introdução?": "Remove intro?",
  "Remover legenda": "Remove subtitle",
  "Remover link": "Remove link",
  "Remover logo": "Remove logo",
  "Remover membro": "Remove member",
  "Remover Membro": "Remove Member",
  "Remover opção {value0}": "Remove option {value0}",
  "Remover parâmetro": "Remove parameter",
  "Remover pitch": "Remove pitch",
  "Remover pixel": "Remove pixel",
  "Remover pixel?": "Remove pixel?",
  "Remover plataforma": "Remove platform",
  "Remover seleção": "Clear selection",
  "Remover vídeo da fila?": "Remove video from queue?",
  "Removido chip X vídeos selecionados do título na etapa de seleção de vídeos. Layout mais limpo e minimalista.": "Removed the X selected videos chip from the video selection step title. Cleaner, more minimalist layout.",
  "Removido SectionCard wrapper do preview da barra de progresso para visual mais limpo.": "Removed the SectionCard wrapper from the progress bar preview for a cleaner look.",
  "Renomear": "Rename",
  "Renomear estratégia": "Rename strategy",
  "Renomear fluxo": "Rename flow",
  "Renomear pasta": "Rename folder",
  "Renomear vídeo": "Rename video",
  "Renova em": "Renews on",
  "Renovação": "Renewal",
  "Reordenação por drag-and-drop dos blocos de legenda": "Drag-and-drop reordering of caption blocks",
  "Repaginamos a Proteção Anti-Plágio de VSL: ficou mais simples de configurar e de esconder sua oferta de concorrentes e espiões.": "We redesigned VSL Anti-Plagiarism Protection: it is easier to configure and hide your offer from competitors and spies.",
  "Repassar os parâmetros da página": "Forward page parameters",
  "Repete o trecho automaticamente": "Repeats the segment automatically",
  "Repetir": "Repeat",
  "Repetir em loop": "Repeat in loop",
  "Repetir Vídeo": "Repeat Video",
  "Repetir vídeo (loop)": "Repeat video (loop)",
  "Repita a senha": "Repeat password",
  "Replique o padrão de benefício + detalhe do VSL principal": "Repeat the main VSL's benefit + detail pattern",
  "Reportar problema": "Report a problem",
  "Reprodução automática": "Autoplay",
  "Reprodução Automática": "Autoplay",
  "Reproduções no período": "Plays in the period",
  "Reproduz um som curto junto da notificação.": "Plays a short sound with the notification.",
  "Reproduz um som junto da notificação.": "Plays a sound together with the notification.",
  "Reproduza o vídeo para ver o formulário aparecendo no tempo configurado.": "Play the video to see the form appear at the configured time.",
  "Reproduzindo": "Playing",
  "Reproduzindo...": "Playing...",
  "Reproduzir": "Play",
  "Reproduzir agora": "Play now",
  "Reproduzir automaticamente a próxima aula quando o vídeo terminar": "Automatically play the next lesson when the video ends",
  "Requer que os controles do player estejam habilitados": "Requires player controls to be enabled",
  "Reset": "Reset",
  "Resetar Configurações": "Reset Settings",
  "Resolução recomendada: 1920×700 pixels": "Recommended resolution: 1920×700 pixels",
  "Respeita pausas manuais: só retoma se foi pausado pela função": "Respects manual pauses: resumes only if paused by this feature",
  "Resposta A": "Answer A",
  "Resposta B": "Answer B",
  "Respostas": "Answers",
  "restantes": "remaining",
  "Restaurar padrões": "Restore defaults",
  "Restaurar principais origens": "Restore top sources",
  "Resultado": "Result",
  "Resultados do Teste": "Test Results",
  "Resultados em tempo real das variações de autoplay": "Real-time autoplay variation results",
  "Resultados em tempo real das variações de headline": "Real-time headline variation results",
  "Resultados esperados": "Expected results",
  "Resultados segmentados que aumentam a conversão final": "Segmented results that increase final conversion",
  "RESUME": "RESUME",
  "Resumo": "Summary",
  "Resumo (A vs B)": "Summary (A vs B)",
  "Resumo da proteção": "Protection summary",
  "Resumo de desempenho desta URL no período selecionado.": "Performance summary for this URL in the selected period.",
  "Resumo de métricas consolidado: {value0} dias processados.": "Metrics summary consolidated: {value0} days processed.",
  "Resumo do desempenho no período": "Performance summary for the period",
  "Resumo Geral": "Overview",
  "Retangular": "Rectangular",
  "Retângulo": "Rectangle",
  "Retém usuários que saíram do vídeo": "Retains users who left the video",
  "retenção": "retention",
  "Retenção": "Retention",
  "Retenção (%)": "Retention (%)",
  "Retenção & Tempo": "Retention & Time",
  "Retenção & Tempo de Exibição": "Retention & Watch Time",
  "Retenção ao longo do tempo": "Retention over time",
  "Retenção ao Longo do Tempo": "Retention Over Time",
  "Retenção ao Longo do Vídeo": "Retention Throughout the Video",
  "Retenção de Audiência": "Audience Retention",
  "Retenção Ideal": "Ideal Retention",
  "Retenção média": "Average retention",
  "Retenção Média": "Average Retention",
  "Retenção média hoje": "Average retention today",
  "Retenção mostra quantas pessoas continuam assistindo ao vídeo ao longo do tempo.": "Retention shows how many people keep watching the video over time.",
  "Retenção no momento": "Retention at this moment",
  "Retenção no momento chave": "Retention at the key moment",
  "Retenção no pitch": "Retention at pitch",
  "Retenção no Pitch": "Retention at Pitch",
  "Retenção no Vídeo": "Video Retention",
  "Retenção Pitch": "Pitch Retention",
  "Retenção por Vídeo": "Retention by Video",
  "Retenção próximo ao pitch": "Retention near the pitch",
  "Retenção:": "Retention:",
  "Retirada Mínima Permitida": "Minimum Allowed Withdrawal",
  "Retoma o vídeo de onde o usuário parou.": "Resumes the video where the user stopped.",
  "Retomada automática": "Auto resume",
  "Retomada instantânea ao voltar, sem precisar clicar em nada": "Instant resume on return, without clicking anything",
  "Retomar": "Resume",
  "Retomar fluxo": "Resume flow",
  "Retomar reprodução": "Resume playback",
  "Retorno automático ao segundo 0:00 ao término do vídeo": "Automatically returns to 0:00 when the video ends",
  "Retroceder": "Rewind",
  "Retroceder 10s": "Rewind",
  "Return to Home": "Return to Home",
  "Revise a etapa atual antes de iniciar o teste.": "Review the current step before starting the test.",
  "Revise seus últimos 5-10 testes para identificar padrões comuns nos vencedores.": "Review your last 5–10 tests to identify common patterns among winners.",
  "Revogada": "Revoked",
  "Revogar": "Revoke",
  "Revogar \"": "Revoke \"",
  "Revogar a chave {value0}": "Revoke key {value0}",
  "Revogar chave": "Revoke key",
  "Rio de Janeiro": "Rio de Janeiro",
  "Ritmo dinâmico": "Dynamic pacing",
  "Roboto": "Roboto",
  "Roboto (Clean)": "Roboto (Clean)",
  "Rodapé": "Footer",
  "Role para baixo e toque em \"Adicionar à Tela de Início\"": "Scroll down and tap \"Add to Home Screen\"",
  "Role para ver mais faturas": "Scroll to see more invoices",
  "Role para ver todas as faturas": "Scroll to see all invoices",
  "Rota": "Route",
  "rotas •": "routes •",
  "Rotas e Navegação": "Routes and Navigation",
  "Rotas Protegidas": "Protected Routes",
  "Rótulo (Label) da conversão de checkout": "Checkout conversion Label",
  "Rótulo (Label) da conversão de play": "Play conversion Label",
  "Rótulo (Label) da conversão do pitch": "Pitch conversion Label",
  "Rótulo da ação \"Checkout\" (opcional)": "\"Checkout\" action Label (optional)",
  "Rótulo da ação \"Pitch\" (opcional)": "\"Pitch\" action Label (optional)",
  "Rótulo da ação \"Play\" *": "\"Play\" action Label *",
  "Rótulo do campo": "Field label",
  "Routing": "Routing",
  "Rua, Avenida, Número e Complemento": "Street, Avenue, Number, and Additional Address Details",
  "Ruim": "Poor",
  "s após abertura": "s after opening",
  "s do Pitch": "s from Pitch",
  "s do vídeo": "s of video",
  "s restantes": "s remaining",
  "Sáb": "Sat",
  "SÁB": "SAT",
  "Sábado": "Saturday",
  "Safari": "Safari",
  "Saiba mais": "Learn more",
  "Saiba Mais": "Learn More",
  "Saiba mais:": "Learn more:",
  "saída": "exit",
  "Saída": "Exit",
  "SAÍDA": "EXIT",
  "Saída · {value0}": "Exit · {value0}",
  "Saída de checkout": "Checkout exit",
  "Saída removida": "Exit removed",
  "Saída sem nome": "Unnamed exit",
  "saídas": "exits",
  "Sair": "Logout",
  "Sair da tela cheia": "Exit full screen",
  "Sair do modo foco": "Exit focus mode",
  "Sair do modo foco (Esc)": "Exit focus mode (Esc)",
  "Sala do Webinário": "Webinar Room",
  "Saldo insuficiente para saque (Mínimo R$ 100,00).": "Insufficient balance for withdrawal (Minimum R$ 100,00).",
  "Salva o progresso do espectador automaticamente": "Automatically saves viewer progress",
  "Salvando...": "Saving...",
  "Salvando…": "Saving…",
  "Salvar": "Save",
  "SALVAR": "SAVE",
  "Salvar / Publicar": "Save / Publish",
  "Salvar & Continuar": "Save & Continue",
  "Salvar Ação": "Save Action",
  "Salvar alteração": "Save change",
  "Salvar alterações": "Save changes",
  "Salvar Alterações": "Save Changes",
  "Salvar Configuração": "Save Configuration",
  "Salvar Configurações": "Save Settings",
  "Salvar Distribuição": "Save Distribution",
  "Salvar e Ativar": "Save and Activate",
  "Salvar e copiar código": "Save and copy code",
  "Salvar e Fechar": "Save and Close",
  "Salvar e Sincronizar": "Save and Sync",
  "Salvar Informações": "Save Information",
  "Salvar Método de Recebimento": "Save Payout Method",
  "Salvar nome": "Save name",
  "Salvar nova senha": "Save new password",
  "Salvar Playlist": "Save Playlist",
  "Salvar proteção": "Save protection",
  "Salvar rascunho": "Save draft",
  "Salvar Teste": "Save Test",
  "Salvar todas as configurações no banco de dados": "Save all settings to the database",
  "Salvar Tracking": "Save Tracking",
  "Salvar tudo": "Save All",
  "Salvar Tudo": "Save All",
  "Salve o tracking para liberar a URL": "Save tracking to unlock the URL",
  "Salve o vídeo antes de adicionar imagens aos mini-hooks.": "Save the video before adding images to mini-hooks.",
  "Salve o vídeo para visualizar as métricas de feedback.": "Save the video to view feedback metrics.",
  "Salve suas alterações e depois copie o código para colar na sua página de vendas.": "Save your changes, then copy the code to paste on your sales page.",
  "Salvo": "Saved",
  "Sans-serif": "Sans-serif",
  "São Paulo": "São Paulo",
  "São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Salvador": "São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Salvador",
  "Saque": "Withdrawal",
  "Saque solicitado com sucesso!": "Withdrawal requested successfully!",
  "Saques": "Withdrawals",
  "Saques mínimos autorizados a partir de": "Minimum authorized withdrawals from",
  "Satisfação": "Satisfaction",
  "Saúde & Velocidade": "Health & Speed",
  "Saúde do Pitch": "Pitch Health",
  "Saúde do Player & Velocidade": "Player Health & Speed",
  "Score de Engajamento": "Engagement Score",
  "Scripts não são permitidos por segurança.": "Scripts are not allowed for security reasons.",
  "Se": "If",
  "Se configurado na etapa \"Vendas\"": "If configured in the \"Sales\" step",
  "Se não concordar, você pode recusar e nada será adicionado.": "If you disagree, you can decline and nothing will be added.",
  "Se o campo \"Final\" estiver vazio, o botão será exibido até o final do vídeo.": "If the \"End\" field is empty, the button appears until the video ends.",
  "Se o usuário recarregar a página sem enviar, mostrar novamente": "Show again if the user reloads without submitting",
  "Se o vídeo estiver dentro de um iframe, a página inteira é trocada.": "If the video is inside an iframe, the entire page is replaced.",
  "Se preenchido, redireciona para esta URL em vez do vídeo alternativo": "If filled in, redirects to this URL instead of the alternative video",
  "Se vazio, será exibido o nome da playlist": "If empty, the playlist name appears",
  "Se você adicionar o connector numa organização do Claude (planos Team ou Enterprise), a chave passa a ser compartilhada por toda a equipe — todos os membros verão as métricas da conta HostVSL de quem a cadastrou.": "If you add the connector to a Claude organization (Team or Enterprise plans), the key is shared across the team — all members will see metrics from the HostVSL account of the person who registered it.",
  "Se você não concordar, clique em": "If you disagree, click",
  "Seção de Bônus": "Bonus Section",
  "Seção de Módulos": "Module Section",
  "Seção de Picos de Horários integrada": "Integrated Peak Hours section",
  "seg": "mon",
  "Seg": "Mon",
  "SEG": "MON",
  "SEG • 08h-10h": "MON • 08:00–10:00",
  "SEG • 18h-20h": "MON • 18:00–20:00",
  "Segmentação por Fonte:": "Segmentation by Source:",
  "Segmentado (Pills)": "Segmented (Pills)",
  "Segunda opção": "Second option",
  "segundo": "second",
  "Segundo Botão (Opcional)": "Second Button (Optional)",
  "Segundo melhor momento": "Second-best time",
  "segundos": "seconds",
  "Segundos": "seconds",
  "Segurança": "Security",
  "SEGURANÇA": "SECURITY",
  "Segurança Avançada": "Advanced Security",
  "Seguro": "Secure",
  "Seja notificado quando suas métricas atingirem marcos importantes": "Get notified when your metrics reach important milestones",
  "Seleção de pastas em desenvolvimento": "Folder selection in development",
  "Seleção de vídeos": "Video selection",
  "Seleção de vídeos com badge ordem": "Video selection with order badge",
  "Seleção de vídeos em desenvolvimento": "Video selection in development",
  "Seleção intros com badge ordem": "Intro selection with order badge",
  "selecionadas)": "selected)",
  "selecionado": "selected",
  "Selecionado": "Selected",
  "Selecionado:": "Selected:",
  "selecionados": "selected",
  "Selecionando...": "Selecting...",
  "Selecionar": "Select",
  "Selecionar Arquivo": "Select File",
  "Selecionar Cartão": "Select Card",
  "Selecionar cor {value0}": "Select color {value0}",
  "Selecionar data": "Select date",
  "Selecionar Evento": "Select Event",
  "Selecionar idioma": "Select language",
  "Selecionar Imagem": "Select Image",
  "Selecionar Introdução": "Select Intro",
  "Selecionar manualmente": "Select manually",
  "Selecionar Modelo": "Select Template",
  "Selecionar período": "Select period",
  "Selecionar plano": "Select plan",
  "Selecionar template": "Select template",
  "Selecionar Tipo de Pixel": "Select Pixel Type",
  "Selecionar todos": "Select all",
  "Selecionar vídeo": "Select video",
  "Selecionar Vídeo": "Select Video",
  "Selecionar vídeo *": "Select video *",
  "Selecionar Vídeo *": "Select Video *",
  "Selecionar Vídeo Alternativo": "Select Alternative Video",
  "Selecionar Vídeo da Biblioteca": "Select Library Video",
  "Selecionar vídeo de entrada": "Select entry video",
  "Selecionar vídeo de saída": "Select exit video",
  "Selecionar Vídeo Original": "Select Original Video",
  "Selecionar Vídeo para Análise": "Select Video to Analyze",
  "Selecionar vídeo para comparação": "Select video to compare",
  "Selecionar Vídeo para Personalizar": "Select Video to Customize",
  "Selecionar Vídeo Principal": "Select Main Video",
  "Selecionar vídeos": "Select videos",
  "Selecionar vídeos para upload": "Select videos to upload",
  "Selecionar VSL": "Select VSL",
  "Selecione": "Select",
  "Selecione a data": "Select the date",
  "Selecione a modalidade": "Select the mode",
  "Selecione a parte da VSL sem a introdução. Assim, você poderá testar diferentes começos.": "Select the VSL segment without the intro so you can test different openings.",
  "Selecione a plataforma": "Select the platform",
  "Selecione a plataforma e informe o token, ou desative o rastreamento": "Select the platform and enter its token, or disable tracking",
  "Selecione a posição": "Select position",
  "Selecione a prioridade": "Select the priority",
  "Selecione a região": "Select the region",
  "Selecione a velocidade desejada": "Select the desired speed",
  "Selecione a velocidade desejada do seu vídeo": "Select your video's desired speed",
  "Selecione a VSL que será protegida.": "Select the VSL to protect.",
  "Selecione apenas arquivos de vídeo": "Select only video files",
  "Selecione arquivos de imagem nítidos da sua CNH ou RG (Formatos aceitos: PNG ou JPEG).": "Select clear image files of your driver's license or ID (Accepted formats: PNG or JPEG).",
  "Selecione as velocidades que deseja testar. Recomendamos testar pelo menos 2 velocidades diferentes para comparar os resultados.": "Select the speeds to test. We recommend at least 2 different speeds to compare results.",
  "Selecione de 2 a 6 vídeos diferentes para comparar o desempenho em tempo real.": "Select 2 to 6 different videos to compare performance in real time.",
  "Selecione diferentes introduções (hooks) para comparar o desempenho em tempo real.": "Select different intros (hooks) to compare performance in real time.",
  "Selecione no máximo 6 vídeos para o teste": "Select at most 6 videos for the test",
  "Selecione o comportamento": "Select the behavior",
  "Selecione o fuso horário": "Select the time zone",
  "Selecione o layout ideal para o seu conteúdo": "Select the ideal layout for your content",
  "Selecione o operador": "Select the operator",
  "Selecione o país": "Select the country",
  "Selecione o parâmetro": "Select the parameter",
  "Selecione o período.": "Select the period.",
  "Selecione o seu banco": "Select your bank",
  "Selecione o tamanho": "Select size",
  "Selecione o tráfego dos vídeos": "Select video traffic",
  "Selecione o vídeo": "Select Video",
  "Selecione o Vídeo": "Select Video",
  "Selecione o vídeo alternativo para acessos bloqueados.": "Select the alternative video for blocked visitors.",
  "Selecione o vídeo e informe a chave da plataforma para receber conversões.": "Select the video and enter the platform key to receive conversions.",
  "Selecione o vídeo onde a captura será exibida": "Select the video where the capture appears",
  "Selecione o vídeo original": "Select original video",
  "Selecione o vídeo para a captura": "Select the video for capture",
  "Selecione o vídeo que deseja adicionar ao slot": "Select the video to add to the slot",
  "Selecione os Vídeos": "Select Videos",
  "Selecione os vídeos de teste": "Select test videos",
  "Selecione os vídeos para teste (min. 2, máx. 6)": "Select test videos (min. 2, max. 6)",
  "Selecione os vídeos que deseja adicionar à playlist": "Select the videos to add to the playlist",
  "Selecione os vídeos que participarão do teste A/B": "Select videos for the A/B test",
  "Selecione os vídeos que receberão as configurações do vídeo atual.": "Select the videos that will receive the current video's settings.",
  "Selecione ou arraste os arquivos de vídeo para importar na sua biblioteca.": "Select or drag video files to import into your library.",
  "Selecione pelo menos 2 modelos para iniciar o teste": "Select at least 2 templates to start the test",
  "Selecione pelo menos 2 velocidades para realizar um teste comparativo.": "Select at least 2 speeds for a comparison test.",
  "Selecione pelo menos 2 vídeos para o teste": "Select at least 2 videos for the test",
  "Selecione pelo menos um vídeo": "Select at least one video",
  "Selecione pelo menos uma intro para continuar": "Select at least one intro to continue",
  "Selecione pelo menos uma playlist": "Select at least one playlist",
  "Selecione um país": "Select a country",
  "Selecione um país para configurar regiões": "Select a country to configure regions",
  "Selecione um período": "Select a date range",
  "Selecione um plano para continuar": "Select a plan to continue",
  "Selecione um template para a tela de retorno": "Pick a template for the resume screen",
  "Selecione um teste para visualizar as métricas.": "Select a test to view metrics.",
  "Selecione um vídeo": "Select a video",
  "Selecione um vídeo *": "Select a video *",
  "Selecione um vídeo alternativo ou URL": "Select an alternative video or URL",
  "Selecione um vídeo base para continuar": "Select a base video to continue",
  "Selecione um vídeo da biblioteca": "Select a video from the library",
  "Selecione um vídeo da biblioteca ou faça upload de um novo": "Select a library video or upload a new one",
  "Selecione um vídeo da sua biblioteca ou faça upload de um novo": "Select a video from your library or upload a new one",
  "Selecione um vídeo da sua biblioteca para começar a personalizar e configurar seus recursos.": "Select a video from your library to start customizing and configuring features.",
  "Selecione um vídeo diferente.": "Select a different video.",
  "Selecione um vídeo e pelo menos um campo para captura (Nome, E-mail ou WhatsApp).": "Select a video and at least one capture field (Name, Email, or WhatsApp).",
  "Selecione um vídeo e um período com visualizações para ver o funil de conversão.": "Select a video and a period with views to see the conversion funnel.",
  "Selecione um vídeo para acessar os recursos de personalização.": "Select a video to access customization features.",
  "Selecione um vídeo para começar a personalizar": "Select a video to start customizing",
  "Selecione um vídeo para continuar.": "Select a video to continue.",
  "Selecione um vídeo para personalizar": "Select a video to customize",
  "Selecione um vídeo para personalizar...": "Select a video to customize...",
  "Selecione um vídeo para ver as métricas": "Select a video to see metrics",
  "Selecione um vídeo para visualizar a captura": "Select a video to view the capture",
  "Selecione um vídeo para visualizar o preview": "Select a video to see the preview",
  "Selecione um vídeo para visualizar os dados de resultado.": "Select a video to view results data.",
  "Selecione um vídeo para visualizar os horários de pico.": "Select a video to view peak hours.",
  "Selecione um vídeo.": "Select a video.",
  "Selecione um vídeo...": "Select a video...",
  "Selecione um webinário": "Select a webinar",
  "Selecione uma animação": "Select an animation",
  "Selecione uma aula": "Select a lesson",
  "Selecione uma aula para começar": "Select a lesson to get started",
  "Selecione uma aula para ver a descrição.": "Select a lesson to see its description.",
  "Selecione uma avaliação": "Select a rating",
  "Selecione uma etapa ou saída no quadro para editar.": "Select a step or exit on the canvas to edit.",
  "Selecione uma pasta": "Select a folder",
  "Selecione uma permissão": "Select a permission",
  "Selecione uma plataforma": "Select a platform",
  "Selecione uma região": "Select a region",
  "Selecione uma solicitação.": "Select a request.",
  "Selecione vídeos da sua conta Google Drive.": "Select videos from your Google Drive account.",
  "Selecione...": "Select...",
  "Seletor": "Selector",
  "Seletor copiado!": "Selector copied!",
  "Seletor CSS *": "CSS Selector *",
  "Seletor de cor personalizado": "Custom color picker",
  "Seletor de período": "Period picker",
  "Seletor de templates": "Template picker",
  "Seletor de vídeo premium": "Premium video picker",
  "Selos de Confiança": "Trust Badges",
  "Sem acesso": "No access",
  "Sem animação": "No animation",
  "Sem arredondamento (0px)": "No rounding (0px)",
  "Sem Borda": "No Border",
  "Sem conexão com o servidor.": "No connection to the server.",
  "Sem conversões": "No conversions",
  "Sem conversões ainda": "No conversions yet",
  "Sem dados": "No data",
  "Sem dados ao vivo": "No live data",
  "Sem dados de {value0} no período": "No {value0} data in this period",
  "Sem dados de dispositivos disponíveis": "No device data available",
  "Sem dados de horários no período": "No time data in this period",
  "Sem dados de performance": "No performance data",
  "Sem dados de referência no período": "No referrer data in this period",
  "Sem dados de retenção": "No retention data",
  "Sem dados de retenção no período": "No retention data in period",
  "Sem dados de retenção no período selecionado.": "No retention data in the selected period.",
  "Sem dados de UTM no período": "No UTM data in period",
  "Sem dados disponíveis": "No data available",
  "Sem dados no período.": "No data in this period.",
  "Sem dados para exibir": "No data to display",
  "Sem dados para mostrar": "No data to show",
  "Sem dados suficientes": "Not enough data",
  "Sem dados suficientes para exibir": "Not enough data to display",
  "sem destino": "no destination",
  "sem edição": "no editing",
  "Sem engajamento ainda": "No engagement yet",
  "Sem etapa": "No step",
  "Sem eventos": "No events",
  "Sem Eventos": "No events",
  "Sem fundo visível": "No visible background",
  "Sem http:// — vamos salvar como https://{url}": "No http:// — it will be saved as https://{url}",
  "Sem Leads ainda": "No Leads yet",
  "Sem métricas ainda": "No metrics yet",
  "Sem nome": "Unnamed",
  "Sem nome (apenas imagem)": "Unnamed (image only)",
  "Sem nome da proteção": "No protection name",
  "Sem Pasta": "No Folder",
  "Sem pergunta": "No question",
  "Sem permissão": "No permission",
  "Sem permissão para adicionar pixels": "No permission to add pixels",
  "Sem permissão para adicionar vídeos": "No permission to add videos",
  "Sem permissão para compartilhar vídeos": "No permission to share videos",
  "Sem permissão para criar pastas": "No permission to create folders",
  "Sem permissão para criar regras UTM": "No permission to create UTM rules",
  "Sem permissão para criar Teste de hook": "No permission to create Hook Tests",
  "Sem permissão para criar testes A/B": "No permission to create A/B tests",
  "Sem permissão para criar testes de Hook": "No permission to create Hook tests",
  "Sem permissão para criar testes de velocidade": "No permission to create speed tests",
  "Sem permissão para editar ações de sincronização": "No permission to edit sync actions",
  "Sem permissão para editar pitches": "No permission to edit pitches",
  "Sem permissão para editar pixels": "No permission to edit pixels",
  "Sem permissão para editar regras do Cloaker": "No permission to edit Cloaker rules",
  "Sem permissão para editar regras geográficas": "No permission to edit geographic rules",
  "Sem permissão para editar testes A/B": "No permission to edit A/B tests",
  "Sem permissão para excluir pastas": "No permission to delete folders",
  "Sem permissão para excluir vídeos": "No permission to delete videos",
  "Sem permissão para finalizar testes A/B": "No permission to finish A/B tests",
  "Sem permissão para remover pixels": "No permission to remove pixels",
  "Sem permissão para renomear pastas": "No permission to rename folders",
  "Sem permissão para renomear vídeos": "No permission to rename videos",
  "Sem Plano": "No Plan",
  "Sem plano ativo": "No active plan",
  "Sem plataforma": "No platform",
  "Sem plugins complexos": "No complex plugins",
  "Sem redistribuição": "No redistribution",
  "Sem regras UTM": "No UTM rules",
  "Sem replay automático se o Autoplay estiver desativado": "No automatic replay if Autoplay is disabled",
  "Sem término (manual)": "No end date (manual)",
  "Sem texto": "No text",
  "Sem thumb": "No thumbnail",
  "Sem uma URL de redirecionamento válida o botão não aparece para o espectador.": "Without a valid redirect URL the button is not shown to the viewer.",
  "Sem vídeo": "No video",
  "Sem vídeo alternativo": "No alternative video",
  "Sem visualizações no período selecionado": "No views in the selected period",
  "Sem VSL protegida": "No protected VSL",
  "sem window": "no window",
  "Semanal": "Weekly",
  "Semi Bold": "Semi Bold",
  "Semi-negrito": "Semibold",
  "Sempre que pausar": "Whenever paused",
  "Sempre uma próxima sessão em poucos minutos": "Always a new session in a few minutes",
  "Sempre visível": "Always visible",
  "senha": "password",
  "Senha": "Password",
  "Senha (": "Password (",
  "Senha *": "Password *",
  "Senha Alterada": "Password Changed",
  "Senha alterada com sucesso": "Password changed successfully",
  "Senha alterada com sucesso! Faça login com sua nova senha.": "Password changed successfully! Sign in with your new password.",
  "Senha Atual": "Current Password",
  "Senha atual é obrigatória": "Current password is required",
  "Senha atual incorreta": "Incorrect current password",
  "Senha de Acesso": "Access Password",
  "Senha Definida *": "Defined Password *",
  "Senha deve ter pelo menos 8 caracteres": "Password must be at least 8 characters",
  "Senha deve ter pelo menos 8 caracteres.": "Password must have at least 8 characters.",
  "Senha do cliente": "Customer password",
  "Senha incorreta. Tente novamente.": "Incorrect password. Please try again.",
  "Separe as cidades por vírgula.": "Separate cities with commas.",
  "Separe múltiplos domínios por vírgula": "Separate multiple domains with commas",
  "Separe os nomes por vírgula.": "Separate names with commas.",
  "Será criada automaticamente no mesmo dia a cada mês": "Will be created automatically on the same day each month",
  "Seria": "Would be",
  "Seria:": "Would be:",
  "Serviço": "Service",
  "Sessão": "Session",
  "Sessão Agendada": "Scheduled Session",
  "Sessão atualizada hoje": "Session updated today",
  "Sessões com saída de checkout": "Sessions with checkout exit",
  "Seu arquivo excede 2GB. Envie um arquivo menor.": "Your file exceeds 2GB. Upload a smaller file.",
  "Seu cartão está vencido.": "Your card has expired.",
  "Seu cartão foi recusado, tente novamente.": "Your card was declined. Please try again.",
  "Seu cartão não possui saldo suficiente.": "Your card has insufficient funds.",
  "Seu conteúdo está performando razoavelmente bem, mas há espaço para melhorias. Um bom equilíbrio entre taxa de reprodução e engajamento é essencial - lembre-se que não adianta ter muitos cliques se as pessoas não assistem o vídeo até o final.": "Your content is performing reasonably well, but there is room for improvement. A good balance between play rate and engagement is essential — remember, many clicks do not help if people do not watch the video to the end.",
  "Seu HTML aparecerá aqui": "Your HTML will appear here",
  "Seu HTML aqui": "Your HTML here",
  "Seu link de afiliado": "Your affiliate link",
  "Seu link de indicação estará sempre ativo, nunca expira.": "Your referral link stays active forever and never expires.",
  "Seu maior ponto de queda está antes do pitch. Considere antecipar a proposta de valor ou adicionar um gancho mais forte nos primeiros 15 minutos.": "Your largest drop-off occurs before the pitch. Consider presenting the value proposition earlier or adding a stronger hook in the first 15 minutes.",
  "Seu navegador não suporta a reprodução de vídeo.": "Your browser does not support video playback.",
  "Seu navegador não suporta notificações push ou o recurso está desabilitado.": "Your browser does not support push notifications or the feature is disabled.",
  "Seu navegador não suporta notificações push. Utilize Chrome, Firefox ou Safari para ativar este recurso.": "Your browser does not support push notifications. Use Chrome, Firefox, or Safari to enable this feature.",
  "Seu navegador não suporta vídeos.": "Your browser does not support videos.",
  "Seu nome": "Your name",
  "Seu pitch está performando muito bem!": "Your pitch is performing very well!",
  "Seu pitch ocorre quando": "Your pitch occurs when",
  "Seu pitch ocorre quando apenas": "Your pitch occurs when only",
  "Seu preço hoje: R$ 99": "Your price today: R$ 99",
  "Seu progresso foi salvo automaticamente.": "Your progress was saved automatically.",
  "Seu progresso foi salvo.": "Your progress was saved.",
  "Seu público hoje": "Your audience today",
  "Seu teste \"{value0}\" foi criado e está pronto para uso.": "Your test \"{value0}\" was created and is ready to use.",
  "Seu teste A/B está ativo": "Your A/B test is active",
  "Seu teste A/B está ativo e coletando dados.": "Your A/B test is active and collecting data.",
  "Seu teste de introduções está ativo": "Your hook test is active",
  "Seu teste de introduções está ativo e coletando dados.": "Your intro test is active and collecting data.",
  "Seu teste de intros foi finalizado com sucesso.": "Your intro test was finished successfully.",
  "Seu time trabalhando junto, cada um no seu lugar.": "Your team working together, each in their own space.",
  "Seu vídeo está sendo processado…": "Your video is processing…",
  "Seu vídeo já começou": "Your video has started",
  "seu-link": "your-link",
  "Seus arquivos de identificación (frente e verso) foram enviados e aprovados com sucesso pelo setor de validação da Stripe Connect. Nenhuma ação adicional é requerida neste bloco.": "Your identification files (front and back) were uploaded and approved by the Stripe Connect validation team. No further action is required in this block.",
  "Seus dados estão seguros conosco.": "Your data is safe with us.",
  "Seus dados serão mantidos por 30 dias": "Your data will be kept for 30 days",
  "Seus melhores horários": "Your best times",
  "Seus Melhores Horários desta Semana": "Your Best Times This Week",
  "Seus Testes A/B": "Your A/B Tests",
  "Seus testes A/B são mais eficazes quando você entende como interpretar os dados corretamente:": "Your A/B tests are more effective when you understand how to interpret the data correctly:",
  "Seus Testes de Introduções": "Your Hook Tests",
  "Seus vídeos não serão mais exibidos": "Your videos will no longer be displayed",
  "seusite.com": "yoursite.com",
  "Sex": "Fri",
  "SEX": "FRI",
  "SEX • 14h-16h": "FRI • 14:00–16:00",
  "SEX • 18h-20h": "FRI • 18:00–20:00",
  "Sexta 14-16h subiu 22% vs semana passada": "Friday 14:00–16:00 rose 22% vs last week",
  "Sidebar — Nova Aba Parceiros": "Sidebar — New Partners Tab",
  "Sidebar — Posicionamento Fixo": "Sidebar — Fixed Position",
  "Sidebar de recursos do vídeo": "Video features sidebar",
  "Sidebar desktop com position fixed para estabilidade, main content com margin-left compensatório. Layout Apple-like.": "Desktop sidebar with fixed positioning for stability; main content with compensating margin-left. Apple-like layout.",
  "Siga estes passos para instalar no Safari": "Follow these steps to install in Safari",
  "Silenciar": "Mute",
  "Silencioso": "Silent",
  "Sim": "Yes",
  "Sim ou Não": "Yes or No",
  "SIM, ADICIONAR AO MEU PEDIDO": "YES, ADD TO MY ORDER",
  "SIM, EU QUERO": "YES, I WANT IT",
  "Sim, excluir teste": "Yes, delete test",
  "Sim, finalizar teste": "Yes, finish test",
  "SIM, QUERO ADICIONAR": "YES, I WANT TO ADD IT",
  "SIM, QUERO APROVEITAR": "YES, I WANT THIS OFFER",
  "Sim! Como parceiro, você pode oferecer vantagens exclusivas aos seus indicados, como bônus especiais e materiais complementares.": "Yes! As a partner, you can offer exclusive benefits to referrals, such as special bonuses and additional materials.",
  "Sim! O programa aceita tanto pessoas físicas quanto jurídicas. Basta ter uma conta bancária ou chave PIX para receber os pagamentos.": "Yes! The program accepts both individuals and companies. You only need a bank account or PIX key to receive payments.",
  "Simulação de Audiência": "Audience Simulation",
  "Simulação de Ganhos": "Earnings Simulation",
  "Simulação do card no final do vídeo": "Card simulation at the end of the video",
  "Simulada": "Simulated",
  "Simular 10s": "Simulate 10s",
  "Simular 3s": "Simulate 3s",
  "Simular Localização": "Simulate Location",
  "Simular visualização": "Simulate view",
  "Simule como a regra se comportaria:": "Simulate how the rule would behave:",
  "Sincronização com AWS concluída!": "AWS sync complete!",
  "Sincronização com o Vídeo": "Video Synchronization",
  "Sincronizar com Horário": "Sync with Time",
  "Sincronizar Métricas": "Sync Metrics",
  "Sincronizar Vídeo com Horário": "Sync Video with Time",
  "Sistema de Documentação Dinâmica": "Dynamic Documentation System",
  "Sistema de Pastas e Subpastas": "Folder and Subfolder System",
  "Sistema de webinars": "Webinar system",
  "Sistema Pré-pago": "Prepaid System",
  "Site URL": "Site URL",
  "Skeleton loading de parceiro": "Partner skeleton loading",
  "Slide": "Slide",
  "Slide de baixo": "Slide from bottom",
  "Slide direito": "Slide right",
  "Smart Autoplay": "Smart Autoplay",
  "Smart TV": "Smart TV",
  "Só o botão. É o comportamento clássico.": "Just the button. The classic behavior.",
  "Só você vê esse nome.": "Only you see this name.",
  "Sobre a reprodução automática:": "About autoplay:",
  "Sobre esta aula": "About this lesson",
  "Sobre o vídeo": "About the video",
  "Sobre o Vídeo": "About the Video",
  "sobre os planos ativados pelos clientes que você indicar.": "on plans activated by the customers you refer.",
  "Sobrenome": "Last Name",
  "Sobrenome Completo": "Full Last Name",
  "Sobrepor no vídeo": "Overlay on video",
  "Sobreposições de Conteúdo": "Content Overlays",
  "Sobrescrever com a minha": "Overwrite with mine",
  "Sócio gerente": "Managing partner",
  "Solicitações de Pagamento": "Payment Requests",
  "Solicitações Pendentes": "Pending Requests",
  "Solicitado": "Requested",
  "Solicitado em": "Requested on",
  "Solicitar nome": "Request name",
  "Solicitar nome e e-mail": "Request name and email",
  "Solicitar nome, e-mail e WhatsApp": "Request name, email, and WhatsApp",
  "Solicitar Saque Imediato ›": "Request Immediate Withdrawal ›",
  "Sólido": "Solid",
  "Soltar aqui": "Drop here",
  "Solte arquivos aqui, cole, navegue ou importe de": "Drop files here, paste, browse, or import from",
  "Solte para enviar": "Drop to upload",
  "Solte seu vídeo aqui,": "Drop your video here,",
  "Som": "Sound",
  "Som de alerta": "Alert sound",
  "Sombra": "Shadow",
  "Sombra de dropdowns": "Dropdown shadow",
  "Sombra de tooltips": "Tooltip shadow",
  "Sombra durante drag": "Shadow while dragging",
  "Sombra no texto": "Text shadow",
  "Sombra nos cards": "Card shadows",
  "Sombra padrão de cards": "Default card shadow",
  "Sombras": "Shadows",
  "Somente hoje": "Today only",
  "Source Sans Pro (Technical)": "Source Sans Pro (Technical)",
  "Spark Points": "Spark Points",
  "src/components/": "src/components/",
  "Stack Trace:": "Stack Trace:",
  "Start time must be non-negative": "Start time must be non-negative",
  "Start time too large": "Start time too large",
  "State Management": "State Management",
  "Status": "Status",
  "Status atual": "Current status",
  "Status atualizado": "Status updated",
  "Status atualizado com sucesso!": "Status updated successfully!",
  "Status da captura:": "Capture status:",
  "Status da conta atualizado!": "Account status updated!",
  "status da inscrição:": "subscription status:",
  "Status da Regra": "Rule Status",
  "Status do Cadastro": "Registration Status",
  "Status do Teste": "Test status",
  "Status geral": "Overall status",
  "Status:": "Status:",
  "Status: Enviado para CRM": "Status: Sent to CRM",
  "Step 10 - Em desenvolvimento": "Step 10 - In development",
  "Step 6 - Em desenvolvimento": "Step 6 - In development",
  "Step 7 - Em desenvolvimento": "Step 7 - In development",
  "Step 8 - Em desenvolvimento": "Step 8 - In development",
  "Step 9 - Em desenvolvimento": "Step 9 - In development",
  "Stepper visual etapas": "Visual step indicator",
  "Storage": "Storage",
  "stores •": "stores •",
  "Stores Principais": "Main Stores",
  "Storyboard": "Storyboard",
  "Stripe não está carregado": "Stripe is not loaded",
  "Styling": "Styling",
  "Sua assinatura está ativa e deve ser renovada na data de": "Your subscription is active and should renew on",
  "Sua assinatura foi cancelada com sucesso.": "Your subscription was canceled successfully.",
  "Sua assinatura será encerrada ao final do período atual.": "Your subscription will end at the close of the current period.",
  "Sua audiência passa o mouse na timeline e já vê uma miniatura do frame daquele momento.": "Your audience hovers over the timeline and immediately sees a thumbnail of the frame at that moment.",
  "Sua audiência pode transmitir o vídeo pra Chromecast ou AirPlay com um clique direto do player.": "Your audience can cast videos to Chromecast or AirPlay with one click directly from the player.",
  "Sua conta deixou de ser de uma pessoa só. Com Membros, você cadastra quem trabalha com você e define, recurso por recurso, o que cada pessoa pode ver e o que pode editar — ou marca como Administrador e libera todas as áreas de uma vez. Também dá pra liberar apenas as pastas de vídeos que interessam àquela pessoa, deixando o resto da sua biblioteca fora do alcance. Cada um entra com o próprio e-mail e a própria senha, então você para de compartilhar o seu login com o time.": "Your account is no longer limited to one person. With Members, add the people you work with and define, feature by feature, what each person can view and edit — or assign Administrator to unlock all areas at once. You can also allow only relevant video folders, keeping the rest of your library out of reach. Everyone signs in with their own email and password, so you can stop sharing your login with the team.",
  "Sua headline aqui": "Your headline here",
  "Sua resposta ajuda a melhorar a experiência.": "Your response helps improve the experience.",
  "Sua resposta foi registrada com sucesso.": "Your response was recorded successfully.",
  "Sua senha deve ter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas e números": "Your password must be at least 8 characters, including uppercase, lowercase letters and numbers",
  "Sua taxa de reprodução está abaixo da média. Experimente utilizar thumbnails mais atraentes, cores que chamem atenção e títulos mais impactantes. A primeira impressão é crucial para aumentar os cliques no play.": "Your play rate is below average. Try more attractive thumbnails, eye-catching colors, and stronger titles. First impressions are crucial for increasing play clicks.",
  "Sua VSL agora pergunta e escuta: o Feedback do Vídeo é um card de avaliação que aparece dentro do player, no momento que você escolher, e recolhe a opinião de quem assistiu sem tirar a pessoa da página. Você define o formato da nota, o gatilho de exibição, os textos e o visual do card. Na aba Métricas do vídeo você acompanha a nota média, o total de respostas, a distribuição das avaliações e a evolução ao longo do tempo.": "Your VSL now asks and listens: Video Feedback is a rating card that appears inside the player at your chosen moment and collects viewers' opinions without taking them off the page. Set the rating format, display trigger, text, and card appearance. In the video's Metrics tab, track the average rating, total responses, rating distribution, and trends over time.",
  "Sua VSL agora pode seguir o caminho de quem está assistindo. Com a VSL Dinâmica 2.0, você monta um funil visual de vídeos, perguntas e opções: o visitante escolhe uma resposta dentro do player e continua no vídeo que faz sentido para ele. Em vez de mostrar a mesma sequência para todo mundo, você pode apresentar argumentos diferentes para cada necessidade e conduzir a pessoa até o checkout, o WhatsApp ou outra página. Tudo é configurado no construtor, com pré-visualização e métricas para acompanhar cada caminho.": "Your VSL can now follow the viewer's path. With Dynamic VSL 2.0, build a visual funnel of videos, questions, and options: visitors choose an answer inside the player and continue to the video relevant to them. Instead of showing everyone the same sequence, present different arguments for each need and guide people to checkout, WhatsApp, or another page. Configure everything in the builder, with previews and metrics to track each path.",
  "sua_chave_api_do_activecampaign": "sua_chave_api_do_activecampaign",
  "Suas chaves": "Your keys",
  "Suas configurações de notificações foram atualizadas.": "Your notification settings were updated.",
  "Suas histórias estão funcionando! Tente adicionar mais elementos de conflito e resolução para aumentar ainda mais o engajamento.": "Your stories are working! Try adding more conflict and resolution elements to increase engagement further.",
  "Suas métricas de conversão aparecerão aqui.": "Your conversion metrics will appear here.",
  "Suas últimas alterações não foram salvas.": "Your latest changes were not saved.",
  "Suave": "Soft",
  "Suave e limpo": "Soft and clean",
  "Subdomínio específico": "Specific subdomain",
  "Subheadline (Opcional)": "Subheadline (Optional)",
  "Subheadline: \"": "Subheadline: \"",
  "Subindo arquivo...": "Uploading file...",
  "Subir opção {value0}": "Move option {value0} up",
  "Sublinhado": "Underline",
  "Subpastas": "Subfolders",
  "Substituir": "Replace",
  "Substituir arquivo": "Replace file",
  "Substituir por Outro Vídeo": "Replace with another video",
  "Subtexto": "Subtext",
  "Subtítulo": "Subtitle",
  "Subtítulo (máx 160 caracteres)": "Subtitle (max 160 characters)",
  "Subtítulo (opcional)": "Subtitle (optional)",
  "Subtítulo de exemplo": "Sample subtitle",
  "Subtítulo do webinar": "Webinar subtitle",
  "Sucesso": "Success",
  "Sucesso!": "Success!",
  "Sugestão automática": "Automatic suggestion",
  "Sugestão Automática": "Automatic suggestion",
  "Sugestão:": "Suggestion:",
  "Sugestões Avançadas": "Advanced Suggestions",
  "Sugestões Avançadas de Retenção": "Advanced Retention Suggestions",
  "Sugestões Avançadas para Teste A/B de Vídeos": "Advanced Suggestions for Video A/B Testing",
  "Sugestões baseadas nos dados de dispositivos para otimizar seu conteúdo.": "Suggestions based on device data to optimize your content.",
  "Sugestões de Melhoria": "Improvement Suggestions",
  "Supabase": "Supabase",
  "Superior central": "Top center",
  "Superior Centro": "Top Center",
  "Superior Direita": "Top Right",
  "Superior direito": "Top Right",
  "Superior Direito": "Top Right",
  "Superior Esquerda": "Top Left",
  "Superior esquerdo": "Top Left",
  "Superior Esquerdo": "Top Left",
  "Suporte": "Support",
  "Suporte ao cliente e sistema de tickets para resolução de problemas.": "Customer support and ticketing system for issue resolution.",
  "Suporte e Atendimento": "Support and Customer Service",
  "Suporte premium HostVSL": "HostVSL premium support",
  "Suporte Prioritário": "Priority Support",
  "Suporte: contato@seudominio.com": "Support: contato@seudominio.com",
  "Sydney (GMT+10)": "Sydney (GMT+10)",
  "Sync AWS": "Sync AWS",
  "Tabela Consolidada": "Consolidated Table",
  "Tablet": "Tablet",
  "Tablet:": "Tablet:",
  "Tags de Campanha": "Campaign Tags",
  "Tamanho": "Size",
  "Tamanho (px)": "Size (px)",
  "Tamanho da fonte": "Font size",
  "Tamanho da Fonte": "Font size",
  "Tamanho da Fonte (px)": "Font Size (px)",
  "Tamanho do botão": "Button size",
  "Tamanho do Ícone": "Icon size",
  "Tamanho dos Cards": "Card Size",
  "Tamanho e Posição": "Size and position",
  "Tamanho e Transparência": "Size and Transparency",
  "Tamanho máximo de 2GB por vídeo (mesmo limite do upload normal)": "Maximum 2GB per video (same limit as regular uploads)",
  "Tamanho máximo: 2MB": "Max size: 2MB",
  "Tamanho recomendado: 1920x1080px • Formatos: JPG, PNG, GIF • Máximo: 10MB": "Recommended size: 1920x1080px • Formats: JPG, PNG, GIF • Max: 10MB",
  "Tamanho:": "Size:",
  "Taxa": "Rate",
  "Taxa Conv.": "Conv. Rate",
  "Taxa de acesso ao checkout": "Checkout visit rate",
  "taxa de conversão": "conversion rate",
  "Taxa de conversão": "Conversion rate",
  "Taxa de Conversão": "Conversion rate",
  "Taxa de conversão final": "Final conversion rate",
  "Taxa de conversão geral:": "Overall conversion rate:",
  "Taxa de E-mail": "Email Rate",
  "Taxa de play": "Play rate",
  "Taxa de Play": "Play Rate",
  "Taxa de Play (%)": "Play Rate (%)",
  "Taxa de Reprodução": "Play Rate",
  "Taxa de Retenção (%)": "Retention Rate (%)",
  "Taxa de Telefone": "Phone Rate",
  "Taxa Média": "Average Rate",
  "Taxa média de conversão calculada entre todas as plataformas": "Average conversion rate calculated across all platforms",
  "Taxa média de retenção": "Average retention rate",
  "Taxa:": "Rate:",
  "Taxas": "Fees",
  "Taxas Acumuladas": "Accumulated Fees",
  "Taxas calculadas automaticamente: Play Rate, Click Rate e Conversion Rate": "Automatically calculated rates: Play Rate, Click Rate, and Conversion Rate",
  "Taxas cobradas sobre pagamentos.": "Fees charged on payments.",
  "Técnica do PAS": "PAS Technique",
  "Tecnologia de": "Technology by",
  "Tela cheia": "Full screen",
  "Tela Cheia": "Full screen",
  "Tela flutuante": "Floating screen",
  "Telefone": "Phone",
  "Telefone copiado!": "Phone number copied!",
  "Telefone inválido": "Invalid phone number",
  "Telefone:": "Phone:",
  "Telefone/WhatsApp": "Phone/WhatsApp",
  "Tem certeza que deseja cancelar?": "Are you sure you want to cancel?",
  "Tem certeza que deseja deletar este teste de velocidade? Esta ação não pode ser desfeita.": "Are you sure you want to delete this speed test? This action cannot be undone.",
  "Tem certeza que deseja desativar a captura de \"": "Are you sure you want to disable capture for \"",
  "Tem certeza que deseja desativar o link de compartilhamento? O link deixará de funcionar imediatamente.": "Are you sure you want to disable the sharing link? It will stop working immediately.",
  "Tem certeza que deseja excluir": "Are you sure you want to delete",
  "Tem certeza que deseja excluir \"": "Are you sure you want to delete \"",
  "Tem certeza que deseja excluir esta legenda?": "Are you sure you want to delete this subtitle?",
  "Tem certeza que deseja excluir esta variação? Esta ação não pode ser desfeita.": "Are you sure you want to delete this variation? This action cannot be undone.",
  "Tem certeza que deseja excluir este compartilhamento? Esta ação não pode ser desfeita.": "Are you sure you want to delete this share? This action cannot be undone.",
  "Tem certeza que deseja excluir este Mini-Hook? Esta ação não pode ser desfeita.": "Are you sure you want to delete this Mini-Hook? This action cannot be undone.",
  "Tem certeza que deseja excluir o registro de": "Are you sure you want to delete the record for",
  "Tem certeza que deseja excluir o registro de {value0}?": "Are you sure you want to delete the record for {value0}?",
  "Tem certeza que deseja excluir o tracking da plataforma": "Are you sure you want to delete tracking for the platform",
  "Tem certeza que deseja excluir os": "Are you sure you want to delete the",
  "Tem certeza que deseja excluir permanentemente o vídeo": "Are you sure you want to permanently delete the video",
  "Tem certeza que deseja remover": "Are you sure you want to remove",
  "Tem certeza que deseja remover '": "Are you sure you want to remove '",
  "Tem certeza que deseja remover esta imagem?": "Are you sure you want to remove this image?",
  "Tem certeza que deseja remover esta imagem? Esta ação não pode ser desfeita.": "Are you sure you want to remove this image? This action cannot be undone.",
  "Tem certeza que deseja remover este método de pagamento?": "Are you sure you want to remove this payment method?",
  "Tem certeza que deseja remover sua foto de perfil? Esta ação não pode ser desfeita.": "Are you sure you want to remove your profile photo? This action cannot be undone.",
  "Tem certeza que deseja sair?": "Are you sure you want to sign out?",
  "Tem certeza? Esta ação não pode ser desfeita.": "Are you sure? This action cannot be undone.",
  "Tem todas as permissões.": "Has all permissions.",
  "Tema": "Theme",
  "Template {value0}": "Template {value0}",
  "Template Base": "Base Template",
  "Template horizontal estilo Wistia/Vimeo com player centralizado, grid responsivo 4/2/1 colunas, autoplay sequencial com countdown.": "Wistia/Vimeo-style horizontal template with a centered player, responsive 4/2/1-column grid, and sequential autoplay with a countdown.",
  "Template não encontrado": "Template not found",
  "Templates": "Templates",
  "Templates Sugeridos": "Suggested Templates",
  "Tempo": "Time",
  "Tempo até retomar": "Time until resume",
  "Tempo atual": "Current time",
  "Tempo Atual": "Current time",
  "Tempo atualizado!": "Time updated!",
  "Tempo da contagem": "Countdown time",
  "Tempo de Carregamento": "Loading Time",
  "Tempo de espera mínimo (minutos)": "Minimum wait time (minutes)",
  "Tempo de Exibição": "Display time",
  "Tempo de preenchimento": "Completion time",
  "Tempo do pitch": "Pitch time",
  "Tempo do Pitch": "Pitch Time",
  "Tempo do pitch:": "Pitch time:",
  "Tempo do vídeo": "Video Time",
  "Tempo do Vídeo": "Video Time",
  "Tempo do Vídeo (min:seg) *": "Video Time (min:sec) *",
  "Tempo do Vídeo (mm:ss) *": "Video time (mm:ss) *",
  "Tempo inválido. Use o formato m:ss.s e garanta que início < fim.": "Invalid time. Use m:ss.s format and ensure start < end.",
  "Tempo médio assistido": "Average Watch Time",
  "Tempo Médio Assistido": "Average Watch Time",
  "Tempo médio do pitch:": "Average pitch time:",
  "Tempo no vídeo": "Time in video",
  "Tempo para exibição (segundos)": "Display delay (seconds)",
  "Tempo para exibir a primeira notificação após o play.": "Time before the first notification appears after playback starts.",
  "Tempo personalizado": "Custom time",
  "Tempo real": "Real time",
  "Tempo Real": "Real Time",
  "Tempo:": "Time:",
  "TEMPO:": "TIME:",
  "Tempo: 00:00 - Início do Vídeo": "Time: 00:00 - Video Start",
  "Temporização": "Timing",
  "Temporizador": "Timer",
  "Tendência Consistente:": "Consistent Trend:",
  "Tendência de Captura": "Capture Trend",
  "Tendência Diária": "Daily Trend",
  "Tendência por Hora": "Hourly Trend",
  "Tenha atendimento exclusivo para parceiros.": "Get dedicated support for partners.",
  "Tentar de novo": "Try again",
  "Tentar novamente": "Try again",
  "Tentar Novamente": "Try Again",
  "Tentativas:": "Attempts:",
  "Tente abrir o vídeo no Chrome (Chromecast) ou Safari (AirPlay).": "Try opening the video in Chrome (Chromecast) or Safari (AirPlay).",
  "Tente ajustar seus filtros de busca ou categoria.": "Try adjusting your search filters or category.",
  "Tente ajustar sua busca ou limpar os filtros.": "Try adjusting your search or clearing filters.",
  "Tente ampliar o período": "Try expanding the period",
  "Tente ampliar o período ou visualizar outro vídeo.": "Try expanding the period or viewing another video.",
  "Tente ampliar o período, escolher outra métrica ou verifique se há uma integração de conversão configurada.": "Try expanding the period, choosing another metric, or checking whether a conversion integration is configured.",
  "Tente buscar por outro termo": "Try another search term",
  "Tente buscar por outro termo ou campanha": "Try another term or campaign",
  "Tente novamente": "Try again",
  "Tente novamente em instantes. Se o problema persistir, entre em contato com o suporte.": "Try again shortly. If the problem persists, contact support.",
  "Tente novamente.": "Please try again.",
  "Tente outro termo ou revise a ortografia.": "Try another term or check spelling.",
  "Tente outro termo.": "Try another term.",
  "Tente reduzir o tamanho do vídeo ou usar adaptação de qualidade para melhorar o tempo de carregamento.": "Try reducing video size or using adaptive quality to improve loading time.",
  "Tente selecionar um intervalo de datas diferente.": "Try selecting a different date range.",
  "Tente uma busca diferente.": "Try a different search.",
  "Tente verificar a ortografia ou usar palavras-chave diferentes": "Try checking spelling or using different keywords",
  "Ter": "Tue",
  "TER": "TUE",
  "TER • 12h-14h": "TUE • 12:00–14:00",
  "TER • 20h-22h": "TUE • 20:00–22:00",
  "Terça 22-00h: Crescimento de 18% nas últimas 3 semanas": "Tuesday 22:00–00:00: 18% growth over the last 3 weeks",
  "Terça-feira": "Tuesday",
  "Terceiro melhor momento": "Third-best time",
  "Termina com": "Ends with",
  "Termina em:": "Ends on:",
  "terminando em": "ending in",
  "Termine suas VSLs levando o espectador direto para a decisão.": "End your VSLs by taking viewers directly to a decision.",
  "Término": "End",
  "Término automático em:": "Automatically ends on:",
  "Término previsto:": "Expected end:",
  "Término:": "End:",
  "Termo (Term)": "Term",
  "Termos": "Terms",
  "Termos de uso": "Terms of use",
  "Termos de Uso": "Terms of Use",
  "Testando...": "Testing...",
  "Testar": "Test",
  "Testar abertura do modal": "Test dialog opening",
  "Testar notificação agora": "Test Notification Now",
  "Testar Regra": "Test Rule",
  "Testar som": "Test sound",
  "Teste": "Test",
  "Teste A/B": "A/B Test",
  "Teste A/B - Remoção Badge Contagem": "A/B Testing - Count Badge Removal",
  "Teste A/B - Wizard Premium com Drag-and-Drop": "A/B Testing - Premium Wizard with Drag-and-Drop",
  "Teste A/B ativado!": "A/B test enabled!",
  "Teste A/B criado com sucesso!": "A/B test created successfully!",
  "Teste A/B criado e ativado!": "A/B test created and activated!",
  "Teste AB": "A/B Test",
  "Teste aplicado com sucesso!": "Test applied successfully!",
  "Teste Automático": "Automatic Test",
  "Teste Automático com Múltiplas Velocidades": "Automatic Test with Multiple Speeds",
  "Teste automático em andamento. A velocidade manual será aplicada quando o teste finalizar.": "Automatic test in progress. Manual speed applies when the test ends.",
  "Teste automático iniciado": "Automatic test started",
  "Teste criado com sucesso!": "Test created successfully!",
  "Teste criado!": "Test created!",
  "Teste de headline carregado!": "Headline test loaded!",
  "Teste de hook": "Hook test",
  "Teste de Hook - Navegação Corrigida": "Hook Testing - Navigation Fixed",
  "Teste de Hook - Padronização com Teste A/B": "Hook Testing - Standardized with A/B Testing",
  "Teste de hook criado com sucesso!": "Hook test created successfully!",
  "Teste de Integrações": "Integration Testing",
  "Teste de velocidade criado com sucesso.": "Speed test created successfully.",
  "Teste de velocidade deletado com sucesso.": "Speed test deleted successfully.",
  "Teste de velocidade iniciado": "Speed test started",
  "Teste deletado com sucesso!": "Test deleted successfully!",
  "Teste deletado!": "Test deleted!",
  "Teste diferentes introduções e descubra a que converte mais": "Test different intros and discover which converts best",
  "Teste diferentes introduções e descubra qual retém mais a atenção": "Test different hooks and discover which retains attention the most",
  "Teste diferentes posições do vídeo na página. Acima da dobra geralmente tem melhores resultados.": "Test different video positions on the page. Above the fold generally performs better.",
  "Teste diferentes variações e otimize suas conversões.": "Test different variations and optimize conversions.",
  "Teste diferentes versões de suas VSLs e descubra o que converte mais": "Test different versions of your VSLs and discover what converts more",
  "Teste encerrado": "Test ended",
  "Teste excluído": "Test deleted",
  "Teste finalizado": "Test finished",
  "Teste finalizado automaticamente": "Test finished automatically",
  "Teste finalizado com sucesso!": "Test finished successfully!",
  "Teste finalizado e deletado com sucesso!": "Test finished and deleted successfully!",
  "Teste grátis": "Free trial",
  "Teste grátis com um clique, sem cartão de crédito": "One-click free trial, no credit card required",
  "Teste grátis iniciado! Seu plano {value0} está ativo. Você não será cobrado pelos próximos 15 dias.": "Free trial started! Your {value0} plan is active. You will not be charged for the next 15 days.",
  "Teste múltiplos botões ao longo do vídeo (não apenas no final)": "Test multiple buttons throughout the video (not just at the end)",
  "Teste não iniciado": "Test not started",
  "Teste no mínimo 3 abordagens de intro diferentes": "Test at least 3 different intro approaches",
  "Teste renomeado": "Test renamed",
  "Teste sem nome": "Unnamed test",
  "Teste Sequencial:": "Sequential Testing:",
  "Teste seu vídeo neste navegador para garantir a melhor experiência.": "Test your video in this browser to ensure the best experience.",
  "Teste títulos com números específicos ou perguntas intrigantes": "Test titles with specific numbers or intriguing questions",
  "Teste uma abordagem diferente: se está usando problema-solução, experimente curiosidade ou história de transformação.": "Test a different approach: if you use problem-solution, try curiosity or a transformation story.",
  "Teste variações": "Test variations",
  "Teste:": "Test:",
  "Testes A/B": "A/B Tests",
  "Testes A/B Integrados": "Built-In A/B Tests",
  "Testes Ativos": "Active Tests",
  "Testes de Velocidade": "Speed Tests",
  "Testes em andamento": "Tests in progress",
  "Texto": "Text",
  "Texto (Hover)": "Text (Hover)",
  "Texto abaixo da imagem": "Text below the image",
  "Texto acima do indicador (opcional, máx 40 caracteres)": "Text above the indicator (optional, max 40 characters)",
  "Texto adicional de segurança ou informação": "Additional security text or information",
  "Texto antes de liberar": "Text before unlocking",
  "Texto atualizado!": "Text updated!",
  "Texto Botão": "Button text",
  "Texto branco em fundo claro": "White text on light background",
  "Texto da barra": "Bar text",
  "Texto da Headline": "Headline text",
  "Texto da opção {value0}": "Text for option {value0}",
  "Texto da Subheadline": "Subheadline text",
  "Texto de Copyright (editável)": "Copyright Text (editable)",
  "Texto de Exibição": "Display Text",
  "Texto dentro da imagem (com overlay)": "Text inside the image (with overlay)",
  "Texto do aviso": "Notice text",
  "Texto do botão": "Button text",
  "Texto do Botão": "Button text",
  "Texto do Botão (máx 40 caracteres)": "Button Text (max 40 characters)",
  "Texto do botão de envio do formulário": "Form submit button text",
  "Texto do botão de início": "Start button text",
  "Texto do botão é obrigatório": "Button text is required",
  "Texto do botão para iniciar": "Button text to start",
  "Texto do botão principal": "Main button text",
  "Texto do Campo": "Field Text",
  "Texto do Link": "Link Text",
  "Texto do link secundário": "Secondary link text",
  "Texto do overlay": "Overlay text",
  "Texto do segundo botão": "Second button text",
  "Texto do template": "Template text",
  "Texto do Termo (máx 250 caracteres)": "Consent Text (max 250 characters)",
  "Texto do texto secundário": "Secondary text",
  "Texto do timer": "Timer text",
  "Texto do Título": "Title Text",
  "Texto exibido na página de compartilhamento": "Text displayed on the sharing page",
  "Texto exibido no overlay para orientar o usuário": "Text shown in the overlay to guide the user",
  "Texto Inferior": "Bottom text",
  "Texto livre permitido - variáveis são opcionais": "Free text allowed - variables are optional",
  "Texto para pular": "Skip text",
  "Texto Personalizado": "Custom Text",
  "Texto personalizado...": "Custom text...",
  "Texto principal": "Primary text",
  "Texto principal do formulário": "Main form text",
  "Texto próprio no botão e escolha de abrir na mesma aba ou em uma nova": "Custom button text and a choice of opening in the same tab or a new one",
  "Texto secundário": "Secondary text",
  "Texto sobre a barra": "Text over bar",
  "Texto Superior": "Top text",
  "Textos": "Text",
  "Textos do bloco": "Block text",
  "Textos do overlay": "Overlay texts",
  "Thumbnail": "Thumbnail",
  "Thumbnail adicionada com sucesso": "Thumbnail added successfully",
  "Thumbnail aplicada!": "Thumbnail applied!",
  "Thumbnail atualizada": "Thumbnail updated",
  "Thumbnail gerada!": "Thumbnail generated!",
  "Thumbnail removida": "Thumbnail removed",
  "Thumbnail removida com sucesso": "Thumbnail removed successfully",
  "Thumbnail será exibida {value0}": "Thumbnail will be shown {value0}",
  "Thumbnail será exibida apenas no trecho específico": "Thumbnail will show only in the specific range",
  "Thumbnail será exibida sempre que pausar": "Thumbnail will show whenever the video pauses",
  "Thumbnails atualizadas": "Thumbnails updated",
  "Thumbnails do Vídeo": "Video Thumbnails",
  "Ticket": "Average Order Value",
  "Ticket médio": "Avg. ticket",
  "Ticket Médio": "Avg. ticket",
  "Ticket:": "Average order value:",
  "Ticto": "Ticto",
  "Timer e Urgência": "Timer and Urgency",
  "Timestamp (min:seg)": "Timestamp (min:sec)",
  "Timing:": "Timing:",
  "Tipo": "Type",
  "Tipo Acesso": "Access Type",
  "Tipo da Regra": "Rule Type",
  "Tipo de Ação *": "Action type *",
  "Tipo de animação": "Animation type",
  "Tipo de Animação": "Animation type",
  "Tipo de arquivo inválido": "Invalid file type",
  "Tipo de botão": "Button type",
  "Tipo de conta": "Account type",
  "Tipo de evento": "Event type",
  "Tipo de Fundo": "Background type",
  "Tipo de Indicador": "Indicator Type",
  "Tipo de notificação": "Notification type",
  "Tipo de Pixel": "Pixel Type",
  "Tipo de Recebimento": "Payout Type",
  "Tipo de regra:": "Rule type:",
  "Tipo de som": "Sound type",
  "Tipo:": "Type:",
  "Tipografia": "Typography",
  "Tipografia Premium — Font-weight 500": "Premium Typography — Font-weight 500",
  "Tipos de Notificações": "Notification Types",
  "Tirar dúvidas no WhatsApp": "Ask questions on WhatsApp",
  "Tire suas dúvidas sobre o programa": "Get your questions about the program answered",
  "Titular": "Account holder",
  "Título": "Title",
  "Título (Headline)": "Title (Headline)",
  "Título (opcional)": "Title (optional)",
  "Título atualizado com sucesso!": "Title updated successfully!",
  "Título convincente": "Compelling title",
  "Título da oferta": "Offer title",
  "Título da Oferta": "Offer Title",
  "Título da Página": "Page Title",
  "Título da Playlist": "Playlist Title",
  "Título da Seção": "Section Title",
  "Título de Exemplo": "Sample Title",
  "Título do Card": "Card title",
  "Título do Episódio": "Episode Title",
  "Título do formulário": "Form title",
  "Título do Header (opcional)": "Header Title (optional)",
  "Título do overlay": "Overlay title",
  "Título do sorteio": "Giveaway title",
  "Título do Vídeo": "Video Title",
  "Título do Webinar": "Webinar Title",
  "Título é obrigatório": "Title is required",
  "Título Principal (máx 150 caracteres)": "Main Title (max 150 characters)",
  "Título Público": "Public Title",
  "Título Público *": "Public Title *",
  "Título que será exibido na sala para os participantes.": "Title displayed to participants in the room.",
  "Título que será exibido para os participantes": "Title displayed to participants",
  "Títulos de tooltips": "Tooltip titles",
  "Todas": "All",
  "Todas as alterações refletem no embed final automaticamente": "All changes automatically appear in the final embed",
  "Todas as alterações são aplicadas instantaneamente": "All changes apply instantly",
  "Todas as alterações são aplicadas instantaneamente.": "All changes apply instantly.",
  "Todas as configurações do seu vídeo foram salvas": "All your video settings were saved",
  "Todas as configurações voltaram ao padrão": "All settings restored to defaults",
  "Todas as legendas foram removidas do vídeo.": "All captions were removed from the video.",
  "Todas as Pastas": "All Folders",
  "Todas as personalizações foram aplicadas ao seu vídeo.": "All customizations were applied to your video.",
  "Todas as plataformas": "All platforms",
  "Todas as Plataformas": "All Platforms",
  "Todas as regiões bloqueadas": "All regions blocked",
  "Todas as regiões permitidas": "All regions allowed",
  "Todas as saídas de checkout já possuem uma integração.": "All checkout exits already have an integration.",
  "Todas as solicitações enviadas pelos afiliados da plataforma.": "All requests submitted by platform affiliates.",
  "todo mês!": "every month!",
  "Todo o vídeo": "Entire video",
  "Todos": "All",
  "Todos dispositivos": "All devices",
  "Todos os campos disponíveis foram adicionados": "All available fields have been added",
  "Todos os Custos": "All Costs",
  "Todos os direitos reservados": "All rights reserved",
  "Todos os planos incluem": "All plans include",
  "Todos os planos incluem 15 dias grátis": "All plans include 15 days free",
  "Todos os recursos da HostVSL": "All HostVSL features",
  "Todos os recursos e benefícios para seu negócio": "All features and benefits for your business",
  "Todos os recursos premium": "All premium features",
  "Todos os Registros": "All Records",
  "Todos os status": "All statuses",
  "Todos os vídeos": "All videos",
  "Todos os vídeos foram carregados": "All videos loaded",
  "Todos os vídeos usados estão prontos": "All videos used are ready",
  "Todos que comprarem hoje participam...": "Everyone who buys today is entered...",
  "Todos que se cadastraram através dos seus links.": "Everyone who registered through your links.",
  "Todos Status": "All Statuses",
  "Toggle": "Toggle",
  "Toggle {value0} section": "Toggle {value0} section",
  "Toggle Sidebar": "Toggle Sidebar",
  "Token": "Token",
  "Token copiado para a área de transferência.": "Token copied to clipboard.",
  "Token copiado!": "Token copied!",
  "Token da plataforma": "Platform token",
  "Token da plataforma (se exigido)": "Platform token (if required)",
  "Token de {value0}": "{value0} token",
  "Token de Acesso": "Access Token",
  "Token de Acesso *": "Access Token *",
  "Token de acesso fornecido pelo": "Access token provided by",
  "Token de acesso fornecido pelo Facebook": "Access token provided by Facebook",
  "Token de acesso vive apenas durante a sessão — segurança em primeiro lugar": "Access token exists only during the session — security first",
  "Token de suporte": "Support token",
  "Token de Suporte": "Support Token",
  "Token de suporte para debug": "Support token for debugging",
  "Token deve ter no máximo 500 caracteres": "Token must be no longer than 500 characters",
  "Token fornecido pelo Facebook": "Token provided by Facebook",
  "Token não disponível": "Token unavailable",
  "Token não pode estar vazio": "Token cannot be empty",
  "Token Revogado": "Token Revoked",
  "Token revogado.": "Token revoked.",
  "Token vazio retornado pelo Google": "Empty token returned by Google",
  "Token:": "Token:",
  "Top": "Top",
  "Top 10 comentários enviados após a avaliação.": "Top 10 comments submitted after rating.",
  "Top 10 Usuários por Custo": "Top 10 Users by Cost",
  "Top 3 horários com maior": "Top 3 times with highest",
  "Top 3 horários com maior consistência": "Top 3 most consistent times",
  "Top 3 horários com melhor": "Top 3 times with best",
  "Top 3 Janelas": "Top 3 Windows",
  "Top 3 por visualizações": "Top 3 by views",
  "Top 3 Receita": "Top 3 Revenue",
  "Top 3 Taxa Conv%": "Top 3 Conv. Rate%",
  "Top 4 por visualizações": "Top 4 by views",
  "Top 5 vídeos com mais captura": "Top 5 videos by captures",
  "Top 5 Vídeos por Receita": "Top 5 Videos by Revenue",
  "Top Estados": "Top States",
  "Top fontes de tráfego": "Top traffic sources",
  "Top lugares": "Top locations",
  "Top vídeos": "Top videos",
  "Top VSL do Período": "Top VSL of the Period",
  "Topo": "Top",
  "Topo Direita": "Top Right",
  "Topo Esquerda": "Top Left",
  "Topo pode funcionar melhor que rodapé": "Top may work better than bottom",
  "Toque em \"Adicionar\"": "Tap \"Add\"",
  "Toque no botão de compartilhar": "Tap the share button",
  "Tóquio (GMT+9)": "Tokyo (GMT+9)",
  "Tornar comentário obrigatório": "Require comment",
  "Tornar obrigatório": "Make required",
  "Tornar Principal": "Make Primary",
  "Torne-se um Afiliado": "Become an Affiliate",
  "Totais": "Totals",
  "total": "total",
  "Total": "total",
  "Total (12m):": "Total (12m):",
  "Total após taxas aplicadas.": "Total after applicable fees.",
  "Total atual:": "Current total:",
  "Total BRL": "Total BRL",
  "Total c/ Impostos": "Total incl. Taxes",
  "Total c/ Taxo": "Total incl. Fees",
  "Total Cliques": "Total Clicks",
  "Total consumido": "Total consumed",
  "Total de": "Total of",
  "Total de Capturas": "Total Captures",
  "Total de Comissões": "Total Commissions",
  "Total de conversões registradas hoje": "Total conversions recorded today",
  "Total de Indicados": "Total Referrals",
  "Total de integrações:": "Total integrations:",
  "Total de Leads": "Total Leads",
  "Total de Leads do Vídeo": "Total Video Leads",
  "Total de pessoas que viram e interagiram com seu vídeo": "Total people who saw and interacted with your video",
  "Total de Plays Únicos": "Total Unique Plays",
  "Total de reproduções": "Total plays",
  "Total de visualizações": "Total views",
  "Total de visualizações do vídeo": "Total video views",
  "Total de Visualizações Únicas": "Total Unique Views",
  "Total de visualizações únicas do dia": "Total unique views today",
  "Total deve ser 100%. Atualmente:": "Total must be 100%. Currently:",
  "Total do dia": "Daily total",
  "Total do período": "Period total",
  "Total do teste": "Test total",
  "Total em BRL": "Total in BRL",
  "Total Estimado Próxima Cobrança": "Estimated Total Next Bill",
  "Total geral": "Grand total",
  "Total geral pago (sem descontos):": "Total paid overall (before discounts):",
  "Total Plays": "Total Plays",
  "Total recebido através da sua rede.": "Total received through your network.",
  "Total solicitado": "Total requested",
  "Total USD": "Total USD",
  "Total Usuários": "Total Users",
  "Total Vídeos": "Total Videos",
  "Total:": "Total:",
  "Total: 100%": "Total: 100%",
  "Total: R$": "Total: R$",
  "Totalizadores gerais no sistema:": "Overall system totals:",
  "Tracking": "Tracking",
  "Tracking excluído com sucesso!": "Tracking deleted successfully!",
  "Tracking para {value0} adicionado": "Tracking added for {value0}",
  "Tracking salvo com sucesso!": "Tracking saved successfully!",
  "tracking(s)?": "tracking entry/entries?",
  "trackings selecionados? Esta ação não pode ser desfeita.": "selected tracking entries? This action cannot be undone.",
  "Tráfego": "Traffic",
  "TRÁFEGO": "TRAFFIC",
  "Tráfego dividido igualmente": "Traffic split evenly",
  "Tráfego:": "Traffic:",
  "Transforme curiosidade em conversão.": "Turn curiosity into conversion.",
  "Transforme sua VSL em um funil interativo: cada resposta leva ao próximo vídeo ou à oferta certa.": "Turn your VSL into an interactive funnel: each answer leads to the next video or the right offer.",
  "Transição suave": "Smooth transition",
  "Transmissão indisponível": "Casting unavailable",
  "Transmissão não suportada neste navegador": "Casting not supported in this browser",
  "Transmitir para TV": "Cast to TV",
  "Transparência": "Transparency",
  "Transparente": "Transparent",
  "Treinamento prático para criar, configurar e abrir sua sala": "Practical training to create, configure, and open your room",
  "Três formatos de avaliação: emojis, estrelas ou nota de 1 a 5": "Three rating formats: emojis, stars, or a score from 1 to 5",
  "Três passos simples para começar a faturar hoje mesmo.": "Three simple steps to start earning today.",
  "Trilha": "Learning path",
  "Trilha organizada por módulos: Primeiros passos, Personalização, Conversão, Análises e Plano": "Learning path organized into modules: Getting started, Customization, Conversion, Analytics, and Plan",
  "Trilho": "Track",
  "Trocar": "Swap",
  "Trocar vídeo": "Change video",
  "Trocar Vídeo": "Change Video",
  "Trocar vídeo de fundo": "Change background video",
  "Tudo certo para publicar": "Ready to publish",
  "Tudo OK": "All OK",
  "Tudo para escalar VSLs com automação, proteção e métricas.": "Everything to scale VSLs with automation, protection and metrics.",
  "Tudo para escalar VSLs com performance, proteção e métricas.": "Everything you need to scale VSLs with performance, protection, and metrics.",
  "Türkçe": "Türkçe",
  "Tutoriais": "Tutorials",
  "Tutorial do Produto": "Product Tutorial",
  "Type Safety": "Type Safety",
  "UF": "State",
  "UI Library": "UI Library",
  "Última atividade detectada": "Last activity detected",
  "Última atualização: agora": "Last updated: now",
  "Última edição": "Last edit",
  "Última Interação": "Last Interaction",
  "Última legenda removida. Arquivo excluído.": "Last subtitle removed. File deleted.",
  "Últimas 24h": "Last 24h",
  "Últimas atualizações": "Latest updates",
  "Últimas Atualizações": "Latest Updates",
  "Último salvamento:": "Last saved:",
  "Último Teste": "Last Test",
  "Último uso": "Last used",
  "Últimos 30 dias": "Last 30 days",
  "Últimos 7 dias": "Last 7 days",
  "Últimos Eventos": "Latest Events",
  "Um exemplo de caminho": "An example path",
  "Um funil de vídeos em que cada resposta do visitante leva ao próximo vídeo, até o checkout.": "A video funnel where each visitor answer leads to the next video, all the way to checkout.",
  "Um vídeo bem-sucedido precisa tanto atrair cliques iniciais quanto manter o interesse ao longo do conteúdo.": "A successful video needs to attract initial clicks and maintain interest throughout the content.",
  "Um vídeo foi compartilhado com você": "A video was shared with you",
  "Uma chave de API permite que uma ferramenta externa leia, em seu nome, as métricas dos seus vídeos e a lista de vídeos da conta — hoje, o connector da HostVSL no Claude. Ela é de leitura: não altera vídeos, não acessa seus dados de cobrança e não faz login no painel.": "An API key allows an external tool to read your video metrics and account video list on your behalf — currently, the HostVSL connector in Claude. It is read-only: it does not change videos, access billing data, or sign in to the dashboard.",
  "Uma legenda por idioma": "One caption track per language",
  "Uma máquina de conversão": "A conversion machine",
  "Uma mensagem principal por vez": "One main message at a time",
  "Uma plataforma de processamento e gerenciamento de pagamentos online.": "An online payment processing and management platform.",
  "Uma variação vencedora normalmente supera as outras em pelo menos 10-15% em métricas-chave.": "A winning variation usually outperforms the others by at least 10–15% on key metrics.",
  "Uma vez por sessão em cada saída. Atualiza a cada minuto.": "Once per session at each exit. Updates every minute.",
  "únicas": "unique",
  "Únicas": "Unique",
  "únicos": "unique",
  "Únicos": "Unique",
  "Upgrade": "Upgrade",
  "Uplift:": "Uplift:",
  "Upload": "Upload",
  "Upload cancelado": "Upload canceled",
  "Upload concluído": "Upload complete",
  "Upload concluído!": "Upload complete!",
  "Upload da Logo": "Upload Logo",
  "Upload de arquivos .VTT e .SRT com detecção automática de formato": "Upload .VTT and .SRT files with automatic format detection",
  "Upload de vídeo": "Video upload",
  "Upload do computador": "Upload from computer",
  "Upload do Ícone Personalizado": "Custom icon upload",
  "Upload do vídeo": "Video upload",
  "Upload file": "Upload file",
  "Upload Modal — Correção Borda Seleção": "Upload Modal — Selection Border Fix",
  "Upload Novo Vídeo": "Upload New Video",
  "Upload Personalizado": "Custom Upload",
  "UploadBox is deprecated. Use UploadQueueModal from @/components/upload instead.": "UploadBox is deprecated. Use UploadQueueModal from @/components/upload instead.",
  "UploadDialog is deprecated. Use UploadQueueModal from @/components/upload instead.": "UploadDialog is deprecated. Use UploadQueueModal from @/components/upload instead.",
  "Uploads concluídos": "Uploads completed",
  "Upsell + Downsell": "Upsell + Downsell",
  "URL": "URL",
  "URL Amigável": "Friendly URL",
  "URL Amigável *": "Friendly URL *",
  "URL com parâmetros UTM": "URL with UTM parameters",
  "URL contains suspicious patterns": "URL contains suspicious patterns",
  "URL copiada": "URL copied",
  "URL copiada para a área de transferência": "URL copied to clipboard",
  "URL da Página de Obrigado": "Thank-You Page URL",
  "URL de destino": "Destination URL",
  "URL de Destino": "Destination URL",
  "URL de download não disponível": "Download URL unavailable",
  "URL de redirecionamento (opcional)": "Redirect URL (optional)",
  "URL de Teste": "Test URL",
  "URL deve ter no máximo 500 caracteres": "URL must be no longer than 500 characters",
  "URL do botão principal inválida": "Invalid primary button URL",
  "URL do segundo botão inválida": "Invalid second button URL",
  "URL do site": "Site URL",
  "URL do site onde o pixel será instalado": "URL of the site where the pixel will be installed",
  "URL do Vídeo": "Video URL",
  "URL do vídeo não disponível": "Video URL unavailable",
  "URL inválida": "Invalid URL",
  "URL inválida. Ex: https://seu-site.com": "Invalid URL. e.g. https://your-site.com",
  "URL inválida. Use http:// ou https://. Ex: https://seu-site.com": "Invalid URL. Use http:// or https://. e.g. https://your-site.com",
  "URL MP4 direta": "Direct MP4 URL",
  "URL must be a non-empty string": "URL must be a non-empty string",
  "URL não navegável": "URL cannot be opened",
  "URL não suportada. Use Vimeo, Bunny, Cloudflare ou MP4 direto.": "Unsupported URL. Use Vimeo, Bunny, Cloudflare, or a direct MP4.",
  "URL Site": "Site URL",
  "URL too long": "URL too long",
  "URL válida": "Valid URL",
  "URL vinculada:": "Linked URL:",
  "URL Webhook": "Webhook URL",
  "URLs": "URLs",
  "URLs de referência": "Referrer URLs",
  "Usa uma versão menor do botão de play no centro do player": "Uses a smaller play button in the center of the player",
  "Usada por {value0} {value1}": "Used by {value0} {value1}",
  "usados": "used",
  "Usar cor do Play": "Use Play color",
  "Usar em nova etapa": "Use in a new step",
  "Usar Esta Thumbnail": "Use This Thumbnail",
  "Usar transparência no fundo": "Use transparent background",
  "Usar velocidade fixa": "Use fixed speed",
  "Usaremos este cartão para cobranças futuras.": "We will use this card for future charges.",
  "USD": "USD",
  "Use \"{count}\" para inserir o número de pessoas dinamicamente.": "Use \"{count}\" to insert the number of people dynamically.",
  "Use #id para IDs ou .classe para classes CSS. Exemplo: #meuBotao ou .minha-secao": "Use #id for IDs or .class for CSS classes. Example: #myButton or .my-section",
  "Use a estrutura Problema, Agitação, Solução para criar tensão e resolução.": "Use the Problem, Agitate, Solution framework to create tension and resolution.",
  "Use a gamificação": "Use gamification",
  "Use a normalização por dia para comparar horários dentro do mesmo dia, independente do volume absoluto.": "Use daily normalization to compare times within the same day, regardless of absolute volume.",
  "Use comandos diretos e claros (\"Clique Agora\" vs \"Saiba Mais\")": "Use clear, direct commands (\"Click Now\" vs \"Learn More\")",
  "Use esse dado para agendar seus conteúdos": "Use this data to schedule your content",
  "Use esses dados para planejar estratégias e otimizar suas conversões.": "Use this data to plan strategies and optimize conversions.",
  "Use este vídeo como modelo para aplicar as mesmas configurações nos outros vídeos.": "Use this video as a template to apply the same settings to other videos.",
  "Use imagens com proporção 16:9 para melhor resultado": "Use images with a 16:9 aspect ratio for best results",
  "Use imagens de alta qualidade e texto claro que capture a essência do seu conteúdo. Teste diferentes cores de fundo e expressões faciais.": "Use high-quality images and clear text that captures the essence of your content. Test different background colors and facial expressions.",
  "Use imagens/GIFs com proporção 16:9 para melhor resultado": "Use images/GIFs with a 16:9 aspect ratio for best results",
  "Use m:ss ou segundos (ex.: 0:38 ou 38,5).": "Use m:ss or seconds (e.g., 0:38 or 38.5).",
  "Use mini hooks para aumentar retenção.": "Use mini hooks to increase retention.",
  "Use Mini-Hooks para exibir imagens ou GIFs em momentos estratégicos do vídeo. Ideal para reforçar promessas, criar avisos visuais e recuperar atenção.": "Use Mini-Hooks to display images or GIFs at strategic moments. Ideal to reinforce promises, create visual cues, and recover attention.",
  "Use mudanças de câmera, efeitos sonoros ou transições visuais a cada 15-20 segundos para renovar a atenção.": "Use camera changes, sound effects, or visual transitions every 15–20 seconds to renew attention.",
  "Use mudanças de cenário, efeitos sonoros ou visuais para 'acordar' o espectador periodicamente e evitar monotonia.": "Use scene changes, sound effects, or visuals to periodically 'wake up' viewers and avoid monotony.",
  "Use o botão": "Use the button",
  "Use o calendário para comparar períodos semelhantes": "Use the calendar to compare similar periods",
  "Use o código abaixo para colocar o vídeo no seu site. Funciona em qualquer plataforma.": "Use the code below to place the video on your site. Works on any platform.",
  "Use o cupom 50%OFF e comece hoje mesmo.": "Use coupon 50%OFF and start today.",
  "Use o cupom abaixo no checkout do plano que você escolher.": "Use the coupon below at checkout for your chosen plan.",
  "Use os resultados para melhorar criativos, páginas e escala.": "Use results to improve creatives, pages, and scaling.",
  "Use parâmetros UTM nas suas URLs para rastrear a origem do tráfego": "Use UTM parameters in your URLs to track traffic sources",
  "Use pastas para organizar suas VSLs por produto ou campanha.": "Use folders to organize VSLs by product or campaign.",
  "Use Picos de Horário para alinhar postagem, disparos e tráfego pago com os momentos de maior atenção. Menos achismo, mais performance.": "Use Peak Hours to align posts, sends, and paid traffic with the moments of greatest attention. Less guesswork, better performance.",
  "Use plays extras se o limite mensal expirar antes da renovação.": "Use extra plays if your monthly allowance runs out before renewal.",
  "Use só letras, números, \"_\", \"-\" e \".\" no nome do parâmetro.": "Use only letters, numbers, \"_\", \"-\", and \".\" in parameter names.",
  "Use tempos com passo de 0,1 s": "Use times in 0.1 s increments",
  "Use thumbnails com expressões faciais fortes e cores contrastantes": "Use thumbnails with strong facial expressions and contrasting colors",
  "Use um checkout dedicado a este fluxo e cadastre apenas as compras dele neste webhook. Os indicadores passam a receber as vendas após a configuração na plataforma.": "Use a checkout dedicated to this flow and register only its purchases in this webhook. Indicators will start receiving sales after setup on the platform.",
  "Use um nome que ajude você a identificar facilmente este experimento no futuro.": "Use a name that helps you identify this experiment easily in the future.",
  "Use um testemunho mais relativo ao público-alvo": "Use a testimonial more relatable to your target audience",
  "Use uma cor no formato #RRGGBB": "Use a color in #RRGGBB format",
  "Use UTM, token, chave de URL e bloqueio de VPN/Proxy para reforçar a segurança.": "Use UTMs, tokens, URL keys, and VPN/Proxy blocking to strengthen security.",
  "Use várias quebras de padrão ou fatos surpreendentes": "Use multiple pattern interrupts or surprising facts",
  "useCustomAuth must be used within CustomAuthProvider": "useCustomAuth must be used within CustomAuthProvider",
  "useDashboard must be used within a DashboardProvider": "useDashboard must be used within a DashboardProvider",
  "useDrawer must be used within a DrawerProvider": "useDrawer must be used within a DrawerProvider",
  "useNewVideoModal must be used within a NewVideoModalProvider": "useNewVideoModal must be used within a NewVideoModalProvider",
  "User ID not found": "User ID not found",
  "User not authenticated": "User not authenticated",
  "userId é obrigatório para ativar um teste": "userId is required to activate a test",
  "userId é obrigatório para criar um teste": "userId is required to create a test",
  "useSidebar must be used within a SidebarProvider.": "useSidebar must be used within a SidebarProvider.",
  "useSupportTokenModal must be used within SupportTokenProvider": "useSupportTokenModal must be used within SupportTokenProvider",
  "useTestMode must be used within a TestModeProvider": "useTestMode must be used within a TestModeProvider",
  "useTheme must be used within ThemeProvider": "useTheme must be used within ThemeProvider",
  "useTour must be inside TourProvider": "useTour must be inside TourProvider",
  "Uso do Plano": "Plan Usage",
  "Uso interno. Aparece no dashboard, não aparece no player público.": "Internal use. Appears in the dashboard, not in the public player.",
  "usuário": "user",
  "Usuário": "User",
  "Usuário carregado com sucesso!": "User loaded successfully!",
  "Usuário Comum": "Regular User",
  "Usuário ID #{value0}": "User ID #{value0}",
  "Usuário não autenticado": "User not authenticated",
  "Usuário não encontrado": "User not found",
  "Usuário não encontrado.": "User not found.",
  "Usuário não identificado": "User not identified",
  "Usuário não pode fechar sem preencher": "Users cannot close without filling it out",
  "Usuários": "Users",
  "Usuários ativos no período": "Active users in the period",
  "Usuários podem entrar até": "Users can enter until",
  "Usuários que clicaram no botão de play e iniciaram o vídeo": "Users who clicked the play button and started the video",
  "UTM": "UTM",
  "UTM •": "UTM •",
  "UTM Campaign": "UTM Campaign",
  "UTM Content": "UTM Content",
  "UTM criada": "UTM created",
  "UTM Medium": "UTM Medium",
  "UTM Source": "UTM Source",
  "UTM Term": "UTM Term",
  "utm_campaign": "utm_campaign",
  "utm_campaign (ex: lancamento)": "utm_campaign (e.g.: launch)",
  "utm_content": "utm_content",
  "utm_medium": "utm_medium",
  "utm_medium (ex: video)": "utm_medium (e.g.: video)",
  "utm_source": "utm_source",
  "utm_source (ex: youtube)": "utm_source (e.g.: youtube)",
  "utm_term": "utm_term",
  "UTM: {value0}={value1}": "UTM: {value0}={value1}",
  "UTMs": "UTMs",
  "UTMs e referências associadas": "Associated UTMs and referrers",
  "UTMs, src, sck e click ids seguem para o destino.": "UTMs, src, sck, and click IDs are forwarded to the destination.",
  "v1.1.0 | dev": "v1.1.0 | dev",
  "Vá até a aba Configurações para cadastrar seu primeiro pixel.": "Go to the Settings tab to register your first pixel.",
  "Vá para a aba \"Automático\" e ative um teste de velocidade para ver as métricas aqui.": "Go to the \"Automatic\" tab and activate a speed test to see metrics here.",
  "Vagas limitadas": "Limited spots",
  "Vai para": "Goes to",
  "Vai para sua biblioteca": "Goes to your library",
  "Válida enquanto durar o evento": "Valid for the duration of the event",
  "Validação falhou": "Validation failed",
  "Validade": "Validity",
  "Validando cupom...": "Validating coupon...",
  "Válido por:": "Valid for:",
  "Valor": "Amount",
  "Valor (R$) *": "Amount (R$) *",
  "Valor a ser pago": "Amount to pay",
  "Valor do parâmetro": "Parameter value",
  "Valor do Parâmetro": "Parameter Value",
  "Valor é obrigatório": "Value is required",
  "Valor inicial do contador": "Initial counter value",
  "Valor inicial do contador de audiência": "Initial audience counter value",
  "Valor inicial para o contador.": "Initial counter value.",
  "Valor inválido": "Invalid value",
  "Valor líquido": "Net amount",
  "Valor Líquido": "Net Amount",
  "Valor médio por venda realizada no período": "Average value per sale in the period",
  "Valor mensal": "Monthly amount",
  "Valor Mensal": "Monthly Amount",
  "Valor numérico": "Numeric value",
  "Valor obrigatório": "Value required",
  "Valor pode variar caso você compre plays extras ou caso a recarga automática seja acionada antes da renovação.": "Amount may vary if you buy extra plays or automatic top-up is triggered before renewal.",
  "Valor total": "Total amount",
  "Valor total de vendas confirmadas no período": "Total value of confirmed sales in the period",
  "Valor total: R$ 999": "Total value: R$ 999",
  "Valores em tooltips": "Tooltip values",
  "Vantagens exclusivas para parceiros Host VSL": "Exclusive benefits for Host VSL partners",
  "Variação": "Variation",
  "Variação {value0}": "Variation {value0}",
  "Variação adicionada!": "Variation added!",
  "Variação atualizada!": "Variation updated!",
  "Variação excluída": "Variation deleted",
  "Variação máxima": "Maximum variation",
  "Variação mínima": "Minimum variation",
  "Variação removida!": "Variation removed!",
  "Variação salva!": "Variation saved!",
  "Variações": "Variations",
  "Variações em teste": "Variations being tested",
  "variações:": "variations:",
  "Variante": "Variant",
  "Varie o ritmo da sua narrativa para manter o interesse ao longo do vídeo. Evite longos períodos apenas falando sem estímulos visuais.": "Vary your narrative pace to maintain interest throughout the video. Avoid long periods of talking without visual stimulation.",
  "vazio": "empty",
  "Vega": "Vega",
  "Veja em que ponto do vídeo a audiência se engaja e onde ocorre a maior queda.": "See where viewers engage and where the biggest drop occurs.",
  "Veja num mapa-múndi quem está assistindo às suas VSLs agora, em qualquer lugar do mundo.": "See on a world map who is watching your VSLs right now, anywhere in the world.",
  "Veja o desempenho completo das introduções testadas.": "See the full performance of tested intros.",
  "Veja o desempenho detalhado de cada introdução testada.": "See detailed performance for each tested intro.",
  "Veja os horários ideais por tipo de acesso (desktop, mobile, tablet)": "See ideal times by access type (desktop, mobile, tablet)",
  "Veja os horários ideais por tipo de acesso e entenda diferenças entre desktop, mobile e tablet": "See ideal times by access type and understand differences between desktop, mobile, and tablet",
  "Veja plays, retenção, conversão e outros indicadores importantes.": "See plays, retention, conversions, and other important indicators.",
  "Veja quais páginas enviaram tráfego para este vídeo.": "See which pages sent traffic to this video.",
  "Veja quais vídeos convertem mais": "See which videos convert best",
  "Veja quanto você pode ganhar por mês": "See how much you can earn per month",
  "Veja quantos visitantes passam por cada etapa, qual opção escolhem, quantos chegam ao checkout e a retenção de cada vídeo. Só o primeiro clique de cada visitante conta como play no seu plano.": "See how many visitors pass through each step, which options they choose, how many reach checkout, and each video's retention. Only each visitor's first click counts as a play against your plan.",
  "Velocidade": "Speed",
  "Velocidade {value0}x": "Speed {value0}x",
  "Velocidade atual": "Current speed",
  "Velocidade atual:": "Current speed:",
  "Velocidade atual: {value0}": "Current speed: {value0}",
  "Velocidade atualizada": "Speed updated",
  "Velocidade configurada para {value0}x": "Speed set to {value0}x",
  "Velocidade da Simulação": "Simulation Speed",
  "Velocidade das Notificações": "Notification Speed",
  "Velocidade de carregamento": "Loading speed",
  "Velocidade de Carregamento": "Loading Speed",
  "Velocidade de reprodução": "Playback Speed",
  "Velocidade de Reprodução": "Playback Speed",
  "Velocidade de reprodução do vídeo. O padrão é 1.0x.": "Video playback speed. Default is 1.0x.",
  "Velocidade e Teste A/B": "Speed and A/B Testing",
  "Velocidade final": "Final speed",
  "Velocidade Fixa": "Fixed speed",
  "Velocidade inicial": "Initial speed",
  "Velocidade manual salva": "Manual speed saved",
  "Velocidade normal de reprodução.": "Normal playback speed.",
  "Velocidade padrão": "Default speed",
  "Velocidades de teste (": "Test speeds (",
  "Velocidades:": "Speeds:",
  "Vencedor": "Winner",
  "Vencedor:": "Winner:",
  "Vencedora": "Winner",
  "Vencendo": "Winning",
  "Venda do dia": "Sale of the day",
  "Vendas": "Sales",
  "Vendas aprovadas": "Approved sales",
  "Vendas aprovadas ÷ plays do fluxo": "Approved sales ÷ flow plays",
  "Vendedor gerou R$ 10.000 em comissões": "Seller generated R$ 10,000 in commissions",
  "Vendedores Ativos": "Active Sellers",
  "Vendedores indicados que já geraram comissões.": "Referred sellers who have already generated commissions.",
  "Ver como funciona": "See how it works",
  "Ver comprovante": "View receipt",
  "Ver conversões por vídeo": "View conversions by video",
  "Ver Dados Detalhados": "View Detailed Data",
  "Ver detalhes": "View details",
  "Ver Detalhes": "View Details",
  "Ver detalhes do teste": "View test details",
  "Ver detalhes do vídeo": "View video details",
  "Ver documentação": "View documentation",
  "Ver Feedback": "View Feedback",
  "Ver horários de pico": "View peak hours",
  "Ver Horários de Pico": "View Peak Hours",
  "Ver integrações": "View integrations",
  "Ver métricas": "View Metrics",
  "Ver Métricas": "View Metrics",
  "Ver Meus Vídeos": "View My Videos",
  "Ver Módulos": "View Modules",
  "Ver no gráfico": "View in chart",
  "Ver opções de importação": "View import options",
  "Ver Prévia": "View Preview",
  "Ver regra em conflito": "View conflicting rule",
  "Ver Relatório": "View Report",
  "Ver relatório completo": "View full report",
  "Ver Relatório Completo": "View Full Report",
  "Ver retenção de {value0}": "View retention for {value0}",
  "VER SITE": "VIEW SITE",
  "Ver Sugestões": "View Suggestions",
  "Ver Teste": "View Test",
  "Ver Testes": "View Tests",
  "Ver todas ({n})": "Show all ({n})",
  "Ver todos os logs": "View all logs",
  "Ver todos os logs →": "View all logs →",
  "Ver Tracking": "View Tracking",
  "Ver tracking detalhado": "View detailed tracking",
  "Ver tudo": "View all",
  "Ver UTMs": "View UTMs",
  "Verde ativo": "Active green",
  "Verificada": "Verified",
  "Verificando...": "Verifying...",
  "Verifique se o link está correto.": "Check that the link is correct.",
  "Verifique se recebeu a notificação de teste.": "Check whether you received the test notification.",
  "Verifique se sua Chromecast/Smart TV está ligada e conectada na mesma rede Wi-Fi.": "Check that your Chromecast/Smart TV is on and connected to the same Wi-Fi network.",
  "Vermelho erro/excluir": "Error/delete red",
  "Verso do Documento": "Document Back",
  "Vertical (↓)": "Vertical (↓)",
  "Vertical (campos empilhados)": "Vertical (stacked fields)",
  "vezes": "times",
  "Via {platformName}": "Via {platformName}",
  "vídeo": "video",
  "Vídeo": "video",
  "Vídeo \"{value0}\" excluído com sucesso": "Video \"{value0}\" deleted successfully",
  "Vídeo \"{value0}\" pronto para personalização!": "Video \"{value0}\" ready to customize!",
  "Vídeo {value0}": "Video {value0}",
  "Vídeo 1": "Video 1",
  "Vídeo 2": "Video 2",
  "Vídeo 3": "Video 3",
  "Vídeo A": "Video A",
  "Vídeo adicionado": "Video added",
  "Vídeo adicionado com sucesso": "Video added successfully",
  "Vídeo Alternativo": "Alternative Video",
  "VÍDEO ALTERNATIVO": "ALTERNATIVE VIDEO",
  "Vídeo alternativo ou URL de redirecionamento é obrigatório": "Alternative video or redirect URL is required",
  "Vídeo atual": "Current video",
  "Vídeo B": "Video B",
  "Vídeo Base": "Base Video",
  "Vídeo C": "Video C",
  "Vídeo carregado": "Video loaded",
  "Vídeo com Maior Captura": "Video with Most Captures",
  "Vídeo compartilhado": "Video shared",
  "Vídeo copiado para sua biblioteca": "Video copied to your library",
  "Vídeo da Captura": "Capture Video",
  "Vídeo da etapa": "Step video",
  "Vídeo de entrada": "Entry video",
  "Vídeo de entrada (antes da VSL) e vídeo de saída (depois) — use um ou os dois": "Entry video (before the VSL) and exit video (after) — use one or both",
  "Vídeo de entrada exibido": "Entry video shown",
  "Vídeo de Fundo": "Background Video",
  "Vídeo de fundo começa mutado (recomendado)": "Background video starts muted (recommended)",
  "Vídeo de Fundo Inteligente": "Smart background video",
  "Vídeo de Lançamento": "Launch Video",
  "Vídeo de origem": "Source video",
  "Vídeo de origem não encontrado.": "Source video not found.",
  "Vídeo de saída": "Exit video",
  "Vídeo de saída não configurado": "Exit video not configured",
  "Vídeo de segurança": "Fallback video",
  "Vídeo de vendas": "Sales video",
  "Vídeo disponível na biblioteca": "Video available in library",
  "Vídeo duplicado com configurações padrão.": "Video duplicated with default settings.",
  "Vídeo e tempos": "Video and timing",
  "Vídeo em preparo": "Video preparing",
  "Vídeo em preparo. Acesse Vídeos Compartilhados para gerenciar.": "Video being prepared. Go to Shared Videos to manage it.",
  "Vídeo excluído com sucesso": "Video deleted successfully",
  "Vídeo excluído com sucesso!": "Video deleted successfully!",
  "Vídeo excluído.": "Video deleted.",
  "Vídeo final exibido": "Final video shown",
  "Vídeo ID:": "Video ID:",
  "Vídeo importado com sucesso!": "Video imported successfully!",
  "Vídeo Institucional": "Corporate Video",
  "Vídeo já clonado": "Video already cloned",
  "Vídeo já está sendo usado em": "Video is already used in",
  "Vídeo movido para a pasta com sucesso!": "Video moved to folder successfully!",
  "Vídeo não encontrado": "Video not found",
  "Vídeo não encontrado para salvar o pitch.": "Video not found to save the pitch.",
  "Vídeo Original": "Original Video",
  "Video preview": "Video preview",
  "Video Preview": "Video Preview",
  "Vídeo Principal": "Main Video",
  "Vídeo principal exibido após as variações": "Main video shown after the variations",
  "Vídeo principal não selecionado": "Main video not selected",
  "Vídeo pronto para personalização!": "Video ready to customize!",
  "Vídeo removido": "Video removed",
  "Vídeo removido da pasta!": "Video removed from folder!",
  "Vídeo renomeado": "Video renamed",
  "Vídeo renomeado com sucesso": "Video renamed successfully",
  "Vídeo renomeado com sucesso!": "Video renamed successfully!",
  "vídeo selecionado": "video selected",
  "Vídeo selecionado": "Video selected",
  "Vídeo sem pitch nesta posição — clique para definir": "No video pitch at this position — click to set",
  "Vídeo sem título": "Untitled video",
  "Video thumbnail": "Video thumbnail",
  "Vídeo usado como variação no teste": "Video used as a test variation",
  "Vídeo vinculado": "Video linked",
  "Vídeo:": "Video:",
  "vídeo(s)": "video(s)",
  "vídeo(s)? Esta ação não pode ser desfeita.": "video(s)? This action cannot be undone.",
  "VideoControlsTab - Simplificação de Labels": "VideoControlsTab - Label Simplification",
  "videoId é obrigatório para criar um teste": "videoId is required to create a test",
  "vídeos": "videos",
  "Vídeos": "videos",
  "Vídeos (1)": "Videos (1)",
  "Vídeos & Pastas": "Videos & Folders",
  "Vídeos adicionados": "Videos added",
  "Vídeos adicionados à fila": "Videos added to queue",
  "Vídeos adicionados!": "Videos added!",
  "Vídeos aplicados:": "Videos applied:",
  "Vídeos compartilhados": "Shared videos",
  "Vídeos Compartilhados": "Shared Videos",
  "Vídeos copiados ficam protegidos e não podem ser compartilhados novamente": "Copied videos remain protected and cannot be shared again",
  "Vídeos de Teste": "Test Videos",
  "Vídeos disponíveis": "Available videos",
  "Vídeos do fluxo": "Flow videos",
  "Vídeos em HD (1080p) oferecem melhor experiência aos espectadores": "HD videos (1080p) offer a better viewing experience",
  "vídeos em teste": "videos being tested",
  "Vídeos em Teste": "videos being tested",
  "Vídeos específicos": "Specific videos",
  "Vídeos ilimitados": "Unlimited videos",
  "Vídeos ilimitados sem restrição": "Unlimited videos without restrictions",
  "Vídeos na plataforma": "Videos on the platform",
  "Vídeos nesta pasta": "Videos in this folder",
  "Vídeos rastreados": "Tracked videos",
  "Vídeos Recentes": "Latest Videos",
  "vídeos selecionados": "selected videos",
  "Vídeos selecionados:": "Selected videos:",
  "vídeos sem funil configurado": "videos without configured funnels",
  "vídeos)": "videos)",
  "VideoSelector — Dropdown Alinhado Premium": "VideoSelector — Premium Aligned Dropdown",
  "Vidro escuro": "Dark glass",
  "views": "views",
  "Views": "views",
  "Views e Plays ao longo do tempo": "Views and Plays over time",
  "Views Únicos": "Unique Views",
  "Views:": "Views:",
  "Vimeo": "Vimeo",
  "Vinculando documentos ao seu cadastro financeiro...": "Linking documents to your financial registration...",
  "Vincular": "Link",
  "Vincular Conta Bancária": "Link Bank Account",
  "Vincular VSL no Rastreamento": "Link VSL in Tracking",
  "Vincule a resposta ao lead, quando disponível.": "Link the response to the lead when available.",
  "Vincule cada pixel a um vídeo e ao site onde a sua VSL está publicada": "Link each pixel to a video and the site where your VSL is published",
  "Vincule uma plataforma de vendas à saída de checkout deste fluxo. Acessar o checkout não significa comprar.": "Link a sales platform to this flow's checkout exit. Visiting checkout does not mean purchasing.",
  "Vis.": "Views",
  "Vis. Únicas": "Unique views",
  "Visão em grade": "Grid view",
  "Visão em lista": "List view",
  "Visão geral": "Overview",
  "Visão Geral": "Overview",
  "Visão geral da plataforma": "Platform overview",
  "Visão Geral da Plataforma": "Platform Overview",
  "Visibilidade:": "Visibility:",
  "Visitar": "Visit",
  "Visitar parceiro {value0}": "Visit partner {value0}",
  "Visitas": "Visits",
  "VISUAL": "VISUAL",
  "Visual apenas • Sem lógica de sorteio": "Visual only • No giveaway logic",
  "Visual apenas • Sem validação": "Visual only • No validation",
  "Visual premium e consistente em toda a plataforma": "Premium, consistent appearance across the platform",
  "Visual premium, navegação mais rápida e consistência total.": "Premium visuals, faster navigation, and complete consistency.",
  "Visualização": "View",
  "Visualização detalhada": "Detailed view",
  "Visualização do fluxo": "Flow preview",
  "Visualização do player com": "Player preview with",
  "Visualização em barras verticais proporcionais com gradiente azul progressivo": "Proportional vertical bar visualization with a progressive blue gradient",
  "visualizações": "views",
  "Visualizações": "Views",
  "Visualizações e insights sobre o desempenho de captura": "Views and insights on capture performance",
  "Visualizações hoje": "Views today",
  "Visualizações Totais": "Total Views",
  "visualizações únicas": "unique views",
  "Visualizações únicas": "Unique views",
  "Visualizações Únicas": "Unique views",
  "Visualizações únicas (por usuário)": "Unique views (per user)",
  "Visualizações únicas e plays únicos contam aparelhos diferentes no período. Clique num vídeo para ver a retenção.": "Unique views and unique plays count distinct devices in the period. Click a video to see retention.",
  "visualizações)": "views)",
  "visualizações).": "views).",
  "Visualizador": "Viewer",
  "Visualizar": "View",
  "Visualizar em dispositivo": "Preview on device",
  "Visualizar este vídeo": "View this video",
  "Visualizar no celular": "Preview on mobile",
  "Visualizar no desktop": "Preview on desktop",
  "Visualizar no tablet": "Preview on tablet",
  "Visualize a evolução da retenção durante o vídeo": "See how retention changes during the video",
  "Visualize como a retenção evoluiu entre as diferentes introduções testadas.": "See how retention evolved across different tested intros.",
  "Visualize como a retenção evoluiu entre os diferentes vídeos testados.": "See how retention evolved across different tested videos.",
  "Visualize como ficará seu autoplay": "Preview how autoplay will look",
  "Visualize toda a jornada do seu público em um funil de barras verticais com taxas de conversão entre etapas.": "Visualize your audience's full journey in a vertical bar funnel with conversion rates between stages.",
  "VITE_GOOGLE_CLIENT_ID não configurado. Adicione no .env e reinicie o dev server.": "VITE_GOOGLE_CLIENT_ID not configured. Add it to .env and restart the dev server.",
  "VITE_GOOGLE_DEVELOPER_KEY não configurado. Adicione no .env e reinicie o dev server.": "VITE_GOOGLE_DEVELOPER_KEY not configured. Add it to .env and restart the dev server.",
  "Você ainda não compartilhou nenhum vídeo": "You have not shared any videos yet",
  "Você ainda não convidou nenhum membro para sua equipe. Comece adicionando membros para colaborar em seus projetos.": "You have not invited any team members yet. Start adding members to collaborate on your projects.",
  "Você ainda não criou nenhum teste de hook.": "You haven't created any hook tests yet.",
  "Você ainda não criou playlists": "You have not created any playlists yet",
  "Você ainda não tem vídeos": "You have no videos yet",
  "Você ainda não tem vídeos processados": "You have no processed videos yet",
  "Você ainda não tem webinários": "You have no webinars yet",
  "Você ainda pode aplicar a regra para o país inteiro.": "You can still apply the rule to the entire country.",
  "Você ainda pode enviar {value0} vídeo{value1} agora. Aguarde os atuais terminarem para enviar mais.": "You can upload {value0} more video{value1} now. Wait for current uploads to finish before uploading more.",
  "Você ainda pode importar {value0} vídeo{value1} agora.": "You can import {value0} more video{value1} now.",
  "Você atingiu o limite de vídeos do período de teste. Ative seu plano agora para voltar a enviar vídeos — leva menos de um minuto.": "You have reached the trial video limit. Activate your plan now to resume uploads — it takes less than a minute.",
  "Você bloqueou as notificações. Para ativá-las novamente, acesse as configurações do seu navegador e permita notificações para este site.": "You blocked notifications. To enable them again, open your browser settings and allow notifications for this site.",
  "Você bloqueou as notificações. Para ativá-las novamente, acesse as configurações do seu navegador.": "You blocked notifications. To enable them again, open your browser settings.",
  "Você completou esta série!": "You completed this series!",
  "Você concluiu toda a playlist \"": "You completed the entire playlist \"",
  "Você conectou plataformas, agora vincule sua VSL para capturar as vendas.": "You connected platforms; now link your VSL to capture sales.",
  "Você confirma que deseja excluir este vídeo da playlist?": "Do you confirm deleting this video from the playlist?",
  "Você deve aceitar os termos": "You must accept the terms",
  "Você é o dono do vídeo": "You own the video",
  "Você é o proprietário deste vídeo": "You own this video",
  "Você encerra o teste quando quiser.": "You can end the test whenever you like.",
  "Você encerra quando quiser.": "You can end it whenever you like.",
  "Você está offline. Verifique sua conexão.": "You are offline. Check your connection.",
  "Você está prestes a iniciar um teste com": "You are about to start a test with",
  "Você está recebendo notificações push sobre eventos importantes da sua conta. Configure abaixo quais tipos de alertas deseja receber.": "You are receiving push notifications about important account events. Configure which alerts you want below.",
  "Você está solicitando o saque do seu saldo liberado de": "You are requesting a withdrawal of your available balance of",
  "Você está visualizando o Dashboard no Modo Teste.": "You are viewing the Dashboard in Test Mode.",
  "Você gerou tokens demais hoje. Tente novamente em 1 hora.": "You generated too many tokens today. Try again in 1 hour.",
  "Você já clonou este vídeo. Cada vídeo pode ser copiado apenas uma vez para sua conta.": "You already cloned this video. Each video can be copied to your account only once.",
  "Você já começou a assistir esse vídeo": "You already started watching this video",
  "Você já pode acessá-lo em": "You can now access it in",
  "Você não poderá compartilhar este vídeo com outras pessoas.": "You cannot share this video with others.",
  "Você não possui nenhum Rastreamento ativo": "You have no active Tracking",
  "Você não tem permissão para fazer upload de vídeos.": "You do not have permission to upload videos.",
  "Você parou em": "You stopped at",
  "Você parou em um ponto importante do vídeo.": "You stopped at an important point of the video.",
  "Você perderá acesso a todos os recursos da HostVSL": "You will lose access to all HostVSL features",
  "Você pode acessar o HostVSL pela tela inicial": "You can access HostVSL from your home screen",
  "Você pode acessar o HostVSL pela tela inicial do seu dispositivo.": "You can access HostVSL from your device's home screen.",
  "Você pode adicionar quantos vídeos quiser para testar diferentes abordagens.": "You can add as many videos as you want to test different approaches.",
  "Você poderá escolher arquivos da sua conta Google com segurança.": "You can securely select files from your Google account.",
  "Você poderá mover vídeos para esta pasta depois. (": "You can move videos to this folder later. (",
  "Você precisa aceitar os termos": "You need to accept the terms",
  "Você precisa aceitar os termos de uso para continuar.": "You need to accept the terms of use to continue.",
  "Você precisa de um plano ativo para enviar vídeos. Ative um plano para continuar.": "You need an active plan to upload videos. Activate a plan to continue.",
  "Você precisa estar autenticado.": "You must be authenticated.",
  "Você precisa estar logado para criar um teste.": "You must be signed in to create a test.",
  "Você precisa selecionar um vídeo para continuar": "You need to select a video to continue",
  "Você recebe": "You receive",
  "Você recebe 20% de comissão recorrente sobre o valor do plano ativo. Por exemplo: se seu indicado possui o plano de R$ 147/mês, você recebe R$ 29,40 todo mês.": "You receive 20% recurring commission on the active plan value. For example: if your referral has a R$ 147/month plan, you receive R$ 29,40 every month.",
  "Você recusou o compartilhamento": "You declined the share",
  "Você será cobrado R$": "You will be charged R$",
  "Você será redirecionado em alguns segundos…": "You will be redirected in a few seconds…",
  "Você será redirecionado para a sala...": "You will be redirected to the room...",
  "Você terá acesso a um painel exclusivo onde poderá acompanhar suas indicações, conversões, comissões e pagamentos em tempo real.": "You get access to an exclusive dashboard to track referrals, conversions, commissions, and payments in real time.",
  "Volta o vídeo ao início quando a reprodução termina.": "Restarts the video when playback ends.",
  "Voltando em": "Returning in",
  "Voltar": "Back",
  "Voltar 10 segundos": "Rewind 10 seconds",
  "Voltar ao dashboard": "Back to dashboard",
  "Voltar ao Dashboard": "Back to Dashboard",
  "Voltar ao início": "Back to home",
  "Voltar para a lista": "Back to the list",
  "Voltar para a lista de fluxos": "Back to the flow list",
  "Voltar para Detalhes": "Back to Details",
  "Voltar para Extrato Administrativo": "Back to Administrative Statement",
  "Voltar para HostVSL": "Back to HostVSL",
  "Voltar para Lista": "Back to List",
  "Voltar para login": "Back to login",
  "Voltar para o login": "Back to login",
  "Voltar para Playlists": "Back to Playlists",
  "Volte para revisar momentos": "Go back to review moments",
  "Volume": "Volume",
  "Volume ({value}%)": "Volume ({value}%)",
  "Volume Contratado": "Contracted Volume",
  "Vou abrir o menu do vídeo para você ver as opções disponíveis.": "I'll open the video menu so you can see the available options.",
  "Voxuy é uma plataforma de envio de SMS em massa.": "Voxuy is a bulk SMS platform.",
  "VSL": "VSL",
  "VSL {value0}": "VSL {value0}",
  "VSL alternativa": "Alternative VSL",
  "VSL Alternativa": "Alternative VSL",
  "VSL Dinâmica": "Dynamic VSL",
  "VSL Dinâmica 2.0": "Dynamic VSL 2.0",
  "VSL Direcionada A": "Targeted VSL A",
  "VSL Direcionada B": "Targeted VSL B",
  "VSL Dynamic": "VSL Dynamic",
  "VSL Original": "Original VSL",
  "VSL Principal": "Main VSL",
  "VSL protegida": "Protected VSL",
  "VSL PROTEGIDA": "PROTECTED VSL",
  "VSLeads": "VSLeads",
  "Webhook copiado.": "Webhook copied.",
  "Webhook URL": "Webhook URL",
  "Webhooks": "Webhooks",
  "Webinário de Lançamento": "Launch Webinar",
  "Webinários": "Webinars",
  "Webinars": "Webinars",
  "WhatsApp": "WhatsApp",
  "WhatsApp inválido": "Invalid WhatsApp",
  "WhatsApp inválido.": "Invalid WhatsApp.",
  "Wildcard inválido. Use *.seudominio.com.": "Invalid wildcard. Use *.yourdomain.com.",
  "Wizard completo de criação de Teste A/B com 3 etapas: seleção de vídeos, distribuição de tráfego com drag-and-drop usando DnD-Kit, e cards sortáveis com badge de ordem e slider Radix.": "Complete 3-step A/B test creation wizard: video selection, drag-and-drop traffic distribution using DnD-Kit, and sortable cards with order badges and Radix sliders.",
  "Wizard criação Teste A/B": "A/B Test creation wizard",
  "Wizard criação Teste Hook": "Hook Test creation wizard",
  "Wizard Teste A/B": "A/B Test Wizard",
  "Wizard Teste Hook": "Hook Test Wizard",
  "Your browser does not support the video tag.": "Your browser does not support the video tag.",
  "Zoom": "Zoom",
  "Zoom leve": "Slight zoom"
};

export default messages;
